import { __decorate, __rest } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, ɵɵinject, EventEmitter, Input, Output, NgModule, HostListener, Directive, ContentChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConfirmationService as ConfirmationService$1 } from 'primeng/api';
import { Subject, BehaviorSubject, of, forkJoin, timer } from 'rxjs';
import { SpinnerService, ToastrNotificationService, UtilsModule } from '@lbmx/phoenix-lib-utils';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { alpha3ToAlpha2, alpha2ToAlpha3 } from 'i18n-iso-countries';
import { map, tap, catchError, finalize, mergeMap, takeUntil, exhaustMap } from 'rxjs/operators';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { selectors } from '@lbmx/app-state';
import { select, Store } from '@ngrx/store';
import { TemplateTypes, PerFormPrimengModule, LuiWizardV3Module, LuiWidgetWrapperModule } from '@lbmx/per-form-primeng';
import { ConfirmationService, ConfirmDialogModule as ConfirmDialogModule$1, ProgressSpinnerModule as ProgressSpinnerModule$1 } from 'primeng';
import { FormBuilder, Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SearchContainerLoaderService, AdvancedSearchLoaderModule, SearchContainerLoaderModule, SearchContainerModule as SearchContainerModule$1, BaseHttpService as BaseHttpService$1 } from '@lbmx/search-container';
import { HttpMethod as HttpMethod$1 } from '@lbmx/web-core';
import { saveAs } from 'file-saver';
import urlJoin from 'proper-url-join';
import { BreadcrumbService } from 'xng-breadcrumb';
import { DatePipe, CommonModule } from '@angular/common';
import { toolKeys } from '@lbmx/types';
import { ConfirmationService as ConfirmationService$2, ProgressSpinnerModule as ProgressSpinnerModule$2, DialogModule as DialogModule$1, ButtonModule as ButtonModule$2 } from 'primeng-lts';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { parsePhoneNumber, isValidPhoneNumber, isValidNumberForRegion, ParseError } from 'libphonenumber-js';
import { GenerateFormService, PerFormModule } from '@lbmx/per-form';
import { ButtonModule as ButtonModule$1 } from 'primeng-lts/button';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { ActionUiService, Action } from '@lbmx/action-ui';
import { InterceptorResponseService } from '@lbmx/root-services';
import { AccordionModule } from 'primeng/accordion';
import { CheckboxModule } from 'primeng/checkbox';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeTableModule } from 'primeng/treetable';
import { CalendarModule } from 'primeng/calendar';
import { TreeModule } from 'primeng/tree';

let MarketplacePartnersService = class MarketplacePartnersService {
    constructor() { }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
};
MarketplacePartnersService.ɵprov = ɵɵdefineInjectable({ factory: function MarketplacePartnersService_Factory() { return new MarketplacePartnersService(); }, token: MarketplacePartnersService, providedIn: "root" });
MarketplacePartnersService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MarketplacePartnersService);

let MarketplacePartnersComponent = class MarketplacePartnersComponent {
};
MarketplacePartnersComponent = __decorate([
    Component({
        selector: 'lib-marketplace-partners',
        template: `
    <lib-toast-notification></lib-toast-notification>
    <lib-working-spinner-component></lib-working-spinner-component>
    <router-outlet></router-outlet>
  `
    })
], MarketplacePartnersComponent);

let MyCompanyBus = class MyCompanyBus {
    constructor() {
        this.defaultValues = {
            master: false,
            details: false,
            contact: false,
            contactPhone: false,
            bankingInfo: false,
            locations: false,
        };
        this.createSubject = new Subject();
        this.updateSubject = new Subject();
        this.deleteSubject = new Subject();
        this.actionResultSubject = new Subject();
        this.searchSubject = new Subject();
        this.fetchingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.updatingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.create$ = this.createSubject.asObservable();
        this.update$ = this.updateSubject.asObservable();
        this.delete$ = this.deleteSubject.asObservable();
        this.actionResult$ = this.actionResultSubject.asObservable();
        this.search$ = this.searchSubject.asObservable();
        this.fetching$ = this.fetchingBehaviorSubject.asObservable();
        this.updating$ = this.updatingBehaviorSubject.asObservable();
    }
    fetching(name, value) {
        const currentValue = this.fetchingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.fetchingBehaviorSubject.next(newValue);
    }
    updating(name, value) {
        const currentValue = this.updatingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.updatingBehaviorSubject.next(newValue);
    }
    publish(event) {
        const { eventType } = event, update = __rest(event, ["eventType"]);
        switch (eventType) {
            case 'create':
                this.createSubject.next(update);
                break;
            case 'update':
                this.updateSubject.next(update);
                break;
            case 'delete':
                this.deleteSubject.next(update);
                break;
            case 'actionResult':
                this.actionResultSubject.next(update);
                break;
            case 'search':
                this.searchSubject.next(update);
                break;
            case 'setFetching':
                this.fetching(event.payload.form, event.payload.value);
                break;
            case 'setUpdating':
                this.updating(update.payload.form, update.payload.value);
                break;
        }
    }
};
MyCompanyBus.ɵprov = ɵɵdefineInjectable({ factory: function MyCompanyBus_Factory() { return new MyCompanyBus(); }, token: MyCompanyBus, providedIn: "root" });
MyCompanyBus = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MyCompanyBus);

let CompanyComponent = class CompanyComponent {
    constructor() { }
    ngOnInit() { }
};
CompanyComponent = __decorate([
    Component({
        selector: 'lib-company',
        template: `<router-outlet></router-outlet>`,
        providers: [MyCompanyBus]
    })
], CompanyComponent);

let AccountService = class AccountService {
    constructor(baseApiService, mpp, sanitizer, http) {
        this.baseApiService = baseApiService;
        this.mpp = mpp;
        this.sanitizer = sanitizer;
        this.http = http;
        this.baseUri = this.mpp.getConfig().getAccountEndpoint;
        this.updates = {
            details: (accountKey, typeKey, payload) => this.updateAccountDetails(accountKey, payload),
            contact: (accountKey, contactKey, payload) => this.updateAccountContact(accountKey, contactKey, payload),
            bankingInfo: (accountKey, accountBankingInfoKey, payload) => this.updateAccountBankingInfo(accountKey, accountBankingInfoKey, payload),
            locations: (accountKey, accountLocationKey, payload) => this.updateAccountLocation(accountKey, accountLocationKey, payload),
        };
        this.creates = {
            contact: (accountKey, payload) => this.addAccountContact(accountKey, payload),
            bankingInfo: (accountKey, payload) => this.addAccountBankingInfo(accountKey, payload),
            locations: (accountKey, payload) => this.addAccountLocation(accountKey, payload),
        };
        this.deletes = {
            contact: (accountKey, payload) => 
            // TODO: Remove single delete in future version if obsolete
            // this.deleteAccountContact(accountKey, payload),
            this.deleteManyAccountContact(accountKey, payload),
            bankingInfo: (accountKey, payload) => 
            // TODO: Remove single delete in future version if obsolete
            // this.deleteAccountBankingInfo(accountKey, payload),
            this.deleteManyAccountBankingInfo(accountKey, payload),
            locations: (accountKey, payload) => 
            // TODO: Remove single delete in future version if obsolete
            // this.deleteAccountLocation(accountKey, payload),
            this.deleteManyAccountLocation(accountKey, payload),
        };
        this.search = {
            contact: (accountKey, payload) => this.searchContact(accountKey, payload),
            bankingInfo: (accountKey, payload) => this.searchBankingInfo(accountKey, payload),
            locations: (accountKey, payload) => this.searchLocations(accountKey, payload),
        };
    }
    getAccount() {
        this.baseApiService.set(`${this.baseUri}`);
        return this.baseApiService.get().pipe(map((accountResponse) => {
            return Object.assign(Object.assign({}, accountResponse.account), { details: accountResponse.account.details[0]
                    ? accountResponse.account.details[0]
                    : {}, contacts: accountResponse.account.contacts
                    ? accountResponse.account.contacts.map((contact) => {
                        return Object.assign(Object.assign({}, contact), { phone: [
                                ...(contact.phone || [
                                    {
                                        contactPhoneKey: null,
                                        description: null,
                                        phoneNumber: '',
                                        phoneTypeKey: 0,
                                    },
                                ]),
                            ] });
                    })
                    : [], bankingInfo: accountResponse.account.bankingInfo
                    ? accountResponse.account.bankingInfo
                    : [], locations: accountResponse.account.locations
                    ? accountResponse.account.locations
                    : [] });
        }));
    }
    updateAccountDetails(accountKey, details) {
        this.baseApiService.set(`${this.baseUri}`);
        return this.baseApiService.put(details);
    }
    addAccountContact(accountKey, contact) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts`);
        return this.baseApiService.post(contact);
    }
    updateAccountContact(accountKey, contactKey, contact) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts/${contactKey}`);
        return this.baseApiService.put(contact);
    }
    deleteManyAccountContact(accountKey, contactKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts`);
        const contactKeys = JSON.parse(contactKeysString);
        return this.baseApiService.deleteMany(contactKeys);
    }
    // TODO: remove in future version if single delete is obsolete
    deleteAccountContact(accountKey, contactKey) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts/${contactKey}`);
        return this.baseApiService.delete();
    }
    searchContact(accountKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts/search`);
        return this.baseApiService.post(searchFilter);
    }
    deleteAccountContactPhone(accountKey, contactPhoneKey) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/contacts/phone/${contactPhoneKey}`);
        return this.baseApiService.delete();
    }
    getAccountBankingInfo(accountKey) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankingInfo`);
        return this.baseApiService.get(accountKey);
    }
    addAccountBankingInfo(accountKey, bankingInfo) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankingInfo`);
        return this.baseApiService.post(bankingInfo);
    }
    updateAccountBankingInfo(accountKey, accountBankingInfoKey, bankingInfo) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankingInfo/${accountBankingInfoKey}`);
        return this.baseApiService.put(bankingInfo);
    }
    deleteManyAccountBankingInfo(accountKey, accountBankingInfoKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankingInfo`);
        const accountBankingInfoKeys = JSON.parse(accountBankingInfoKeysString);
        return this.baseApiService.deleteMany(accountBankingInfoKeys);
    }
    // TODO: remove in future version if single delete is obsolete
    deleteAccountBankingInfo(accountKey, bankingInfoKey) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankingInfo/${bankingInfoKey}`);
        return this.baseApiService.delete();
    }
    searchBankingInfo(accountKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/bankinginfo/search`);
        return this.baseApiService.post(searchFilter);
    }
    getAccountLocations() {
        this.baseApiService.set(`${this.baseUri}/locations`);
        return this.baseApiService.get();
    }
    addAccountLocation(accountKey, location) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/locations`);
        return this.baseApiService.post(location);
    }
    updateAccountLocation(accountKey, accountLocationKey, location) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/locations/${accountLocationKey}`);
        return this.baseApiService.put(location);
    }
    deleteManyAccountLocation(accountKey, locationKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/locations`);
        const locationKeys = JSON.parse(locationKeysString);
        return this.baseApiService.deleteMany(locationKeys);
    }
    // TODO: Remove in Future Version if Single Delete is Obsolete
    deleteAccountLocation(accountKey, locationKey) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/locations/${locationKey}`);
        return this.baseApiService.delete();
    }
    searchLocations(accountKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountKey}/locations/search`);
        return this.baseApiService.post(searchFilter);
    }
    getAccountConfiguration() {
        this.baseApiService.set(`${this.baseUri}/demographics`);
        return this.baseApiService
            .get()
            .pipe(map((d) => d.demographics || {}));
    }
    createUrlFromBlob(image) {
        const objectURL = URL.createObjectURL(image);
        return this.sanitizer.bypassSecurityTrustUrl(objectURL);
    }
    deleteCompanyLogo(accountAssetKey) {
        this.baseApiService.set(this.mpp.getConfig().deleteAccountAssetsEndPoint);
        return this.baseApiService.post(accountAssetKey);
    }
    updateLogoAccountAssetKey(account) {
        this.baseApiService.set(this.mpp.getConfig().getAccountEndpoint);
        return this.baseApiService.put(account);
    }
    deleteLogoAccountAssetKey() {
        this.baseApiService.set(this.mpp.getConfig().deleteLogoAssetKeyEndpoint);
        return this.baseApiService.delete();
    }
    getImageUrl(accountAssetKey, accountKey) {
        return `${this.mpp.getConfig().accountAssetsEndPoint}/${accountAssetKey}?accountKey=${accountKey}`;
    }
};
AccountService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: MarketplacePartnersService },
    { type: DomSanitizer },
    { type: HttpClient }
];
AccountService.ɵprov = ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(ɵɵinject(BaseAPIService), ɵɵinject(MarketplacePartnersService), ɵɵinject(DomSanitizer), ɵɵinject(HttpClient)); }, token: AccountService, providedIn: "root" });
AccountService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AccountService);

let ConfigService = class ConfigService {
    constructor(baseApiService, mpp) {
        this.baseApiService = baseApiService;
        this.mpp = mpp;
        this.baseUri = this.mpp.getConfig().getConfigEndpoint;
    }
    getCountries() {
        this.baseApiService.set(`${this.baseUri}/country`);
        return this.baseApiService.get();
    }
    getCurrencyTypes() {
        this.baseApiService.set(`${this.baseUri}/currencyType`);
        return this.baseApiService.get();
    }
    getContactRoles() {
        this.baseApiService.set(`${this.baseUri}/contactRole`);
        return this.baseApiService.get();
    }
    getDocumentStatus() {
        this.baseApiService.set(`${this.baseUri}/documentStatus`);
        return this.baseApiService.get();
    }
    getDocumentTypes() {
        var _a;
        this.baseApiService.set(`${this.baseUri}/documentType`);
        return (_a = this.baseApiService
            .get()) === null || _a === void 0 ? void 0 : _a.pipe(map((documentType) => documentType.documentTypeResponse));
    }
    getPhoneTypes() {
        this.baseApiService.set(`${this.baseUri}/phoneType`);
        return this.baseApiService.get();
    }
    getProvinces() {
        this.baseApiService.set(`${this.baseUri}/province`);
        return this.baseApiService.get();
    }
    getExportDataTypes() {
        this.baseApiService.set(`${this.baseUri}/exportdatatype`);
        return this.baseApiService
            .get()
            .pipe(map((exportDataType) => exportDataType.records));
    }
    getExportFormatTypes() {
        this.baseApiService.set(`${this.baseUri}/exportformattype`);
        return this.baseApiService
            .get()
            .pipe(map((exportFormatType) => exportFormatType.records));
    }
};
ConfigService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: MarketplacePartnersService }
];
ConfigService.ɵprov = ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(ɵɵinject(BaseAPIService), ɵɵinject(MarketplacePartnersService)); }, token: ConfigService, providedIn: "root" });
ConfigService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ConfigService);

let ViewCompanyContainerComponent = class ViewCompanyContainerComponent {
    constructor(account, config, myCompanyBus, transloco, spinner, toast) {
        this.account = account;
        this.config = config;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.subscriptions = [];
        this.accountKey = '';
    }
    ngOnInit() {
        this.fetchMyCompany();
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ master }) => master));
        this.updating$ = this.myCompanyBus.updating$.pipe(map((forms) => Object.values(forms).reduce((updating, form) => {
            return form || updating;
        }, false)));
        this.subscriptions.push(this.myCompanyBus.update$.subscribe((args) => this.update(args)));
        this.subscriptions.push(this.myCompanyBus.create$.subscribe((args) => this.create(args)));
        this.subscriptions.push(this.myCompanyBus.delete$.subscribe((args) => this.delete(args)));
        this.subscriptions.push(this.myCompanyBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    create({ type, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.account.creates[type](this.accountKey, payload.create)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')))
                : of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    delete({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'contactPhone'
            ? this.subscriptions.push(this.account
                .deleteAccountContactPhone(`${this.account}`, `${payload.delete.contactPhoneKey}`)
                .pipe(tap(() => this.fetchMyCompany()), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                .subscribe())
            : this.subscriptions.push(this.account.deletes[type](this.accountKey, typeKey)
                .pipe(tap(() => {
                this.search({ type, payload: payload.search });
                this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
                this.spinner.off();
                this.setUpdating(type, false);
            }))
                .subscribe());
    }
    fetchMyCompany() {
        this.spinner.on();
        this.setFetching('master', true);
        this.subscriptions.push(forkJoin([
            this.config.getCurrencyTypes(),
            this.config.getProvinces(),
            this.config.getCountries(),
            this.account.getAccount(),
        ])
            .pipe(tap(([currencies, provinces, countries, myCompany]) => {
            this.accountKey = `${myCompany.details.accountKey}`;
            this.myCompany = myCompany;
            this.currencies = currencies.map((currency) => {
                return {
                    label: currency.description,
                    value: `${currency.currencyTypeKey}`,
                };
            });
            this.provinces = provinces.map((province) => {
                return {
                    label: province.provinceName,
                    value: province.provinceCode.trim(),
                    code: province.countryCode,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: country.countryName,
                    value: country.countryCode.trim(),
                };
            });
        }), finalize(() => {
            this.spinner.off();
            this.setFetching('master', false);
        }), catchError(() => {
            this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE'));
            return of();
        }))
            .subscribe());
    }
    search({ type, payload }) {
        var _a;
        this.setFetching(type, true);
        ((_a = this.accountKey) === null || _a === void 0 ? void 0 : _a.length) === 0
            ? this.subscriptions.push(this.account
                .getAccount()
                .pipe(tap((myCompany) => {
                this.accountKey = `${myCompany.details.accountKey}`;
                this.subscriptions.push(this.account.search[type](this.accountKey, payload)
                    .pipe(tap((data) => {
                    this.myCompanyBus.publish({
                        eventType: 'actionResult',
                        payload: {
                            type,
                            result: true,
                            data,
                        },
                    });
                }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
                    .subscribe());
            }))
                .subscribe())
            : this.subscriptions.push(this.account.search[type](this.accountKey, payload)
                .pipe(tap((data) => {
                this.myCompanyBus.publish({
                    eventType: 'actionResult',
                    payload: {
                        type,
                        result: true,
                        data,
                    },
                });
            }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
                .subscribe());
    }
    update({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.account.updates[type](this.accountKey, typeKey, payload.update)
            .pipe(tap(() => {
            type === 'details'
                ? this.fetchMyCompany()
                : this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')))
                : of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
        }))
            .subscribe());
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    setUpdating(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setUpdating',
            payload: { form, value },
        });
    }
};
ViewCompanyContainerComponent.ctorParameters = () => [
    { type: AccountService },
    { type: ConfigService },
    { type: MyCompanyBus },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService }
];
ViewCompanyContainerComponent = __decorate([
    Component({
        selector: 'lib-view-company-container',
        template: ` <lib-view-company
    [myCompany]="myCompany"
    [fetching]="fetching$ | async"
    [updating]="updating$ | async"
    [countries]="countries"
    [provinces]="provinces"
    [currencies]="currencies"
  >
  </lib-view-company>`
    })
], ViewCompanyContainerComponent);

const ɵ0 = { breadcrumb: 'BREADCRUMB.MY_COMPANY' };
const routes = [
    {
        path: 'company',
        component: CompanyComponent,
        data: ɵ0,
        children: [
            {
                path: '',
                component: ViewCompanyContainerComponent,
            },
        ],
    },
];

let AccountRelationshipService = class AccountRelationshipService {
    constructor(baseApiService, mpp, store) {
        this.baseApiService = baseApiService;
        this.mpp = mpp;
        this.store = store;
        this.subscriptions = [];
        this.baseUri = this.mpp.getConfig().getAccountRelationshipEndpoint;
        this.creates = {
            contact: (accountRelationshipKey, payload) => this.addAccountRelationshipContact(accountRelationshipKey, payload),
            note: (accountRelationshipKey, payload) => this.addAccountRelationshipNote(accountRelationshipKey, payload),
            edi: (accountRelationshipKey, payload) => this.addAccountRelationshipDocument(accountRelationshipKey, payload),
        };
        this.updates = {
            contact: (accountRelationshipKey, contactKey, payload) => this.updateAccountRelationshipContact(accountRelationshipKey, contactKey, payload),
            note: (accountRelationshipKey, accountRelationshipNoteKey, payload) => this.updateAccountRelationshipNote(accountRelationshipKey, accountRelationshipNoteKey, payload),
            details: (accountRelationshipKey, key, payload) => this.updateAccountRelationshipDetails(accountRelationshipKey, payload),
            edi: (accountRelationshipKey, accountRelationshipDocumentKey, payload) => this.updateAccountRelationshipDocument(accountRelationshipKey, accountRelationshipDocumentKey, payload),
        };
        this.deletes = {
            contact: (accountRelationshipKey, payload) => 
            // TODO: Remove in Future Version if Single Delete is Obsolete
            // this.deleteAccountRelationshipContact(accountRelationshipKey, payload),
            this.deleteManyAccountRelationshipContact(accountRelationshipKey, payload),
            note: (accountRelationshipKey, payload) => 
            // TODO: Remove in Future Version if Single Delete is Obsolete
            // this.deleteAccountRelationshipNote(accountRelationshipKey, payload),
            this.deleteManyAccountRelationshipNote(accountRelationshipKey, payload),
            edi: (accountRelationshipKey, payload) => 
            // TODO: Remove in Future Version if Single Delete is Obsolete
            // this.deleteAccountRelationshipDocument(accountRelationshipKey, payload),
            this.deleteManyAccountRelationshipDocument(accountRelationshipKey, payload),
        };
        this.search = {
            contact: (accountRelationshipKey, payload) => this.searchContact(accountRelationshipKey, payload),
            note: (accountRelationshipKey, payload) => this.searchNote(accountRelationshipKey, payload),
            locations: (accountRelationshipKey, payload) => this.searchLocation(accountRelationshipKey, payload),
            edi: (accountRelationshipKey, payload) => this.searchDocument(accountRelationshipKey, payload),
        };
    }
    getAccountRelationships(relationshipType) {
        this.baseApiService.set(`${this.baseUri}/${relationshipType}`);
        return this.baseApiService.get().pipe(map((accountRelationshipResponse) => accountRelationshipResponse.accountRelationshipResponse.map((accountRelationship) => {
            return Object.assign(Object.assign({}, accountRelationship), { details: accountRelationship
                    ? accountRelationship.details[0]
                    : {} });
        })));
    }
    getAccountRelationship(relationshipType, key) {
        this.baseApiService.set(`${this.baseUri}/${relationshipType}/${key}`);
        return this.baseApiService.get().pipe(map((accountRelationship) => {
            return Object.assign(Object.assign({}, accountRelationship.accountRelationship), { details: accountRelationship.accountRelationship.details[0] || {}, tags: this.tagsToCategoryRegion(accountRelationship.accountRelationship.tags || []), contacts: accountRelationship.accountRelationship.contacts
                    ? accountRelationship.accountRelationship.contacts.map((contact) => {
                        return Object.assign(Object.assign({}, contact), { phone: [
                                ...((contact === null || contact === void 0 ? void 0 : contact.phone) || [
                                    {
                                        contactPhoneKey: 0,
                                        description: '',
                                        phoneNumber: '',
                                        phoneTypeKey: 0,
                                        phoneCountryCode: 'CA',
                                    },
                                ]),
                            ] });
                    })
                    : [], bankingInfo: accountRelationship.accountRelationship.bankingInfo
                    ? accountRelationship.accountRelationship.bankingInfo
                    : [], locations: accountRelationship.accountRelationship.locations
                    ? accountRelationship.accountRelationship.locations
                    : [], notes: accountRelationship.accountRelationship.notes
                    ? accountRelationship.accountRelationship.notes
                    : [], documents: accountRelationship.accountRelationship.documents
                    ? accountRelationship.accountRelationship.documents
                    : [] });
        }));
    }
    getMarketplace() {
        this.baseApiService.set(`${this.baseUri}/marketplace`);
        return this.baseApiService.get().pipe(map((marketplace) => {
            return Object.assign(Object.assign({}, marketplace.accountRelationship), { details: marketplace.accountRelationship.details[0] || {}, contacts: marketplace.accountRelationship.contacts
                    ? marketplace.accountRelationship.contacts.map((contact) => {
                        return Object.assign(Object.assign({}, contact), { phone: [
                                ...(contact.phone || [
                                    {
                                        contactPhoneKey: null,
                                        description: null,
                                        phoneNumber: '',
                                        phoneTypeKey: 0,
                                    },
                                ]),
                            ] });
                    })
                    : [] });
        }));
    }
    tagsToCategoryRegion(tags) {
        const defaultSelectItem = { label: '', value: '' };
        if (tags === undefined || tags === null) {
            return defaultSelectItem;
        }
        const category = tags.find((obj) => obj.context === 'Category');
        const region = tags.find((obj) => obj.context === 'Region');
        return {
            category: category
                ? { label: category.name, value: category.tagKey }
                : defaultSelectItem,
            region: region
                ? { label: region.name, value: region.tagKey }
                : defaultSelectItem,
        };
    }
    deleteAccountRelationship(key) {
        this.baseApiService.set(`${this.baseUri}/${key}`);
        return this.baseApiService.delete();
    }
    updateAccountRelationshipDetails(accountRelationshipKey, details) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}`);
        return this.baseApiService.put(details);
    }
    searchDetails(relationshipType, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${relationshipType}/search`);
        return this.baseApiService.post(searchFilter);
    }
    addAccountRelationshipContact(accountRelationshipKey, contact) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts`);
        return this.baseApiService.post(contact);
    }
    updateAccountRelationshipContact(accountRelationshipKey, contactKey, contact) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts/${contactKey}`);
        return this.baseApiService.put(contact);
    }
    deleteManyAccountRelationshipContact(accountRelationshipKey, contactKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts`);
        const contactKeys = JSON.parse(contactKeysString);
        return this.baseApiService.deleteMany(contactKeys);
    }
    // TODO: Delete in Future Version if Single Delete is Obsolete
    deleteAccountRelationshipContact(accountRelationshipKey, contactKey) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts/${contactKey}`);
        return this.baseApiService.delete();
    }
    searchContact(accountRelationshipKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts/search`);
        return this.baseApiService.post(searchFilter);
    }
    searchLocation(accountRelationshipKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/locations/search`);
        return this.baseApiService.post(searchFilter);
    }
    deleteAccountRelationshipContactPhone(accountRelationshipKey, contactPhoneKey) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/contacts/phone/${contactPhoneKey}`);
        return this.baseApiService.delete();
    }
    addAccountRelationshipBankingInfo(accountRelationshipKey, bankingInfo) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/bankingInfo`);
        return this.baseApiService.post(bankingInfo);
    }
    updateAccountRelationshipBankingInfo(accountRelationshipKey, accountBankingInfoKey, bankingInfo) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/bankingInfo/${accountBankingInfoKey}`);
        return this.baseApiService.post(bankingInfo);
    }
    deleteAccountRelationshipBankingInfo(accountRelationshipKey, bankingInfoKey) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/bankingInfo/${bankingInfoKey}`);
        return this.baseApiService.delete();
    }
    addAccountRelationshipNote(accountRelationshipKey, note) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/notes`);
        return this.baseApiService.post(note);
    }
    updateAccountRelationshipNote(accountRelationshipKey, accountRelationshipNoteKey, note) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/notes/${accountRelationshipNoteKey}`);
        return this.baseApiService.put(note);
    }
    deleteManyAccountRelationshipNote(accountRelationshipKey, accountRelationshipNoteKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/notes`);
        const accountRelationshipNoteKeys = JSON.parse(accountRelationshipNoteKeysString);
        return this.baseApiService.deleteMany(accountRelationshipNoteKeys);
    }
    // TODO: Delete in Future Version if Single Delete is Obsolete
    deleteAccountRelationshipNote(accountRelationshipKey, accountRelationshipNoteKey) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/notes/${accountRelationshipNoteKey}`);
        return this.baseApiService.delete();
    }
    addAccountRelationshipDocument(accountRelationshipKey, payload) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/documents`);
        return this.baseApiService.post(payload);
    }
    updateAccountRelationshipDocument(accountRelationshipKey, accountRelationshipDocumentKey, payload) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/documents/${accountRelationshipDocumentKey}`);
        return this.baseApiService.put(payload);
    }
    searchDocument(accountRelationshipKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/documents/search`);
        return this.baseApiService.post(searchFilter);
    }
    deleteManyAccountRelationshipDocument(accountRelationshipKey, accountRelationshipDocumentKeysString) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/documents`);
        const accountRelationshipDocumentKeys = JSON.parse(accountRelationshipDocumentKeysString);
        return this.baseApiService.deleteMany(accountRelationshipDocumentKeys);
    }
    // TODO: Delete in Future Version if Single Delete is Obsolete
    deleteAccountRelationshipDocument(accountRelationshipKey, accountRelationshipDocumentKey) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/documents/${accountRelationshipDocumentKey}`);
        return this.baseApiService.delete();
    }
    getSearchFilters(accountRelationship) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationship}/SearchFilters`);
        return this.baseApiService.get().pipe(map((response) => {
            return response.searchFilterResponse
                ? this.validatedFilterList(response.searchFilterResponse[0])
                : { countries: [], regions: [], categories: [] };
        }));
    }
    validatedFilterList(filters) {
        return {
            countries: filters.countries ? filters.countries : [],
            regions: filters.regions ? filters.regions : [],
            categories: filters.categories ? filters.categories : [],
        };
    }
    searchNote(accountRelationshipKey, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${accountRelationshipKey}/notes/search`);
        return this.baseApiService.post(searchFilter);
    }
    getUserDateFormat() {
        let resp;
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            resp = {
                format: user.userInfo.DateTypeFormat,
                description: user.userInfo.DateTypeDescription,
                primeNgFormat: user.userInfo.PrimeNGDateTypeFormat,
            };
        }))
            .subscribe());
        return resp;
    }
    isEmptyObject(obj) {
        return JSON.stringify(obj) === '{}';
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
AccountRelationshipService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: MarketplacePartnersService },
    { type: Store }
];
AccountRelationshipService.ɵprov = ɵɵdefineInjectable({ factory: function AccountRelationshipService_Factory() { return new AccountRelationshipService(ɵɵinject(BaseAPIService), ɵɵinject(MarketplacePartnersService), ɵɵinject(Store)); }, token: AccountRelationshipService, providedIn: "root" });
AccountRelationshipService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AccountRelationshipService);

let GroupBus = class GroupBus {
    constructor() {
        this.defaultValues = {
            master: false,
            details: false,
            contact: false,
            contactPhone: false,
            bankingInfo: false,
            edi: false,
            locations: false,
            note: false,
        };
        this.createSubject = new Subject();
        this.updateSubject = new Subject();
        this.deleteSubject = new Subject();
        this.actionResultSubject = new Subject();
        this.searchSubject = new Subject();
        this.fetchingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.updatingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.create$ = this.createSubject.asObservable();
        this.update$ = this.updateSubject.asObservable();
        this.delete$ = this.deleteSubject.asObservable();
        this.actionResult$ = this.actionResultSubject.asObservable();
        this.search$ = this.searchSubject.asObservable();
        this.fetching$ = this.fetchingBehaviorSubject.asObservable();
        this.updating$ = this.updatingBehaviorSubject.asObservable();
    }
    fetching(name, value) {
        const currentValue = this.fetchingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.fetchingBehaviorSubject.next(newValue);
    }
    updating(name, value) {
        const currentValue = this.updatingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.updatingBehaviorSubject.next(newValue);
    }
    publish(event) {
        const { eventType } = event, update = __rest(event, ["eventType"]);
        switch (eventType) {
            case 'create':
                this.createSubject.next(update);
                break;
            case 'update':
                this.updateSubject.next(update);
                break;
            case 'delete':
                this.deleteSubject.next(update);
                break;
            case 'actionResult':
                this.actionResultSubject.next(update);
                break;
            case 'search':
                this.searchSubject.next(update);
                break;
            case 'setFetching':
                this.fetching(event.payload.form, event.payload.value);
                break;
            case 'setUpdating':
                this.updating(update.payload.form, update.payload.value);
                break;
        }
    }
};
GroupBus.ɵprov = ɵɵdefineInjectable({ factory: function GroupBus_Factory() { return new GroupBus(); }, token: GroupBus, providedIn: "root" });
GroupBus = __decorate([
    Injectable({
        providedIn: 'root',
    })
], GroupBus);

let FormsContainerComponent = class FormsContainerComponent {
    constructor(route, accountRelationship, groupBus, transloco, spinner, toast) {
        this.route = route;
        this.accountRelationship = accountRelationship;
        this.groupBus = groupBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.route.params.subscribe((params) => {
            this.accountRelationshipKey = `${params.id}`;
            this.fetchGroup(this.accountRelationshipKey);
        }));
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ master }) => {
            return master;
        }));
        this.updating$ = this.groupBus.updating$.pipe(map((forms) => Object.values(forms).reduce((updating, form) => {
            return form || updating;
        }, false)));
        this.subscriptions.push(this.groupBus.update$.subscribe((args) => this.update(args)));
        this.subscriptions.push(this.groupBus.create$.subscribe((args) => this.create(args)));
        this.subscriptions.push(this.groupBus.delete$.subscribe((args) => this.delete(args)));
        this.subscriptions.push(this.groupBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    create({ type, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.accountRelationship.creates[type](this.accountRelationshipKey, payload)
            .pipe(tap(() => {
            this.fetchGroup(this.accountRelationshipKey);
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    delete({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'contactPhone'
            ? this.subscriptions.push(this.accountRelationship
                .deleteAccountRelationshipContactPhone(`${this.accountRelationshipKey}`, `${payload.contactPhoneKey}`)
                .pipe(tap(() => this.fetchGroup(this.accountRelationshipKey)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                .subscribe())
            : this.subscriptions.push(this.accountRelationship.deletes[type](this.accountRelationshipKey, typeKey)
                .pipe(tap(() => {
                this.fetchGroup(this.accountRelationshipKey);
                this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
                this.spinner.off();
                this.setUpdating(type, false);
            }))
                .subscribe());
    }
    fetchGroup(accountRelationshipKey) {
        this.spinner.on();
        this.subscriptions.push(this.accountRelationship
            .getAccountRelationship('marketplace', accountRelationshipKey)
            .pipe(tap((group) => {
            this.group = group;
            this.setFetching('master', true);
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.setFetching('master', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    search({ type, payload }) {
        this.setFetching(type, true);
        this.subscriptions.push(this.accountRelationship.search[type](this.accountRelationshipKey, payload)
            .pipe(tap((data) => {
            this.groupBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    result: true,
                    data,
                },
            });
        }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
            .subscribe());
    }
    update({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.accountRelationship.updates[type](this.accountRelationshipKey, typeKey, payload)
            .pipe(tap(() => {
            this.fetchGroup(this.accountRelationshipKey);
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    setFetching(form, value) {
        this.groupBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    setUpdating(form, value) {
        this.groupBus.publish({
            eventType: 'setUpdating',
            payload: { form, value },
        });
    }
};
FormsContainerComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AccountRelationshipService },
    { type: GroupBus },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService }
];
FormsContainerComponent = __decorate([
    Component({
        selector: 'lib-forms-container',
        template: ` <lib-forms
    [group]="group"
    [fetching]="fetching$ | async"
    [updating]="updating$ | async"
  ></lib-forms>`
    })
], FormsContainerComponent);

let GroupComponent = class GroupComponent {
    constructor() { }
    ngOnInit() { }
};
GroupComponent = __decorate([
    Component({
        selector: 'lib-group',
        template: `<router-outlet></router-outlet>`
    })
], GroupComponent);

let MarketplaceSetupService = class MarketplaceSetupService {
    constructor() {
        this.activeIndex = 0;
        this.redirectUrl = '/MarketplacePartnersModule/my_marketplace';
    }
    reset() {
        // empty
    }
};
MarketplaceSetupService.ɵprov = ɵɵdefineInjectable({ factory: function MarketplaceSetupService_Factory() { return new MarketplaceSetupService(); }, token: MarketplaceSetupService, providedIn: "root" });
MarketplaceSetupService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MarketplaceSetupService);

let MarketplaceSetupEditComponent = class MarketplaceSetupEditComponent {
    constructor(mpSetupService, router, confirmationService, translocoService, toast) {
        this.mpSetupService = mpSetupService;
        this.router = router;
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.templateTypes = TemplateTypes;
        this.wizardConfig = mpSetupService.wizardConfig;
        this.baseUrl = mpSetupService.baseUrl;
    }
    closeEditDialog() {
        this.confirmationService.confirm({
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.router.navigate([this.mpSetupService.redirectUrl]);
            },
            reject: () => { },
        });
    }
    submitEditMarketplace(event) {
        this.toast.successNotify(this.translocoService.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        this.router.navigate([this.mpSetupService.redirectUrl]);
    }
};
MarketplaceSetupEditComponent.ctorParameters = () => [
    { type: MarketplaceSetupService },
    { type: Router },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: ToastrNotificationService }
];
MarketplaceSetupEditComponent = __decorate([
    Component({
        selector: 'lib-marketplace-setup-edit',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (submit)=\"submitEditMarketplace($event)\"\r\n  (cancel)=\"closeEditDialog()\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n    <div>\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"closeEditDialog()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], MarketplaceSetupEditComponent);

let ViewMarketplaceContainerComponent = class ViewMarketplaceContainerComponent {
    constructor(account, accountRelationship, groupBus, transloco, spinner, toast, store) {
        this.account = account;
        this.accountRelationship = accountRelationship;
        this.groupBus = groupBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.store = store;
        this.subscriptions = [];
        this.marketplaceKey = '';
    }
    ngOnInit() {
        this.fetchMarketplace();
        this.subscriptions.push(this.store
            .pipe(select(selectors.marketplaces), tap((marketplaces) => {
            this.marketplaceKey = marketplaces.marketplace;
        }))
            .subscribe());
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ master }) => master));
        this.subscriptions.push(this.groupBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    search({ type, payload }) {
        this.setFetching(type, true);
        this.subscriptions.push(this.account.search[type](this.marketplaceKey, payload)
            .pipe(tap((data) => {
            this.groupBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    result: true,
                    data,
                },
            });
        }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
            .subscribe());
    }
    fetchMarketplace() {
        this.spinner.on();
        this.setFetching('master', true);
        this.subscriptions.push(this.accountRelationship
            .getMarketplace()
            .pipe(tap((myMarketplace) => {
            this.myMarketplace = myMarketplace;
        }), finalize(() => {
            this.spinner.off();
            this.setFetching('master', false);
        }), catchError(() => {
            this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE'));
            return of();
        }))
            .subscribe());
    }
    setFetching(form, value) {
        this.groupBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
};
ViewMarketplaceContainerComponent.ctorParameters = () => [
    { type: AccountService },
    { type: AccountRelationshipService },
    { type: GroupBus },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: Store }
];
ViewMarketplaceContainerComponent = __decorate([
    Component({
        selector: 'lib-view-marketplace-container',
        template: ` <lib-view-groups
    [myMarketplace]="myMarketplace"
    [fetching]="fetching$ | async"
    (refreshMarketplace)="fetchMarketplace()"
  >
  </lib-view-groups>`
    })
], ViewMarketplaceContainerComponent);

const ɵ0$1 = { breadcrumb: 'NAV.MY_MARKETPLACE' }, ɵ1 = { breadcrumb: 'NAV.MY_MARKETPLACE' }, ɵ2 = { breadcrumb: 'GROUP.EDIT' }, ɵ3 = { breadcrumb: 'NAV.MY_MARKETPLACE' };
const routes$1 = [
    {
        path: 'my_marketplace',
        component: GroupComponent,
        data: ɵ0$1,
        children: [
            {
                path: '',
                component: ViewMarketplaceContainerComponent,
                data: ɵ1,
            },
            {
                path: ':id/edit',
                component: FormsContainerComponent,
                data: ɵ2,
            },
            {
                path: 'marketplace-edit',
                component: MarketplaceSetupEditComponent,
                data: ɵ3,
            },
        ],
    },
];

let LocationComponent = class LocationComponent {
    constructor() { }
    ngOnInit() { }
};
LocationComponent = __decorate([
    Component({
        selector: 'lib-location',
        template: `<router-outlet></router-outlet>`
    })
], LocationComponent);

let NewLocationComponent = class NewLocationComponent {
    constructor(route) {
        this.route = route;
    }
    ngOnInit() {
        this.location$ = this.route.paramMap.pipe(map(() => {
            const { location } = window.history.state;
            return location || {};
        }));
    }
};
NewLocationComponent.ctorParameters = () => [
    { type: ActivatedRoute }
];
NewLocationComponent = __decorate([
    Component({
        selector: 'lib-new-location',
        template: "<div class=\"container-fluid\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-8 col-sm-offset-2\">\r\n      <h2 class=\"lbmx-h2\">{{ 'LOCATION.NEW' | transloco }}</h2>\r\n      <lib-location-form [location]=\"location$ | async\"></lib-location-form>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], NewLocationComponent);

const locations = [
    {
        lbmxId: 5508,
        locationKey: 710,
        locationName: 'Skipstorm',
        country: 'CAN',
        address: '1636 Sunbrook Place',
        city: 'Canmore',
        province: 'AB',
        postalCode: 'T1W',
        phoneNumber: '631-173-1697',
        faxNumber: '816-547-0639',
        locationWebsite: 'http://oxzlx.com',
        contactFirstName: 'Goldina',
        contactLastName: 'Tosh',
        contactTitle: 'Ms',
        contactPhoneNumber: '546-331-7449',
        contactEmailAddress: 'gtosh0@sfgate.com',
    },
];

let LocationService = class LocationService {
    constructor() { }
    getLocation(index) {
        const result = locations.filter((location) => location.locationKey === parseInt(index, 10));
        return result[0];
    }
    getLocationByName(name) {
        const searchTerm = new RegExp(`${name}`, 'i');
        return of(locations.filter((location) => searchTerm.test(location.locationName)));
    }
    search(term) {
        const terms = term.split(/\s/).filter((t) => t !== '');
        const tokens = terms.map((t) => t.match(/(\w*):(\w*)/).slice(-2));
        return locations.filter((location) => this.matches(location, tokens));
    }
    matches(item, tokens) {
        return tokens.reduce((prev, [field, value]) => {
            const regEx = new RegExp(`${value}`, 'i');
            return prev && regEx.test(item[field]);
        }, true);
    }
};
LocationService.ɵprov = ɵɵdefineInjectable({ factory: function LocationService_Factory() { return new LocationService(); }, token: LocationService, providedIn: "root" });
LocationService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], LocationService);

let UpdateLocationComponent = class UpdateLocationComponent {
    constructor(route, locationService) {
        this.route = route;
        this.locationService = locationService;
        this.location = {};
        this.subscriptions = [];
        this.activateLocationForm = true;
        this.activateAttributesForm = false;
    }
    ngOnInit() {
        this.subscriptions.push(this.route.params.subscribe((params) => {
            this.paramsChanged(params.id);
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    paramsChanged(id) {
        this.location = this.locationService.getLocation(id);
    }
};
UpdateLocationComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: LocationService }
];
UpdateLocationComponent = __decorate([
    Component({
        selector: 'lib-update-location',
        template: "<div class=\"container-fluid\">\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-8 col-sm-offset-2\">\r\n      <h2 class=\"lbmx-h2\">{{ 'LOCATION.LOCATION' | transloco }}</h2>\r\n      <lib-location-form [location]=\"location\"></lib-location-form>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], UpdateLocationComponent);

let ViewLocationsComponent = class ViewLocationsComponent {
    constructor(formBuilder, locationService, confirmationService, router, route) {
        this.formBuilder = formBuilder;
        this.locationService = locationService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.route = route;
        this.name = 'ViewLocations'; // should be changed to input in component
        this.subscriptions = [];
        this.rowsPerPageArray = [25, 50, 100]; // override with input?
        this.editUrlSegment = '/edit';
        this.showAdvancedSearchFilter = false;
        this.visible = true;
        this.copyDisabled = true;
        this.deleteDisabled = true;
        this.editDisabled = true;
    }
    ngOnInit() {
        this.stateKey = `${this.router.url.replace(/[/]/g, '_')}_${this.name}`;
        this.columnsToDisplay = [
            { field: 'locationName', header: 'Location Name' },
            { field: 'address', header: 'Address' },
            { field: 'city', header: 'City' },
            { field: 'country', header: 'Country' },
            { field: 'province', header: 'Province' },
            { field: 'postalCode', header: 'Postal Code' },
            { field: 'phoneNumber', header: 'Phone' },
        ];
        this.selectedColumns = this.setSelectedColumns();
        this.searchForm = this.formBuilder.group({
            searchText: '',
        });
        this.selectedColumnsForm = this.formBuilder.group({
            selected: [this.selectedColumns],
        });
        this.subscriptions.push(this.selectedColumnsForm.valueChanges.subscribe(({ selected }) => {
            this.handleColumnsChanged(selected);
        }));
        this.search({});
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    clear() {
        this.data$ = of([]);
        this.searchForm.reset({
            searchText: '',
        });
    }
    deleteLocations(locations) {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => { },
            reject: () => { },
        });
    }
    getDataFromLocalStorage() {
        return JSON.parse(localStorage.getItem(this.stateKey));
    }
    handleColumnsChanged(columns) {
        this.selectedColumns = columns;
    }
    handleSelection({ data }) {
        if (data.length === 1) {
            this.locationEditURlSegment = `${data[0].locationKey}/${this.editUrlSegment}`;
        }
        this.copyDisabled = this.editDisabled = data.length !== 1;
        this.deleteDisabled = data.length === 0;
    }
    onToolbarClick({ command, selection }) {
        const [firstSelection] = selection;
        switch (command) {
            case 'new':
                this.router.navigate(['new'], { relativeTo: this.route });
                break;
            case 'copy':
                this.router.navigate(['new'], {
                    relativeTo: this.route,
                    state: { location: firstSelection },
                });
                break;
            case 'edit':
                this.router.navigate([`${firstSelection.locationKey}/edit`], {
                    relativeTo: this.route,
                });
                break;
            case 'delete':
                this.deleteLocations(selection);
                break;
            case 'export':
                // handle export
                break;
            default:
                break;
        }
    }
    resetGridSettingsToDefault() {
        localStorage.removeItem(this.stateKey);
        this.selectedColumns = this.setSelectedColumns();
        this.selectedColumnsForm.reset({ selected: this.selectedColumns });
        this.visible = false;
        setTimeout(() => (this.visible = true), 0);
        this.handleSelection({ data: [] });
    }
    search($event) {
        this.data$ = this.locationService.getLocationByName($event.key || '');
    }
    setSelectedColumns() {
        const gridStateFromLocalstorage = this.getDataFromLocalStorage();
        return this.columnsToDisplay.filter((item) => !!gridStateFromLocalstorage
            ? gridStateFromLocalstorage.columnOrder
                ? gridStateFromLocalstorage.columnOrder.includes(item.field)
                : true
            : true);
    }
    toggleAdvancedSearch() {
        this.showAdvancedSearchFilter = !this.showAdvancedSearchFilter;
    }
};
ViewLocationsComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: LocationService },
    { type: ConfirmationService$1 },
    { type: Router },
    { type: ActivatedRoute }
];
ViewLocationsComponent = __decorate([
    Component({
        selector: 'lib-view-locations',
        template: "<div class=\"row searchHeaderTitle\">\r\n  <div class=\"col-sm-12\">\r\n    <!-- Header placeholder -->\r\n    <div class=\"row\">\r\n      <h2>{{ 'LOCATION.LOCATION' | transloco }}</h2>\r\n    </div>\r\n    <!-- End of Header placeholder -->\r\n\r\n    <lib-search-container\r\n      endPoint=\"locations\"\r\n      i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n      idColumn=\"locationKey\"\r\n      name=\"locationsSearch\"\r\n      searchProperty=\"key\"\r\n      [columns]=\"columnsToDisplay\"\r\n      [results]=\"data$\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n    >\r\n      <lib-advanced-search libSearch> </lib-advanced-search>\r\n    </lib-search-container>\r\n    <p-confirmDialog\r\n      [closeOnEscape]=\"false\"\r\n      [closable]=\"false\"\r\n    ></p-confirmDialog>\r\n  </div>\r\n</div>\r\nAdvanced Search/Search Toolbar/GRID container\r\n",
        styles: [""]
    })
], ViewLocationsComponent);

const ɵ0$2 = { breadcrumb: 'Location' };
const routes$2 = [
    {
        path: 'location',
        component: LocationComponent,
        data: ɵ0$2,
        children: [
            {
                path: '',
                component: ViewLocationsComponent,
            },
            {
                path: 'new',
                component: NewLocationComponent,
            },
            {
                path: ':id/edit',
                component: UpdateLocationComponent,
            },
        ],
    },
];

let MemberCrossReferencesComponent = class MemberCrossReferencesComponent {
    constructor() { }
    ngOnInit() { }
};
MemberCrossReferencesComponent = __decorate([
    Component({
        selector: 'lib-member-cross-references',
        template: `<router-outlet></router-outlet>`
    })
], MemberCrossReferencesComponent);

let CrossReferenceService = class CrossReferenceService {
    constructor(baseApiService, mpp, http) {
        this.baseApiService = baseApiService;
        this.mpp = mpp;
        this.http = http;
        this.subscriptions = [];
        this.baseUri = this.mpp.getConfig().getAccountRelationshipEndpoint;
        this.defaults = { withCredentials: true };
    }
    update(relationshipType, request) {
        this.baseApiService.set(`${this.baseUri}/${relationshipType}/CrossReference`);
        return this.baseApiService.post(request);
    }
    search(relationshipType, searchFilter) {
        this.baseApiService.set(`${this.baseUri}/${relationshipType}/CrossReference/search`);
        return this.baseApiService.post(searchFilter);
    }
    export(relationshipType, exportData) {
        return this.post(urlJoin(this.baseUri, relationshipType, 'CrossReference', 'export'), exportData, {
            responseType: 'blob',
        });
    }
    import(relationshipType, file, email) {
        const formData = new FormData();
        formData.append('fileName', file);
        return this.post(urlJoin(this.mpp.getConfig().getDocumentServerEndpoint, this.buildFileUploadRequest(file)), formData).pipe(mergeMap((uploadedFile) => this.post(urlJoin(`${this.mpp.getConfig().account}/marketplace/${relationshipType}/crossReference/import`), {
            email,
            originalFileName: file === null || file === void 0 ? void 0 : file.name,
            importFile: uploadedFile[0].guid,
        })));
    }
    buildFileUploadRequest(file) {
        const extension = file.name.split('.').pop().toLocaleLowerCase();
        let fileType = 0;
        let delimiter = null;
        const headerLines = 1;
        switch (extension) {
            // We do not support xls file format
            case 'xls':
                fileType = 1;
                break;
            case 'xlsx':
                fileType = 2;
                delimiter = '';
                break;
            case 'csv':
                fileType = 3;
                delimiter = ',';
                break;
            default:
                fileType = 2;
                delimiter = '';
                break;
        }
        return `?FileType=${fileType}&Delimiter=${delimiter}&HeaderLines=${headerLines}`;
    }
    // http methods
    post(url, body, options) {
        return this.http.post(url, body, Object.assign(Object.assign({}, this.defaults), options));
    }
};
CrossReferenceService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: MarketplacePartnersService },
    { type: HttpClient }
];
CrossReferenceService.ɵprov = ɵɵdefineInjectable({ factory: function CrossReferenceService_Factory() { return new CrossReferenceService(ɵɵinject(BaseAPIService), ɵɵinject(MarketplacePartnersService), ɵɵinject(HttpClient)); }, token: CrossReferenceService, providedIn: "root" });
CrossReferenceService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], CrossReferenceService);

var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
let BaseHttpService = class BaseHttpService {
    constructor(http) {
        this.http = http;
        this._baseUrl = '';
    }
    set baseUrl(baseUrl) {
        this._baseUrl = baseUrl;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    fetchWithFqn({ endpoint, httpMethod, body, responseField, }) {
        return this.buildRequest(endpoint, httpMethod, body).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    fetch({ endpoint, httpMethod, body, responseField, options, }) {
        return this.buildRequest(urlJoin(this._baseUrl, endpoint), httpMethod, body, options).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    buildRequest(endpoint, httpMethod, body, options) {
        switch (httpMethod) {
            case HttpMethod.GET:
                return this.http.get(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.POST:
                return this.http.post(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.PUT:
                return this.http.put(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.DELETE:
                return this.http.delete(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
        }
    }
};
BaseHttpService.ctorParameters = () => [
    { type: HttpClient }
];
BaseHttpService.ɵprov = ɵɵdefineInjectable({ factory: function BaseHttpService_Factory() { return new BaseHttpService(ɵɵinject(HttpClient)); }, token: BaseHttpService, providedIn: "root" });
BaseHttpService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], BaseHttpService);

let ViewMembersCrossReferencesComponent = class ViewMembersCrossReferencesComponent {
    constructor(crossReferenceService, http, translocoService, toast, spinner, store, searchContainerLoaderService, mppService) {
        this.crossReferenceService = crossReferenceService;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.store = store;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        // search container loader states
        this.searchContainerName = 'membersCrossReferencesSearch';
        this.i18nSearchField = 'PARTNERS.MEMBER_CROSS_REFERENCE_SEARCH';
        this.showApplyPaymentDialog = false;
        this.toolbarActionsDispatcher = {
            view: (selection) => {
                this.showViewDialog = true;
                this.data = selection[0];
            },
            edit: (selection) => {
                this.showEditDialog = true;
                this.data = selection[0];
            },
            import: (selection) => {
                this.showImportDialog = true;
            },
            export: (selection) => {
                this.showExportDialog = true;
                this.selectedAccountKeys = this.getAccountLocationKeys(selection);
            },
            applyPaymentPreference: (selection) => {
                this.selections = selection;
                this.showApplyPaymentDialog = true;
                this.selections = selection;
            },
            wizardExport: (selection) => {
                this.showWizardExport = true;
                this.wizardExport = {
                    endpoint: `v2/account/ui/member/cross-reference/export`,
                    httpMethod: HttpMethod$1.POST,
                };
            },
            wizardImport: (selection) => {
                this.showWizardImport = true;
                this.wizardImport = {
                    endpoint: `v2/account/ui/member/cross-reference/import`,
                    httpMethod: HttpMethod$1.POST,
                };
            },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/marketplace/member/location`;
        this.wizardUrl = `${this.mppService.getConfig().apiBaseUrl}`;
        this.columnActions = {
            legalName: {
                link: () => ({ path: './' }),
                event: (crossReference) => crossReference,
            },
            dbaName: {
                link: () => ({ path: './' }),
                event: (crossReference) => crossReference,
            },
        };
        this.subscriptions = [];
        this.showEditDialog = false;
        this.showViewDialog = false;
        this.showExportDialog = false;
        this.showImportDialog = false;
        // wizard import states
        this.showWizardImport = false;
        // wizard export states
        this.showWizardExport = false;
        this.templateTypes = TemplateTypes;
        http.baseUrl = mppService.getConfig().account;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.email = user.sub;
        }))
            .subscribe());
        this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(tap((translate) => (this.translate = translate)))
            .subscribe();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    closeEdit() {
        this.showEditDialog = false;
    }
    closeView() {
        this.showViewDialog = false;
    }
    closeExport() {
        this.showExportDialog = false;
    }
    closeImport() {
        this.showImportDialog = false;
        this.searchContainerLoaderService.refreshSearch();
    }
    saveEdit(data) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `marketplace/member/location`,
            httpMethod: 'POST',
            body: data,
        })
            .pipe(tap(() => {
            this.showEditDialog = false;
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError((error) => {
            var _a, _b;
            this.showEditDialog = false;
            return ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.errorCode) === 3
                ? of(this.toast.errorNotify((_b = error === null || error === void 0 ? void 0 : error.error) === null || _b === void 0 ? void 0 : _b.errorMessage))
                : of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe();
    }
    saveExport(data) {
        this.showExportDialog = false;
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        let exportData = Object.assign(Object.assign({}, data), { email: this.email, filter: {
                offset: pagination === null || pagination === void 0 ? void 0 : pagination.first,
                limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows,
                filters: [],
                sort: [
                    {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        dir: (pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder) === 1 ? 'asc' : 'desc',
                    },
                ],
                term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
            } });
        switch (data.exportDataOption) {
            case 3:
                exportData = Object.assign(Object.assign({}, exportData), { keys: this.selectedAccountKeys });
                break;
            case 2:
                exportData = Object.assign(Object.assign({}, exportData), { keys: this.currentPageAccountKeys });
                break;
            case 1:
            default:
                break;
        }
        this.spinner.on();
        this.crossReferenceService
            .export('member', exportData)
            .pipe(catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe((response) => saveAs(response, `${data.fileName}`));
    }
    saveImport(data) {
        this.showImportDialog = false;
    }
    closeDialog(name) {
        this.showImportDialog = false;
    }
    getAccountLocationKeys(accounts) {
        let keys = [];
        try {
            accounts.map((account) => (keys = [...keys, account.accountLocationKey]));
            return keys;
        }
        catch (_a) {
            return keys;
        }
    }
    closeApplyPaymentDialog() {
        this.showApplyPaymentDialog = false;
    }
    saveApplyPayment(applyPayment) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `marketplace/member/location/apply-payment`,
            httpMethod: 'POST',
            body: {
                keys: [...this.selections].map((_a) => {
                    var { accountLocationKey } = _a, _ = __rest(_a, ["accountLocationKey"]);
                    return accountLocationKey;
                }),
                optionType: Number(applyPayment === null || applyPayment === void 0 ? void 0 : applyPayment.options),
                paymentPreferenceTypeKey: applyPayment === null || applyPayment === void 0 ? void 0 : applyPayment.paymentPreference,
                search: {
                    page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows },
                    sort: {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                    },
                    search: { filters: {}, term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '' },
                },
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => {
            this.showApplyPaymentDialog = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openView(crossReference) {
        this.showViewDialog = true;
        this.data = crossReference;
    }
    closeExportWizard() {
        this.showWizardExport = false;
    }
    submitExportWizard(event) {
        this.showWizardExport = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeImportWizard() {
        this.showWizardImport = false;
    }
    submitImportWizard(event) {
        this.showWizardImport = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
};
ViewMembersCrossReferencesComponent.ctorParameters = () => [
    { type: CrossReferenceService },
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Store },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService }
];
ViewMembersCrossReferencesComponent = __decorate([
    Component({
        selector: 'lib-view-members-cross-references',
        template: "<div style=\"display: flex; flex-direction: column; row-gap: 2em\">\r\n  <h2>{{ 'SUPPLIER.MEMBER_CROSS_REFERENCE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    (field)=\"openView($event)\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showEditDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-edit\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeEditDialog)=\"closeEdit()\"\r\n      (saveEditDialog)=\"saveEdit($event)\"\r\n    ></lib-edit>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showViewDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-view\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      (closeViewDialog)=\"closeView()\"\r\n    ></lib-view>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showExportDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-export-container\r\n      [translate]=\"translate\"\r\n      [itemSelected]=\"selectedAccountKeys.length > 0\"\r\n      (closeExportDialog)=\"closeExport()\"\r\n      (saveExportDialog)=\"saveExport($event)\"\r\n    ></lib-export-container>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showImportDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n    dismissableMask=\"true\"\r\n  >\r\n    <lib-import\r\n      [translate]=\"translate\"\r\n      (closeImportDialog)=\"closeImport()\"\r\n      (saveImportDialog)=\"saveImport($event)\"\r\n    ></lib-import>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    [(visible)]=\"showApplyPaymentDialog\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-apply-payment\r\n      *ngIf=\"showApplyPaymentDialog\"\r\n      [itemSelected]=\"selections.length > 0\"\r\n      [baseUrl]=\"baseUrl\"\r\n      (saveDialog)=\"saveApplyPayment($event)\"\r\n      (closeDialog)=\"closeApplyPaymentDialog()\"\r\n    ></lib-apply-payment>\r\n  </p-dialog>\r\n  <p-dialog\r\n    *ngIf=\"showWizardExport\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"wizardUrl\"\r\n      [wizardConfig]=\"wizardExport\"\r\n      (submit)=\"submitExportWizard($event)\"\r\n      (cancel)=\"closeExportWizard()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeExportWizard()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n  <p-dialog\r\n    *ngIf=\"showWizardImport\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"wizardUrl\"\r\n      [wizardConfig]=\"wizardImport\"\r\n      (submit)=\"submitImportWizard($event)\"\r\n      (cancel)=\"closeImportWizard()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeImportWizard()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], ViewMembersCrossReferencesComponent);

const ɵ0$3 = { breadcrumb: 'BREADCRUMB.MEMBER_CROSS_REFERENCE' }, ɵ1$1 = { breadcrumb: 'SUPPLIER.MEMBER_CROSS_REFERENCE' };
const routes$3 = [
    {
        path: 'member-cross-references',
        component: MemberCrossReferencesComponent,
        data: ɵ0$3,
        children: [
            {
                path: '',
                component: ViewMembersCrossReferencesComponent,
                data: ɵ1$1,
            },
        ],
    },
];

let MemberBus = class MemberBus {
    constructor() {
        this.defaultValues = {
            master: false,
            details: false,
            contact: false,
            contactPhone: false,
            bankingInfo: false,
            edi: false,
            locations: false,
            note: false,
        };
        this.createSubject = new Subject();
        this.updateSubject = new Subject();
        this.deleteSubject = new Subject();
        this.actionResultSubject = new Subject();
        this.searchSubject = new Subject();
        this.fetchingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.updatingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.create$ = this.createSubject.asObservable();
        this.update$ = this.updateSubject.asObservable();
        this.delete$ = this.deleteSubject.asObservable();
        this.actionResult$ = this.actionResultSubject.asObservable();
        this.search$ = this.searchSubject.asObservable();
        this.fetching$ = this.fetchingBehaviorSubject.asObservable();
        this.updating$ = this.updatingBehaviorSubject.asObservable();
    }
    fetching(name, value) {
        const currentValue = this.fetchingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.fetchingBehaviorSubject.next(newValue);
    }
    updating(name, value) {
        const currentValue = this.updatingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.updatingBehaviorSubject.next(newValue);
    }
    publish(event) {
        const { eventType } = event, update = __rest(event, ["eventType"]);
        switch (eventType) {
            case 'create':
                this.createSubject.next(update);
                break;
            case 'update':
                this.updateSubject.next(update);
                break;
            case 'delete':
                this.deleteSubject.next(update);
                break;
            case 'actionResult':
                this.actionResultSubject.next(update);
                break;
            case 'search':
                this.searchSubject.next(update);
                break;
            case 'setFetching':
                this.fetching(event.payload.form, event.payload.value);
                break;
            case 'setUpdating':
                this.updating(update.payload.form, update.payload.value);
                break;
        }
    }
};
MemberBus.ɵprov = ɵɵdefineInjectable({ factory: function MemberBus_Factory() { return new MemberBus(); }, token: MemberBus, providedIn: "root" });
MemberBus = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MemberBus);

let FormsContainerComponent$1 = class FormsContainerComponent {
    constructor(route, accountService, accountRelationship, memberBus, transloco, spinner, toast, breadcrumbSrv) {
        this.route = route;
        this.accountService = accountService;
        this.accountRelationship = accountRelationship;
        this.memberBus = memberBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.breadcrumbSrv = breadcrumbSrv;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.route.params.subscribe((params) => {
            this.accountRelationshipKey = `${params.id}`;
            this.fetchMember(this.accountRelationshipKey);
        }));
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ master }) => {
            return master;
        }));
        this.updating$ = this.memberBus.updating$.pipe(map((forms) => Object.values(forms).reduce((updating, form) => {
            return form || updating;
        }, false)));
        this.subscriptions.push(this.memberBus.update$.subscribe((args) => this.update(args)));
        this.subscriptions.push(this.memberBus.create$.subscribe((args) => this.create(args)));
        this.subscriptions.push(this.memberBus.delete$.subscribe((args) => this.delete(args)));
        this.subscriptions.push(this.memberBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    create({ type, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.accountRelationship.creates[type](this.accountRelationshipKey, payload.create)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    delete({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'contactPhone'
            ? this.subscriptions.push(this.accountRelationship
                .deleteAccountRelationshipContactPhone(`${this.accountRelationshipKey}`, `${payload.delete.contactPhoneKey}`)
                .pipe(tap(() => this.fetchMember(this.accountRelationshipKey)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                .subscribe())
            : this.subscriptions.push(this.accountRelationship.deletes[type](this.accountRelationshipKey, typeKey)
                .pipe(tap(() => {
                this.search({ type, payload: payload.search });
                this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
                this.spinner.off();
                this.setUpdating(type, false);
            }))
                .subscribe());
    }
    fetchMember(accountRelationshipKey) {
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.accountRelationship.getAccountRelationship('member', accountRelationshipKey),
            this.accountService.getAccountConfiguration(),
        ])
            .pipe(tap(([member, configuration]) => {
            this.member = member;
            this.breadcrumbSrv.set('MarketplacePartnersModule/member/:id/details', `${this.member.details.legalName
                ? this.member.details.legalName
                : ''}`);
            this.configuration = Object.entries(configuration).reduce((config, [key, value]) => {
                if ([value][0] == null) {
                    return null;
                }
                else {
                    return Object.assign(Object.assign({}, config), { [key]: value.map((v) => ({
                            value: v.tagKey,
                            label: v.name,
                        })) });
                }
            }, {});
            this.setFetching('master', true);
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.setFetching('master', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    search({ type, payload }) {
        this.setFetching(type, true);
        this.accountRelationship.search[type](this.accountRelationshipKey, payload)
            .pipe(tap((data) => {
            this.memberBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    result: true,
                    data,
                },
            });
        }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
    }
    update({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'details'
            ? this.updateDetails({ type, typeKey, payload })
            : this.updateDefault({ type, typeKey, payload });
    }
    updateDefault({ type, typeKey, payload }) {
        this.subscriptions.push(this.accountRelationship.updates[type](this.accountRelationshipKey, typeKey, payload.update)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    updateDetails({ type, typeKey, payload }) {
        this.subscriptions.push(this.accountRelationship.updates[type](this.accountRelationshipKey, typeKey, payload.update)
            .pipe(tap(() => {
            this.memberBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    error: null,
                },
            });
            this.fetchMember(this.accountRelationshipKey);
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? this.duplicateError({ type, typeKey, payload })
                : this.genericError({ type, typeKey, payload });
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    genericError({ type, typeKey, payload }) {
        this.memberBus.publish({
            eventType: 'actionResult',
            payload: {
                type,
                error: 2,
            },
        });
        return of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
    }
    duplicateError({ type, typeKey, payload }) {
        this.memberBus.publish({
            eventType: 'actionResult',
            payload: {
                type,
                error: 3,
            },
        });
        return of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')));
    }
    setFetching(form, value) {
        this.memberBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    setUpdating(form, value) {
        this.memberBus.publish({
            eventType: 'setUpdating',
            payload: { form, value },
        });
    }
};
FormsContainerComponent$1.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AccountService },
    { type: AccountRelationshipService },
    { type: MemberBus },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: BreadcrumbService }
];
FormsContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-forms-container',
        template: ` <lib-forms
    [member]="member"
    [configuration]="configuration"
    [fetching]="fetching$ | async"
    [updating]="updating$ | async"
    (resultsSubmission)="fetchMember(accountRelationshipKey)"
  ></lib-forms>`
    })
], FormsContainerComponent$1);

let MemberComponent = class MemberComponent {
    constructor() { }
    ngOnInit() { }
};
MemberComponent = __decorate([
    Component({
        selector: 'lib-member',
        template: `<router-outlet></router-outlet>`,
        providers: [MemberBus]
    })
], MemberComponent);

const searchFilters = (term = '', pagination, advancedSearch, defaultSortField = '', defaultSortOrder = 1) => {
    const page = pagination !== null && pagination !== undefined ? pagination : {};
    return {
        offset: page.first ? page.first : 0,
        limit: page.rows ? page.rows : 25,
        filters: advancedSearch,
        sort: [
            {
                field: page.sortField !== null && page.sortField !== undefined
                    ? page.sortField
                    : defaultSortField,
                dir: page.sortOrder !== null && page.sortOrder !== undefined
                    ? page.sortOrder === 1
                        ? 'asc'
                        : 'desc'
                    : defaultSortOrder === 1
                        ? 'asc'
                        : 'desc',
            },
        ],
        term,
    };
};

let ViewMembersComponent = class ViewMembersComponent {
    constructor(accountRelationship, datePipe, router, route, translocoService, store) {
        this.accountRelationship = accountRelationship;
        this.datePipe = datePipe;
        this.router = router;
        this.route = route;
        this.translocoService = translocoService;
        this.store = store;
        this.data$ = of([]);
        this.rows = 25;
        this.fetching = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.subscriptions.push(this.store.pipe(select(selectors.userProfile)).subscribe((res) => {
            var _a;
            this.dateFormat = (_a = res === null || res === void 0 ? void 0 : res.userInfo) === null || _a === void 0 ? void 0 : _a.DateTypeFormat;
        }));
        this.translateLabels();
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        const [firstSelection] = selection;
        switch (command) {
            case 'view':
                this.router.navigate([`${firstSelection.accountRelationshipKey}/details`], {
                    relativeTo: this.route,
                });
                break;
            case 'edit':
                this.router.navigate([`${firstSelection.accountRelationshipKey}/details`], {
                    relativeTo: this.route,
                });
                break;
            default:
                break;
        }
    }
    clear() {
        this.data$ = this.getPaginatedData(searchFilters('', {
            first: 0,
            rows: this.rows,
            sortField: 'LegalName',
            sortOrder: 1,
        }, this.advancedSearch));
    }
    getPaginatedData(filters) {
        this.fetching = true;
        return this.accountRelationship.searchDetails('member', filters).pipe(tap((accountRelationshipResponse) => (this.paging = Object.assign(Object.assign({}, this.paging), { records: accountRelationshipResponse.totalResults }))), map((accountRelationshipResponse) => {
            return accountRelationshipResponse.accountRelationshipDetailsResponse.map((accountRelationshipDetails) => {
                return accountRelationshipDetails;
            });
        }), finalize(() => (this.fetching = false)));
    }
    search(_a) {
        var _b = _a.filters, { term } = _b, advancedSearch = __rest(_b, ["term"]), pagination = __rest(_a, ["filters"]);
        this.rows = pagination.rows;
        this.advancedSearch = Object.values(Object.assign({}, advancedSearch));
        this.data$ = this.getPaginatedData(searchFilters(term, pagination, this.advancedSearch, 'LegalName'));
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: ({ accountRelationshipKey, }) => ({
                        path: `${accountRelationshipKey}/details`,
                    }),
                },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: ({ accountRelationshipKey, }) => ({
                        path: `${accountRelationshipKey}/details`,
                    }),
                    required: true,
                },
                {
                    field: 'activeDate',
                    header: translate.ACTIVE_DATE,
                    formatter: ({ activeDate }) => `${(activeDate === null) ? '' : this.datePipe.transform(activeDate, this.dateFormat)}`,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                { field: 'country', header: translate.COUNTRY },
                { field: 'region', header: translate.REGION },
                { field: 'province', header: translate.STATE_PROVINCE },
                { field: 'postalCode', header: translate.ZIP_POSTAL_CODE },
                { field: 'number', header: translate.MEMBER_NUMBER },
                { field: 'website', header: translate.WEBSITE },
                { field: 'category', header: translate.CATEGORY },
                { field: 'email', header: translate.EMAIL },
                { field: 'currencyType', header: translate.CURRENCY_TYPE },
                { field: 'creditLimit', header: translate.CREDIT_LIMIT },
                {
                    field: 'externalAccountNumber',
                    header: translate.EXTERNAL_ACCOUNT_NUMBER,
                },
                {
                    field: 'fax',
                    header: translate.FAX,
                },
                {
                    field: 'inactiveDate',
                    header: translate.INACTIVE_DATE,
                    formatter: ({ inactiveDate }) => `${(inactiveDate === null) ? '' : this.datePipe.transform(inactiveDate, this.dateFormat)}`,
                },
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxId',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'onHold',
                    header: translate.ON_HOLD,
                },
                {
                    field: 'phone',
                    header: translate.PHONE_NUMBER,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
            edit: toolKeys.MPP_MEMBER_MAINTENANCE,
        };
    }
};
ViewMembersComponent.ctorParameters = () => [
    { type: AccountRelationshipService },
    { type: DatePipe },
    { type: Router },
    { type: ActivatedRoute },
    { type: TranslocoService },
    { type: Store }
];
ViewMembersComponent = __decorate([
    Component({
        selector: 'lib-view-members',
        template: "<div class=\"vertical-flow space-between-200\">\r\n  <h2>{{ 'SUPPLIER.MEMBER' | transloco }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columnsAvailable\"\r\n    i18nSearchField=\"{{ 'PARTNERS.MEMBER_SEARCH' | transloco }}\"\r\n    name=\"membersSearch\"\r\n    searchProperty=\"key\"\r\n    [buttons]=\"toolbarButtons\"\r\n    [loading]=\"fetching\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"columnsToDisplay\"\r\n    [paging]=\"paging\"\r\n    [results]=\"data$\"\r\n    [searchProperty]=\"'term'\"\r\n    (clear)=\"clear()\"\r\n    (query)=\"search($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    [lazy]=\"true\"\r\n    (lazyLoad)=\"search($event)\"\r\n    [lazyLoadOnInit]=\"false\"\r\n  >\r\n    <lib-advanced-search libSearch> </lib-advanced-search>\r\n  </lib-search-container>\r\n  <p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n</div>\r\n",
        styles: [""]
    })
], ViewMembersComponent);

const ɵ0$4 = { breadcrumb: 'BREADCRUMB.MEMBER' }, ɵ1$2 = { breadcrumb: 'SUPPLIER.MEMBER' }, ɵ2$1 = { breadcrumb: 'MEMBER.EDIT' };
const routes$4 = [
    {
        path: 'member',
        component: MemberComponent,
        data: ɵ0$4,
        children: [
            {
                path: '',
                component: ViewMembersComponent,
                data: ɵ1$2,
            },
            {
                path: ':id/details',
                component: FormsContainerComponent$1,
                data: ɵ2$1,
            },
        ],
    },
];

let SupplierCrossReferencesComponent = class SupplierCrossReferencesComponent {
    constructor() { }
    ngOnInit() { }
};
SupplierCrossReferencesComponent = __decorate([
    Component({
        selector: 'lib-supplier-cross-references',
        template: `<router-outlet></router-outlet>`
    })
], SupplierCrossReferencesComponent);

let ViewSuppliersCrossReferencesComponent = class ViewSuppliersCrossReferencesComponent {
    constructor(http, translocoService, toast, spinner, store, searchContainerLoaderService, mppService) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.store = store;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        // search container loader states
        this.searchContainerName = 'suppliersCrossReferencesSearch';
        this.i18nSearchField = 'PARTNERS.SUPPLIER_CROSS_REFERENCE_SEARCH';
        this.showApplyPaymentDialog = false;
        this.toolbarActionsDispatcher = {
            edit: (selection) => {
                this.showDialog = true;
                this.data = selection[0];
            },
            wizardExport: (selection) => {
                this.showWizardExport = true;
                this.wizardExport = {
                    endpoint: `v2/account/ui/supplier/cross-reference/export`,
                    httpMethod: HttpMethod$1.POST,
                };
            },
            wizardImport: (selection) => {
                this.showWizardImport = true;
                this.wizardImport = {
                    endpoint: `v2/account/ui/supplier/cross-reference/import`,
                    httpMethod: HttpMethod$1.POST,
                };
            },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/marketplace/supplier/location`;
        this.wizardUrl = `${this.mppService.getConfig().apiBaseUrl}`;
        this.columnActions = {
            dbaName: {
                link: () => ({ path: './' }),
                event: (crossReference) => crossReference,
            },
        };
        this.subscriptions = [];
        this.showDialog = false;
        this.hasEditPermission = false;
        this.templateTypes = TemplateTypes;
        // wizard import states
        this.showWizardImport = false;
        // wizard export states
        this.showWizardExport = false;
        http.baseUrl = mppService.getConfig().account;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            const hasTools = (...tools) => user.toolKeys.find((ut) => tools.includes(ut)) !== undefined;
            this.hasEditPermission = hasTools(toolKeys.PIM_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES_EDIT, toolKeys.PDX_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES_EDIT, toolKeys.MP_SUPPLIER_CROSS_REFERENCES_EDIT);
            this.email = user.sub;
        }))
            .subscribe(), this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(tap((translate) => (this.translate = translate)))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    openView(crossReference) {
        this.showDialog = true;
        this.data = crossReference;
    }
    closeDialog() {
        this.showDialog = false;
    }
    submitEdit(data) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `marketplace/supplier/location`,
            httpMethod: 'POST',
            body: data,
        })
            .pipe(tap(() => {
            this.showDialog = false;
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError((error) => {
            var _a, _b;
            this.showDialog = false;
            return ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.errorCode) === 3
                ? of(this.toast.errorNotify((_b = error === null || error === void 0 ? void 0 : error.error) === null || _b === void 0 ? void 0 : _b.errorMessage))
                : of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe();
    }
    closeExportWizard() {
        this.showWizardExport = false;
    }
    submitExportWizard(event) {
        this.showWizardExport = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeImportWizard() {
        this.showWizardImport = false;
    }
    submitImportWizard(event) {
        this.showWizardImport = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
};
ViewSuppliersCrossReferencesComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Store },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService }
];
ViewSuppliersCrossReferencesComponent = __decorate([
    Component({
        selector: 'lib-view-suppliers-cross-references',
        template: "<div style=\"display: flex; flex-direction: column; row-gap: 2em\">\r\n  <h2>{{ 'SUPPLIER.SUPPLIER_CROSS_REFERENCE' | transloco }}</h2>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    (field)=\"openView($event)\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-edit\r\n      [data]=\"data\"\r\n      [translate]=\"translate\"\r\n      [isEditMode]=\"hasEditPermission\"\r\n      (closeDialog)=\"closeDialog()\"\r\n      (submitDialog)=\"submitEdit($event)\"\r\n    ></lib-edit>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showWizardExport\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"wizardUrl\"\r\n      [wizardConfig]=\"wizardExport\"\r\n      (submit)=\"submitExportWizard($event)\"\r\n      (cancel)=\"closeExportWizard()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeExportWizard()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showWizardImport\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"wizardUrl\"\r\n      [wizardConfig]=\"wizardImport\"\r\n      (submit)=\"submitImportWizard($event)\"\r\n      (cancel)=\"closeImportWizard()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeImportWizard()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], ViewSuppliersCrossReferencesComponent);

const routes$5 = [
    {
        path: 'supplier-cross-references',
        component: SupplierCrossReferencesComponent,
        children: [
            {
                path: '',
                component: ViewSuppliersCrossReferencesComponent,
            },
        ],
    },
];

let SupplierBus = class SupplierBus {
    constructor() {
        this.defaultValues = {
            master: false,
            details: false,
            contact: false,
            contactPhone: false,
            bankingInfo: false,
            edi: false,
            locations: false,
            note: false,
        };
        this.createSubject = new Subject();
        this.updateSubject = new Subject();
        this.deleteSubject = new Subject();
        this.actionResultSubject = new Subject();
        this.searchSubject = new Subject();
        this.fetchingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.updatingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.create$ = this.createSubject.asObservable();
        this.update$ = this.updateSubject.asObservable();
        this.delete$ = this.deleteSubject.asObservable();
        this.actionResult$ = this.actionResultSubject.asObservable();
        this.search$ = this.searchSubject.asObservable();
        this.fetching$ = this.fetchingBehaviorSubject.asObservable();
        this.updating$ = this.updatingBehaviorSubject.asObservable();
    }
    fetching(name, value) {
        const currentValue = this.fetchingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.fetchingBehaviorSubject.next(newValue);
    }
    updating(name, value) {
        const currentValue = this.updatingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.updatingBehaviorSubject.next(newValue);
    }
    publish(event) {
        const { eventType } = event, update = __rest(event, ["eventType"]);
        switch (eventType) {
            case 'create':
                this.createSubject.next(update);
                break;
            case 'update':
                this.updateSubject.next(update);
                break;
            case 'delete':
                this.deleteSubject.next(update);
                break;
            case 'actionResult':
                this.actionResultSubject.next(update);
                break;
            case 'search':
                this.searchSubject.next(update);
                break;
            case 'setFetching':
                this.fetching(event.payload.form, event.payload.value);
                break;
            case 'setUpdating':
                this.updating(update.payload.form, update.payload.value);
                break;
        }
    }
};
SupplierBus.ɵprov = ɵɵdefineInjectable({ factory: function SupplierBus_Factory() { return new SupplierBus(); }, token: SupplierBus, providedIn: "root" });
SupplierBus = __decorate([
    Injectable({
        providedIn: 'root',
    })
], SupplierBus);

let FormsContainerComponent$2 = class FormsContainerComponent {
    constructor(route, accountService, accountRelationship, supplierBus, transloco, spinner, toast, breadcrumbSrv) {
        this.route = route;
        this.accountService = accountService;
        this.accountRelationship = accountRelationship;
        this.supplierBus = supplierBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.breadcrumbSrv = breadcrumbSrv;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.route.params.subscribe((params) => {
            this.accountRelationshipKey = `${params.id}`;
            this.fetchSupplier(this.accountRelationshipKey);
        }));
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ master }) => {
            return master;
        }));
        this.updating$ = this.supplierBus.updating$.pipe(map((forms) => Object.values(forms).reduce((updating, form) => {
            return form || updating;
        }, false)));
        this.subscriptions.push(this.supplierBus.update$.subscribe((args) => this.update(args)));
        this.subscriptions.push(this.supplierBus.create$.subscribe((args) => this.create(args)));
        this.subscriptions.push(this.supplierBus.delete$.subscribe((args) => this.delete(args)));
        this.subscriptions.push(this.supplierBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    create({ type, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.accountRelationship.creates[type](this.accountRelationshipKey, payload.create)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    delete({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'contactPhone'
            ? this.subscriptions.push(this.accountRelationship
                .deleteAccountRelationshipContactPhone(`${this.accountRelationshipKey}`, `${payload.delete.contactPhoneKey}`)
                .pipe(tap(() => this.fetchSupplier(this.accountRelationshipKey)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                .subscribe())
            : this.subscriptions.push(this.accountRelationship.deletes[type](this.accountRelationshipKey, typeKey)
                .pipe(tap(() => {
                this.search({ type, payload: payload.search });
                this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
                this.spinner.off();
                this.setUpdating(type, false);
            }))
                .subscribe());
    }
    fetchSupplier(accountRelationshipKey) {
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.accountRelationship.getAccountRelationship('supplier', accountRelationshipKey),
            this.accountService.getAccountConfiguration(),
        ])
            .pipe(tap(([supplier, configuration]) => {
            this.supplier = supplier;
            this.breadcrumbSrv.set('MarketplacePartnersModule/supplier/:id/details', `${this.supplier.details.legalName
                ? this.supplier.details.legalName
                : ''}`);
            this.configuration = Object.entries(configuration).reduce((config, [key, value]) => {
                if ([value][0] == null) {
                    return null;
                }
                else {
                    return Object.assign(Object.assign({}, config), { [key]: value.map((v) => ({
                            value: v.tagKey,
                            label: v.name,
                        })) });
                }
            }, {});
            this.setFetching('master', true);
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.setFetching('master', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    search({ type, payload }) {
        this.setFetching(type, true);
        this.accountRelationship.search[type](this.accountRelationshipKey, payload)
            .pipe(tap((data) => {
            this.supplierBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    result: true,
                    data,
                },
            });
        }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
    }
    update({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'details'
            ? this.updateDetails({ type, typeKey, payload })
            : this.updateDefault({ type, typeKey, payload });
    }
    updateDefault({ type, typeKey, payload }) {
        this.subscriptions.push(this.accountRelationship.updates[type](this.accountRelationshipKey, typeKey, payload.update)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    updateDetails({ type, typeKey, payload }) {
        this.subscriptions.push(this.accountRelationship.updates[type](this.accountRelationshipKey, typeKey, payload.update)
            .pipe(tap(() => {
            this.supplierBus.publish({
                eventType: 'actionResult',
                payload: {
                    type,
                    error: null,
                },
            });
            this.fetchSupplier(this.accountRelationshipKey);
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? this.duplicateError({ type, typeKey, payload })
                : this.genericError({ type, typeKey, payload });
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    genericError({ type, typeKey, payload }) {
        this.supplierBus.publish({
            eventType: 'actionResult',
            payload: {
                type,
                error: 2,
            },
        });
        return of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
    }
    duplicateError({ type, typeKey, payload }) {
        this.supplierBus.publish({
            eventType: 'actionResult',
            payload: {
                type,
                error: 3,
            },
        });
        return of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')));
    }
    setFetching(form, value) {
        this.supplierBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    setUpdating(form, value) {
        this.supplierBus.publish({
            eventType: 'setUpdating',
            payload: { form, value },
        });
    }
};
FormsContainerComponent$2.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: AccountService },
    { type: AccountRelationshipService },
    { type: SupplierBus },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: BreadcrumbService }
];
FormsContainerComponent$2 = __decorate([
    Component({
        selector: 'lib-forms-container',
        template: ` <lib-forms
    [supplier]="supplier"
    [configuration]="configuration"
    [fetching]="fetching$ | async"
    [updating]="updating$ | async"
    (editPaySubmit)="fetchSupplier(accountRelationshipKey)"
  ></lib-forms>`
    })
], FormsContainerComponent$2);

let PayEditWizardComponent = class PayEditWizardComponent {
    constructor(mppService, translocoService, confirmationService, toast, router, route) {
        this.mppService = mppService;
        this.translocoService = translocoService;
        this.confirmationService = confirmationService;
        this.toast = toast;
        this.router = router;
        this.route = route;
        this.baseUrl = `${this.mppService.getConfig().account}`;
        this.templateTypes = TemplateTypes;
    }
    ngOnInit() {
        this.mppService.activeIndex = 6;
    }
    exitEditPage() {
        this.confirmationService.confirm({
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.router.navigate([`../${this.mppService.supplierKey}/details`], {
                    relativeTo: this.route,
                });
            },
        });
    }
    submitEditPay(event) {
        this.router.navigate([`../${this.mppService.supplierKey}/details`], {
            relativeTo: this.route,
        });
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
PayEditWizardComponent.ctorParameters = () => [
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ConfirmationService$2 },
    { type: ToastrNotificationService },
    { type: Router },
    { type: ActivatedRoute }
];
PayEditWizardComponent = __decorate([
    Component({
        selector: 'lib-pay-edit-wizard',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"mppService.payEditDetailsConfig\"\r\n  (submit)=\"submitEditPay($event)\"\r\n  (cancel)=\"exitEditPage()\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n    <div>\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"exitEditPage()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService$2]
    })
], PayEditWizardComponent);

let SupplierComponent = class SupplierComponent {
    constructor() { }
    ngOnInit() { }
};
SupplierComponent = __decorate([
    Component({
        selector: 'lib-supplier',
        template: `<router-outlet></router-outlet>`,
        providers: [SupplierBus]
    })
], SupplierComponent);

let ViewSuppliersComponent = class ViewSuppliersComponent {
    constructor(accountRelationship, datePipe, router, route, translocoService, store) {
        this.accountRelationship = accountRelationship;
        this.datePipe = datePipe;
        this.router = router;
        this.route = route;
        this.translocoService = translocoService;
        this.store = store;
        this.data$ = of([]);
        this.rows = 25;
        this.fetching = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.subscriptions.push(this.store.pipe(select(selectors.userProfile)).subscribe((res) => {
            var _a;
            this.dateFormat = (_a = res === null || res === void 0 ? void 0 : res.userInfo) === null || _a === void 0 ? void 0 : _a.DateTypeFormat;
        }));
        this.translateLabels();
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        const [firstSelection] = selection;
        switch (command) {
            case 'view':
                this.router.navigate([`${firstSelection.accountRelationshipKey}/details`], {
                    relativeTo: this.route,
                });
                break;
            case 'edit':
                this.router.navigate([`${firstSelection.accountRelationshipKey}/details`], {
                    relativeTo: this.route,
                });
                break;
            default:
                break;
        }
    }
    clear() {
        this.data$ = this.getPaginatedData(searchFilters('', {
            first: 0,
            rows: this.rows,
            sortField: 'LegalName',
            sortOrder: 1,
        }, this.advancedSearch));
    }
    getPaginatedData(filters) {
        this.fetching = true;
        return this.accountRelationship.searchDetails('supplier', filters).pipe(tap((accountRelationshipResponse) => (this.paging = Object.assign(Object.assign({}, this.paging), { records: accountRelationshipResponse.totalResults }))), map((accountRelationshipResponse) => {
            return accountRelationshipResponse.accountRelationshipDetailsResponse.map((accountRelationshipDetails) => {
                return accountRelationshipDetails;
            });
        }), finalize(() => (this.fetching = false)));
    }
    search(_a) {
        var _b = _a.filters, { term } = _b, advancedSearch = __rest(_b, ["term"]), pagination = __rest(_a, ["filters"]);
        this.rows = pagination.rows;
        this.advancedSearch = Object.values(Object.assign({}, advancedSearch));
        this.data$ = this.getPaginatedData(searchFilters(term, pagination, this.advancedSearch, 'LegalName'));
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: ({ accountRelationshipKey, }) => ({
                        path: `${accountRelationshipKey}/details`,
                    }),
                },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: ({ accountRelationshipKey, }) => ({
                        path: `${accountRelationshipKey}/details`,
                    }),
                    required: true,
                },
                {
                    field: 'activeDate',
                    header: translate.ACTIVE_DATE,
                    formatter: ({ activeDate }) => `${(activeDate === null) ? '' : this.datePipe.transform(activeDate, this.dateFormat)}`,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                { field: 'country', header: translate.COUNTRY },
                { field: 'region', header: translate.REGION },
                { field: 'province', header: translate.STATE_PROVINCE },
                { field: 'postalCode', header: translate.ZIP_POSTAL_CODE },
                { field: 'number', header: translate.SUPPLIER_NUMBER },
                { field: 'website', header: translate.WEBSITE },
                { field: 'category', header: translate.CATEGORY },
                { field: 'email', header: translate.EMAIL },
                { field: 'currencyType', header: translate.CURRENCY_TYPE },
                { field: 'creditLimit', header: translate.CREDIT_LIMIT },
                {
                    field: 'externalAccountNumber',
                    header: translate.EXTERNAL_ACCOUNT_NUMBER,
                },
                {
                    field: 'fax',
                    header: translate.FAX,
                },
                {
                    field: 'inactiveDate',
                    header: translate.INACTIVE_DATE,
                    formatter: ({ inactiveDate }) => `${(inactiveDate === null) ? '' : this.datePipe.transform(inactiveDate, this.dateFormat)}`,
                },
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxId',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'onHold',
                    header: translate.ON_HOLD,
                },
                {
                    field: 'phone',
                    header: translate.PHONE_NUMBER,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
ViewSuppliersComponent.ctorParameters = () => [
    { type: AccountRelationshipService },
    { type: DatePipe },
    { type: Router },
    { type: ActivatedRoute },
    { type: TranslocoService },
    { type: Store }
];
ViewSuppliersComponent = __decorate([
    Component({
        selector: 'lib-view-suppliers',
        template: "<div class=\"vertical-flow space-between-200\">\r\n  <h2>{{ 'SUPPLIER.SUPPLIER' | transloco }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columnsAvailable\"\r\n    i18nSearchField=\"{{ 'PARTNERS.SUPPLIER_SEARCH' | transloco }}\"\r\n    name=\"suppliersSearch\"\r\n    searchProperty=\"key\"\r\n    [buttons]=\"toolbarButtons\"\r\n    [loading]=\"fetching\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"columnsToDisplay\"\r\n    [paging]=\"paging\"\r\n    [results]=\"data$\"\r\n    [searchProperty]=\"'term'\"\r\n    (clear)=\"clear()\"\r\n    (query)=\"search($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    [lazy]=\"true\"\r\n    (lazyLoad)=\"search($event)\"\r\n    [lazyLoadOnInit]=\"false\"\r\n  >\r\n    <lib-advanced-search libSearch> </lib-advanced-search>\r\n  </lib-search-container>\r\n  <p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n</div>\r\n",
        styles: [""]
    })
], ViewSuppliersComponent);

const ɵ0$5 = { breadcrumb: 'BREADCRUMB.SUPPLIER' }, ɵ1$3 = { breadcrumb: 'SUPPLIER.SUPPLIER' }, ɵ2$2 = { breadcrumb: 'SUPPLIER.EDIT' }, ɵ3$1 = { breadcrumb: 'SUPPLIER.PAY_CONFIGURATION' };
const routes$6 = [
    {
        path: 'supplier',
        component: SupplierComponent,
        data: ɵ0$5,
        children: [
            {
                path: '',
                component: ViewSuppliersComponent,
                data: ɵ1$3,
            },
            {
                path: ':id/details',
                component: FormsContainerComponent$2,
                data: ɵ2$2,
            },
            {
                path: 'pay-edit',
                component: PayEditWizardComponent,
                data: ɵ3$1,
            },
        ],
    },
];

let RequestsComponent = class RequestsComponent {
    constructor(confirmationService) {
        this.confirmationService = confirmationService;
        this.permission = toolKeys;
        this.relationships = [
            { name: 'Supplier', code: '1' },
            { name: 'Member', code: '2' },
            { name: 'Group', code: '3' },
        ];
        this.selectedStatus = { value: '1' };
        this.displayDeclineRequest = false;
        this.displayApproveRequest = false;
        this.requestsObj = {
            data: [
                {
                    id: '1000',
                    name: 'Wunsch Inc',
                    status: '1',
                },
                {
                    id: '1001',
                    name: 'Torphy and Sons',
                    status: '1',
                },
                {
                    id: '1002',
                    name: 'Herman-Ritchie',
                    status: '1',
                },
                {
                    id: '1003',
                    name: 'Wiegand Group',
                    status: '1',
                },
                {
                    id: '1004',
                    name: 'Konopelski-Herzog',
                    status: '1',
                },
                {
                    id: '1005',
                    name: 'Zemlak Group',
                    status: '1',
                },
            ],
        };
        this.actionOptions = [
            {
                label: 'Approve',
                value: '1',
                disabled: 25 === toolKeys.MPP_REQUEST_MAINTENANCE ? false : true,
            },
            {
                label: 'Decline',
                value: '2',
                disabled: 25 === toolKeys.MPP_REQUEST_MAINTENANCE ? false : true,
            },
        ];
        this.sortOptions = [
            { label: 'Pending', value: '1' },
            { label: 'Declined', value: '2' },
        ];
    }
    ngOnInit() {
        this.selectedStatus = { value: '1' };
    }
    onActionChange(event) {
        const value = event.value;
        if (value === '1') {
            this.displayApproveRequest = true;
        }
        else {
            this.confirmationService.confirm({
                message: 'Are you sure that you want to proceed?',
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => { },
                reject: () => { },
            });
        }
    }
    onSortChange(event) {
        if (event.value === '1') {
            this.getPendingRequestsList();
            this.actionOptions = [
                {
                    label: 'Approve',
                    value: '1',
                    disabled: 25 === toolKeys.MPP_REQUEST_MAINTENANCE ? false : true,
                },
                {
                    label: 'Decline',
                    value: '2',
                    disabled: 25 === toolKeys.MPP_REQUEST_MAINTENANCE ? false : true,
                },
            ];
        }
        else {
            this.getDeclinedRequestsList();
            this.actionOptions = [
                {
                    label: 'Approve',
                    value: '1',
                    disabled: 25 === toolKeys.MPP_REQUEST_MAINTENANCE ? false : true,
                },
            ];
        }
    }
    getPendingRequestsList() {
        // if empty "No records msg otherwise data"
        this.requestsObj = {
            data: [
                {
                    id: '1000',
                    name: 'Wunsch Inc',
                    status: '1',
                },
                {
                    id: '1001',
                    name: 'Torphy and Sons',
                    status: '1',
                },
                {
                    id: '1002',
                    name: 'Herman-Ritchie',
                    status: '1',
                },
                {
                    id: '1003',
                    name: 'Wiegand Group',
                    status: '1',
                },
                {
                    id: '1004',
                    name: 'Konopelski-Herzog',
                    status: '1',
                },
                {
                    id: '1005',
                    name: 'Zemlak Group',
                    status: '1',
                },
            ],
        };
    }
    getDeclinedRequestsList() {
        // if empty "No records msg otherwise data"
        this.requestsObj = {
            data: [
                {
                    id: '1005',
                    name: 'Feeney-Little',
                    status: '2',
                },
                {
                    id: '1009',
                    name: 'Jakubowski LLC',
                    status: '2',
                },
            ],
        };
    }
    approveRequest() {
        this.displayApproveRequest = false;
    }
};
RequestsComponent.ctorParameters = () => [
    { type: ConfirmationService$1 }
];
RequestsComponent = __decorate([
    Component({
        selector: 'lib-requests',
        template: "<div class=\"container-fluid\">\r\n  <div class=\"row\">\r\n    <p-dataView\r\n      styleClass=\"requestsListView\"\r\n      [value]=\"requestsObj.data\"\r\n      [paginator]=\"true\"\r\n      [rows]=\"5\"\r\n    >\r\n      <p-header>\r\n        <div class=\"ui-helper-clearfix\">\r\n          <div class=\"p-grid\">\r\n            <div class=\"p-col-12 p-md-4\"></div>\r\n            <div class=\"p-col-6 p-md-4 filter-container\">\r\n              <div style=\"position: relative\">\r\n                <p-dropdown\r\n                  [options]=\"sortOptions\"\r\n                  placeholder=\"Filter by status\"\r\n                  (onChange)=\"onSortChange($event)\"\r\n                  [(ngModel)]=\"selectedStatus.value\"\r\n                  styleClass=\"p-mb-2 p-mb-md-0\"\r\n                ></p-dropdown>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </p-header>\r\n\r\n      <ng-template let-product pTemplate=\"listItem\">\r\n        <div class=\"p-col-12 reqList\">\r\n          <div\r\n            class=\"product-list-item\"\r\n            style=\"border-bottom: 1px solid #e0e0e0\"\r\n          >\r\n            <div class=\"product-list-detail\">\r\n              <div class=\"product-name\">{{ product.name }}</div>\r\n            </div>\r\n            <div class=\"product-list-action\">\r\n              <p-dropdown\r\n                [options]=\"actionOptions\"\r\n                placeholder=\"Actions\"\r\n                (onChange)=\"onActionChange($event)\"\r\n                styleClass=\"\"\r\n              >\r\n              </p-dropdown>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </ng-template>\r\n    </p-dataView>\r\n  </div>\r\n</div>\r\n<p-dialog [(visible)]=\"displayApproveRequest\" [style]=\"{ width: '40vw' }\">\r\n  <p-header> Approve </p-header>\r\n  <div class=\"confirmation-content\">\r\n    <p-multiSelect\r\n      appendTo=\"body\"\r\n      [options]=\"relationships\"\r\n      defaultLabel=\"Select Relationships\"\r\n      optionLabel=\"name\"\r\n      resetFilterOnHide=\"true\"\r\n    ></p-multiSelect>\r\n  </div>\r\n  <p-footer>\r\n    <div class=\"horizontal-flow form-controls\">\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"Cancel\"\r\n        class=\"primaryLightGreyLargeBtn\"\r\n        autowidth=\"false\"\r\n        (click)=\"displayApproveRequest = false\"\r\n      ></button>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"Approve\"\r\n        class=\"primaryDefaultLargeBtn\"\r\n        autowidth=\"false\"\r\n        (click)=\"approveRequest()\"\r\n      ></button>\r\n    </div>\r\n  </p-footer>\r\n</p-dialog>\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        styles: [":host ::ng-deep .p-dropdown{width:14rem;font-weight:400}:host ::ng-deep .product-name{font-size:1.5rem;font-weight:700}:host ::ng-deep .product-description{margin:0 0 1rem}:host ::ng-deep .product-category-icon{vertical-align:middle;margin-right:.5rem}:host ::ng-deep .product-category{font-weight:600;vertical-align:middle}:host ::ng-deep .product-list-item{display:flex;align-items:center;padding:1rem;width:100%}:host ::ng-deep .product-list-item img{width:150px;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);margin-right:2rem}:host ::ng-deep .product-list-item .product-list-detail{flex:1 1 0}:host ::ng-deep .product-list-item .p-rating{margin:0 0 .5rem}:host ::ng-deep .product-list-item .product-price{font-size:1.5rem;font-weight:600;margin-bottom:.5rem;align-self:flex-end}:host ::ng-deep .product-list-item .product-list-action{display:flex;flex-direction:column}:host ::ng-deep .product-list-item .p-button{margin-bottom:.5rem}:host ::ng-deep .product-grid-item{margin:.5em;border:1px solid #dee2e6}:host ::ng-deep .product-grid-item .product-grid-item-bottom,:host ::ng-deep .product-grid-item .product-grid-item-top{display:flex;align-items:center;justify-content:space-between}:host ::ng-deep .product-grid-item img{width:75%;box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);margin:2rem 0}:host ::ng-deep .product-grid-item .product-grid-item-content{text-align:center}:host ::ng-deep .product-grid-item .product-price{font-size:1.5rem;font-weight:600}.card{padding:2rem;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);border-radius:4px;margin-bottom:2rem}@media screen and (max-width:576px){:host ::ng-deep .product-list-item{flex-direction:column;align-items:center}:host ::ng-deep .product-list-item img{width:75%;margin:2rem 0}:host ::ng-deep .product-list-item .product-list-detail{text-align:center}:host ::ng-deep .product-list-item .product-price{align-self:center}:host ::ng-deep .product-list-item .product-list-action{display:flex;flex-direction:column;margin-top:2rem;flex-direction:row;justify-content:space-between;align-items:center;width:100%}}.confirmation-content{text-align:center;margin:auto}"]
    })
], RequestsComponent);

const query = {
    my_marketplace: toolKeys.MPP_GROUP,
    'my_marketplace_marketplace-edit': toolKeys.MPP_GROUP,
    group_new: toolKeys.MPP_GROUP_MAINTENANCE,
    group_edit: toolKeys.MPP_GROUP_MAINTENANCE,
    member: toolKeys.MPP_MEMBER,
    'member-cross-references': toolKeys.MPP_MEMBER_MEMBER_CROSSREFERENCES,
    member_new: toolKeys.MPP_MEMBER_MAINTENANCE,
    member_details: toolKeys.MPP_MEMBER,
    supplier: toolKeys.MPP_SUPPLIER,
    'supplier-cross-references': [
        toolKeys.MPP_SUPPLIER_SUPPLIER_CROSSREFERENCES,
        toolKeys.PIM_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES,
        toolKeys.PDX_CROSS_REFERENCES_SUPPLIER_CROSS_REFERENCES
    ],
    supplier_new: toolKeys.MPP_SUPPLIER_MAINTENANCE,
    supplier_details: toolKeys.MPP_SUPPLIER,
    'supplier_pay-edit': toolKeys.MPP_SUPPLIER,
    company: toolKeys.MPP_COMPANY,
    // 'company-beta': toolKeys.MPP_COMPANY,
    company_edit: toolKeys.MPP_COMPANY_MAINTENANCE,
    requests: toolKeys.MPP_REQUEST,
};

let AuthGuardService = class AuthGuardService {
    constructor(router, store) {
        this.router = router;
        this.store = store;
    }
    canActivateChild(_, state) {
        const [modulePath, ...path] = state.url
            .split('?')[0]
            .split('/')
            .filter((x) => x !== '');
        const permissionKey = this.urlToPermissionKey(path);
        const requiredPermissions = query[permissionKey];
        // hack to allow for multiple permissions to toggle this page on/off.
        // rather than sending the entire 'routerPermissions' list to the
        // isAuthorized selector we can create object with the permission(s)
        // required for just the current route and check if any values are true
        const permissionsQuery = Array.isArray(requiredPermissions)
            ? requiredPermissions.reduce((acc, p) => (Object.assign(Object.assign({}, acc), { [p]: p })), {})
            : { [requiredPermissions]: requiredPermissions };
        return this.store.pipe(select(selectors.isAuthorized, permissionsQuery), map((results) => Object.values(results).filter(v => v).length !== 0
            ? true
            : this.router.parseUrl(`/${modulePath}`)), catchError(() => of(this.router.parseUrl(`/${modulePath}`))));
    }
    urlToPermissionKey(url) {
        return url.filter((path) => isNaN(parseInt(path, 10))).join('_');
    }
};
AuthGuardService.ctorParameters = () => [
    { type: Router },
    { type: Store }
];
AuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(ɵɵinject(Router), ɵɵinject(Store)); }, token: AuthGuardService, providedIn: "root" });
AuthGuardService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AuthGuardService);

// import { routes as companyBetaRoutes } from './features/beta/company/company.routes';
const routes$7 = [
    {
        path: '',
        component: MarketplacePartnersComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: 'requests',
                component: RequestsComponent,
            },
            ...routes$1,
            ...routes$2,
            ...routes$4,
            ...routes$6,
            ...routes,
            // ...companyBetaRoutes,
            ...routes$5,
            ...routes$3,
        ],
    },
    {
        path: 'pim',
        component: MarketplacePartnersComponent,
        CanActivateChild: [AuthGuardService],
        children: [
            ...routes$5
        ]
    },
    {
        path: 'pdx',
        component: MarketplacePartnersComponent,
        CanActivateChild: [AuthGuardService],
        children: [
            ...routes$5
        ]
    }
];

var PhoneFormComponent_1;
let PhoneFormComponent = PhoneFormComponent_1 = 
// tslint:disable:one-line
class PhoneFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.viewOnly = false;
        this.deletedPhone = new EventEmitter();
        this.currentIndex = 0;
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.onValidatorChange = () => { };
        this.onTouched = () => { };
    }
    get phoneForms() {
        return this.formGroup.controls.phone;
    }
    // tslint:enable:one-line
    set resetPhoneSetter(resetPhone) {
        if (resetPhone) {
            this.deletePhone(this.phoneForms.length - 1);
        }
    }
    handleDeleteButtonStatus() {
        try {
            return this.phoneForms.length === 1 ? true : false;
        }
        catch (error) {
            return false;
        }
    }
    getValue(array, code) {
        try {
            return array.find((arrayObj) => arrayObj.value === code).label;
        }
        catch (error) {
            return '';
        }
    }
    writeValue(phones) {
        (phones === null || phones === void 0 ? void 0 : phones.length) > 0
            ? (this.formGroup = this.formBuilder.group({
                phone: this.formBuilder.array(this.buildExistingPhone(phones)),
            }))
            : (this.formGroup = this.formBuilder.group({
                phone: this.formBuilder.array([this.buildNewPhone()]),
            }));
    }
    registerOnChange(onChange) {
        this.onChangeSubscription = this.formGroup.valueChanges.subscribe(onChange);
    }
    registerOnTouched(onTouched) {
        this.onTouched = onTouched;
    }
    registerOnValidatorChange(onValidatorChange) {
        this.onValidatorChange = onValidatorChange;
    }
    validate(control) {
        return this.formGroup.valid ? null : { error: true };
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this.formGroup.disable();
        }
        else {
            this.formGroup.enable();
        }
    }
    buildExistingPhone(existingPhones) {
        return existingPhones === null || existingPhones === void 0 ? void 0 : existingPhones.map((phone) => {
            var _a, _b, _c, _d, _e, _f;
            return this.formBuilder.group({
                contactPhoneKey: [(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) || 0],
                phoneCountryCode: [
                    ((_b = (_a = phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) === 3
                        ? alpha3ToAlpha2(phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode)
                        : (_c = phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode) === null || _c === void 0 ? void 0 : _c.trim(),
                ],
                phoneNumber: [
                    `${this.formatPhoneToInternational(phone)}`,
                    Validators.compose([
                        Validators.required,
                        this.validatePhoneNumber(((_e = (_d = phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode) === null || _d === void 0 ? void 0 : _d.trim()) === null || _e === void 0 ? void 0 : _e.length) === 3
                            ? alpha3ToAlpha2(phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode)
                            : (_f = phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode) === null || _f === void 0 ? void 0 : _f.trim()),
                    ]),
                ],
                phoneExtension: [
                    `${(phone === null || phone === void 0 ? void 0 : phone.phoneExtension) || ''}`,
                    Validators.compose([
                        Validators.pattern('^[0-9]*$'),
                        Validators.maxLength(10),
                    ]),
                ],
                phoneTypeKey: [(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) || 1, Validators.required],
            }, {
                validators: this.validatePhoneForm('phoneNumber', 'phoneExtension'),
            });
        });
    }
    addPhone() {
        var _a;
        if (this.phoneForms.valid) {
            (_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.push(this.buildNewPhone());
        }
    }
    buildNewPhone() {
        return this.formBuilder.group({
            contactPhoneKey: [0],
            phoneCountryCode: [
                `${alpha3ToAlpha2(this.defaultCountry || 'CAN')}`,
            ],
            phoneNumber: [
                '',
                Validators.compose([
                    Validators.required,
                    this.validatePhoneNumber(`${alpha3ToAlpha2(this.defaultCountry || 'CAN')}`),
                ]),
            ],
            phoneExtension: [
                '',
                Validators.compose([
                    Validators.pattern('^[0-9]*$'),
                    Validators.maxLength(10),
                ]),
            ],
            phoneTypeKey: [1, Validators.required],
        }, {
            validators: this.validatePhoneForm('phoneNumber', 'phoneExtension'),
        });
    }
    delete(payload, index) {
        var _a;
        (_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.removeAt(index);
        this.deletedPhone.emit(payload);
    }
    deletePhone(index) {
        var _a, _b, _c, _d;
        try {
            if (this.phoneForms && ((_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                ((_b = this.phoneForms) === null || _b === void 0 ? void 0 : _b.value[index].contactPhoneKey) < 1
                    ? (_c = this.phoneForms) === null || _c === void 0 ? void 0 : _c.removeAt(index) : this.delete((_d = this.phoneForms) === null || _d === void 0 ? void 0 : _d.value[index], index);
            }
        }
        catch (_e) {
            /*empty*/
        }
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    // bound to Phone control's input event
    formatPhoneNumber(index) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.currentIndex = index;
        try {
            if (((_c = (_b = (_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.at(index).get('phoneNumber')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length) < 1) {
                this.phoneForms
                    .at(index)
                    .get('phoneCountryCode')
                    .setValue(alpha3ToAlpha2(this.defaultCountry));
            }
            this.phoneForms
                .at(index)
                .get('phoneNumber')
                .setValue(parsePhoneNumber((_e = (_d = this.phoneForms) === null || _d === void 0 ? void 0 : _d.at(index).get('phoneNumber')) === null || _e === void 0 ? void 0 : _e.value, (_g = (_f = this.phoneForms) === null || _f === void 0 ? void 0 : _f.at(index).get('phoneCountryCode')) === null || _g === void 0 ? void 0 : _g.value).formatInternational());
        }
        catch (_h) {
            /*empty*/
        }
    }
    preventCharacter(event) {
        return event.keyCode !== 187;
    }
    // bound to Countries Dropdown control's onChange event
    resetPhoneNumber(index) {
        var _a;
        (_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.at(index).get('phoneNumber').setValue('');
    }
    formatPhoneToInternational(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, alpha3ToAlpha2(phone.phoneCountryCode)).formatInternational();
        }
        catch (_a) {
            return phone === null || phone === void 0 ? void 0 : phone.phoneNumber;
        }
    }
    validatePhoneForm(phoneNumberControlName, ExtensionControlName) {
        return (formGroup) => {
            try {
                const phoneNumberControl = formGroup.controls[phoneNumberControlName];
                const extensionControl = formGroup.controls[ExtensionControlName];
                return extensionControl &&
                    extensionControl.value &&
                    extensionControl.value.length > 0 &&
                    phoneNumberControl.value.length === 0
                    ? { invalidPhoneNumber: true }
                    : null;
            }
            catch (error) {
                return error;
            }
        };
    }
    validatePhoneNumber(countryCode) {
        return (control) => {
            var _a, _b, _c;
            try {
                const parsedPhoneNumber = parsePhoneNumber(control.value.toString());
                const phoneCountry = (_c = (_b = (_a = this.phoneForms) === null || _a === void 0 ? void 0 : _a.at(this.currentIndex).get('phoneCountryCode')) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : countryCode;
                return isValidPhoneNumber(parsedPhoneNumber.formatInternational(), phoneCountry) && isValidNumberForRegion(control.value.toString(), phoneCountry)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (error) {
                return error instanceof ParseError
                    ? {
                        invalidPhoneNumber: true,
                    }
                    : null;
            }
        };
    }
    ngOnDestroy() {
        if (this.onChangeSubscription) {
            this.onChangeSubscription.unsubscribe();
        }
    }
};
PhoneFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input('resetPhone')
], PhoneFormComponent.prototype, "resetPhoneSetter", null);
__decorate([
    Input()
], PhoneFormComponent.prototype, "viewOnly", void 0);
__decorate([
    Input()
], PhoneFormComponent.prototype, "defaultCountry", void 0);
__decorate([
    Input()
], PhoneFormComponent.prototype, "countries", void 0);
__decorate([
    Input()
], PhoneFormComponent.prototype, "phoneTypes", void 0);
__decorate([
    Output()
], PhoneFormComponent.prototype, "deletedPhone", void 0);
PhoneFormComponent = PhoneFormComponent_1 = __decorate([
    Component({
        selector: 'lib-phone-form',
        template: "<form [formGroup]=\"formGroup\">\r\n  <div formArrayName=\"phone\">\r\n    <div\r\n      class=\"space-between-025\"\r\n      *ngFor=\"let phn of phoneForms?.controls; let i = index\"\r\n      [formGroupName]=\"i\"\r\n    >\r\n      <div class=\"vertical-flow space-between-025 input\">\r\n        <label for=\"phoneTypeKey\">{{\r\n          'SUPPLIER.CONTACT_PHONE_TYPE' | transloco\r\n        }}</label>\r\n        <p-dropdown\r\n          *ngIf=\"!viewOnly; else SHOW_PHONE_TYPE\"\r\n          placeholder=\"{{ 'SUPPLIER.CONTACT_SELECT_PHONE_TYPE' | transloco }}\"\r\n          [style]=\"{ width: '100%' }\"\r\n          [options]=\"phoneTypes\"\r\n          name=\"phoneTypeKey\"\r\n          formControlName=\"phoneTypeKey\"\r\n          filter=\"true\"\r\n          (onBlur)=\"onTouched()\"\r\n        ></p-dropdown>\r\n        <ng-template #SHOW_PHONE_TYPE>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            [value]=\"getValue(phoneTypes, phn.get('phoneTypeKey').value)\"\r\n            [attr.disabled]=\"true\"\r\n          />\r\n        </ng-template>\r\n      </div>\r\n      <br />\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <div *ngIf=\"!viewOnly; else SHOW_PHONE_COUNTRY\">\r\n          <label for=\"phoneCountryCode\">{{\r\n            'SUPPLIER.CONTACT_SELECT_PHONE_COUNTRY' | transloco\r\n          }}</label>\r\n          <p-dropdown\r\n            placeholder=\"{{\r\n              'SUPPLIER.CONTACT_SELECT_PHONE_COUNTRY' | transloco\r\n            }}\"\r\n            [options]=\"countries\"\r\n            (onChange)=\"resetPhoneNumber(i)\"\r\n            formControlName=\"phoneCountryCode\"\r\n            filter=\"true\"\r\n            (onBlur)=\"onTouched()\"\r\n          >\r\n          </p-dropdown>\r\n        </div>\r\n        <ng-template #SHOW_PHONE_COUNTRY>\r\n          <label for=\"phoneCountryCode\">{{\r\n            'SUPPLIER.CONTACT_PHONE_COUNTRY' | transloco\r\n          }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            [value]=\"getValue(countries, phn.get('phoneCountryCode').value)\"\r\n            [attr.disabled]=\"true\"\r\n          />\r\n        </ng-template>\r\n      </div>\r\n      <br />\r\n      <div class=\"horizontal-flow space-between-100\">\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <label for=\"phoneNumber\">{{\r\n            'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco\r\n          }}</label>\r\n          <div *ngIf=\"!viewOnly; else SHOW_PHONE_NUMBER\">\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"ui-inputtext\"\r\n              formControlName=\"phoneNumber\"\r\n              placeholder=\"(999) 999-9999\"\r\n              (keydown)=\"preventCharacter($event)\"\r\n              (input)=\"formatPhoneNumber(i)\"\r\n              (onBlur)=\"onTouched()\"\r\n            />\r\n          </div>\r\n          <ng-template #SHOW_PHONE_NUMBER>\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"ui-inputtext\"\r\n              formControlName=\"phoneNumber\"\r\n              placeholder=\"(999) 999-9999\"\r\n              (input)=\"formatPhoneNumber(i)\"\r\n              [attr.disabled]=\"true\"\r\n            />\r\n          </ng-template>\r\n        </div>\r\n        <div class=\"vertical-flow space-between-025 input\">\r\n          <label for=\"phoneExtension\">{{\r\n            'SUPPLIER.CONTACT_PHONE_EXTENSION' | transloco\r\n          }}</label>\r\n          <div *ngIf=\"!viewOnly; else SHOW_PHONE_EXTENSION\">\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"ui-inputtext\"\r\n              formControlName=\"phoneExtension\"\r\n              placeholder=\"{{\r\n                'SUPPLIER.CONTACT_PHONE_EXTENSION_PLACEHOLDER' | transloco\r\n              }}\"\r\n              (onBlur)=\"onTouched()\"\r\n            />\r\n          </div>\r\n          <ng-template #SHOW_PHONE_EXTENSION>\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"ui-inputtext\"\r\n              formControlName=\"phoneExtension\"\r\n              placeholder=\"{{\r\n                'SUPPLIER.CONTACT_PHONE_EXTENSION_PLACEHOLDER' | transloco\r\n              }}\"\r\n              [attr.disabled]=\"true\"\r\n            />\r\n          </ng-template>\r\n        </div>\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"phn.get('phoneNumber')\"\r\n      ></lib-control-message>\r\n      <lib-control-message\r\n        [control]=\"phn.get('phoneExtension')\"\r\n        [errorMsg]=\"phoneExtension.phoneExtension\"\r\n      ></lib-control-message>\r\n      <lib-control-message [control]=\"phn\"></lib-control-message>\r\n      <br />\r\n      <ng-container *ngIf=\"!viewOnly\">\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <button\r\n            [disabled]=\"handleDeleteButtonStatus()\"\r\n            pButton\r\n            type=\"button\"\r\n            label=\"{{ 'SUPPLIER.DELETE' | transloco }}\"\r\n            (click)=\"deletePhone(i)\"\r\n            class=\"ds\"\r\n            autowidth=\"false\"\r\n          ></button>\r\n        </div>\r\n        <br />\r\n      </ng-container>\r\n    </div>\r\n    <ng-container *ngIf=\"!viewOnly\">\r\n      <div class=\"horizontal-flow space-between-050 form-controls\">\r\n        <button\r\n          [disabled]=\"false\"\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'SUPPLIER.ADD_PHONE' | transloco }}\"\r\n          (click)=\"addPhone()\"\r\n          class=\"ds\"\r\n          autowidth=\"false\"\r\n        ></button>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</form>\r\n",
        providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: PhoneFormComponent_1,
            },
            {
                provide: NG_VALIDATORS,
                multi: true,
                useExisting: PhoneFormComponent_1,
            },
        ]
    })
    // tslint:disable:one-line
], PhoneFormComponent);

let PhoneFormModule = class PhoneFormModule {
};
PhoneFormModule = __decorate([
    NgModule({
        declarations: [PhoneFormComponent],
        imports: [
            ButtonModule,
            DropdownModule,
            ReactiveFormsModule,
            TranslocoModule,
            UtilsModule,
            FormsModule,
            CommonModule,
        ],
        exports: [PhoneFormComponent],
    })
], PhoneFormModule);

let CompanyBankingComponent = class CompanyBankingComponent {
    constructor(confirmationService, http, translocoService, toast, spinner, searchContainerLoaderService, mppService) {
        this.confirmationService = confirmationService;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        // dialog configs
        this.showDialog = false;
        this.actionType = '';
        // search container loader states
        this.searchContainerName = 'CompanyBankingSearch';
        this.i18nSearchField = 'PARTNERS.BANKING_SEARCH';
        this.toolbarActionsDispatcher = {
            new: (selection) => {
                // set actionType to new
                // set showDialog to true.
            },
            view: (selection) => { },
            edit: (selection) => { },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'banking/delete',
                            httpMethod: 'POST',
                            body: {
                            // keys: [...selection].map(({ poKey, ..._ }) => poKey),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/banking`;
        this.columnActions = {
            poNumber: {
                link: () => ({ path: './' }),
                event: (sentPo) => sentPo,
            },
        };
        this.defaultState = {
            page: 0,
            title: 'PARTNERS.BANKING_WIZARD',
            screens: {},
        };
        this.showWizard = false;
        http.baseUrl = mppService.getConfig().account;
    }
    ngOnInit() { }
    close() {
        this.resetDialogConfigs();
    }
    save(form) {
        switch (this.actionType) {
            case 'new':
                // make api call
                this.update('banking', form).subscribe();
                break;
            case 'edit':
                // make api call
                this.update('banking/key', form).subscribe();
                break;
            default:
                break;
        }
        this.resetDialogConfigs();
    }
    update(endpoint = '', body = {}) {
        this.spinner.on();
        return this.http
            .fetch({
            endpoint,
            httpMethod: 'POST',
            body,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()));
    }
    resetDialogConfigs() {
        this.showDialog = false;
        this.actionType = '';
    }
};
CompanyBankingComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService }
];
CompanyBankingComponent = __decorate([
    Component({
        selector: 'lib-company-banking',
        template: "<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [baseUrl]=\"baseUrl\"\r\n  [columnActions]=\"columnActions\"\r\n  [disableAdvancedSearch]=\"true\"\r\n></lib-search-container-loader>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDialog\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], CompanyBankingComponent);

let MyCompanyBus$1 = class MyCompanyBus {
    constructor() {
        this.defaultValues = {
            master: false,
            details: false,
            contact: false,
            contactPhone: false,
            bankingInfo: false,
            locations: false,
        };
        this.createSubject = new Subject();
        this.updateSubject = new Subject();
        this.deleteSubject = new Subject();
        this.actionResultSubject = new Subject();
        this.searchSubject = new Subject();
        this.fetchingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.updatingBehaviorSubject = new BehaviorSubject(Object.assign({}, this.defaultValues));
        this.create$ = this.createSubject.asObservable();
        this.update$ = this.updateSubject.asObservable();
        this.delete$ = this.deleteSubject.asObservable();
        this.actionResult$ = this.actionResultSubject.asObservable();
        this.search$ = this.searchSubject.asObservable();
        this.fetching$ = this.fetchingBehaviorSubject.asObservable();
        this.updating$ = this.updatingBehaviorSubject.asObservable();
    }
    fetching(name, value) {
        const currentValue = this.fetchingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.fetchingBehaviorSubject.next(newValue);
    }
    updating(name, value) {
        const currentValue = this.updatingBehaviorSubject.getValue();
        const newValue = Object.assign(Object.assign({}, currentValue), { [name]: value });
        this.updatingBehaviorSubject.next(newValue);
    }
    publish(event) {
        const { eventType } = event, update = __rest(event, ["eventType"]);
        switch (eventType) {
            case 'create':
                this.createSubject.next(update);
                break;
            case 'update':
                this.updateSubject.next(update);
                break;
            case 'delete':
                this.deleteSubject.next(update);
                break;
            case 'actionResult':
                this.actionResultSubject.next(update);
                break;
            case 'search':
                this.searchSubject.next(update);
                break;
            case 'setFetching':
                this.fetching(event.payload.form, event.payload.value);
                break;
            case 'setUpdating':
                this.updating(update.payload.form, update.payload.value);
                break;
        }
    }
};
MyCompanyBus$1.ɵprov = ɵɵdefineInjectable({ factory: function MyCompanyBus_Factory() { return new MyCompanyBus$1(); }, token: MyCompanyBus$1, providedIn: "root" });
MyCompanyBus$1 = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MyCompanyBus$1);

let DetailsComponent = class DetailsComponent {
    constructor(formBuilder, myCompanyBus, transloco) {
        this.formBuilder = formBuilder;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.account = {
            details: { country: '' },
        };
        this.fax = {
            fax: () => this.transloco.translate('VALIDATION_MESSAGE.COMPANY_FAX'),
        };
        this.website = {
            website: () => this.transloco.translate('VALIDATION_MESSAGE.WEBSITE'),
        };
        this.phoneNumber = {
            phoneNumber: () => this.transloco.translate('VALIDATION_MESSAGE.COMPANY_PHONE'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
        this.disableProvinceDropdown = true;
        this.enableEdit = false;
        this.permissions = {};
    }
    set detailsSetter(details) {
        this.details = details;
        try {
            this.details.fax = parsePhoneNumber(this.details.fax, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational();
            this.details.phone = parsePhoneNumber(this.details.phone, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational();
        }
        catch (_a) { }
        this.initializeForm(details);
    }
    set accountSetter(account) {
        this.account = account;
    }
    set currenciesSetter(currencies) {
        this.currencies = currencies;
    }
    set countriesSetter(countries) {
        this.countries = countries;
    }
    set provincesSetter(provinces) {
        this.provinces = provinces;
        this.filteredProvinces = provinces;
        this.getFilteredProvinces(this.provinces);
    }
    set permissionsSetter(permissions) {
        this.permissions = permissions;
    }
    initializeForm(detailsInput) {
        const details = detailsInput ||
            { fax: '', country: '', province: '' };
        this.detailsForm = this.formBuilder.group({
            legalName: [details.legalName, Validators.required],
            dbaName: [details.dbaName, Validators.required],
            address1: [details.address1, Validators.required],
            address2: [details.address2],
            country: [details.country.trim(), Validators.required],
            city: [details.city, Validators.required],
            postalCode: [details.postalCode, Validators.required],
            province: [details.province.trim(), Validators.required],
            currencyTypeKey: [`${details.currencyTypeKey}`, Validators.required],
            // isaNumber: [details.isaNumber],
            phone: [
                this.formatPhoneToInternational(details.phone, details.country),
                Validators.compose([Validators.required, this.validatePhoneNumber()]),
            ],
            fax: [
                this.formatPhoneToInternational(details.fax, details.country),
                Validators.compose([this.validateFaxNumber()]),
            ],
            website: [details.website],
        });
        this.getFilteredProvinces(this.provinces);
    }
    // bound to Phone and Fax control's input event
    formatPhoneNumber(input) {
        try {
            if (input.length < 1) {
                this.detailsForm
                    .get('phone')
                    .setValue(alpha3ToAlpha2(this.account ? this.account.details.country : 'CA'));
            }
            this.detailsForm
                .get('phone')
                .setValue(parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational());
        }
        catch (_a) {
            /*empty*/
        }
    }
    // bound to Phone and Fax control's input event
    formatFaxNumber(input) {
        try {
            if (input.length < 1) {
                this.detailsForm
                    .get('fax')
                    .setValue(alpha3ToAlpha2(this.account ? this.account.details.country : 'CA'));
            }
            this.detailsForm
                .get('fax')
                .setValue(parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational());
        }
        catch (_a) {
            /*empty*/
        }
    }
    preventCharacter(event) {
        return event.keyCode !== 187;
    }
    // bound to Countries Dropdown control's onChange event
    resetFaxNumberAndProvince(selectedCountry) {
        this.detailsForm.get('province').setValue('');
        this.detailsForm.get('fax').setValue('');
        this.detailsForm.get('phone').setValue('');
        this.filteredProvinces = this.provinces.filter((province) => province.code === selectedCountry.value);
        this.disableProvinceDropdown = false;
    }
    formatNumberForSave(input) {
        try {
            return parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).format('E.164');
        }
        catch (_a) {
            return '';
        }
    }
    save() {
        var _a, _b;
        this.myCompanyBus.publish({
            eventType: 'update',
            type: 'details',
            payload: {
                update: Object.assign(Object.assign(Object.assign({}, this.details), this.detailsForm.value), { currencyTypeKey: Number((_b = (_a = this.detailsForm) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.currencyTypeKey), fax: this.formatNumberForSave(this.detailsForm.get('fax').value), phone: this.formatNumberForSave(this.detailsForm.get('phone').value) }),
            },
        });
        this.configEditModal();
    }
    configEditModal() {
        this.enableEdit = !this.enableEdit;
    }
    cancelEditModal() {
        this.initializeForm(this.details);
        this.enableEdit = !this.enableEdit;
    }
    validatePhoneNumber() {
        return (control) => {
            try {
                return this.checkValidity(control)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (error) {
                return error instanceof ParseError
                    ? {
                        invalidPhoneNumber: true,
                    }
                    : null;
            }
        };
    }
    validateFaxNumber() {
        return (control) => {
            var _a, _b;
            if (((_a = control.value) === null || _a === void 0 ? void 0 : _a.length) === undefined) {
                return null;
            }
            try {
                return this.checkValidity(control)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (error) {
                return ((_b = control.value) === null || _b === void 0 ? void 0 : _b.length) === 0 || undefined
                    ? null
                    : error instanceof ParseError
                        ? {
                            invalidPhoneNumber: true,
                        }
                        : null;
            }
        };
    }
    checkValidity(control) {
        var _a, _b;
        const parsedPhoneNumber = parsePhoneNumber(control.value.toString());
        return (isValidPhoneNumber(parsedPhoneNumber.formatInternational(), this.getPhoneCountry(parsedPhoneNumber)) &&
            isValidNumberForRegion(control.value.toString(), alpha3ToAlpha2((_b = (_a = this.detailsForm.get('country')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim())));
    }
    getPhoneCountry(parsedPhoneNumber) {
        var _a;
        return ((_a = alpha3ToAlpha2(this.detailsForm.get('country').value.trim())) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? alpha3ToAlpha2(this.detailsForm.get('country').value.trim())
            : parsedPhoneNumber.country;
    }
    getFilteredProvinces(provinces) {
        if (provinces !== undefined) {
            // Once province list is available see if user has country set,if not disable province dropdown
            const countryCode = this.detailsForm
                ? this.detailsForm.get('country').value.trim()
                : '';
            this.disableProvinceDropdown = countryCode.length === 0 ? true : false;
            if (countryCode.length !== 0) {
                this.filteredProvinces = provinces.filter((province) => province.code === countryCode);
            }
        }
    }
    formatPhoneToInternational(fax, country) {
        try {
            return parsePhoneNumber(fax, alpha3ToAlpha2(country || 'CA')).formatInternational();
        }
        catch (_a) {
            return fax;
        }
    }
};
DetailsComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: MyCompanyBus$1 },
    { type: TranslocoService }
];
__decorate([
    Input('details')
], DetailsComponent.prototype, "detailsSetter", null);
__decorate([
    Input('account')
], DetailsComponent.prototype, "accountSetter", null);
__decorate([
    Input('currencies')
], DetailsComponent.prototype, "currenciesSetter", null);
__decorate([
    Input('countries')
], DetailsComponent.prototype, "countriesSetter", null);
__decorate([
    Input('provinces')
], DetailsComponent.prototype, "provincesSetter", null);
__decorate([
    Input('permissions')
], DetailsComponent.prototype, "permissionsSetter", null);
DetailsComponent = __decorate([
    Component({
        selector: 'lib-details',
        template: "<!--Company Details - View Mode-->\r\n<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button\r\n    pButton\r\n    class=\"ds tertiary small\"\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    [disabled]=\"!permissions?.edit\"\r\n    (click)=\"configEditModal()\"\r\n  ></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <!-- <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ISA_NUMBER' | transloco,\r\n          value: details.isaNumber\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container> -->\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.LEGAL_NAME' | transloco,\r\n          value: details.legalName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.DBA_NAME' | transloco,\r\n          value: details.dbaName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_ONE' | transloco,\r\n          value: details.address1\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_TWO' | transloco,\r\n          value: details.address2\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: { label: 'SUPPLIER.CITY' | transloco, value: details.city }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.STATE_PROVINCE' | transloco,\r\n          value: details.provinceName || details.province.trim()\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ZIP_POSTAL_CODE' | transloco,\r\n          value: details.postalCode\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.COUNTRY' | transloco,\r\n          value: details.countryName || details.country\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco,\r\n          value: details.phone\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.FAX' | transloco,\r\n          value: details.fax\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.ACCOUNT_WEBSITE' | transloco,\r\n          value: details.website\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco,\r\n          value: details.currencyType\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n</div>\r\n<ng-template #companyDetails let-value=\"details\">\r\n  <div class=\"view-details view-details-row\">\r\n    <div class=\"view-details view-details-tile\">\r\n      <div class=\"view-details view-details-label\">\r\n        {{ value.label }}\r\n      </div>\r\n      <div>\r\n        <span> {{ value.value }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<!--Company Details - Edit Modal-->\r\n<p-dialog\r\n  [(visible)]=\"enableEdit\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n  <div class=\"vertical-flow modal-details-container\">\r\n    <h2 class=\"center\">{{ 'COMMON.EDIT_DETAILS' | transloco }}</h2>\r\n    <form\r\n      class=\"vertical-flow space-before-100\"\r\n      [formGroup]=\"detailsForm\"\r\n      (ngSubmit)=\"save()\"\r\n    >\r\n      <!-- <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"isaNumber\">{{ 'SUPPLIER.ISA_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"isaNumber\"\r\n          />\r\n        </div>\r\n      </div> -->\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"legalName\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.legalName\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"dbaName\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.dbaName\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n        <div>\r\n          <p-dropdown\r\n            styleClass=\"width-100 height-46\"\r\n            name=\"country\"\r\n            [options]=\"countries\"\r\n            (onChange)=\"resetFaxNumberAndProvince($event)\"\r\n            placeholder=\"{{\r\n              'VALIDATION_MESSAGE.COUNTRY_SELECTION' | transloco\r\n            }}\"\r\n            formControlName=\"country\"\r\n            filter=\"true\"\r\n          ></p-dropdown>\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.country\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address1\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.address1\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address2\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-200\">\r\n        <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"city\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.city\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-000\">\r\n        <label for=\"province\">{{\r\n          'SUPPLIER.STATE_PROVINCE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <fieldset\r\n            [disabled]=\"disableProvinceDropdown\"\r\n            style=\"border: 0; padding-left: 0\"\r\n          >\r\n            <p-dropdown\r\n              styleClass=\"width-100 height-46\"\r\n              name=\"province\"\r\n              [options]=\"filteredProvinces\"\r\n              placeholder=\"{{\r\n                'VALIDATION_MESSAGE.PROVINCE_SELECTION' | transloco\r\n              }}\"\r\n              formControlName=\"province\"\r\n              filter=\"true\"\r\n            ></p-dropdown>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.province\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"postalCode\">{{\r\n          'SUPPLIER.ZIP_POSTAL_CODE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"postalCode\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.postalCode\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <div>\r\n          <label for=\"phone\">{{\r\n            'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco\r\n          }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"phone\"\r\n            (keydown)=\"preventCharacter($event)\"\r\n            (input)=\"formatPhoneNumber($event.target.value)\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.phone\"\r\n            [errorMsg]=\"phoneNumber.phoneNumber\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <div>\r\n          <label for=\"website\">{{ 'COMPANY.FAX' | transloco }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"fax\"\r\n            (input)=\"formatFaxNumber($event.target.value)\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.fax\"\r\n            [errorMsg]=\"fax.fax\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"website\">{{ 'COMPANY.ACCOUNT_WEBSITE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"website\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.website\"\r\n            [errorMsg]=\"website.website\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-200\">\r\n        <label for=\"currencyTypeKey\">{{\r\n          'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco\r\n        }}</label>\r\n        <div>\r\n          <p-dropdown\r\n            styleClass=\"width-100 height-46\"\r\n            name=\"currencyTypeKey\"\r\n            [options]=\"currencies\"\r\n            placeholder=\"{{\r\n              'VALIDATION_MESSAGE.CURRENCY_SELECTION' | transloco\r\n            }}\"\r\n            formControlName=\"currencyTypeKey\"\r\n            filter=\"true\"\r\n          ></p-dropdown>\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.currencyTypeKey\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"horizontal-flow form-controls\">\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n          class=\"ds secondary\"\r\n          autowidth=\"false\"\r\n          (click)=\"cancelEditModal()\"\r\n        ></button>\r\n        <button\r\n          [disabled]=\"detailsForm.invalid\"\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n          type=\"submit\"\r\n          class=\"ds primary\"\r\n          autowidth=\"false\"\r\n        ></button>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</p-dialog>\r\n",
        styles: [""]
    })
], DetailsComponent);

let CompanyHeaderComponent = class CompanyHeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], CompanyHeaderComponent.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], CompanyHeaderComponent.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], CompanyHeaderComponent.prototype, "contentTemplate", void 0);
CompanyHeaderComponent = __decorate([
    Component({
        selector: 'lib-company-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em;\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], CompanyHeaderComponent);

let CompanyLocationsComponent = class CompanyLocationsComponent {
    constructor(confirmationService, myCompanyBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.myCompanyBus = myCompanyBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showLocationDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set locationsSetter(locations) {
        this.locations = locations;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.myCompanyBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'locations' && payload.result) {
                this.data$ = of(payload.data.accountLocationResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ locations }) => locations));
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(locations, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const accountLocationKeys = [];
                locations.forEach((location) => accountLocationKeys.push(location.accountLocationKey));
                const accountLocationKeysString = JSON.stringify(accountLocationKeys);
                this.myCompanyBus.publish({
                    eventType: 'delete',
                    type: 'locations',
                    typeKey: accountLocationKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'legalName'),
                    },
                });
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showLocationDialog = true;
                this.editLocationData = undefined;
                break;
            case 'edit':
                this.action = 'edit';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            case 'view':
                this.action = 'view';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'legalName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters('', this.prevPagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters(term, pagination, [], 'legalName'),
        });
    }
    locationCRUD(data) {
        this.myCompanyBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'legalName') }) }));
    }
    closeLocationDialog() {
        this.showLocationDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxid',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                    required: true,
                },
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                },
                {
                    field: 'number',
                    header: translate.LOCATION_NUMBER,
                },
                {
                    field: 'country',
                    header: translate.COUNTRY,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                {
                    field: 'province',
                    header: translate.STATE_PROVINCE,
                },
                {
                    field: 'postalCode',
                    header: translate.ZIP_POSTAL_CODE,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    openViewLocation(location) {
        this.action = 'view';
        this.showLocationDialog = true;
        this.editLocationData = location;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            add: toolKeys.MPP_COMPANY_MAINTENANCE,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
            delete: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
CompanyLocationsComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MyCompanyBus$1 },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('locations')
], CompanyLocationsComponent.prototype, "locationsSetter", null);
CompanyLocationsComponent = __decorate([
    Component({
        selector: 'lib-company-locations',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"companyLocations\"\r\n      i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching$ | async\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewLocation($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showLocationDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <lib-location-form-container\r\n        [action]=\"action\"\r\n        [location]=\"editLocationData\"\r\n        (locationCRUD)=\"locationCRUD($event)\"\r\n        (closeLocationDialog)=\"closeLocationDialog()\"\r\n      >\r\n      </lib-location-form-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], CompanyLocationsComponent);

let LocationFormContainerComponent = class LocationFormContainerComponent {
    constructor(config, myCompanyBus, spinner) {
        this.config = config;
        this.myCompanyBus = myCompanyBus;
        this.spinner = spinner;
        this.closeLocationDialog = new EventEmitter();
        this.locationCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set locationSetter(location) {
        this.location = location;
    }
    ngOnInit() {
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ details }) => details));
        this.setFetching('locations', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([this.config.getProvinces(), this.config.getCountries()])
            .pipe(tap(([provinces, countries]) => {
            this.provinces = provinces.map((province) => {
                return {
                    label: province.provinceName,
                    value: province.provinceCode.trim(),
                    code: province.countryCode.trim(),
                };
            });
            this.countries = countries.map((country) => {
                return {
                    label: country.countryName,
                    value: country.countryCode.trim(),
                    code: country.countryCode.trim(),
                };
            });
        }), finalize(() => {
            this.spinner.off();
            this.setFetching('locations', false);
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeLocationDialog.emit();
    }
};
LocationFormContainerComponent.ctorParameters = () => [
    { type: ConfigService },
    { type: MyCompanyBus$1 },
    { type: SpinnerService }
];
__decorate([
    Input()
], LocationFormContainerComponent.prototype, "action", void 0);
__decorate([
    Input('location')
], LocationFormContainerComponent.prototype, "locationSetter", null);
__decorate([
    Output()
], LocationFormContainerComponent.prototype, "closeLocationDialog", void 0);
__decorate([
    Output()
], LocationFormContainerComponent.prototype, "locationCRUD", void 0);
LocationFormContainerComponent = __decorate([
    Component({
        selector: 'lib-location-form-container',
        template: `<lib-location-form
    [action]="action"
    [location]="location"
    [countries]="countries"
    [provinces]="provinces"
    (locationCRUD)="locationCRUD.emit($event)"
    (closeLocationDialog)="closeDialog()"
  ></lib-location-form>`
    })
], LocationFormContainerComponent);

let LocationFormComponent = class LocationFormComponent {
    constructor(formBuilder, myCompanyBus, transloco) {
        this.formBuilder = formBuilder;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.action = '';
        this.closeLocationDialog = new EventEmitter();
        this.locationCRUD = new EventEmitter();
        this.pattern = {
            pattern: () => this.transloco.translate('VALIDATION_MESSAGE.LOCATION_NUMBER'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
        this.authorizedActions = {};
    }
    set locationSetter(location) {
        this.location = location;
        this.initializeForm(location);
    }
    set countriesSetter(countries) {
        this.countries = countries;
    }
    set provincesSetter(provinces) {
        this.provinces = provinces;
    }
    initializeForm(locationInput) {
        const location = locationInput;
        this.setFilteredProvinces(this.provinces, location === null || location === void 0 ? void 0 : location.country);
        this.locationForm = this.formBuilder.group({
            isaNumber: [location === null || location === void 0 ? void 0 : location.isaNumber],
            lbmxId: [location === null || location === void 0 ? void 0 : location.lbmxid],
            legalName: [location === null || location === void 0 ? void 0 : location.legalName, Validators.required],
            dbaName: [location === null || location === void 0 ? void 0 : location.dbaName],
            number: [
                location === null || location === void 0 ? void 0 : location.number,
                Validators.compose([
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9]*$'),
                ]),
            ],
            country: [location === null || location === void 0 ? void 0 : location.country, Validators.required],
            city: [location === null || location === void 0 ? void 0 : location.city, Validators.required],
            province: [location === null || location === void 0 ? void 0 : location.province.trim(), Validators.required],
            postalCode: [location === null || location === void 0 ? void 0 : location.postalCode, Validators.required],
            address1: [location === null || location === void 0 ? void 0 : location.address1, Validators.required],
            address2: [location === null || location === void 0 ? void 0 : location.address2],
        });
    }
    getValue(set, item) {
        try {
            return set.find((value) => value.value === item.trim()).label;
        }
        catch (_a) { }
    }
    closeDialog() {
        this.closeLocationDialog.emit();
        this.locationForm.reset();
    }
    save() {
        var _a, _b;
        const locationKey = this.action === 'add' ? '' : `${this.location.accountLocationKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.locationCRUD.emit({
            eventType,
            type: 'locations',
            typeKey: locationKey,
            payload: {
                [`${eventType}`]: Object.assign(Object.assign(Object.assign({}, this.location), this.locationForm.value), { lbmxId: Number((_b = (_a = this.locationForm) === null || _a === void 0 ? void 0 : _a.get('lbmxId')) === null || _b === void 0 ? void 0 : _b.value) }),
            },
        });
        this.closeDialog();
    }
    resetProvince(selectedCountry) {
        this.locationForm.get('province').setValue('');
        this.setFilteredProvinces(this.provinces, selectedCountry);
    }
    setFilteredProvinces(provinces, countryCode) {
        try {
            this.filteredProvinces = provinces.filter((province) => province.code.trim() === countryCode);
        }
        catch (error) {
            this.filteredProvinces = provinces;
        }
    }
};
LocationFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: MyCompanyBus$1 },
    { type: TranslocoService }
];
__decorate([
    Input()
], LocationFormComponent.prototype, "action", void 0);
__decorate([
    Input('location')
], LocationFormComponent.prototype, "locationSetter", null);
__decorate([
    Input('countries')
], LocationFormComponent.prototype, "countriesSetter", null);
__decorate([
    Input('provinces')
], LocationFormComponent.prototype, "provincesSetter", null);
__decorate([
    Output()
], LocationFormComponent.prototype, "closeLocationDialog", void 0);
__decorate([
    Output()
], LocationFormComponent.prototype, "locationCRUD", void 0);
LocationFormComponent = __decorate([
    Component({
        selector: 'lib-location-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"locationForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else legalName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"legalName\"\r\n    />\r\n    <ng-template #legalName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.legalName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.legalName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else dbaName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"dbaName\"\r\n    />\r\n    <ng-template #dbaName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.dbaName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.dbaName\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else country\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"country\"\r\n      [options]=\"countries\"\r\n      (onChange)=\"resetProvince($event?.value)\"\r\n      formControlName=\"country\"\r\n      filter=\"true\"\r\n      placeholder=\"{{ 'VALIDATION_MESSAGE.COUNTRY_SELECTION' | transloco }}\"\r\n    ></p-dropdown>\r\n    <ng-template #country>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getValue(countries, location?.country)\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.country\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else address1\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address1\"\r\n    />\r\n    <ng-template #address1>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.address1\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.address1\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else address2\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address2\"\r\n    />\r\n    <ng-template #address2>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.address2\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.address2\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else city\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"city\"\r\n    />\r\n    <ng-template #city>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.city\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.city\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"number\">{{ 'SUPPLIER.LOCATION_NUMBER' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else number\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"number\"\r\n    />\r\n    <ng-template #number>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.number\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.number\"\r\n      [errorMsg]=\"pattern.pattern\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"province\">{{ 'SUPPLIER.STATE_PROVINCE' | transloco }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else province\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"province\"\r\n      [options]=\"filteredProvinces\"\r\n      formControlName=\"province\"\r\n      filter=\"true\"\r\n      placeholder=\"{{ 'VALIDATION_MESSAGE.PROVINCE_SELECTION' | transloco }}\"\r\n    ></p-dropdown>\r\n    <ng-template #province>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getValue(filteredProvinces, location?.province)\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.province\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"postalCode\">{{ 'SUPPLIER.ZIP_POSTAL_CODE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else postalCode\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"postalCode\"\r\n    />\r\n    <ng-template #postalCode>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.postalCode\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.postalCode\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"locationForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], LocationFormComponent);

let CompanyPaymentPreferencesComponent = class CompanyPaymentPreferencesComponent {
    constructor(http, translocoService, toast, spinner, searchContainerLoaderService, mppService) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        // dialog configs
        this.showDialog = false;
        this.actionType = '';
        // search container loader states
        this.searchContainerName = 'CompanyPaymentPreferencesSearch';
        this.i18nSearchField = 'PARTNERS.PAYMENT_PREFERENCES_SEARCH';
        this.toolbarActionsDispatcher = {
            view: (selection) => { },
            edit: (selection) => { },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/payment-preferences`;
        this.columnActions = {
            poNumber: {
                link: () => ({ path: './' }),
                event: (sentPo) => sentPo,
            },
        };
        http.baseUrl = mppService.getConfig().account;
    }
    ngOnInit() { }
    close() {
        this.resetDialogConfigs();
    }
    save(form) {
        switch (this.actionType) {
            case 'new':
                // make api call
                this.update('payment-preference', form).subscribe();
                break;
            case 'edit':
                // make api call
                this.update('payment-preference/key', form).subscribe();
                break;
            default:
                break;
        }
        this.resetDialogConfigs();
    }
    update(endpoint = '', body = {}) {
        this.spinner.on();
        return this.http
            .fetch({
            endpoint,
            httpMethod: 'POST',
            body,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()));
    }
    resetDialogConfigs() {
        this.showDialog = false;
        this.actionType = '';
    }
};
CompanyPaymentPreferencesComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService }
];
CompanyPaymentPreferencesComponent = __decorate([
    Component({
        selector: 'lib-company-payment-preferences',
        template: "<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [baseUrl]=\"baseUrl\"\r\n  [columnActions]=\"columnActions\"\r\n  [disableAdvancedSearch]=\"true\"\r\n></lib-search-container-loader>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDialog\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], CompanyPaymentPreferencesComponent);

let CompanyComponent$1 = class CompanyComponent {
    constructor() { }
    ngOnInit() { }
};
CompanyComponent$1 = __decorate([
    Component({
        selector: 'lib-company',
        template: `<router-outlet></router-outlet>`,
        providers: [MyCompanyBus$1]
    })
], CompanyComponent$1);

let ContactFormContainerComponent = class ContactFormContainerComponent {
    constructor(config, accountService, myCompanyBus, spinner) {
        this.config = config;
        this.accountService = accountService;
        this.myCompanyBus = myCompanyBus;
        this.spinner = spinner;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set contactSetter(contact) {
        this.contact = contact;
    }
    ngOnInit() {
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ contact }) => contact));
        this.setFetching('contact', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.config.getContactRoles(),
            this.config.getPhoneTypes(),
            this.config.getCountries(),
            this.accountService.getAccount(),
        ])
            .pipe(tap(([roles, phoneTypes, countries, account]) => {
            this.contactRoles = roles.map((role) => {
                return {
                    label: role.description,
                    value: role.contactRoleKey,
                };
            });
            this.phoneTypes = phoneTypes.map((phoneType) => {
                return {
                    label: phoneType.description,
                    value: phoneType.phoneTypeKey,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: `${country.countryName} (${country.countryCode})`,
                    value: alpha3ToAlpha2(country.countryCode),
                };
            });
            this.account = account;
        }), finalize(() => {
            this.setFetching('contact', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeContactDialog.emit();
    }
};
ContactFormContainerComponent.ctorParameters = () => [
    { type: ConfigService },
    { type: AccountService },
    { type: MyCompanyBus$1 },
    { type: SpinnerService }
];
__decorate([
    Input()
], ContactFormContainerComponent.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormContainerComponent.prototype, "contactSetter", null);
__decorate([
    Output()
], ContactFormContainerComponent.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormContainerComponent.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormContainerComponent.prototype, "contactsCRUD", void 0);
ContactFormContainerComponent = __decorate([
    Component({
        selector: 'lib-contact-form-container',
        template: `<lib-contact-form
    [action]="action"
    [account]="account"
    [countries]="countries"
    [contact]="contact"
    [contactRoles]="contactRoles"
    [phoneTypes]="phoneTypes"
    (closeContactDialog)="closeContactDialog.emit()"
    (deletePhones)="deletePhones.emit($event)"
    (contactsCRUD)="contactsCRUD.emit($event)"
  ></lib-contact-form>`
    })
], ContactFormContainerComponent);

let ContactFormComponent = class ContactFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.controls = [
            'firstName',
            'lastName',
            'title',
            'email',
            'contactRoleKey',
            'notes',
        ];
        this.resetPhone = false;
        this.deletedPhones = [];
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.emailError = {
            email: () => this.transloco.translate('VALIDATION_MESSAGE.EMAIL'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set contactSetter(contact) {
        this.contact = contact;
        this.initializeForm(contact);
    }
    initializeForm(contactInput) {
        const contact = contactInput ? contactInput : {};
        this.contactForm = this.formBuilder.group({
            firstName: [contact.firstName, Validators.required],
            lastName: [contact.lastName, Validators.required],
            title: [contact.title, Validators.required],
            email: [
                contact.email,
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            contactRoleKey: [contact.contactRoleKey || 1, Validators.required],
            notes: [contact.notes],
            phone: [contact === null || contact === void 0 ? void 0 : contact.phone, Validators.required],
        });
    }
    closeDialog() {
        this.resetContactForm();
        this.closeContactDialog.emit();
        this.deletedPhones = [];
    }
    deletePhone(deletedPhones) {
        this.deletedPhones = [...this.deletedPhones, deletedPhones];
    }
    getContactRole() {
        var _a;
        try {
            return (_a = this.contactRoles) === null || _a === void 0 ? void 0 : _a.find((contactRole) => contactRole.value === this.contact.contactRoleKey).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        if (this.deletedPhones && this.deletedPhones.length > 0) {
            this.deletedPhones.forEach((payload) => this.deletePhones.emit(payload));
        }
        const contactKey = this.action === 'add' ? '' : `${this.contact.contactKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.contactsCRUD.emit({
            eventType,
            type: 'contact',
            typeKey: contactKey,
            payload: {
                [`${eventType}`]: this.formatContactPayload(),
            },
        });
        this.closeDialog();
    }
    formatContactPayload() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const phones = ((_c = (_b = (_a = this.contactForm) === null || _a === void 0 ? void 0 : _a.get('phone')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.phone) ? (_f = (_e = (_d = this.contactForm) === null || _d === void 0 ? void 0 : _d.get('phone')) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.phone : (_h = (_g = this.contactForm) === null || _g === void 0 ? void 0 : _g.get('phone')) === null || _h === void 0 ? void 0 : _h.value;
        return Object.assign(Object.assign(Object.assign({}, this.contact), this.contactForm.value), { phone: phones.map((phone) => (Object.assign(Object.assign({}, phone), { contactPhoneKey: (phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) : 0, phoneTypeKey: (phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) : 1, phoneNumber: this.formatPhoneForSave(phone), phoneCountryCode: phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode }))) });
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    resetContactForm() {
        this.resetPhone = true;
        this.controls.forEach((control) => this.contactForm.get(control).setValue(''));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
ContactFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], ContactFormComponent.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormComponent.prototype, "contactSetter", null);
__decorate([
    Input()
], ContactFormComponent.prototype, "account", void 0);
__decorate([
    Input()
], ContactFormComponent.prototype, "contactRoles", void 0);
__decorate([
    Input()
], ContactFormComponent.prototype, "phoneTypes", void 0);
__decorate([
    Input()
], ContactFormComponent.prototype, "countries", void 0);
__decorate([
    Output()
], ContactFormComponent.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormComponent.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormComponent.prototype, "contactsCRUD", void 0);
ContactFormComponent = __decorate([
    Component({
        selector: 'lib-contact-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"contactForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"firstName\">{{\r\n      'SUPPLIER.CONTACT_FIRST_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else firstName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"firstName\"\r\n    />\r\n    <ng-template #firstName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.firstName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.firstName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"lastName\">{{ 'SUPPLIER.CONTACT_LAST_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else lastName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"lastName\"\r\n    />\r\n    <ng-template #lastName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.lastName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.lastName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"title\">{{ 'SUPPLIER.CONTACT_TITLE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else title\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"title\"\r\n    />\r\n    <ng-template #title>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.title\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.title\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <lib-phone-form\r\n    [countries]=\"countries\"\r\n    [defaultCountry]=\"account?.details?.country\"\r\n    [phoneTypes]=\"phoneTypes\"\r\n    [resetPhone]=\"resetPhone\"\r\n    [viewOnly]=\"action === 'view'\"\r\n    (deletedPhone)=\"deletePhone($event)\"\r\n    formControlName=\"phone\"\r\n  ></lib-phone-form>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"email\">{{ 'SUPPLIER.CONTACT_EMAIL' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else email\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"email\"\r\n    />\r\n    <ng-template #email>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.email\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.email\"\r\n      [errorMsg]=\"emailError.email\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"contactRoleKey\">{{\r\n      'SUPPLIER.CONTACT_ROLE' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else role\"\r\n      placeholder=\"{{ 'SUPPLIER.CONTACT_SELECT_ROLE' | transloco }}\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"contactRoleKey\"\r\n      [options]=\"contactRoles\"\r\n      formControlName=\"contactRoleKey\"\r\n      filter=\"true\"\r\n    ></p-dropdown>\r\n    <ng-template #role>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getContactRole()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.role\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"notes\">{{ 'SUPPLIER.CONTACT_NOTES' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else notes\"\r\n      rows=\"5\"\r\n      autoresize=\"false\"\r\n      name=\"notes\"\r\n      pInputTextarea\r\n      formControlName=\"notes\"\r\n      class=\"width-100 ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #notes>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"false\"\r\n        name=\"notes\"\r\n        pInputTextarea\r\n        formControlName=\"notes\"\r\n        class=\"width-100 ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"contactForm?.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ContactFormComponent);

const contactRoles = [
    { description: 'Accounting' },
    { description: 'Administration' },
    { description: 'Customer Service' },
    { description: 'EDI' },
    { description: 'Executive' },
    { description: 'Marketing' },
    { description: 'Operations' },
    { description: 'Sales' },
    { description: 'Support' },
];
var roles;
(function (roles) {
    roles[roles["Accounting"] = 1] = "Accounting";
    roles[roles["Administration"] = 2] = "Administration";
    roles[roles["Customer Service"] = 3] = "Customer Service";
    roles[roles["EDI"] = 4] = "EDI";
    roles[roles["Executive"] = 5] = "Executive";
    roles[roles["Marketing"] = 6] = "Marketing";
    roles[roles["Operations"] = 7] = "Operations";
    roles[roles["Sales"] = 8] = "Sales";
    roles[roles["Support"] = 9] = "Support";
})(roles || (roles = {}));
const documentStatus = [
    { description: 'Test' },
    { description: 'Production' },
    { description: 'Not Supported' },
];
const documentTypes = [
    { description: 'Invoice' },
    { description: 'PO' },
    {
        description: 'PO Acknowledgement Status',
    },
    { description: 'ASN' },
    { description: 'Claim' },
    { description: 'Remittance Advice' },
];

let ContactsComponent = class ContactsComponent {
    constructor(confirmationService, myCompanyBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.myCompanyBus = myCompanyBus;
        this.translocoService = translocoService;
        this.store = store;
        this.action = null;
        this.toolbarButtons = [];
        this.showContactDialog = false;
        this.columnsAvailable = false;
        this.fetching = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set contactsSetter(contacts) {
        this.contacts = contacts;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.myCompanyBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'contact' && payload.result) {
                this.data$ = of(this.transformContactPhoneForSC(payload.data.contactResponse));
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ contact }) => (this.fetching = contact)));
        this.columnsToDisplay = [
            'firstName',
            'workPhone',
            'mobilePhone',
            'otherPhone',
            'email',
            'contactRole',
            'title',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(contacts, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const contactKeys = [];
                contacts.forEach((contactInfo) => contactKeys.push(contactInfo.contactKey));
                const contactKeysString = JSON.stringify(contactKeys);
                this.myCompanyBus.publish({
                    eventType: 'delete',
                    type: 'contact',
                    typeKey: contactKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'firstName'),
                    },
                });
                // TODO: Remove in Future Version if Single Delete is Obsolete
                // contacts.forEach((contact) =>
                //   this.myCompanyBus.publish({
                //     eventType: 'delete',
                //     type: 'contact',
                //     typeKey: `${contact.contactKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showContactDialog = true;
                this.editContactData = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'firstName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters(term, pagination, [], 'firstName'),
        });
    }
    deletePhones(payload) {
        this.myCompanyBus.publish({
            eventType: 'delete',
            type: 'contactPhone',
            payload: {
                delete: payload,
                search: searchFilters('', this.prevPagination, [], 'firstName'),
            },
        });
    }
    contactsCRUD(data) {
        this.myCompanyBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'firstName') }) }));
    }
    closeContactDialog() {
        this.showContactDialog = false;
        this.action = null;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactRole',
                    header: translate.CONTACT_ROLE,
                    formatter: ({ contactRoleKey }) => `${roles[contactRoleKey]}`,
                },
                {
                    field: 'firstName',
                    header: translate.FULL_NAME,
                    formatter: ({ firstName, lastName }) => `${firstName} ${lastName}`,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (contact) => contact,
                    required: true,
                },
                {
                    field: 'workPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.WORK_PHONE}`,
                    formatter: ({ workPhone }) => {
                        var _a;
                        return `${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber) || ''} ${((_a = workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'mobilePhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.MOBILE_PHONE}`,
                    formatter: ({ mobilePhone }) => {
                        var _a;
                        return `${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber) || ''} ${((_a = mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'otherPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.OTHER_PHONE}`,
                    formatter: ({ otherPhone }) => {
                        var _a;
                        return `${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber) || ''} ${((_a = otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'title',
                    header: translate.TITLE,
                },
                {
                    field: 'email',
                    header: translate.EMAIL,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    formatPhoneNumber(phoneNumber, countryCode) {
        try {
            return parsePhoneNumber(phoneNumber, alpha3ToAlpha2(countryCode)).formatInternational();
        }
        catch (_a) {
            return phoneNumber;
        }
    }
    transformContactPhoneForSC(contacts) {
        return contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => {
            const mobilePhone = this.findPhone(contact, 1);
            const otherPhone = this.findPhone(contact, 2);
            const workPhone = this.findPhone(contact, 3);
            return Object.assign(Object.assign({}, contact), { mobilePhone: Object.assign(Object.assign({}, mobilePhone), { phoneNumber: this.formatPhoneNumber(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber, mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneCountryCode) }), otherPhone: Object.assign(Object.assign({}, otherPhone), { phoneNumber: this.formatPhoneNumber(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber, otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneCountryCode) }), workPhone: Object.assign(Object.assign({}, workPhone), { phoneNumber: this.formatPhoneNumber(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber, workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneCountryCode) }) });
        });
    }
    findPhone(contact, phoneTypeKey) {
        try {
            return contact.phone.find((phn) => phn.phoneTypeKey === phoneTypeKey);
        }
        catch (_a) {
            return undefined;
        }
    }
    openViewContact(contact) {
        this.action = 'view';
        this.showContactDialog = true;
        this.editContactData = contact;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            add: toolKeys.MPP_COMPANY_MAINTENANCE,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
            delete: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
ContactsComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MyCompanyBus$1 },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('contacts')
], ContactsComponent.prototype, "contactsSetter", null);
ContactsComponent = __decorate([
    Component({
        selector: 'lib-contacts',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"companyContacts\"\r\n      i18nSearchField=\"{{ 'PARTNERS.CONTACT_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewContact($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showContactDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (deletePhones)=\"deletePhones($event)\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], ContactsComponent);

let ViewCompanyContainerComponent$1 = class ViewCompanyContainerComponent {
    constructor(account, config, myCompanyBus, transloco, spinner, toast) {
        this.account = account;
        this.config = config;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.spinner = spinner;
        this.toast = toast;
        this.subscriptions = [];
        this.accountKey = '';
    }
    ngOnInit() {
        this.fetchMyCompany();
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ master }) => master));
        this.updating$ = this.myCompanyBus.updating$.pipe(map((forms) => Object.values(forms).reduce((updating, form) => {
            return form || updating;
        }, false)));
        this.subscriptions.push(this.myCompanyBus.update$.subscribe((args) => this.update(args)));
        this.subscriptions.push(this.myCompanyBus.create$.subscribe((args) => this.create(args)));
        this.subscriptions.push(this.myCompanyBus.delete$.subscribe((args) => this.delete(args)));
        this.subscriptions.push(this.myCompanyBus.search$.subscribe((args) => this.search(args)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    create({ type, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.account.creates[type](this.accountKey, payload.create)
            .pipe(tap(() => {
            this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')))
                : of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }))
            .subscribe());
    }
    delete({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        type === 'contactPhone'
            ? this.subscriptions.push(this.account
                .deleteAccountContactPhone(`${this.account}`, `${payload.delete.contactPhoneKey}`)
                .pipe(tap(() => this.fetchMyCompany()), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                .subscribe())
            : this.subscriptions.push(this.account.deletes[type](this.accountKey, typeKey)
                .pipe(tap(() => {
                this.search({ type, payload: payload.search });
                this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
                this.spinner.off();
                this.setUpdating(type, false);
            }))
                .subscribe());
    }
    fetchMyCompany() {
        this.spinner.on();
        this.setFetching('master', true);
        this.subscriptions.push(forkJoin([
            this.config.getCurrencyTypes(),
            this.config.getProvinces(),
            this.config.getCountries(),
            this.account.getAccount(),
        ])
            .pipe(tap(([currencies, provinces, countries, myCompany]) => {
            this.accountKey = `${myCompany.details.accountKey}`;
            this.myCompany = myCompany;
            this.currencies = currencies.map((currency) => {
                return {
                    label: currency.description,
                    value: `${currency.currencyTypeKey}`,
                };
            });
            this.provinces = provinces.map((province) => {
                return {
                    label: province.provinceName,
                    value: province.provinceCode.trim(),
                    code: province.countryCode,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: country.countryName,
                    value: country.countryCode.trim(),
                };
            });
        }), finalize(() => {
            this.spinner.off();
            this.setFetching('master', false);
        }), catchError(() => {
            this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE'));
            return of();
        }))
            .subscribe());
    }
    search({ type, payload }) {
        var _a;
        this.setFetching(type, true);
        ((_a = this.accountKey) === null || _a === void 0 ? void 0 : _a.length) === 0
            ? this.subscriptions.push(this.account
                .getAccount()
                .pipe(tap((myCompany) => {
                this.accountKey = `${myCompany.details.accountKey}`;
                this.subscriptions.push(this.account.search[type](this.accountKey, payload)
                    .pipe(tap((data) => {
                    this.myCompanyBus.publish({
                        eventType: 'actionResult',
                        payload: {
                            type,
                            result: true,
                            data,
                        },
                    });
                }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
                    .subscribe());
            }))
                .subscribe())
            : this.subscriptions.push(this.account.search[type](this.accountKey, payload)
                .pipe(tap((data) => {
                this.myCompanyBus.publish({
                    eventType: 'actionResult',
                    payload: {
                        type,
                        result: true,
                        data,
                    },
                });
            }), finalize(() => this.setFetching(type, false)), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))))
                .subscribe());
    }
    update({ type, typeKey, payload }) {
        this.spinner.on();
        this.setUpdating(type, true);
        this.subscriptions.push(this.account.updates[type](this.accountKey, typeKey, payload.update)
            .pipe(tap(() => {
            type === 'details'
                ? this.fetchMyCompany()
                : this.search({ type, payload: payload.search });
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), finalize(() => {
            this.spinner.off();
            this.setUpdating(type, false);
        }), catchError((error) => {
            return error.error.errorCode === 3
                ? of(this.toast.warnNotify(this.transloco.translate('SUPPLIER.WARNING_TOAST_MESSAGE')))
                : of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')));
        }))
            .subscribe());
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    setUpdating(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setUpdating',
            payload: { form, value },
        });
    }
};
ViewCompanyContainerComponent$1.ctorParameters = () => [
    { type: AccountService },
    { type: ConfigService },
    { type: MyCompanyBus$1 },
    { type: TranslocoService },
    { type: SpinnerService },
    { type: ToastrNotificationService }
];
ViewCompanyContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-view-company-container',
        template: ` <lib-view-company
    [myCompany]="myCompany"
    [fetching]="fetching$ | async"
    [updating]="updating$ | async"
    [countries]="countries"
    [provinces]="provinces"
    [currencies]="currencies"
  >
  </lib-view-company>`
    })
], ViewCompanyContainerComponent$1);

let ViewCompanyComponent = class ViewCompanyComponent {
    constructor(accountService, mppService, transloco, confirmationService, spinner, toast, store) {
        this.accountService = accountService;
        this.mppService = mppService;
        this.transloco = transloco;
        this.confirmationService = confirmationService;
        this.spinner = spinner;
        this.toast = toast;
        this.store = store;
        this.imageSrc = '';
        this.imageAlt = '';
        this.isCompanyLogoPresent = false;
        this.logoUploaded = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set myCompanySetter(myCompany) {
        this.myCompany = myCompany;
        this.displayLogo();
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.uploadLogoUrl = this.mppService.getConfig().accountAssetsEndPoint;
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onLogoUpload(event) {
        this.spinner.on();
        if (event.originalEvent &&
            event.originalEvent.body &&
            event.originalEvent.body[0] &&
            event.originalEvent.body[0].id) {
            this.myCompany.details.logo_AccountAssetKey = this.accountAssetKey;
            this.accountAssetKey = event.originalEvent.body[0].id;
            this.subscriptions.push(this.accountService
                .updateLogoAccountAssetKey(this.myCompany.details)
                .pipe(tap(() => {
                this.imageSrc = this.accountService.getImageUrl(this.accountAssetKey, this.myCompany.details.accountKey);
                this.isCompanyLogoPresent = true;
                this.toast.successNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_SUCCESS'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_FAILURE')))), finalize(() => this.spinner.off()))
                .subscribe());
        }
    }
    displayLogo() {
        try {
            this.accountAssetKey = Number(this.myCompany.details.logo_AccountAssetKey);
            this.imageSrc =
                this.accountAssetKey > 0
                    ? this.accountService.getImageUrl(this.accountAssetKey, this.myCompany.details.accountKey)
                    : '';
            this.isCompanyLogoPresent = this.accountAssetKey > 0 ? true : false;
        }
        catch (error) {
            /*empty */
        }
    }
    logoUploadError() {
        this.logoUploaded = false;
        this.toast.errorNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_FAILURE'));
    }
    onLogoSelect(event) {
        if (event.files[0].size > 5000000) {
            this.toast.errorNotify(this.transloco.translate('VALIDATION_MESSAGE.ASSET_UPLOAD_MAX_SIZE'));
        }
        const extension = event.files[0].type.split('/').pop().toLocaleLowerCase();
        const extensions = ['jpg', 'png', 'jpeg', 'gif'];
        if (!extensions.includes(extension)) {
            this.toast.errorNotify(this.transloco.translate('COMPANY.INVALID_FORMAT_MSG'));
        }
    }
    confirmLogoDelete() {
        this.confirmationService.confirm({
            message: this.transloco.translate('PIM.DELETE_ASSET_CONFIRM'),
            header: this.transloco.translate('ADMINISTRATION.DELETE_DIALOG_HEADER'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.transloco.translate('ACTIONS.YES'),
            rejectLabel: this.transloco.translate('ACTIONS.NO'),
            accept: () => {
                this.subscriptions.push(this.accountService
                    .deleteCompanyLogo(this.accountAssetKey)
                    .pipe(tap((res) => ((this.isCompanyLogoPresent = false), this.deleteLogoAssetKey())))
                    .subscribe());
            },
            reject: () => { },
        });
    }
    deleteLogoAssetKey() {
        this.subscriptions.push(this.accountService.deleteLogoAccountAssetKey().subscribe((res) => {
            this.isCompanyLogoPresent = false;
            this.toast.successNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_DELETE_SUCCESS'));
        }, (error) => {
            this.toast.errorNotify(this.transloco.translate('MESSAGES.GENERIC_ERROR'));
        }));
    }
    getPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
ViewCompanyComponent.ctorParameters = () => [
    { type: AccountService },
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ConfirmationService$1 },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: Store }
];
__decorate([
    Input('myCompany')
], ViewCompanyComponent.prototype, "myCompanySetter", null);
__decorate([
    Input()
], ViewCompanyComponent.prototype, "currencies", void 0);
__decorate([
    Input()
], ViewCompanyComponent.prototype, "countries", void 0);
__decorate([
    Input()
], ViewCompanyComponent.prototype, "provinces", void 0);
__decorate([
    Input()
], ViewCompanyComponent.prototype, "fetching", void 0);
__decorate([
    Input()
], ViewCompanyComponent.prototype, "updating", void 0);
ViewCompanyComponent = __decorate([
    Component({
        selector: 'lib-view-company',
        template: "<div\r\n  *ngIf=\"authorizedActions?.view || authorizedActions?.edit\"\r\n  class=\"details-container\"\r\n>\r\n  <div>\r\n    <lib-company-header\r\n      [imageTemplate]=\"header_image\"\r\n      [titleTemplate]=\"header_title\"\r\n      [contentTemplate]=\"header_content\"\r\n    >\r\n      <ng-template #header_title>\r\n        <h2 class=\"header-card-title\">{{ 'COMPANY.COMPANY' | transloco }}</h2>\r\n      </ng-template>\r\n      <ng-template #header_image>\r\n        <ng-container *ngIf=\"isCompanyLogoPresent; else logoMissing\">\r\n          <div class=\"img-container header\">\r\n            <img class=\"target\" [src]=\"imageSrc\" />\r\n            <button\r\n              *ngIf=\"authorizedActions?.edit\"\r\n              pButton\r\n              class=\"ds tertiary small control\"\r\n              type=\"button\"\r\n              (click)=\"confirmLogoDelete()\"\r\n            >\r\n              {{ 'ACTIONS.DELETE' | transloco }}\r\n            </button>\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #logoMissing>\r\n          <div class=\"img-container header no-img\">\r\n            <span>\r\n              {{ 'COMPANY.LOGO_DEFAULT_MSG_1' | transloco }}<br />{{\r\n                'COMPANY.LOGO_DEFAULT_MSG_2' | transloco\r\n              }}\r\n            </span>\r\n            <p-fileUpload\r\n              *ngIf=\"authorizedActions?.edit\"\r\n              chooseLabel=\"{{ 'ACTIONS.ADD' | transloco }}\"\r\n              styleClass=\"ds small tertiary ui-button control\"\r\n              [url]=\"uploadLogoUrl\"\r\n              mode=\"basic\"\r\n              (onUpload)=\"onLogoUpload($event)\"\r\n              accept=\".jpg,.png,.jpeg,.gif\"\r\n              maxFileSize=\"5000000\"\r\n              [auto]=\"true\"\r\n              (onError)=\"logoUploadError()\"\r\n              (onSelect)=\"onLogoSelect($event)\"\r\n              withCredentials=\"true\"\r\n            >\r\n            </p-fileUpload>\r\n          </div>\r\n        </ng-template>\r\n      </ng-template>\r\n      <ng-template #header_content>\r\n        <div class=\"vertical-flow\">\r\n          <h4 class=\"content-title\">\r\n            <ng-container\r\n              *ngIf=\"myCompany?.details?.dbaName?.length > 0; else legalName\"\r\n            >\r\n              {{ myCompany?.details?.legalName }} ({{\r\n                myCompany?.details?.dbaName\r\n              }})\r\n            </ng-container>\r\n            <ng-template #legalName>\r\n              {{ myCompany?.details?.legalName }}\r\n            </ng-template>\r\n          </h4>\r\n          <!-- <p>\r\n            {{ 'SUPPLIER.LBMXID' | transloco }}\r\n            {{ myCompany?.details?.lbmxId }}\r\n          </p> -->\r\n        </div>\r\n      </ng-template>\r\n    </lib-company-header>\r\n  </div>\r\n  <div>\r\n    <p-tabView>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n        <lib-details\r\n          [details]=\"myCompany?.details\"\r\n          [countries]=\"countries\"\r\n          [provinces]=\"provinces\"\r\n          [currencies]=\"currencies\"\r\n          [permissions]=\"authorizedActions\"\r\n        ></lib-details>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n        <lib-contacts [contacts]=\"myCompany?.contacts\"></lib-contacts>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_BANKING' | transloco }}\">\r\n        <lib-company-banking></lib-company-banking>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_PAYMENT_PREFERENCES' | transloco }}\">\r\n        <lib-company-payment-preferences></lib-company-payment-preferences>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_LOCATIONS' | transloco }}\">\r\n        <lib-company-locations\r\n          [locations]=\"myCompany?.locations\"\r\n        ></lib-company-locations>\r\n      </p-tabPanel>\r\n    </p-tabView>\r\n    <p-confirmDialog\r\n      [closeOnEscape]=\"false\"\r\n      [closable]=\"false\"\r\n    ></p-confirmDialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".content-title{font-size:22px;display:block;margin:0}"]
    })
], ViewCompanyComponent);

let CompanyModule = class CompanyModule {
};
CompanyModule = __decorate([
    NgModule({
        declarations: [
            ViewCompanyComponent,
            CompanyComponent$1,
            CompanyHeaderComponent,
            ContactsComponent,
            CompanyLocationsComponent,
            DetailsComponent,
            ContactFormComponent,
            ContactFormContainerComponent,
            ViewCompanyContainerComponent$1,
            LocationFormComponent,
            LocationFormContainerComponent,
            CompanyBankingComponent,
            CompanyPaymentPreferencesComponent,
        ],
        imports: [
            AdvancedSearchLoaderModule,
            CommonModule,
            ConfirmDialogModule,
            TranslocoModule,
            TabViewModule,
            DropdownModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule,
            MenuModule,
            SearchContainerLoaderModule,
            SearchContainerModule$1,
            DialogModule,
            UtilsModule,
            ListboxModule,
            InputMaskModule,
            FileUploadModule,
            PhoneFormModule,
        ],
    })
], CompanyModule);

var Status;
(function (Status) {
    Status[Status["ERROR"] = -1] = "ERROR";
    Status[Status["READY"] = 0] = "READY";
    Status[Status["LOADING"] = 1] = "LOADING";
    Status[Status["DONE"] = 2] = "DONE";
})(Status || (Status = {}));
const defaultScreenState = {
    startPage: 0,
    page: 0,
    screens: {},
    status: Status.LOADING,
};
const ɵ0$6 = (_, state) => {
    const status = state.status < 0 ? state.status : Status.DONE;
    return { status };
}, ɵ1$4 = (status) => ({ status }), ɵ2$3 = (screens) => ({ screens }), ɵ3$2 = (_, { page }) => ({
    status: Status.LOADING,
    page: page + 1,
}), ɵ4 = (_, { page }) => ({
    status: Status.LOADING,
    page: page - 1,
}), ɵ5 = ({ screen, index }, { screens }) => {
    return { screens: Object.assign(Object.assign({}, screens), { [index]: screen }) };
};
const screenSchema = {
    finalize: {
        command: ɵ0$6,
    },
    setStatus: { command: ɵ1$4 },
    setScreens: { command: ɵ2$3 },
    nextPage: {
        command: ɵ3$2,
    },
    previousPage: {
        command: ɵ4,
    },
    addScreen: {
        command: ɵ5,
    },
};
const ɵ6 = () => ({
    fetchUrl: '/connectors/type',
    fetchMethod: 'GET',
    title: 'New Connector',
    form: (options) => ({
        fields: {
            description: { type: 'text', required: true },
            connectorType: { type: 'pDropdown', options, required: true },
        },
    }),
    response: ({ screenConfig, response }) => {
        const { form } = screenConfig;
        return form(response);
    },
}), ɵ7 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}`,
    fetchMethod: 'GET',
    title: `Configuration`,
    response: ({ response }) => {
        return response;
    },
}), ɵ8 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}/form`,
    fetchMethod: 'POST',
    title: `Actions`,
    response: ({ response }) => {
        return response;
    },
});
const wizardConfig = [
    ɵ6,
    ɵ7,
    ɵ8,
];

var DefaultButtons;
(function (DefaultButtons) {
    DefaultButtons["CANCEL"] = "cancel";
    DefaultButtons["NEXT"] = "next";
    DefaultButtons["PREVIOUS"] = "previous";
    DefaultButtons["SUBMIT"] = "submit";
})(DefaultButtons || (DefaultButtons = {}));
const defaultButtonProperties = {
    icon: '',
    iconPos: 'left',
    style: {},
};
const ɵ0$7 = ({ events }) => {
    events.cancel.emit();
}, ɵ1$5 = (state, form) => false, ɵ2$4 = ({ actions, state, form }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    actions.nextPage.dispatch();
}, ɵ3$3 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ4$1 = ({ actions }) => {
    actions.previousPage.dispatch();
}, ɵ5$1 = (state, form) => state.page === 0, ɵ6$1 = ({ actions, form, state, events }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    events.submit.emit();
}, ɵ7$1 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ8$1 = (_) => { }, ɵ9 = (state, form) => false;
const buttonDefaults = {
    cancel: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ0$7,
        disabled: ɵ1$5,
    },
    next: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ2$4,
        disabled: ɵ3$3,
    },
    previous: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ4$1,
        disabled: ɵ5$1,
    },
    submit: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ6$1,
        disabled: ɵ7$1,
    },
    default: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ8$1,
        disabled: ɵ9,
    },
};

let ScreenComponent = class ScreenComponent {
    constructor(actionUi, formGenerator, http) {
        this.actionUi = actionUi;
        this.formGenerator = formGenerator;
        this.http = http;
        this.screenSubmit = new EventEmitter();
        this.screenCancel = new EventEmitter();
        this.fetch = new Subject();
        this.statusEnum = Status;
        this.isValid = false;
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), tap((state) => (this.status = state.status)), tap((_) => { var _a; return (this.isValid = ((_a = this.form) === null || _a === void 0 ? void 0 : _a.valid) || false); }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch
            .pipe(exhaustMap(() => this.request.pipe(catchError((err) => {
            this.actions.setStatus.dispatch(Status.ERROR);
            return of(err);
        }), finalize(() => this.actions.finalize.dispatch()))), tap((form) => {
            this.form = this.formGenerator.init(this.screen.response({
                screenConfig: this.screen,
                response: form,
            }), this.state.screens[this.state.page] || {});
        }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    buildRequest() {
        this.request = this.http.fetch({
            endpoint: this.screen.fetchUrl,
            httpMethod: this.screen.fetchMethod,
            responseField: this.screen.responseField,
            body: this.screen.body,
        });
    }
    ngOnInit() {
        this.screen = this.config(this.state);
        this.buttons = this.addButtonDefaults(this.screen.buttons);
        this.buildRequest();
        this.fetch.next();
    }
    submit() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.addScreen.dispatch({
            screen: this.form.values,
            index: this.state.page,
        });
        this.actions.nextPage.dispatch();
        this.screenSubmit.emit();
    }
    previous() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.previousPage.dispatch();
    }
    addButtonDefaults(buttons) {
        return Object.entries(buttons).reduce((controlSchema, [key, button]) => {
            const newButton = button.componentProperties
                ? Object.assign(Object.assign({}, button), { componentProperties: Object.assign(Object.assign({}, defaultButtonProperties), button.componentProperties) }) : Object.assign(Object.assign({}, button), { componentProperties: Object.assign({}, defaultButtonProperties) });
            switch (key) {
                case DefaultButtons.CANCEL:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.cancel), newButton) });
                case DefaultButtons.NEXT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.next), newButton) });
                case DefaultButtons.PREVIOUS:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.previous), newButton) });
                case DefaultButtons.SUBMIT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.submit), newButton) });
                default:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.default), newButton) });
            }
        }, {});
    }
    get screenControls() {
        return {
            actions: this.actions,
            state: this.state,
            form: this.form,
            events: { submit: this.screenSubmit, cancel: this.screenCancel },
        };
    }
    preserveOrder() {
        return 0;
    }
};
ScreenComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: GenerateFormService },
    { type: BaseHttpService }
];
__decorate([
    Input()
], ScreenComponent.prototype, "config", void 0);
__decorate([
    Input()
], ScreenComponent.prototype, "actions", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenSubmit", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenCancel", void 0);
ScreenComponent = __decorate([
    Component({
        selector: 'lib-screen',
        template: "<div class=\"screen\" style=\"display: flex; flex-direction: column\">\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <ng-container *ngIf=\"status === statusEnum.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.READY\"> ready</ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.LOADING\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.DONE\">\r\n      <div style=\"display: flex; justify-content: center\">\r\n        <h2>{{ screen.title }}</h2>\r\n      </div>\r\n      <lui-form *ngIf=\"form\" [form]=\"form\"></lui-form>\r\n    </ng-container>\r\n  </div>\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; margin-bottom: 5em\"\r\n  >\r\n    <button\r\n      *ngFor=\"let button of buttons | keyvalue: preserveOrder\"\r\n      pButton\r\n      (click)=\"button.value.callback(screenControls)\"\r\n      [disabled]=\"button.value.disabled(state, form)\"\r\n      [icon]=\"button.value.componentProperties.icon\"\r\n      [iconPos]=\"button.value.componentProperties.iconPos\"\r\n      [label]=\"button.value.label\"\r\n      [ngStyle]=\"button.value.componentProperties.style\"\r\n      class=\"ds {{ button.value.role }}\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n",
        styles: [".controls{display:flex;flex-direction:row}"]
    })
], ScreenComponent);

let WizardComponent = class WizardComponent {
    constructor(actionUi) {
        this.actionUi = actionUi;
        this.defaultState = {};
        this.finalize = new EventEmitter();
        this.cancel = new EventEmitter();
        this.actions = Action.createDispatcher(screenSchema);
    }
    ngOnInit() {
        this.actionUi.initialize(Object.assign(Object.assign({}, defaultScreenState), this.defaultState), this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    screenSubmit() {
        this.finalize.emit(Object.values(this.state.screens));
    }
};
WizardComponent.ctorParameters = () => [
    { type: ActionUiService }
];
__decorate([
    Input()
], WizardComponent.prototype, "wizardConfig", void 0);
__decorate([
    Input()
], WizardComponent.prototype, "defaultState", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "finalize", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "cancel", void 0);
WizardComponent = __decorate([
    Component({
        selector: 'lib-wizard',
        template: "<div class=\"wizard\">\r\n  <ng-container *ngFor=\"let screen of wizardConfig; index as i\">\r\n    <lib-screen\r\n      *ngIf=\"state.page === i\"\r\n      appScreen\r\n      [config]=\"screen\"\r\n      [actions]=\"actions\"\r\n      (screenCancel)=\"cancel.emit()\"\r\n      (screenSubmit)=\"screenSubmit()\"\r\n    ></lib-screen>\r\n  </ng-container>\r\n</div>\r\n",
        providers: [ActionUiService]
    })
], WizardComponent);

let WizardModule = class WizardModule {
};
WizardModule = __decorate([
    NgModule({
        declarations: [WizardComponent, ScreenComponent],
        imports: [
            CommonModule,
            PerFormPrimengModule,
            PerFormModule,
            ButtonModule$1,
            ProgressSpinnerModule,
            TranslocoModule,
        ],
        exports: [WizardComponent],
    })
], WizardModule);

const defaultState = {
    defaultState: {
        page: 0,
        screens: {},
    },
    viewDefaultState: {
        page: 0,
        screens: {},
    },
    showWizard: false,
    showViewWizard: false,
    toolbarActionsType: '',
};
const ɵ0$8 = (defaultWizardState) => ({
    defaultState: defaultWizardState,
}), ɵ1$6 = (viewDefaultWizardState) => ({
    viewDefaultState: viewDefaultWizardState,
}), ɵ2$5 = (showWizard) => ({
    showWizard,
}), ɵ3$4 = (showViewWizard) => ({
    showViewWizard,
}), ɵ4$2 = (toolbarActionsType) => ({
    toolbarActionsType,
});
const schema = {
    setDefaultState: {
        command: ɵ0$8,
    },
    setViewDefaultState: {
        command: ɵ1$6,
    },
    setShowWizard: {
        command: ɵ2$5,
    },
    setShowViewWizard: {
        command: ɵ3$4,
    },
    setToolbarActionsType: {
        command: ɵ4$2,
    },
};
const wizardConfig$1 = (translateService) => [
    ({ title }) => ({
        fetchUrl: 'banking/form',
        fetchMethod: 'GET',
        responseField: 'fields',
        title: translateService.translate(title),
        form: (fields) => ({
            fields,
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens, startPage, page, title }) => ({
        fetchUrl: `banking/form/${screens[0].bankCountry}`,
        fetchMethod: 'GET',
        title: translateService.translate(title),
        response: ({ response }) => {
            return addValidations(response, translateService);
        },
        buttons: Object.assign({
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
        }, page > startPage && {
            previous: {
                label: translateService.translate('ACTIONS.PREVIOUS'),
            },
        }, {
            submit: {
                label: translateService.translate('ACTIONS.SAVE'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        }),
    }),
];
const viewWizardConfig = (translateService) => [
    ({ title }) => ({
        fetchUrl: 'banking/form',
        fetchMethod: 'GET',
        responseField: 'fields',
        title: translateService.translate(title),
        form: (fields) => ({
            fields,
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(Object.entries(response).reduce((fields, [prop, value]) => {
                return Object.assign(Object.assign({}, fields), { [`${prop}`]: Object.assign(Object.assign({}, value), { readonly: true }) });
            }, {}));
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CLOSE'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens }) => ({
        fetchUrl: `banking/form/${screens[0].bankCountry}`,
        fetchMethod: 'GET',
        title: translateService.translate('PARTNERS.VIEW_BANKING_INFORMATION'),
        response: ({ response }) => {
            var _a, _b, _c;
            const bankFileTemplateKeys = (_a = response === null || response === void 0 ? void 0 : response.fields) === null || _a === void 0 ? void 0 : _a.bankFileTemplateTypeKeys;
            response =
                (bankFileTemplateKeys === null || bankFileTemplateKeys === void 0 ? void 0 : bankFileTemplateKeys.type) === 'multiSelect'
                    ? Object.assign(Object.assign({}, response), { fields: Object.assign(Object.assign({}, response === null || response === void 0 ? void 0 : response.fields), { bankFileTemplateTypeKeys: ((_c = (_b = screens[1]) === null || _b === void 0 ? void 0 : _b.bankFileTemplateTypeKeys) === null || _c === void 0 ? void 0 : _c.length) > 0
                                ? Object.assign(Object.assign({}, bankFileTemplateKeys), { componentProperties: {
                                        showIcon: false,
                                    } }) : {
                                type: 'text',
                                label: bankFileTemplateKeys === null || bankFileTemplateKeys === void 0 ? void 0 : bankFileTemplateKeys.label,
                                required: true,
                            } }) }) : response;
            return Object.assign(Object.assign({}, response), { fields: Object.entries(response.fields).reduce((fields, [prop, value]) => {
                    return Object.assign(Object.assign({}, fields), { [`${prop}`]: Object.assign(Object.assign({}, value), { readonly: true, required: false }) });
                }, {}) });
        },
        buttons: {
            submit: {
                label: translateService.translate('ACTIONS.CLOSE'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
];
function addValidations(response, translateService) {
    const fieldsWithValidations = Object.keys(Object.assign({}, response === null || response === void 0 ? void 0 : response.fields)).reduce((fields, fieldsProperty) => {
        const currentValue = Object.assign({}, response === null || response === void 0 ? void 0 : response.fields)[fieldsProperty];
        if (typeof currentValue === 'object') {
            fields[fieldsProperty] = currentValue;
            // switch (fieldsProperty) {
            // case 'routingNumber':
            //   fields[fieldsProperty] = {
            //     ...currentValue,
            //     validations: [
            //       {
            //         test: isNumber('routingNumber'),
            //         message: translateService.translate('PARTNERS.NUMERIC_ONLY'),
            //       },
            //       {
            //         test: maxCharacters('routingNumber', 9),
            //         message: translateService.translate(
            //           'PARTNERS.NINE_CHARACTER_MAX'
            //         ),
            //       },
            //     ],
            //   };
            //   break;
            // case 'institutionNumber':
            //   fields[fieldsProperty] = {
            //     ...currentValue,
            //     validations: [
            //       {
            //         test: isNumber('institutionNumber'),
            //         message: translateService.translate('PARTNERS.NUMERIC_ONLY'),
            //       },
            //       {
            //         test: maxCharacters('institutionNumber', 9),
            //         message: translateService.translate(
            //           'PARTNERS.NINE_CHARACTER_MAX'
            //         ),
            //       },
            //     ],
            //   };
            //   break;
            // case 'transitNumber':
            //   fields[fieldsProperty] = {
            //     ...currentValue,
            //     validations: [
            //       {
            //         test: isNumber('transitNumber'),
            //         message: translateService.translate('PARTNERS.NUMERIC_ONLY'),
            //       },
            //       // {
            //       //   test: maxCharacters('transitNumber', 5),
            //       //   message: translateService.translate(
            //       //     'PARTNERS.FIVE_CHARACTER_MAX'
            //       //   ),
            //       // },
            //     ],
            //   };
            //   break;
            //   default:
            //     fields[fieldsProperty] = currentValue;
            //     break;
            // }
        }
        return fields;
    }, {});
    return Object.assign(Object.assign({}, response), { fields: fieldsWithValidations });
}
const isNumber = (fieldToCheck) => ({ [fieldToCheck]: field }) => {
    return !isNaN(Number(field));
};
const ɵ5$2 = isNumber;
const maxCharacters = (fieldToCheck, length) => ({ [fieldToCheck]: field }) => {
    return `${field}`.length <= length;
};
const ɵ6$2 = maxCharacters;

let CompanyBankingComponent$1 = class CompanyBankingComponent {
    constructor(actionUi, confirmationService, http, translocoService, toast, spinner, searchContainerLoaderService, mppService, interceptorResponseService) {
        this.actionUi = actionUi;
        this.confirmationService = confirmationService;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        this.interceptorResponseService = interceptorResponseService;
        // dialog configs
        this.showDialog = false;
        this.actionType = '';
        // search container loader states
        this.subscriptions = [];
        this.searchContainerName = 'CompanyBankingSearch';
        this.i18nSearchField = 'PARTNERS.BANKING_SEARCH';
        this.toolbarActionsDispatcher = {
            new: () => {
                this.actions.setDefaultState.dispatch({
                    page: 0,
                    title: 'PARTNERS.NEW_BANKING_INFORMATION',
                    screens: {},
                });
                this.actions.setToolbarActionsType.dispatch('new');
                this.actions.setShowWizard.dispatch(true);
            },
            edit: (selection) => {
                var _a;
                this.spinner.on();
                this.http
                    .fetch({
                    endpoint: `banking/${(_a = selection[0]) === null || _a === void 0 ? void 0 : _a.accountBankingInfoKey}`,
                    httpMethod: 'GET',
                })
                    .pipe(tap((bankingInfo) => {
                    var _a, _b, _c;
                    this.selectionKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.accountBankingInfoKey;
                    this.actions.setDefaultState.dispatch({
                        startPage: 1,
                        page: 1,
                        title: 'PARTNERS.EDIT_BANKING_INFORMATION',
                        screens: {
                            0: {
                                bankCountry: (_b = selection[0]) === null || _b === void 0 ? void 0 : _b.countryCode,
                                description: (_c = selection[0]) === null || _c === void 0 ? void 0 : _c.description,
                            },
                            1: Object.assign({}, bankingInfo === null || bankingInfo === void 0 ? void 0 : bankingInfo.record),
                        },
                    });
                    this.actions.setToolbarActionsType.dispatch('edit');
                    this.actions.setShowWizard.dispatch(true);
                }), catchError(() => {
                    return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
                }), finalize(() => this.spinner.off()))
                    .subscribe();
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.update(this.http.fetch({
                            endpoint: 'banking/delete',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { accountBankingInfoKey } = _a, _ = __rest(_a, ["accountBankingInfoKey"]);
                                    return accountBankingInfoKey;
                                }),
                            },
                        }));
                    },
                    reject: () => { },
                });
            },
            view: (selection) => {
                this._view(selection[0]);
            },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/banking`;
        this.columnActions = {
            description: {
                link: () => ({ path: './' }),
                event: (bankingInfo) => bankingInfo,
            },
        };
        this.actions = Action.createDispatcher(schema);
        http.baseUrl = mppService.getConfig().account;
    }
    ngOnInit() {
        this.actionUi.initialize(defaultState, this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.wizardConfig = wizardConfig$1(this.translocoService);
        this.viewWizardConfig = viewWizardConfig(this.translocoService);
    }
    _view(selectedBankingIfo) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `banking/${selectedBankingIfo === null || selectedBankingIfo === void 0 ? void 0 : selectedBankingIfo.accountBankingInfoKey}`,
            httpMethod: 'GET',
        })
            .pipe(tap((bankingData) => {
            this.actions.setViewDefaultState.dispatch({
                page: 1,
                title: 'PARTNERS.VIEW_BANKING_INFORMATION',
                screens: {
                    0: {
                        bankCountry: selectedBankingIfo === null || selectedBankingIfo === void 0 ? void 0 : selectedBankingIfo.countryCode,
                        description: selectedBankingIfo === null || selectedBankingIfo === void 0 ? void 0 : selectedBankingIfo.description,
                    },
                    1: Object.assign({}, bankingData === null || bankingData === void 0 ? void 0 : bankingData.record),
                },
            });
            this.actions.setToolbarActionsType.dispatch('view');
            this.actions.setShowViewWizard.dispatch(true);
        }), catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe();
    }
    data(data) {
        var _a;
        const body = Object.assign(Object.assign(Object.assign({}, data[0]), { countryCode: (_a = data[0]) === null || _a === void 0 ? void 0 : _a.bankCountry }), data[1]);
        this.state.toolbarActionsType === 'new'
            ? this.update(this.http.fetch({
                endpoint: 'banking',
                httpMethod: 'POST',
                body,
            }))
            : this.update(this.http.fetch({
                endpoint: `banking/${this.selectionKey}`,
                httpMethod: 'PUT',
                body,
            }));
    }
    update(bankingInfo) {
        this.spinner.on();
        bankingInfo
            .pipe(catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
            .subscribe();
        this.interceptorResponseService.success$
            .pipe(tap(() => {
            this.actions.setShowWizard.dispatch(false);
            this.searchContainerLoaderService.refreshSearch();
        }))
            .subscribe();
    }
};
CompanyBankingComponent$1.ctorParameters = () => [
    { type: ActionUiService },
    { type: ConfirmationService$1 },
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService },
    { type: InterceptorResponseService }
];
CompanyBankingComponent$1 = __decorate([
    Component({
        selector: 'lib-company-banking',
        template: "<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [baseUrl]=\"baseUrl\"\r\n  [columnActions]=\"columnActions\"\r\n  (field)=\"_view($event)\"\r\n  [disableAdvancedSearch]=\"true\"\r\n></lib-search-container-loader>\r\n\r\n<p-dialog\r\n  *ngIf=\"state.showWizard\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n  <lib-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [defaultState]=\"state.defaultState\"\r\n    (finalize)=\"data($event)\"\r\n    (cancel)=\"actions.setShowWizard.dispatch(false)\"\r\n  ></lib-wizard>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"state.showViewWizard\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n  <lib-wizard\r\n    [wizardConfig]=\"viewWizardConfig\"\r\n    [defaultState]=\"state.viewDefaultState\"\r\n    (finalize)=\"actions.setShowViewWizard.dispatch(false)\"\r\n    (cancel)=\"actions.setShowViewWizard.dispatch(false)\"\r\n  ></lib-wizard>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, ConfirmationService$1]
    })
], CompanyBankingComponent$1);

let DetailsComponent$1 = class DetailsComponent {
    constructor(formBuilder, myCompanyBus, transloco) {
        this.formBuilder = formBuilder;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.account = {
            details: { country: '' },
        };
        this.fax = {
            fax: () => this.transloco.translate('VALIDATION_MESSAGE.COMPANY_FAX'),
        };
        this.website = {
            website: () => this.transloco.translate('VALIDATION_MESSAGE.WEBSITE'),
        };
        this.phoneNumber = {
            phoneNumber: () => this.transloco.translate('VALIDATION_MESSAGE.COMPANY_PHONE'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
        this.disableProvinceDropdown = true;
        this.enableEdit = false;
        this.permissions = {};
    }
    set detailsSetter(details) {
        this.details = details;
        try {
            this.details.fax = parsePhoneNumber(this.details.fax, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational();
            this.details.phone = parsePhoneNumber(this.details.phone, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational();
        }
        catch (_a) { }
        this.initializeForm(details);
    }
    set accountSetter(account) {
        this.account = account;
    }
    set currenciesSetter(currencies) {
        this.currencies = currencies;
    }
    set countriesSetter(countries) {
        this.countries = countries;
    }
    set provincesSetter(provinces) {
        this.provinces = provinces;
        this.filteredProvinces = provinces;
        this.getFilteredProvinces(this.provinces);
    }
    set permissionsSetter(permissions) {
        this.permissions = permissions;
    }
    initializeForm(detailsInput) {
        const details = detailsInput ||
            { fax: '', country: '', province: '' };
        this.detailsForm = this.formBuilder.group({
            legalName: [details.legalName, Validators.required],
            dbaName: [details.dbaName, Validators.required],
            address1: [details.address1, Validators.required],
            address2: [details.address2],
            country: [details.country.trim(), Validators.required],
            city: [details.city, Validators.required],
            postalCode: [details.postalCode, Validators.required],
            province: [details.province.trim(), Validators.required],
            currencyTypeKey: [`${details.currencyTypeKey}`, Validators.required],
            // isaNumber: [details.isaNumber],
            phone: [
                this.formatPhoneToInternational(details.phone, details.country),
                Validators.compose([Validators.required, this.validatePhoneNumber()]),
            ],
            fax: [
                this.formatPhoneToInternational(details.fax, details.country),
                Validators.compose([this.validateFaxNumber()]),
            ],
            website: [details.website],
        });
        this.getFilteredProvinces(this.provinces);
    }
    // bound to Phone and Fax control's input event
    formatPhoneNumber(input) {
        try {
            if (input.length < 1) {
                this.detailsForm
                    .get('phone')
                    .setValue(alpha3ToAlpha2(this.account ? this.account.details.country : 'CA'));
            }
            this.detailsForm
                .get('phone')
                .setValue(parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational());
        }
        catch (_a) {
            /*empty*/
        }
    }
    // bound to Phone and Fax control's input event
    formatFaxNumber(input) {
        try {
            if (input.length < 1) {
                this.detailsForm
                    .get('fax')
                    .setValue(alpha3ToAlpha2(this.account ? this.account.details.country : 'CA'));
            }
            this.detailsForm
                .get('fax')
                .setValue(parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).formatInternational());
        }
        catch (_a) {
            /*empty*/
        }
    }
    preventCharacter(event) {
        return event.keyCode !== 187;
    }
    // bound to Countries Dropdown control's onChange event
    resetFaxNumberAndProvince(selectedCountry) {
        this.detailsForm.get('province').setValue('');
        this.detailsForm.get('fax').setValue('');
        this.detailsForm.get('phone').setValue('');
        this.filteredProvinces = this.provinces.filter((province) => province.code === selectedCountry.value);
        this.disableProvinceDropdown = false;
    }
    formatNumberForSave(input) {
        try {
            return parsePhoneNumber(input, alpha3ToAlpha2(this.detailsForm.get('country').value)).format('E.164');
        }
        catch (_a) {
            return '';
        }
    }
    save() {
        var _a, _b;
        this.myCompanyBus.publish({
            eventType: 'update',
            type: 'details',
            payload: {
                update: Object.assign(Object.assign(Object.assign({}, this.details), this.detailsForm.value), { currencyTypeKey: Number((_b = (_a = this.detailsForm) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.currencyTypeKey), fax: this.formatNumberForSave(this.detailsForm.get('fax').value), phone: this.formatNumberForSave(this.detailsForm.get('phone').value) }),
            },
        });
        this.configEditModal();
    }
    configEditModal() {
        this.enableEdit = !this.enableEdit;
    }
    cancelEditModal() {
        this.initializeForm(this.details);
        this.enableEdit = !this.enableEdit;
    }
    validatePhoneNumber() {
        return (control) => {
            try {
                return this.checkValidity(control)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (error) {
                return error instanceof ParseError
                    ? {
                        invalidPhoneNumber: true,
                    }
                    : null;
            }
        };
    }
    validateFaxNumber() {
        return (control) => {
            var _a, _b;
            if (((_a = control.value) === null || _a === void 0 ? void 0 : _a.length) === undefined) {
                return null;
            }
            try {
                return this.checkValidity(control)
                    ? null
                    : {
                        invalidPhoneNumber: true,
                    };
            }
            catch (error) {
                return ((_b = control.value) === null || _b === void 0 ? void 0 : _b.length) === 0 || undefined
                    ? null
                    : error instanceof ParseError
                        ? {
                            invalidPhoneNumber: true,
                        }
                        : null;
            }
        };
    }
    checkValidity(control) {
        var _a, _b;
        const parsedPhoneNumber = parsePhoneNumber(control.value.toString());
        return (isValidPhoneNumber(parsedPhoneNumber.formatInternational(), this.getPhoneCountry(parsedPhoneNumber)) &&
            isValidNumberForRegion(control.value.toString(), alpha3ToAlpha2((_b = (_a = this.detailsForm.get('country')) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim())));
    }
    getPhoneCountry(parsedPhoneNumber) {
        var _a;
        return ((_a = alpha3ToAlpha2(this.detailsForm.get('country').value.trim())) === null || _a === void 0 ? void 0 : _a.length) > 0
            ? alpha3ToAlpha2(this.detailsForm.get('country').value.trim())
            : parsedPhoneNumber.country;
    }
    getFilteredProvinces(provinces) {
        if (provinces !== undefined) {
            // Once province list is available see if user has country set,if not disable province dropdown
            const countryCode = this.detailsForm
                ? this.detailsForm.get('country').value.trim()
                : '';
            this.disableProvinceDropdown = countryCode.length === 0 ? true : false;
            if (countryCode.length !== 0) {
                this.filteredProvinces = provinces.filter((province) => province.code === countryCode);
            }
        }
    }
    formatPhoneToInternational(fax, country) {
        try {
            return parsePhoneNumber(fax, alpha3ToAlpha2(country || 'CA')).formatInternational();
        }
        catch (_a) {
            return fax;
        }
    }
};
DetailsComponent$1.ctorParameters = () => [
    { type: FormBuilder },
    { type: MyCompanyBus },
    { type: TranslocoService }
];
__decorate([
    Input('details')
], DetailsComponent$1.prototype, "detailsSetter", null);
__decorate([
    Input('account')
], DetailsComponent$1.prototype, "accountSetter", null);
__decorate([
    Input('currencies')
], DetailsComponent$1.prototype, "currenciesSetter", null);
__decorate([
    Input('countries')
], DetailsComponent$1.prototype, "countriesSetter", null);
__decorate([
    Input('provinces')
], DetailsComponent$1.prototype, "provincesSetter", null);
__decorate([
    Input('permissions')
], DetailsComponent$1.prototype, "permissionsSetter", null);
DetailsComponent$1 = __decorate([
    Component({
        selector: 'lib-details',
        template: "<!--Company Details - View Mode-->\r\n<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button\r\n    pButton\r\n    class=\"ds tertiary small\"\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    [disabled]=\"!permissions?.edit\"\r\n    (click)=\"configEditModal()\"\r\n  ></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <!-- <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ISA_NUMBER' | transloco,\r\n          value: details.isaNumber\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container> -->\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.LEGAL_NAME' | transloco,\r\n          value: details.legalName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.DBA_NAME' | transloco,\r\n          value: details.dbaName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_ONE' | transloco,\r\n          value: details.address1\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_TWO' | transloco,\r\n          value: details.address2\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: { label: 'SUPPLIER.CITY' | transloco, value: details.city }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.STATE_PROVINCE' | transloco,\r\n          value: details.provinceName || details.province.trim()\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ZIP_POSTAL_CODE' | transloco,\r\n          value: details.postalCode\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.COUNTRY' | transloco,\r\n          value: details.countryName || details.country\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco,\r\n          value: details.phone\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.FAX' | transloco,\r\n          value: details.fax\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.ACCOUNT_WEBSITE' | transloco,\r\n          value: details.website\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      companyDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco,\r\n          value: details.currencyType\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n</div>\r\n<ng-template #companyDetails let-value=\"details\">\r\n  <div class=\"view-details view-details-row\">\r\n    <div class=\"view-details view-details-tile\">\r\n      <div class=\"view-details view-details-label\">\r\n        {{ value.label }}\r\n      </div>\r\n      <div>\r\n        <span> {{ value.value }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n<!--Company Details - Edit Modal-->\r\n<p-dialog\r\n  [(visible)]=\"enableEdit\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n  <div class=\"vertical-flow modal-details-container\">\r\n    <h2 class=\"center\">{{ 'COMMON.EDIT_DETAILS' | transloco }}</h2>\r\n    <form\r\n      class=\"vertical-flow space-before-100\"\r\n      [formGroup]=\"detailsForm\"\r\n      (ngSubmit)=\"save()\"\r\n    >\r\n      <!-- <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"isaNumber\">{{ 'SUPPLIER.ISA_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"isaNumber\"\r\n          />\r\n        </div>\r\n      </div> -->\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"legalName\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.legalName\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"dbaName\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.dbaName\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n        <div>\r\n          <p-dropdown\r\n            styleClass=\"width-100 height-46\"\r\n            name=\"country\"\r\n            [options]=\"countries\"\r\n            (onChange)=\"resetFaxNumberAndProvince($event)\"\r\n            placeholder=\"{{\r\n              'VALIDATION_MESSAGE.COUNTRY_SELECTION' | transloco\r\n            }}\"\r\n            formControlName=\"country\"\r\n            filter=\"true\"\r\n          ></p-dropdown>\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.country\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address1\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.address1\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address2\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-200\">\r\n        <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"city\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.city\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-000\">\r\n        <label for=\"province\">{{\r\n          'SUPPLIER.STATE_PROVINCE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <fieldset\r\n            [disabled]=\"disableProvinceDropdown\"\r\n            style=\"border: 0; padding-left: 0\"\r\n          >\r\n            <p-dropdown\r\n              styleClass=\"width-100 height-46\"\r\n              name=\"province\"\r\n              [options]=\"filteredProvinces\"\r\n              placeholder=\"{{\r\n                'VALIDATION_MESSAGE.PROVINCE_SELECTION' | transloco\r\n              }}\"\r\n              formControlName=\"province\"\r\n              filter=\"true\"\r\n            ></p-dropdown>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.province\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"postalCode\">{{\r\n          'SUPPLIER.ZIP_POSTAL_CODE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"postalCode\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.postalCode\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <div>\r\n          <label for=\"phone\">{{\r\n            'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco\r\n          }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"phone\"\r\n            (keydown)=\"preventCharacter($event)\"\r\n            (input)=\"formatPhoneNumber($event.target.value)\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.phone\"\r\n            [errorMsg]=\"phoneNumber.phoneNumber\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <div>\r\n          <label for=\"website\">{{ 'COMPANY.FAX' | transloco }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"fax\"\r\n            (input)=\"formatFaxNumber($event.target.value)\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.fax\"\r\n            [errorMsg]=\"fax.fax\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"website\">{{ 'COMPANY.ACCOUNT_WEBSITE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"website\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.website\"\r\n            [errorMsg]=\"website.website\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-200\">\r\n        <label for=\"currencyTypeKey\">{{\r\n          'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco\r\n        }}</label>\r\n        <div>\r\n          <p-dropdown\r\n            styleClass=\"width-100 height-46\"\r\n            name=\"currencyTypeKey\"\r\n            [options]=\"currencies\"\r\n            placeholder=\"{{\r\n              'VALIDATION_MESSAGE.CURRENCY_SELECTION' | transloco\r\n            }}\"\r\n            formControlName=\"currencyTypeKey\"\r\n            filter=\"true\"\r\n          ></p-dropdown>\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"detailsForm.controls.currencyTypeKey\"\r\n            [errorMsg]=\"requiredMsg.requiredMsg\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"horizontal-flow form-controls\">\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n          class=\"ds secondary\"\r\n          autowidth=\"false\"\r\n          (click)=\"cancelEditModal()\"\r\n        ></button>\r\n        <button\r\n          [disabled]=\"detailsForm.invalid\"\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n          type=\"submit\"\r\n          class=\"ds primary\"\r\n          autowidth=\"false\"\r\n        ></button>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</p-dialog>\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService$1],
        styles: [""]
    })
], DetailsComponent$1);

let CompanyHeaderComponent$1 = class CompanyHeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], CompanyHeaderComponent$1.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], CompanyHeaderComponent$1.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], CompanyHeaderComponent$1.prototype, "contentTemplate", void 0);
CompanyHeaderComponent$1 = __decorate([
    Component({
        selector: 'lib-company-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em;\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], CompanyHeaderComponent$1);

let CompanyLocationsComponent$1 = class CompanyLocationsComponent {
    constructor(confirmationService, myCompanyBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.myCompanyBus = myCompanyBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showLocationDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set locationsSetter(locations) {
        this.locations = locations;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.myCompanyBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'locations' && payload.result) {
                this.data$ = of(payload.data.accountLocationResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ locations }) => locations));
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(locations, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const accountLocationKeys = [];
                locations.forEach((location) => accountLocationKeys.push(location.accountLocationKey));
                const accountLocationKeysString = JSON.stringify(accountLocationKeys);
                this.myCompanyBus.publish({
                    eventType: 'delete',
                    type: 'locations',
                    typeKey: accountLocationKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'legalName'),
                    },
                });
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showLocationDialog = true;
                this.editLocationData = undefined;
                break;
            case 'edit':
                this.action = 'edit';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            case 'view':
                this.action = 'view';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'legalName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters('', this.prevPagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters(term, pagination, [], 'legalName'),
        });
    }
    locationCRUD(data) {
        this.myCompanyBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'legalName') }) }));
    }
    closeLocationDialog() {
        this.showLocationDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxid',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                    required: true,
                },
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                },
                {
                    field: 'number',
                    header: translate.LOCATION_NUMBER,
                },
                {
                    field: 'country',
                    header: translate.COUNTRY,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                {
                    field: 'province',
                    header: translate.STATE_PROVINCE,
                },
                {
                    field: 'postalCode',
                    header: translate.ZIP_POSTAL_CODE,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    openViewLocation(location) {
        this.action = 'view';
        this.showLocationDialog = true;
        this.editLocationData = location;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            add: toolKeys.MPP_COMPANY_MAINTENANCE,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
            delete: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
CompanyLocationsComponent$1.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MyCompanyBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('locations')
], CompanyLocationsComponent$1.prototype, "locationsSetter", null);
CompanyLocationsComponent$1 = __decorate([
    Component({
        selector: 'lib-company-locations',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"companyLocations\"\r\n      i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching$ | async\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewLocation($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showLocationDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_LOCATION' | transloco }}\r\n        </h2>\r\n      </ng-container>\r\n      <lib-location-form-container\r\n        [action]=\"action\"\r\n        [location]=\"editLocationData\"\r\n        (locationCRUD)=\"locationCRUD($event)\"\r\n        (closeLocationDialog)=\"closeLocationDialog()\"\r\n      >\r\n      </lib-location-form-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService$1],
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], CompanyLocationsComponent$1);

let LocationFormContainerComponent$1 = class LocationFormContainerComponent {
    constructor(config, myCompanyBus, spinner) {
        this.config = config;
        this.myCompanyBus = myCompanyBus;
        this.spinner = spinner;
        this.closeLocationDialog = new EventEmitter();
        this.locationCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set locationSetter(location) {
        this.location = location;
    }
    ngOnInit() {
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ details }) => details));
        this.setFetching('locations', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([this.config.getProvinces(), this.config.getCountries()])
            .pipe(tap(([provinces, countries]) => {
            this.provinces = provinces.map((province) => {
                return {
                    label: province.provinceName,
                    value: province.provinceCode.trim(),
                    code: province.countryCode.trim(),
                };
            });
            this.countries = countries.map((country) => {
                return {
                    label: country.countryName,
                    value: country.countryCode.trim(),
                    code: country.countryCode.trim(),
                };
            });
        }), finalize(() => {
            this.spinner.off();
            this.setFetching('locations', false);
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeLocationDialog.emit();
    }
};
LocationFormContainerComponent$1.ctorParameters = () => [
    { type: ConfigService },
    { type: MyCompanyBus },
    { type: SpinnerService }
];
__decorate([
    Input()
], LocationFormContainerComponent$1.prototype, "action", void 0);
__decorate([
    Input('location')
], LocationFormContainerComponent$1.prototype, "locationSetter", null);
__decorate([
    Output()
], LocationFormContainerComponent$1.prototype, "closeLocationDialog", void 0);
__decorate([
    Output()
], LocationFormContainerComponent$1.prototype, "locationCRUD", void 0);
LocationFormContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-location-form-container',
        template: `<lib-location-form
    [action]="action"
    [location]="location"
    [countries]="countries"
    [provinces]="provinces"
    (locationCRUD)="locationCRUD.emit($event)"
    (closeLocationDialog)="closeDialog()"
  ></lib-location-form>`
    })
], LocationFormContainerComponent$1);

let LocationFormComponent$1 = class LocationFormComponent {
    constructor(formBuilder, myCompanyBus, transloco) {
        this.formBuilder = formBuilder;
        this.myCompanyBus = myCompanyBus;
        this.transloco = transloco;
        this.action = '';
        this.closeLocationDialog = new EventEmitter();
        this.locationCRUD = new EventEmitter();
        this.pattern = {
            pattern: () => this.transloco.translate('VALIDATION_MESSAGE.LOCATION_NUMBER'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
        this.authorizedActions = {};
    }
    set locationSetter(location) {
        this.location = location;
        this.initializeForm(location);
    }
    set countriesSetter(countries) {
        this.countries = countries;
    }
    set provincesSetter(provinces) {
        this.provinces = provinces;
    }
    initializeForm(locationInput) {
        const location = locationInput;
        this.setFilteredProvinces(this.provinces, location === null || location === void 0 ? void 0 : location.country);
        this.locationForm = this.formBuilder.group({
            isaNumber: [location === null || location === void 0 ? void 0 : location.isaNumber],
            lbmxId: [location === null || location === void 0 ? void 0 : location.lbmxid],
            legalName: [location === null || location === void 0 ? void 0 : location.legalName, Validators.required],
            dbaName: [location === null || location === void 0 ? void 0 : location.dbaName],
            number: [
                location === null || location === void 0 ? void 0 : location.number,
                Validators.compose([
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9]*$'),
                ]),
            ],
            country: [location === null || location === void 0 ? void 0 : location.country, Validators.required],
            city: [location === null || location === void 0 ? void 0 : location.city, Validators.required],
            province: [location === null || location === void 0 ? void 0 : location.province.trim(), Validators.required],
            postalCode: [location === null || location === void 0 ? void 0 : location.postalCode, Validators.required],
            address1: [location === null || location === void 0 ? void 0 : location.address1, Validators.required],
            address2: [location === null || location === void 0 ? void 0 : location.address2],
        });
    }
    getValue(set, item) {
        try {
            return set.find((value) => value.value === item.trim()).label;
        }
        catch (_a) { }
    }
    closeDialog() {
        this.closeLocationDialog.emit();
        this.locationForm.reset();
    }
    save() {
        var _a, _b;
        const locationKey = this.action === 'add' ? '' : `${this.location.accountLocationKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.locationCRUD.emit({
            eventType,
            type: 'locations',
            typeKey: locationKey,
            payload: {
                [`${eventType}`]: Object.assign(Object.assign(Object.assign({}, this.location), this.locationForm.value), { lbmxId: Number((_b = (_a = this.locationForm) === null || _a === void 0 ? void 0 : _a.get('lbmxId')) === null || _b === void 0 ? void 0 : _b.value) }),
            },
        });
        this.closeDialog();
    }
    resetProvince(selectedCountry) {
        this.locationForm.get('province').setValue('');
        this.setFilteredProvinces(this.provinces, selectedCountry);
    }
    setFilteredProvinces(provinces, countryCode) {
        try {
            this.filteredProvinces = provinces.filter((province) => province.code.trim() === countryCode);
        }
        catch (error) {
            this.filteredProvinces = provinces;
        }
    }
};
LocationFormComponent$1.ctorParameters = () => [
    { type: FormBuilder },
    { type: MyCompanyBus },
    { type: TranslocoService }
];
__decorate([
    Input()
], LocationFormComponent$1.prototype, "action", void 0);
__decorate([
    Input('location')
], LocationFormComponent$1.prototype, "locationSetter", null);
__decorate([
    Input('countries')
], LocationFormComponent$1.prototype, "countriesSetter", null);
__decorate([
    Input('provinces')
], LocationFormComponent$1.prototype, "provincesSetter", null);
__decorate([
    Output()
], LocationFormComponent$1.prototype, "closeLocationDialog", void 0);
__decorate([
    Output()
], LocationFormComponent$1.prototype, "locationCRUD", void 0);
LocationFormComponent$1 = __decorate([
    Component({
        selector: 'lib-location-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"locationForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else legalName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"legalName\"\r\n    />\r\n    <ng-template #legalName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.legalName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.legalName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else dbaName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"dbaName\"\r\n    />\r\n    <ng-template #dbaName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.dbaName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.dbaName\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else country\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"country\"\r\n      [options]=\"countries\"\r\n      (onChange)=\"resetProvince($event?.value)\"\r\n      formControlName=\"country\"\r\n      filter=\"true\"\r\n      placeholder=\"{{ 'VALIDATION_MESSAGE.COUNTRY_SELECTION' | transloco }}\"\r\n    ></p-dropdown>\r\n    <ng-template #country>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getValue(countries, location?.country)\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.country\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else address1\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address1\"\r\n    />\r\n    <ng-template #address1>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.address1\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.address1\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else address2\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address2\"\r\n    />\r\n    <ng-template #address2>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.address2\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.address2\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else city\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"city\"\r\n    />\r\n    <ng-template #city>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.city\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.city\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"number\">{{ 'SUPPLIER.LOCATION_NUMBER' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else number\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"number\"\r\n    />\r\n    <ng-template #number>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.number\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.number\"\r\n      [errorMsg]=\"pattern.pattern\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"province\">{{ 'SUPPLIER.STATE_PROVINCE' | transloco }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else province\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"province\"\r\n      [options]=\"filteredProvinces\"\r\n      formControlName=\"province\"\r\n      filter=\"true\"\r\n      placeholder=\"{{ 'VALIDATION_MESSAGE.PROVINCE_SELECTION' | transloco }}\"\r\n    ></p-dropdown>\r\n    <ng-template #province>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getValue(filteredProvinces, location?.province)\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.province\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"postalCode\">{{ 'SUPPLIER.ZIP_POSTAL_CODE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else postalCode\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"postalCode\"\r\n    />\r\n    <ng-template #postalCode>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"location?.postalCode\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"locationForm.controls.postalCode\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"locationForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], LocationFormComponent$1);

let ContactFormContainerComponent$1 = class ContactFormContainerComponent {
    constructor(config, accountService, myCompanyBus, spinner) {
        this.config = config;
        this.accountService = accountService;
        this.myCompanyBus = myCompanyBus;
        this.spinner = spinner;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set contactSetter(contact) {
        this.contact = contact;
    }
    ngOnInit() {
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ contact }) => contact));
        this.setFetching('contact', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.config.getContactRoles(),
            this.config.getPhoneTypes(),
            this.config.getCountries(),
            this.accountService.getAccount(),
        ])
            .pipe(tap(([roles, phoneTypes, countries, account]) => {
            this.contactRoles = roles.map((role) => {
                return {
                    label: role.description,
                    value: role.contactRoleKey,
                };
            });
            this.phoneTypes = phoneTypes.map((phoneType) => {
                return {
                    label: phoneType.description,
                    value: phoneType.phoneTypeKey,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: `${country.countryName} (${country.countryCode})`,
                    value: alpha3ToAlpha2(country.countryCode),
                };
            });
            this.account = account;
        }), finalize(() => {
            this.setFetching('contact', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.myCompanyBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeContactDialog.emit();
    }
};
ContactFormContainerComponent$1.ctorParameters = () => [
    { type: ConfigService },
    { type: AccountService },
    { type: MyCompanyBus },
    { type: SpinnerService }
];
__decorate([
    Input()
], ContactFormContainerComponent$1.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormContainerComponent$1.prototype, "contactSetter", null);
__decorate([
    Output()
], ContactFormContainerComponent$1.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$1.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$1.prototype, "contactsCRUD", void 0);
ContactFormContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-contact-form-container',
        template: `<lib-contact-form
    [action]="action"
    [account]="account"
    [countries]="countries"
    [contact]="contact"
    [contactRoles]="contactRoles"
    [phoneTypes]="phoneTypes"
    (closeContactDialog)="closeContactDialog.emit()"
    (deletePhones)="deletePhones.emit($event)"
    (contactsCRUD)="contactsCRUD.emit($event)"
  ></lib-contact-form>`
    })
], ContactFormContainerComponent$1);

let ContactFormComponent$1 = class ContactFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.controls = [
            'firstName',
            'lastName',
            'title',
            'email',
            'contactRoleKey',
            'notes',
        ];
        this.resetPhone = false;
        this.deletedPhones = [];
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.emailError = {
            email: () => this.transloco.translate('VALIDATION_MESSAGE.EMAIL'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set contactSetter(contact) {
        this.contact = contact;
        this.initializeForm(contact);
    }
    initializeForm(contactInput) {
        const contact = contactInput ? contactInput : {};
        this.contactForm = this.formBuilder.group({
            firstName: [contact.firstName, Validators.required],
            lastName: [contact.lastName, Validators.required],
            title: [contact.title, Validators.required],
            email: [
                contact.email,
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            contactRoleKey: [contact.contactRoleKey || 1, Validators.required],
            notes: [contact.notes],
            phone: [contact === null || contact === void 0 ? void 0 : contact.phone, Validators.required],
        });
    }
    closeDialog() {
        this.resetContactForm();
        this.closeContactDialog.emit();
        this.deletedPhones = [];
    }
    deletePhone(deletedPhones) {
        this.deletedPhones = [...this.deletedPhones, deletedPhones];
    }
    getContactRole() {
        var _a;
        try {
            return (_a = this.contactRoles) === null || _a === void 0 ? void 0 : _a.find((contactRole) => contactRole.value === this.contact.contactRoleKey).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        if (this.deletedPhones && this.deletedPhones.length > 0) {
            this.deletedPhones.forEach((payload) => this.deletePhones.emit(payload));
        }
        const contactKey = this.action === 'add' ? '' : `${this.contact.contactKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.contactsCRUD.emit({
            eventType,
            type: 'contact',
            typeKey: contactKey,
            payload: {
                [`${eventType}`]: this.formatContactPayload(),
            },
        });
        this.closeDialog();
    }
    formatContactPayload() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const phones = ((_c = (_b = (_a = this.contactForm) === null || _a === void 0 ? void 0 : _a.get('phone')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.phone) ? (_f = (_e = (_d = this.contactForm) === null || _d === void 0 ? void 0 : _d.get('phone')) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.phone : (_h = (_g = this.contactForm) === null || _g === void 0 ? void 0 : _g.get('phone')) === null || _h === void 0 ? void 0 : _h.value;
        return Object.assign(Object.assign(Object.assign({}, this.contact), this.contactForm.value), { phone: phones.map((phone) => (Object.assign(Object.assign({}, phone), { contactPhoneKey: (phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) : 0, phoneTypeKey: (phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) : 1, phoneNumber: this.formatPhoneForSave(phone), phoneCountryCode: phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode }))) });
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    resetContactForm() {
        this.resetPhone = true;
        this.controls.forEach((control) => this.contactForm.get(control).setValue(''));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
ContactFormComponent$1.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], ContactFormComponent$1.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormComponent$1.prototype, "contactSetter", null);
__decorate([
    Input()
], ContactFormComponent$1.prototype, "account", void 0);
__decorate([
    Input()
], ContactFormComponent$1.prototype, "contactRoles", void 0);
__decorate([
    Input()
], ContactFormComponent$1.prototype, "phoneTypes", void 0);
__decorate([
    Input()
], ContactFormComponent$1.prototype, "countries", void 0);
__decorate([
    Output()
], ContactFormComponent$1.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormComponent$1.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormComponent$1.prototype, "contactsCRUD", void 0);
ContactFormComponent$1 = __decorate([
    Component({
        selector: 'lib-contact-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"contactForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"firstName\">{{\r\n      'SUPPLIER.CONTACT_FIRST_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else firstName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"firstName\"\r\n    />\r\n    <ng-template #firstName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.firstName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.firstName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"lastName\">{{ 'SUPPLIER.CONTACT_LAST_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else lastName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"lastName\"\r\n    />\r\n    <ng-template #lastName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.lastName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.lastName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"title\">{{ 'SUPPLIER.CONTACT_TITLE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else title\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"title\"\r\n    />\r\n    <ng-template #title>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.title\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.title\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <lib-phone-form\r\n    [countries]=\"countries\"\r\n    [defaultCountry]=\"account?.details?.country\"\r\n    [phoneTypes]=\"phoneTypes\"\r\n    [resetPhone]=\"resetPhone\"\r\n    [viewOnly]=\"action === 'view'\"\r\n    (deletedPhone)=\"deletePhone($event)\"\r\n    formControlName=\"phone\"\r\n  ></lib-phone-form>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"email\">{{ 'SUPPLIER.CONTACT_EMAIL' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else email\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"email\"\r\n    />\r\n    <ng-template #email>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.email\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.email\"\r\n      [errorMsg]=\"emailError.email\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"contactRoleKey\">{{\r\n      'SUPPLIER.CONTACT_ROLE' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else role\"\r\n      placeholder=\"{{ 'SUPPLIER.CONTACT_SELECT_ROLE' | transloco }}\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"contactRoleKey\"\r\n      [options]=\"contactRoles\"\r\n      formControlName=\"contactRoleKey\"\r\n      filter=\"true\"\r\n    ></p-dropdown>\r\n    <ng-template #role>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getContactRole()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.role\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"notes\">{{ 'SUPPLIER.CONTACT_NOTES' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else notes\"\r\n      rows=\"5\"\r\n      autoresize=\"false\"\r\n      name=\"notes\"\r\n      pInputTextarea\r\n      formControlName=\"notes\"\r\n      class=\"width-100 ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #notes>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"false\"\r\n        name=\"notes\"\r\n        pInputTextarea\r\n        formControlName=\"notes\"\r\n        class=\"width-100 ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"contactForm?.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ContactFormComponent$1);

let ContactsComponent$1 = class ContactsComponent {
    constructor(confirmationService, myCompanyBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.myCompanyBus = myCompanyBus;
        this.translocoService = translocoService;
        this.store = store;
        this.action = null;
        this.toolbarButtons = [];
        this.showContactDialog = false;
        this.columnsAvailable = false;
        this.fetching = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set contactsSetter(contacts) {
        this.contacts = contacts;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.myCompanyBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'contact' && payload.result) {
                this.data$ = of(this.transformContactPhoneForSC(payload.data.contactResponse));
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.myCompanyBus.fetching$.pipe(map(({ contact }) => (this.fetching = contact)));
        this.columnsToDisplay = [
            'firstName',
            'workPhone',
            'mobilePhone',
            'otherPhone',
            'email',
            'contactRole',
            'title',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(contacts, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const contactKeys = [];
                contacts.forEach((contactInfo) => contactKeys.push(contactInfo.contactKey));
                const contactKeysString = JSON.stringify(contactKeys);
                this.myCompanyBus.publish({
                    eventType: 'delete',
                    type: 'contact',
                    typeKey: contactKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'firstName'),
                    },
                });
                // TODO: Remove in Future Version if Single Delete is Obsolete
                // contacts.forEach((contact) =>
                //   this.myCompanyBus.publish({
                //     eventType: 'delete',
                //     type: 'contact',
                //     typeKey: `${contact.contactKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showContactDialog = true;
                this.editContactData = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'firstName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.myCompanyBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters(term, pagination, [], 'firstName'),
        });
    }
    deletePhones(payload) {
        this.myCompanyBus.publish({
            eventType: 'delete',
            type: 'contactPhone',
            payload: {
                delete: payload,
                search: searchFilters('', this.prevPagination, [], 'firstName'),
            },
        });
    }
    contactsCRUD(data) {
        this.myCompanyBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'firstName') }) }));
    }
    closeContactDialog() {
        this.showContactDialog = false;
        this.action = null;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactRole',
                    header: translate.CONTACT_ROLE,
                    formatter: ({ contactRoleKey }) => `${roles[contactRoleKey]}`,
                },
                {
                    field: 'firstName',
                    header: translate.FULL_NAME,
                    formatter: ({ firstName, lastName }) => `${firstName} ${lastName}`,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (contact) => contact,
                    required: true,
                },
                {
                    field: 'workPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.WORK_PHONE}`,
                    formatter: ({ workPhone }) => {
                        var _a;
                        return `${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber) || ''} ${((_a = workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'mobilePhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.MOBILE_PHONE}`,
                    formatter: ({ mobilePhone }) => {
                        var _a;
                        return `${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber) || ''} ${((_a = mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'otherPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.OTHER_PHONE}`,
                    formatter: ({ otherPhone }) => {
                        var _a;
                        return `${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber) || ''} ${((_a = otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'title',
                    header: translate.TITLE,
                },
                {
                    field: 'email',
                    header: translate.EMAIL,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    formatPhoneNumber(phoneNumber, countryCode) {
        try {
            return parsePhoneNumber(phoneNumber, alpha3ToAlpha2(countryCode)).formatInternational();
        }
        catch (_a) {
            return phoneNumber;
        }
    }
    transformContactPhoneForSC(contacts) {
        return contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => {
            const mobilePhone = this.findPhone(contact, 1);
            const otherPhone = this.findPhone(contact, 2);
            const workPhone = this.findPhone(contact, 3);
            return Object.assign(Object.assign({}, contact), { mobilePhone: Object.assign(Object.assign({}, mobilePhone), { phoneNumber: this.formatPhoneNumber(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber, mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneCountryCode) }), otherPhone: Object.assign(Object.assign({}, otherPhone), { phoneNumber: this.formatPhoneNumber(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber, otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneCountryCode) }), workPhone: Object.assign(Object.assign({}, workPhone), { phoneNumber: this.formatPhoneNumber(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber, workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneCountryCode) }) });
        });
    }
    findPhone(contact, phoneTypeKey) {
        try {
            return contact.phone.find((phn) => phn.phoneTypeKey === phoneTypeKey);
        }
        catch (_a) {
            return undefined;
        }
    }
    openViewContact(contact) {
        this.action = 'view';
        this.showContactDialog = true;
        this.editContactData = contact;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            add: toolKeys.MPP_COMPANY_MAINTENANCE,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
            delete: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
ContactsComponent$1.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MyCompanyBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('contacts')
], ContactsComponent$1.prototype, "contactsSetter", null);
ContactsComponent$1 = __decorate([
    Component({
        selector: 'lib-contacts',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"companyContacts\"\r\n      i18nSearchField=\"{{ 'PARTNERS.CONTACT_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewContact($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showContactDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (deletePhones)=\"deletePhones($event)\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService$1],
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], ContactsComponent$1);

let ApplyBankingFormComponent = class ApplyBankingFormComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input()
], ApplyBankingFormComponent.prototype, "form", void 0);
__decorate([
    Output()
], ApplyBankingFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], ApplyBankingFormComponent.prototype, "saveDialog", void 0);
ApplyBankingFormComponent = __decorate([
    Component({
        selector: 'lib-apply-banking-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.APPLY_BANKING' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ApplyBankingFormComponent);

const schemaDefinition = (fields) => ({
    fields,
});

let ApplyBankingComponent = class ApplyBankingComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/apply-banking/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            var _a;
            if (!this.itemSelected) {
                fields = Object.assign(Object.assign({}, fields), { options: Object.assign(Object.assign({}, fields === null || fields === void 0 ? void 0 : fields.options), { options: [...(_a = fields === null || fields === void 0 ? void 0 : fields.options) === null || _a === void 0 ? void 0 : _a.options].filter((option) => {
                            return `${option === null || option === void 0 ? void 0 : option.value}` !== '3';
                        }) }) });
            }
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ApplyBankingComponent.ctorParameters = () => [
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ApplyBankingComponent.prototype, "itemSelected", void 0);
__decorate([
    Input()
], ApplyBankingComponent.prototype, "baseUrl", void 0);
__decorate([
    Output()
], ApplyBankingComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], ApplyBankingComponent.prototype, "saveDialog", void 0);
ApplyBankingComponent = __decorate([
    Component({
        selector: 'lib-apply-banking',
        template: ` <lib-apply-banking-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-apply-banking-form>`
    })
], ApplyBankingComponent);

let LocationsComponent = class LocationsComponent {
    constructor(confirmationService, http, translocoService, toast, spinner, searchContainerLoaderService, mppService) {
        this.confirmationService = confirmationService;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.mppService = mppService;
        // dialog configs
        this.showDialog = false;
        this.showLocationDialog = false;
        this.showApplyBankingDialog = false;
        this.showViewBankingDialog = false;
        // search container loader states
        this.searchContainerName = 'CompanyLocationsSearch';
        this.i18nSearchField = 'PARTNERS.LOCATION_SEARCH';
        this.toolbarActionsDispatcher = {
            new: () => {
                this.action = 'add';
                this.showLocationDialog = true;
                this.editLocationData = undefined;
            },
            edit: (selection) => {
                // this.spinner.on();
                // this.http
                //   .fetch({
                //     endpoint: `location/${selection[0].accountLocationKey}`,
                //     httpMethod: 'GET',
                //   })
                //   .pipe(
                //     tap((location) => {
                //       this.action = 'edit';
                //       this.showLocationDialog = true;
                //       this.editLocationData = location;
                //     }),
                //     catchError(() => {
                //       return of(
                //         this.toast.errorNotify(
                //           this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')
                //         )
                //       );
                //     }),
                //     finalize(() => this.spinner.off())
                //   )
                //   .subscribe();
                this.action = 'edit';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
            },
            delete: (selection) => {
                this.delete(selection);
            },
            view: (selection) => {
                // this.spinner.on();
                // this.http
                //   .fetch({
                //     endpoint: `location/${selection[0].accountLocationKey}`,
                //     httpMethod: 'GET',
                //   })
                //   .pipe(
                //     tap((location) => {
                //       this.action = 'view';
                //       this.showLocationDialog = true;
                //       this.editLocationData = location;
                //     }),
                //     catchError(() => {
                //       return of(
                //         this.toast.errorNotify(
                //           this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')
                //         )
                //       );
                //     }),
                //     finalize(() => this.spinner.off())
                //   )
                //   .subscribe();
                this.action = 'view';
                this.showLocationDialog = true;
                this.editLocationData = selection[0];
            },
            applyBanking: (selection) => {
                this.selectedLocations = selection;
                this.showApplyBankingDialog = true;
            },
            viewBanking: (selection) => {
                var _a;
                this.accountLocationKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.accountLocationKey;
                this.showViewBankingDialog = true;
            },
        };
        this.baseUrl = `${this.mppService.getConfig().account}/location`;
        this.columnActions = {
            legalName: {
                link: () => ({ path: './' }),
                event: (location) => location,
            },
            dbaName: {
                link: () => ({ path: './' }),
                event: (location) => location,
            },
        };
        http.baseUrl = mppService.getConfig().account;
    }
    delete(selection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.spinner.on();
                this.http
                    .fetch({
                    endpoint: 'location/delete',
                    httpMethod: 'POST',
                    body: {
                        keys: [...selection].map((_a) => {
                            var { accountLocationKey } = _a, _ = __rest(_a, ["accountLocationKey"]);
                            return accountLocationKey;
                        }),
                    },
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => {
                    return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
                }), finalize(() => this.spinner.off()))
                    .subscribe();
            },
            reject: () => { },
        });
    }
    locationCRUD(location) {
        const eventType = location === null || location === void 0 ? void 0 : location.eventType;
        const locationKey = location === null || location === void 0 ? void 0 : location.typeKey;
        const data = location === null || location === void 0 ? void 0 : location.payload[`${eventType}`];
        switch (eventType) {
            case 'create':
                this.create(data);
                break;
            case 'update':
                this.update(locationKey, data);
                break;
            default:
                break;
        }
    }
    update(locationKey, data) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `location/${locationKey}`,
            httpMethod: 'PUT',
            body: data,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe();
    }
    create(data) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `location`,
            httpMethod: 'POST',
            body: data,
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => this.spinner.off()))
            .subscribe();
    }
    closeLocationDialog() {
        this.showLocationDialog = false;
    }
    closeApplyBankingDialog() {
        this.showApplyBankingDialog = false;
    }
    closeViewBankingDialog() {
        this.showViewBankingDialog = false;
    }
    openViewLocation(location) {
        this.action = 'view';
        this.showLocationDialog = true;
        this.editLocationData = location;
    }
    saveApplyBanking(applyBanking) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `location/apply-banking`,
            httpMethod: 'POST',
            body: {
                keys: [...this.selectedLocations].map((_a) => {
                    var { accountLocationKey } = _a, _ = __rest(_a, ["accountLocationKey"]);
                    return accountLocationKey;
                }),
                optionType: Number(applyBanking === null || applyBanking === void 0 ? void 0 : applyBanking.options),
                accountBankingInfoKey: applyBanking === null || applyBanking === void 0 ? void 0 : applyBanking.banking,
                isDefault: applyBanking === null || applyBanking === void 0 ? void 0 : applyBanking.isDefault,
                search: {
                    page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows },
                    sort: {
                        field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                        order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                    },
                    search: { filters: {}, term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '' },
                },
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => {
            return of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')));
        }), finalize(() => {
            this.showApplyBankingDialog = false;
            this.spinner.off();
        }))
            .subscribe();
    }
};
LocationsComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: MarketplacePartnersService }
];
LocationsComponent = __decorate([
    Component({
        selector: 'lib-locations',
        template: "<lib-search-container-loader\r\n  [searchContainerName]=\"searchContainerName\"\r\n  [i18nSearchField]=\"i18nSearchField\"\r\n  [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n  [baseUrl]=\"baseUrl\"\r\n  [columnActions]=\"columnActions\"\r\n  [disableAdvancedSearch]=\"true\"\r\n  (field)=\"openViewLocation($event)\"\r\n></lib-search-container-loader>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showLocationDialog\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <ng-container *ngIf=\"action === 'edit'\">\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'COMPANY.EDIT_LOCATION' | transloco }}\r\n    </h2>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"action === 'add'\">\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'COMPANY.ADD_LOCATION' | transloco }}\r\n    </h2>\r\n  </ng-container>\r\n  <ng-container *ngIf=\"action === 'view'\">\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'COMPANY.VIEW_LOCATION' | transloco }}\r\n    </h2>\r\n  </ng-container>\r\n  <lib-location-form-container\r\n    [action]=\"action\"\r\n    [location]=\"editLocationData\"\r\n    (locationCRUD)=\"locationCRUD($event)\"\r\n    (closeLocationDialog)=\"closeLocationDialog()\"\r\n  >\r\n  </lib-location-form-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showApplyBankingDialog\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-apply-banking\r\n    *ngIf=\"showApplyBankingDialog\"\r\n    [itemSelected]=\"selectedLocations.length > 0\"\r\n    [baseUrl]=\"baseUrl\"\r\n    (saveDialog)=\"saveApplyBanking($event)\"\r\n    (closeDialog)=\"closeApplyBankingDialog()\"\r\n  ></lib-apply-banking>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showViewBankingDialog\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-view-banking\r\n    *ngIf=\"showViewBankingDialog\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [key]=\"accountLocationKey\"\r\n    (closeDialog)=\"closeViewBankingDialog()\"\r\n  ></lib-view-banking>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService]
    })
], LocationsComponent);

let ViewBankingFormComponent = class ViewBankingFormComponent {
    // @Output() public saveDialog = new EventEmitter();
    constructor() {
        this.closeDialog = new EventEmitter();
    }
    ngOnInit() { }
    // public save() {
    //   this.saveDialog.emit(this.form.values);
    // }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input()
], ViewBankingFormComponent.prototype, "form", void 0);
__decorate([
    Output()
], ViewBankingFormComponent.prototype, "closeDialog", void 0);
ViewBankingFormComponent = __decorate([
    Component({
        selector: 'lib-view-banking-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.VIEW_APPLIED_BANKING' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      style=\"flex-grow: 1\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <!-- <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button> -->\r\n  </div>\r\n</div>\r\n"
    })
], ViewBankingFormComponent);

const schemaDefinition$1 = (fields) => ({
    fields,
});

let ViewBankingComponent = class ViewBankingComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$1;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/${this.key}/view-banking/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ViewBankingComponent.ctorParameters = () => [
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ViewBankingComponent.prototype, "itemSelected", void 0);
__decorate([
    Input()
], ViewBankingComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], ViewBankingComponent.prototype, "key", void 0);
__decorate([
    Output()
], ViewBankingComponent.prototype, "closeDialog", void 0);
ViewBankingComponent = __decorate([
    Component({
        selector: 'lib-view-banking',
        template: ` <lib-view-banking-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
  ></lib-view-banking-form>`
    })
], ViewBankingComponent);

let ViewCompanyComponent$1 = class ViewCompanyComponent {
    constructor(accountService, mppService, transloco, confirmationService, spinner, toast, store) {
        this.accountService = accountService;
        this.mppService = mppService;
        this.transloco = transloco;
        this.confirmationService = confirmationService;
        this.spinner = spinner;
        this.toast = toast;
        this.store = store;
        this.imageSrc = '';
        this.imageAlt = '';
        this.isCompanyLogoPresent = false;
        this.logoUploaded = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set myCompanySetter(myCompany) {
        this.myCompany = myCompany;
        this.displayLogo();
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.uploadLogoUrl = this.mppService.getConfig().accountAssetsEndPoint;
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onLogoUpload(event) {
        this.spinner.on();
        if (event.originalEvent &&
            event.originalEvent.body &&
            event.originalEvent.body[0] &&
            event.originalEvent.body[0].id) {
            this.accountAssetKey = event.originalEvent.body[0].id;
            this.myCompany.details.logo_AccountAssetKey = this.accountAssetKey;
            this.subscriptions.push(this.accountService
                .updateLogoAccountAssetKey(this.myCompany.details)
                .pipe(tap(() => {
                this.imageSrc = this.accountService.getImageUrl(this.accountAssetKey, this.myCompany.details.accountKey);
                this.isCompanyLogoPresent = true;
                this.toast.successNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_SUCCESS'));
            }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_FAILURE')))), finalize(() => this.spinner.off()))
                .subscribe());
        }
    }
    displayLogo() {
        try {
            this.accountAssetKey = Number(this.myCompany.details.logo_AccountAssetKey);
            this.imageSrc =
                this.accountAssetKey > 0
                    ? this.accountService.getImageUrl(this.accountAssetKey, this.myCompany.details.accountKey)
                    : '';
            this.isCompanyLogoPresent = this.accountAssetKey > 0 ? true : false;
        }
        catch (error) {
            /*empty */
        }
    }
    logoUploadError() {
        this.logoUploaded = false;
        this.toast.errorNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_UPDATE_FAILURE'));
    }
    onLogoSelect(event) {
        if (event.files[0].size > 5000000) {
            this.toast.errorNotify(this.transloco.translate('VALIDATION_MESSAGE.ASSET_UPLOAD_MAX_SIZE'));
        }
        const extension = event.files[0].type.split('/').pop().toLocaleLowerCase();
        const extensions = ['jpg', 'png', 'jpeg', 'gif'];
        if (!extensions.includes(extension)) {
            this.toast.errorNotify(this.transloco.translate('COMPANY.INVALID_FORMAT_MSG'));
        }
    }
    confirmLogoDelete() {
        this.confirmationService.confirm({
            message: this.transloco.translate('PIM.DELETE_ASSET_CONFIRM'),
            header: this.transloco.translate('ADMINISTRATION.DELETE_DIALOG_HEADER'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.transloco.translate('ACTIONS.YES'),
            rejectLabel: this.transloco.translate('ACTIONS.NO'),
            accept: () => {
                this.subscriptions.push(this.accountService
                    .deleteCompanyLogo(this.accountAssetKey)
                    .pipe(tap((res) => ((this.isCompanyLogoPresent = false), this.deleteLogoAssetKey())))
                    .subscribe());
            },
            reject: () => { },
        });
    }
    deleteLogoAssetKey() {
        this.subscriptions.push(this.accountService.deleteLogoAccountAssetKey().subscribe((res) => {
            this.isCompanyLogoPresent = false;
            this.toast.successNotify(this.transloco.translate('COMPANY.COMPANY_LOGO_DELETE_SUCCESS'));
        }, (error) => {
            this.toast.errorNotify(this.transloco.translate('MESSAGES.GENERIC_ERROR'));
        }));
    }
    getPermissions() {
        return {
            view: toolKeys.MPP_COMPANY,
            edit: toolKeys.MPP_COMPANY_MAINTENANCE,
        };
    }
};
ViewCompanyComponent$1.ctorParameters = () => [
    { type: AccountService },
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: SpinnerService },
    { type: ToastrNotificationService },
    { type: Store }
];
__decorate([
    Input('myCompany')
], ViewCompanyComponent$1.prototype, "myCompanySetter", null);
__decorate([
    Input()
], ViewCompanyComponent$1.prototype, "currencies", void 0);
__decorate([
    Input()
], ViewCompanyComponent$1.prototype, "countries", void 0);
__decorate([
    Input()
], ViewCompanyComponent$1.prototype, "provinces", void 0);
__decorate([
    Input()
], ViewCompanyComponent$1.prototype, "fetching", void 0);
__decorate([
    Input()
], ViewCompanyComponent$1.prototype, "updating", void 0);
ViewCompanyComponent$1 = __decorate([
    Component({
        selector: 'lib-view-company',
        template: "<div\r\n  *ngIf=\"authorizedActions?.view || authorizedActions?.edit\"\r\n  class=\"details-container\"\r\n>\r\n  <div>\r\n    <lib-company-header\r\n      [imageTemplate]=\"header_image\"\r\n      [titleTemplate]=\"header_title\"\r\n      [contentTemplate]=\"header_content\"\r\n    >\r\n      <ng-template #header_title>\r\n        <h2 class=\"header-card-title\">{{ 'COMPANY.COMPANY' | transloco }}</h2>\r\n      </ng-template>\r\n      <ng-template #header_image>\r\n        <ng-container *ngIf=\"isCompanyLogoPresent; else logoMissing\">\r\n          <div class=\"img-container header\">\r\n            <img class=\"target\" [src]=\"imageSrc\" />\r\n            <button\r\n              *ngIf=\"authorizedActions?.edit\"\r\n              pButton\r\n              class=\"ds tertiary small control\"\r\n              type=\"button\"\r\n              (click)=\"confirmLogoDelete()\"\r\n            >\r\n              {{ 'ACTIONS.DELETE' | transloco }}\r\n            </button>\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #logoMissing>\r\n          <div class=\"img-container header no-img\">\r\n            <span>\r\n              {{ 'COMPANY.LOGO_DEFAULT_MSG_1' | transloco }}<br />{{\r\n                'COMPANY.LOGO_DEFAULT_MSG_2' | transloco\r\n              }}\r\n            </span>\r\n            <p-fileUpload\r\n              *ngIf=\"authorizedActions?.edit\"\r\n              chooseLabel=\"{{ 'ACTIONS.ADD' | transloco }}\"\r\n              styleClass=\"ds small tertiary ui-button control\"\r\n              [url]=\"uploadLogoUrl\"\r\n              mode=\"basic\"\r\n              (onUpload)=\"onLogoUpload($event)\"\r\n              accept=\".jpg,.png,.jpeg,.gif\"\r\n              maxFileSize=\"5000000\"\r\n              [auto]=\"true\"\r\n              (onError)=\"logoUploadError()\"\r\n              (onSelect)=\"onLogoSelect($event)\"\r\n              withCredentials=\"true\"\r\n            >\r\n            </p-fileUpload>\r\n          </div>\r\n        </ng-template>\r\n      </ng-template>\r\n      <ng-template #header_content>\r\n        <div class=\"vertical-flow\">\r\n          <h4 class=\"content-title\">\r\n            <ng-container\r\n              *ngIf=\"myCompany?.details?.dbaName?.length > 0; else legalName\"\r\n            >\r\n              {{ myCompany?.details?.legalName }} ({{\r\n                myCompany?.details?.dbaName\r\n              }})\r\n            </ng-container>\r\n            <ng-template #legalName>\r\n              {{ myCompany?.details?.legalName }}\r\n            </ng-template>\r\n          </h4>\r\n          <!-- <p>\r\n            {{ 'SUPPLIER.LBMXID' | transloco }}\r\n            {{ myCompany?.details?.lbmxId }}\r\n          </p> -->\r\n        </div>\r\n      </ng-template>\r\n    </lib-company-header>\r\n  </div>\r\n  <div>\r\n    <p-tabView>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n        <lib-details\r\n          [details]=\"myCompany?.details\"\r\n          [countries]=\"countries\"\r\n          [provinces]=\"provinces\"\r\n          [currencies]=\"currencies\"\r\n          [permissions]=\"authorizedActions\"\r\n        ></lib-details>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n        <lib-contacts [contacts]=\"myCompany?.contacts\"></lib-contacts>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_BANKING' | transloco }}\">\r\n        <lib-company-banking></lib-company-banking>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_LOCATIONS' | transloco }}\">\r\n        <lib-locations></lib-locations>\r\n        <!-- <lib-company-locations\r\n          [locations]=\"myCompany?.locations\"\r\n        ></lib-company-locations> -->\r\n      </p-tabPanel>\r\n    </p-tabView>\r\n  </div>\r\n</div>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService],
        styles: [".content-title{font-size:22px;display:block;margin:0}"]
    })
], ViewCompanyComponent$1);

let CompanyModule$1 = class CompanyModule {
};
CompanyModule$1 = __decorate([
    NgModule({
        declarations: [
            ViewCompanyComponent$1,
            CompanyComponent,
            CompanyHeaderComponent$1,
            ContactsComponent$1,
            CompanyLocationsComponent$1,
            CompanyBankingComponent$1,
            DetailsComponent$1,
            ContactFormComponent$1,
            ContactFormContainerComponent$1,
            ViewCompanyContainerComponent,
            LocationFormComponent$1,
            LocationFormContainerComponent$1,
            LocationsComponent,
            ApplyBankingComponent,
            ApplyBankingFormComponent,
            ViewBankingComponent,
            ViewBankingFormComponent,
        ],
        imports: [
            AdvancedSearchLoaderModule,
            CommonModule,
            ConfirmDialogModule$1,
            TranslocoModule,
            TabViewModule,
            DropdownModule,
            FormsModule,
            ReactiveFormsModule,
            ButtonModule,
            MenuModule,
            SearchContainerLoaderModule,
            SearchContainerModule$1,
            DialogModule,
            UtilsModule,
            ListboxModule,
            InputMaskModule,
            FileUploadModule,
            PhoneFormModule,
            WizardModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        providers: [ConfirmationService],
    })
], CompanyModule$1);

let AdvancedSearchComponent = class AdvancedSearchComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.setFilterEvent = new EventEmitter();
        this.selectedGroupCategories = [];
        this.selectedCategories = [];
        this.subscriptions = [];
        this.defaultValues = {
            activeStatus: true,
            inactiveStatus: false,
            centralBill: false,
            directBill: false,
            testInvoiceStatus: false,
            prodInvoiceStatus: false,
            testPurchaseOrderStatus: false,
            prodPurchaseOrderStatus: false,
            categories: [],
        };
    }
    ngOnInit() {
        this.groupAdvancedSearchForm = this.formBuilder.group(Object.entries(this.defaultValues).reduce((prev, [key, value]) => (Object.assign(Object.assign({}, prev), { [key]: [value] })), {}));
        this.selectedNodes = [];
        this.groupCategories = [
            {
                data: {
                    groupCategory: 'Timber Mart',
                },
                expanded: true,
            },
            {
                data: {
                    groupCategory: 'ABCD',
                },
                expanded: true,
            },
            {
                data: {
                    groupCategory: 'Skipstorm',
                },
                expanded: true,
            },
            {
                data: {
                    groupCategory: 'ABCD1',
                },
                expanded: true,
            },
            {
                data: {
                    groupCategory: 'Canadian',
                },
                expanded: true,
            },
            {
                data: {
                    groupCategory: 'CA',
                },
                expanded: true,
            },
        ];
        this.subscriptions.push(timer(0).subscribe(() => {
            this.handleAdvancedSearch();
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    handleAdvancedSearch() {
        this.selectedGroupCategories = this.getSelectedGroupCategories();
        this.groupAdvancedSearchForm.patchValue({
            categories: this.selectedGroupCategories,
        });
        this.setFilterEvent.emit({
            filters: this.filterEmptyFields(),
            options: { search: true },
        });
    }
    handleClear() {
        this.selectedNodes = [];
        this.groupAdvancedSearchForm.reset(this.defaultValues);
        setTimeout(() => {
            this.setFilterEvent.emit({
                filters: {},
                options: { clearResults: false },
            });
        }, 20000);
    }
    filterEmptyFields() {
        return Object.entries(this.groupAdvancedSearchForm.value).reduce((prev, [field, value]) => {
            if (value !== '') {
                return Object.assign(Object.assign({}, prev), { [field]: value });
            }
            else {
                return prev;
            }
        }, {});
    }
    getSelectedGroupCategories() {
        this.selectedCategories = [];
        this.selectedCategories = this.selectedNodes.map((n) => n.data.groupCategory);
        return this.selectedCategories;
    }
};
AdvancedSearchComponent.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Output()
], AdvancedSearchComponent.prototype, "setFilterEvent", void 0);
AdvancedSearchComponent = __decorate([
    Component({
        selector: 'lib-advanced-search',
        template: "<div class=\"vertical-flow advanced-search\">\r\n  <div class=\"horizontal-fixed space-between-075\">\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n      (click)=\"handleClear()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n      (click)=\"handleAdvancedSearch()\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"space-before-100\">\r\n    <p-accordion\r\n      styleClass=\"advancedSearchTabHeader\"\r\n      expandIcon=\"pi pi-caret-right\"\r\n      collapseIcon=\"pi pi-caret-down\"\r\n      [multiple]=\"true\"\r\n    >\r\n      <form [formGroup]=\"groupAdvancedSearchForm\">\r\n        <div class=\"vertical-flow space-between-025\">\r\n          <p-accordionTab header=\"{{ 'SUPPLIER.ACTIVE_INACTIVE' | transloco }}\">\r\n            <div class=\"vertical-flow\">\r\n              <p-checkbox\r\n                label=\"{{ 'SUPPLIER.ACTIVE' | transloco }}\"\r\n                binary=\"true\"\r\n                formControlName=\"activeStatus\"\r\n              >\r\n              </p-checkbox>\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.INACTIVE' | transloco }}\"\r\n                formControlName=\"inactiveStatus\"\r\n                class=\"space-before-075\"\r\n              >\r\n              </p-checkbox>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab header=\"{{ 'SUPPLIER.CATEGORY' | transloco }}\">\r\n            <div>\r\n              <p-treeTable\r\n                [value]=\"groupCategories\"\r\n                selectionMode=\"checkbox\"\r\n                [(selection)]=\"selectedNodes\"\r\n              >\r\n                <ng-template pTemplate=\"body\" let-rowNode let-rowData=\"rowData\">\r\n                  <tr>\r\n                    <td class=\"no-padding-top no-padding-bottom fontSize14px\">\r\n                      <p-treeTableToggler\r\n                        [rowNode]=\"rowNode\"\r\n                      ></p-treeTableToggler>\r\n                      <p-treeTableCheckbox\r\n                        [value]=\"rowNode\"\r\n                      ></p-treeTableCheckbox>\r\n                      {{ rowData.groupCategory }}\r\n                    </td>\r\n                  </tr>\r\n                </ng-template>\r\n              </p-treeTable>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab header=\"{{ 'SUPPLIER.BILLING_TYPE' | transloco }}\">\r\n            <div class=\"vertical-flow\">\r\n              <p-checkbox\r\n                label=\"{{ 'SUPPLIER.CENTRAL_BILL' | transloco }}\"\r\n                binary=\"true\"\r\n                formControlName=\"centralBill\"\r\n              >\r\n              </p-checkbox>\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.DIRECT_BILL' | transloco }}\"\r\n                formControlName=\"directBill\"\r\n                class=\"space-before-075\"\r\n              >\r\n              </p-checkbox>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab header=\"{{ 'SUPPLIER.INVOICE_STATUS' | transloco }}\">\r\n            <div class=\"vertical-flow\">\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.TEST' | transloco }}\"\r\n                formControlName=\"testInvoiceStatus\"\r\n              >\r\n              </p-checkbox>\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.PRODUCTION' | transloco }}\"\r\n                formControlName=\"prodInvoiceStatus\"\r\n                class=\"space-before-075\"\r\n              >\r\n              </p-checkbox>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab\r\n            header=\"{{ 'SUPPLIER.PURCHASE_ORDER_STATUS' | transloco }}\"\r\n          >\r\n            <div class=\"vertical-flow\">\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.TEST' | transloco }}\"\r\n                formControlName=\"testPurchaseOrderStatus\"\r\n              >\r\n              </p-checkbox>\r\n              <p-checkbox\r\n                binary=\"true\"\r\n                label=\"{{ 'SUPPLIER.PRODUCTION' | transloco }}\"\r\n                formControlName=\"prodPurchaseOrderStatus\"\r\n                class=\"space-before-075\"\r\n              >\r\n              </p-checkbox>\r\n            </div>\r\n          </p-accordionTab>\r\n        </div>\r\n      </form>\r\n    </p-accordion>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], AdvancedSearchComponent);

let BankingComponent = class BankingComponent {
    constructor(translocoService, store) {
        this.translocoService = translocoService;
        this.store = store;
        this.viewBankingInfo = {};
        this.toolbarButtons = [];
        this.displayViewBanking = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set bankingInfoSetter(bankingInfos) {
        this.data$ = of(bankingInfos);
        this.bankingInfo = bankingInfos;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['contactName', 'contactEmail'];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayViewBanking = true;
                this.viewBankingInfo = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.search();
    }
    search({ filters: { contactName } } = { filters: { contactName: '.*' } }) {
        const regex = new RegExp(contactName, 'i');
        this.data$ = of(this.bankingInfo.filter((bankingInfo) => bankingInfo.contactName.match(regex)));
    }
    closeViewBankingDialog() {
        this.displayViewBanking = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactName',
                    header: translate.VIEW_BANKING_CONTACT_NAME,
                },
                {
                    field: 'contactEmail',
                    header: translate.VIEW_BANKING_CONTACT_EMAIL,
                },
                {
                    field: 'externalAccountName',
                    header: translate.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'internalAccountName',
                    header: translate.VIEW_BANKING_INTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'accountNumber',
                    header: translate.VIEW_BANKING_ACCOUNT_NUMBER,
                },
                {
                    field: 'routingNumber',
                    header: translate.VIEW_BANKING_ROUTING_NUMBER,
                },
                {
                    field: 'federalTaxID',
                    header: translate.VIEW_BANKING_FEDERAL_TAX_ID,
                },
                {
                    field: 'identificationNumber',
                    header: translate.VIEW_BANKING_IDENTIFICATION_NUMBER,
                },
                {
                    field: 'traceNumber',
                    header: translate.VIEW_BANKING_TRACE_NUMBER,
                },
                {
                    field: 'sequenceNumber',
                    header: translate.VIEW_BANKING_SEQUENCE_NUMBER,
                },
                {
                    field: 'originName',
                    header: translate.VIEW_BANKING_ORIGIN_NAME,
                },
                {
                    field: 'bankName',
                    header: translate.VIEW_BANKING_BANK_NAME,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
BankingComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('bankingInfo')
], BankingComponent.prototype, "bankingInfoSetter", null);
BankingComponent = __decorate([
    Component({
        selector: 'lib-banking',
        template: "<div>\r\n  <lib-search-container\r\n    *ngIf=\"columnsAvailable\"\r\n    name=\"groupBanking\"\r\n    i18nSearchField=\"{{ 'PARTNERS.BANKING_SEARCH' | transloco }}\"\r\n    [buttons]=\"toolbarButtons\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"columnsToDisplay\"\r\n    [paging]=\"paging\"\r\n    [results]=\"data$\"\r\n    [searchProperty]=\"'contactName'\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    (clear)=\"clear()\"\r\n    (query)=\"search($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n  ></lib-search-container>\r\n  <p-dialog\r\n    [modal]=\"true\"\r\n    position=\"center\"\r\n    [(visible)]=\"displayViewBanking\"\r\n    [showHeader]=\"false\"\r\n  >\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'SUPPLIER.VIEW_BANKING' | transloco }}\r\n    </h2>\r\n    <lib-view-banking\r\n      [bankingInfo]=\"viewBankingInfo\"\r\n      (closeViewBankingDialog)=\"closeViewBankingDialog()\"\r\n    ></lib-view-banking>\r\n  </p-dialog>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], BankingComponent);

let ViewBankingComponent$1 = class ViewBankingComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeViewBankingDialog = new EventEmitter();
    }
    set bankingInfoSetter(bankingInfo) {
        this.initializeForm(bankingInfo);
    }
    initializeForm(bankingInfoInput) {
        const bankingInfo = bankingInfoInput || {};
        this.editBankingForm = this.formBuilder.group({
            contactName: [{ value: bankingInfo.contactName, disabled: true }],
            contactEmail: [{ value: bankingInfo.contactEmail, disabled: true }],
            accountNumber: [{ value: bankingInfo.accountNumber, disabled: true }],
            externalAccountName: [
                { value: bankingInfo.externalAccountName, disabled: true },
            ],
            internalAccountName: [
                { value: bankingInfo.internalAccountName, disabled: true },
            ],
            routingNumber: [{ value: bankingInfo.routingNumber, disabled: true }],
            federalTaxID: [{ value: bankingInfo.federalTaxID, disabled: true }],
            identificationNumber: [
                { value: bankingInfo.identificationNumber, disabled: true },
            ],
            traceNumber: [{ value: bankingInfo.traceNumber, disabled: true }],
            sequenceNumber: [{ value: bankingInfo.sequenceNumber, disabled: true }],
            originName: [{ value: bankingInfo.originName, disabled: true }],
            bankName: [{ value: bankingInfo.bankName, disabled: true }],
        });
    }
    closeDialog() {
        this.closeViewBankingDialog.emit();
        this.editBankingForm.reset();
    }
};
ViewBankingComponent$1.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('bankingInfo')
], ViewBankingComponent$1.prototype, "bankingInfoSetter", null);
__decorate([
    Output()
], ViewBankingComponent$1.prototype, "closeViewBankingDialog", void 0);
ViewBankingComponent$1 = __decorate([
    Component({
        selector: 'lib-view-banking',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"editBankingForm\"\r\n>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactName\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactEmail\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_EMAIL' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactEmail\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"accountNumber\">{{\r\n      'SUPPLIER.VIEW_BANKING_ACCOUNT_NUMBER' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"accountNumber\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"externalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"externalAccountName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"internalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_INTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"internalAccountName\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"routingNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_ROUTING_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"routingNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"federalTaxID\">{{\r\n        'SUPPLIER.VIEW_BANKING_FEDERAL_TAX_ID' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"federalTaxID\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"identificationNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_IDENTIFICATION_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"identificationNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"traceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_TRACE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"traceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"originName\">{{\r\n        'SUPPLIER.VIEW_BANKING_ORIGIN_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"originName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"sequenceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_SEQUENCE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"sequenceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"bankName\">{{\r\n      'SUPPLIER.VIEW_BANKING_BANK_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"bankName\"\r\n    />\r\n  </div>\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n    class=\"ds secondary\"\r\n    autowidth=\"false\"\r\n    (click)=\"closeDialog()\"\r\n  ></button>\r\n</form>\r\n",
        styles: [""]
    })
], ViewBankingComponent$1);

let BillingTypeComponent = class BillingTypeComponent {
    constructor(mppService, translocoService, toast, store) {
        this.mppService = mppService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.editBillingInfoSubmit = new EventEmitter();
        this.templateTypes = TemplateTypes;
        this.baseUrl = `${this.mppService.getConfig().account}`;
        this.enableEdit = false;
        // edit billing type states
        this.showEditDialog = false;
    }
    set billingSetter(billingInfo) {
        this.billingInfo = billingInfo;
    }
    ngOnInit() {
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(16)) {
                    this.enableEdit = true;
                }
            }
        }))
            .subscribe();
    }
    openEditDialog() {
        this.editBillingTypeConfig = {
            endpoint: `wizard/marketplace/billing-type-setup`,
            httpMethod: HttpMethod$1.GET,
            body: {},
        };
        this.showEditDialog = true;
    }
    closeEditDialog() {
        this.showEditDialog = false;
    }
    submitEditBilling(event) {
        this.showEditDialog = false;
        this.editBillingInfoSubmit.emit();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
BillingTypeComponent.ctorParameters = () => [
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store }
];
__decorate([
    Input('billingInfo')
], BillingTypeComponent.prototype, "billingSetter", null);
__decorate([
    Output()
], BillingTypeComponent.prototype, "editBillingInfoSubmit", void 0);
BillingTypeComponent = __decorate([
    Component({
        selector: 'lib-billing-type',
        template: "<div class=\"toolbar\">\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    class=\"ds tertiary small\"\r\n    label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    (click)=\"openEditDialog()\"\r\n    [disabled]=\"!enableEdit\"\r\n  ></button>\r\n</div>\r\n<div *ngIf=\"billingInfo\" class=\"details\">\r\n  <div>\r\n    <ng-container\r\n      *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          billingInfo: {\r\n            label: 'MEMBER.BILLING_TYPE' | transloco,\r\n            value: billingInfo?.billingType\r\n          }\r\n        }\r\n      \"\r\n    ></ng-container>\r\n    <ng-container\r\n      *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          billingInfo: {\r\n            label: 'MEMBER.PRIMARY_BILLING_TYPE' | transloco,\r\n            value: billingInfo?.primaryBillingType\r\n          }\r\n        }\r\n      \"\r\n    ></ng-container>\r\n  </div>\r\n\r\n  <ng-template #billingDetails let-value=\"billingInfo\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">\r\n          {{ value.label }}\r\n        </div>\r\n        <div>\r\n          <span> {{ value.value }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showEditDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  [styleClass]=\"'visible-dropdown'\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"editBillingTypeConfig\"\r\n    (submit)=\"submitEditBilling($event)\"\r\n    (cancel)=\"closeEditDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeEditDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n"
    })
], BillingTypeComponent);

let ContactFormContainerComponent$2 = class ContactFormContainerComponent {
    constructor(config, accountService, groupBus, spinner) {
        this.config = config;
        this.accountService = accountService;
        this.groupBus = groupBus;
        this.spinner = spinner;
        this.closeContactDialog = new EventEmitter();
        this.subscriptions = [];
    }
    set contactSetter(contact) {
        this.contact = contact;
    }
    ngOnInit() {
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ contact }) => contact));
        this.setFetching('contact', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.config.getContactRoles(),
            this.config.getPhoneTypes(),
            this.config.getCountries(),
            this.accountService.getAccount(),
        ])
            .pipe(tap(([roles, phoneTypes, countries, account]) => {
            this.contactRoles = roles.map((role) => {
                return {
                    label: role.description,
                    value: role.contactRoleKey,
                };
            });
            this.phoneTypes = phoneTypes.map((phoneType) => {
                return {
                    label: phoneType.description,
                    value: phoneType.phoneTypeKey,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: `${country.countryName} (${alpha3ToAlpha2(country.countryCode)})`,
                    value: alpha3ToAlpha2(country.countryCode),
                };
            });
            this.account = account;
        }), finalize(() => {
            this.setFetching('contact', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.groupBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeContactDialog.emit();
    }
};
ContactFormContainerComponent$2.ctorParameters = () => [
    { type: ConfigService },
    { type: AccountService },
    { type: GroupBus },
    { type: SpinnerService }
];
__decorate([
    Input('contact')
], ContactFormContainerComponent$2.prototype, "contactSetter", null);
__decorate([
    Output()
], ContactFormContainerComponent$2.prototype, "closeContactDialog", void 0);
ContactFormContainerComponent$2 = __decorate([
    Component({
        selector: 'lib-contact-form-container',
        template: `<lib-contact-form
    [account]="account"
    [countries]="countries"
    [contact]="contact"
    [contactRoles]="contactRoles"
    [phoneTypes]="phoneTypes"
    (closeContactDialog)="closeDialog()"
  ></lib-contact-form>`
    })
], ContactFormContainerComponent$2);

let ContactFormComponent$2 = class ContactFormComponent {
    constructor(formBuilder, groupBus, transloco) {
        this.formBuilder = formBuilder;
        this.groupBus = groupBus;
        this.transloco = transloco;
        this.closeContactDialog = new EventEmitter();
        this.controls = [
            'firstName',
            'lastName',
            'title',
            'email',
            'contactRoleKey',
            'notes',
        ];
        this.disableContactRole = true;
        this.resetPhone = false;
        this.deletedPhones = [];
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.emailError = {
            email: () => this.transloco.translate('VALIDATION_MESSAGE.EMAIL'),
        };
    }
    set contactSetter(contact) {
        this.action = contact ? 'update' : 'create';
        this.contact = contact;
        this.initializeForm(contact);
    }
    initializeForm(contactInput) {
        const contact = contactInput
            ? contactInput
            : {};
        this.contactForm = this.formBuilder.group({
            firstName: [
                { value: contact.firstName, disabled: true },
                Validators.required,
            ],
            lastName: [
                { value: contact.lastName, disabled: true },
                Validators.required,
            ],
            title: [{ value: contact.title, disabled: true }, Validators.required],
            email: [
                { value: contact.email, disabled: true },
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            contactRoleKey: [
                { value: contact.contactRoleKey || 1, disabled: true },
                Validators.required,
            ],
            notes: [{ value: contact.notes, disabled: true }],
            phone: [{ value: contact === null || contact === void 0 ? void 0 : contact.phone, disabled: true }, Validators.required],
        });
    }
    getContactRole() {
        var _a;
        try {
            return (_a = this.contactRoles) === null || _a === void 0 ? void 0 : _a.find((contactRole) => contactRole.value === this.contact.contactRoleKey).label;
        }
        catch (error) {
            return '';
        }
    }
    closeDialog() {
        this.resetContactForm();
        this.closeContactDialog.emit();
        this.deletedPhones = [];
    }
    deletePhone(deletedPhones) {
        this.deletedPhones = [...this.deletedPhones, deletedPhones];
    }
    save() {
        const contactKey = this.action === 'create' ? '' : `${this.contact.contactKey}`;
        if (this.deletedPhones && this.deletedPhones.length > 0) {
            this.deletedPhones.forEach((payload) => this.groupBus.publish({
                eventType: 'delete',
                type: 'contactPhone',
                payload,
            }));
        }
        this.groupBus.publish({
            eventType: this.action,
            type: 'contact',
            typeKey: contactKey,
            payload: this.formatContactPayload(),
        });
        this.closeDialog();
    }
    formatContactPayload() {
        var _a, _b, _c, _d;
        return Object.assign(Object.assign(Object.assign({}, this.contact), this.contactForm.value), { phone: (_d = (_c = (_b = (_a = this.contactForm) === null || _a === void 0 ? void 0 : _a.get('phone')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.phone) === null || _d === void 0 ? void 0 : _d.map((phone) => {
                return Object.assign(Object.assign({}, phone), { contactPhoneKey: (phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) !== null
                        ? Number(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey)
                        : 0, phoneTypeKey: (phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) : 1, phoneNumber: this.formatPhoneForSave(phone), phoneCountryCode: alpha2ToAlpha3((phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode) || 'CA') });
            }) });
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    resetContactForm() {
        this.resetPhone = true;
        this.controls.forEach((control) => this.contactForm.get(control).setValue(''));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
ContactFormComponent$2.ctorParameters = () => [
    { type: FormBuilder },
    { type: GroupBus },
    { type: TranslocoService }
];
__decorate([
    Input('contact')
], ContactFormComponent$2.prototype, "contactSetter", null);
__decorate([
    Input()
], ContactFormComponent$2.prototype, "account", void 0);
__decorate([
    Input()
], ContactFormComponent$2.prototype, "contactRoles", void 0);
__decorate([
    Input()
], ContactFormComponent$2.prototype, "phoneTypes", void 0);
__decorate([
    Input()
], ContactFormComponent$2.prototype, "countries", void 0);
__decorate([
    Output()
], ContactFormComponent$2.prototype, "closeContactDialog", void 0);
ContactFormComponent$2 = __decorate([
    Component({
        selector: 'lib-contact-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"contactForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"firstName\">{{\r\n      'SUPPLIER.CONTACT_FIRST_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"firstName\"\r\n    />\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.firstName\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"lastName\">{{ 'SUPPLIER.CONTACT_LAST_NAME' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"lastName\"\r\n    />\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.lastName\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"title\">{{ 'SUPPLIER.CONTACT_TITLE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"title\"\r\n    />\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.title\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <lib-phone-form\r\n    [countries]=\"countries\"\r\n    [defaultCountry]=\"account?.details?.country\"\r\n    [phoneTypes]=\"phoneTypes\"\r\n    [resetPhone]=\"resetPhone\"\r\n    [viewOnly]=\"true\"\r\n    (deletedPhone)=\"deletePhone($event)\"\r\n    formControlName=\"phone\"\r\n  ></lib-phone-form>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"email\">{{ 'SUPPLIER.CONTACT_EMAIL' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"email\"\r\n    />\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.email\"\r\n      [errorMsg]=\"emailError.email\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"contactRoleKey\">{{\r\n      'SUPPLIER.CONTACT_ROLE' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      [value]=\"getContactRole()\"\r\n      [disabled]=\"disableContactRole\"\r\n    />\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.role\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"notes\">{{ 'SUPPLIER.CONTACT_NOTES' | transloco }}</label>\r\n    <textarea\r\n      rows=\"5\"\r\n      autoresize=\"false\"\r\n      name=\"notes\"\r\n      pInputTextarea\r\n      formControlName=\"notes\"\r\n      class=\"width-100 ui-inputtext\"\r\n    ></textarea>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ContactFormComponent$2);

let ContactsComponent$2 = class ContactsComponent {
    constructor(confirmationService, groupBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.groupBus = groupBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showContactDialog = false;
        this.columnsAvailable = false;
        this.fetching = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set notesSetter(contacts) {
        this.contacts = contacts;
    }
    set contactRolesSetter(contactsRoles) {
        this.contactRoles = contactsRoles;
    }
    set phoneTypesSetter(phoneTypes) {
        this.phoneTypes = phoneTypes;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 20 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.groupBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'contact' && payload.result) {
                this.data$ = of(this.transformContactPhoneForSC(payload.data.contactResponse));
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ contact }) => (this.fetching = contact)));
        this.columnsToDisplay = [
            'firstName',
            'workPhone',
            'mobilePhone',
            'otherPhone',
            'email',
            'contactRole',
            'title',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(contacts, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                contacts.forEach((contact) => this.groupBus.publish({
                    eventType: 'delete',
                    type: 'contact',
                    typeKey: `${contact.contactKey}`,
                }));
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.action = 'view';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.groupBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters('', {
                first: 0,
                rows: 25,
                sortField: 'firstName',
                sortOrder: 1,
            }, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.groupBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters(term, pagination, [], 'firstName'),
        });
    }
    closeContactDialog() {
        this.showContactDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactRole',
                    header: translate.CONTACT_ROLE,
                    formatter: ({ contactRoleKey }) => `${roles[contactRoleKey]}`,
                },
                {
                    field: 'firstName',
                    header: translate.FULL_NAME,
                    formatter: ({ firstName, lastName }) => `${firstName} ${lastName}`,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (contact) => contact,
                    required: true,
                },
                {
                    field: 'workPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.WORK_PHONE}`,
                    formatter: ({ workPhone }) => {
                        var _a;
                        return `${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber) || ''} ${((_a = workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'mobilePhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.MOBILE_PHONE}`,
                    formatter: ({ mobilePhone }) => {
                        var _a;
                        return `${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber) || ''} ${((_a = mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'otherPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.OTHER_PHONE}`,
                    formatter: ({ otherPhone }) => {
                        var _a;
                        return `${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber) || ''} ${((_a = otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'title',
                    header: translate.TITLE,
                },
                {
                    field: 'email',
                    header: translate.EMAIL,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    formatPhoneNumber(phoneNumber, countryCode) {
        try {
            return parsePhoneNumber(phoneNumber, alpha3ToAlpha2(countryCode)).formatInternational();
        }
        catch (_a) {
            return phoneNumber;
        }
    }
    transformContactPhoneForSC(contacts) {
        return contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => {
            const mobilePhone = this.findPhone(contact, 1);
            const otherPhone = this.findPhone(contact, 2);
            const workPhone = this.findPhone(contact, 3);
            return Object.assign(Object.assign({}, contact), { mobilePhone: Object.assign(Object.assign({}, mobilePhone), { phoneNumber: this.formatPhoneNumber(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber, mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneCountryCode) }), otherPhone: Object.assign(Object.assign({}, otherPhone), { phoneNumber: this.formatPhoneNumber(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber, otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneCountryCode) }), workPhone: Object.assign(Object.assign({}, workPhone), { phoneNumber: this.formatPhoneNumber(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber, workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneCountryCode) }) });
        });
    }
    findPhone(contact, phoneTypeKey) {
        try {
            return contact.phone.find((phn) => phn.phoneTypeKey === phoneTypeKey);
        }
        catch (_a) {
            return undefined;
        }
    }
    openViewContact(contact) {
        this.action = 'view';
        this.showContactDialog = true;
        this.editContactData = contact;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_GROUP,
        };
    }
};
ContactsComponent$2.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: GroupBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('contacts')
], ContactsComponent$2.prototype, "notesSetter", null);
__decorate([
    Input('contactRoles')
], ContactsComponent$2.prototype, "contactRolesSetter", null);
__decorate([
    Input('phoneTypes')
], ContactsComponent$2.prototype, "phoneTypesSetter", null);
ContactsComponent$2 = __decorate([
    Component({
        selector: 'lib-contacts',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"myMarketplace\"\r\n      i18nSearchField=\"{{ 'PARTNERS.CONTACT_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewContact($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showContactDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"editContactData; else Add\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-template #Add>\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.ADD_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-template>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], ContactsComponent$2);

let DetailsComponent$2 = class DetailsComponent {
    constructor() { }
    set detailsSetter(details) {
        this.details = details;
        try {
            this.details.fax = parsePhoneNumber(this.details.fax, alpha3ToAlpha2(this.details.country)).formatInternational();
            this.details.phone = parsePhoneNumber(this.details.phone, alpha3ToAlpha2(this.details.country)).formatInternational();
        }
        catch (_a) { }
    }
    ngOnInit() { }
};
__decorate([
    Input('details')
], DetailsComponent$2.prototype, "detailsSetter", null);
DetailsComponent$2 = __decorate([
    Component({
        selector: 'lib-details',
        template: "<!--My Marketplace Details - View Mode-->\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <!-- <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ISA_NUMBER' | transloco,\r\n          value: details?.isaNumber\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container> -->\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.LEGAL_NAME' | transloco,\r\n          value: details?.legalName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.DBA_NAME' | transloco,\r\n          value: details?.dbaName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_ONE' | transloco,\r\n          value: details?.address1\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_TWO' | transloco,\r\n          value: details?.address2\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: { label: 'SUPPLIER.CITY' | transloco, value: details?.city }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.STATE_PROVINCE' | transloco,\r\n          value: details?.provinceName || details?.province.trim()\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ZIP_POSTAL_CODE' | transloco,\r\n          value: details?.postalCode\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.COUNTRY' | transloco,\r\n          value: details?.countryName || details.country\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco,\r\n          value: details?.phone\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.FAX' | transloco,\r\n          value: details?.fax\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.ACCOUNT_WEBSITE' | transloco,\r\n          value: details?.website\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      marketplaceDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco,\r\n          value: details?.currencyType\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n</div>\r\n<ng-template #marketplaceDetails let-value=\"details\">\r\n  <div class=\"view-details view-details-row\">\r\n    <div class=\"view-details view-details-tile\">\r\n      <div class=\"view-details view-details-label\">\r\n        {{ value.label }}\r\n      </div>\r\n      <div>\r\n        <span> {{ value.value }}</span>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n",
        styles: [""]
    })
], DetailsComponent$2);

let EdiFormContainerComponent = class EdiFormContainerComponent {
    constructor(config, groupBus, spinner) {
        this.config = config;
        this.groupBus = groupBus;
        this.spinner = spinner;
        this.closeEdiDialog = new EventEmitter();
        this.edi = [];
        this.documentTypes = [];
        this.documentStatus = [];
    }
    set ediSetter(edi) {
        this.edi = edi;
    }
    ngOnInit() {
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ edi }) => edi));
        this.setFetching('edi', true);
        this.spinner.on();
        this.subscription = forkJoin([
            this.config.getDocumentTypes(),
            this.config.getDocumentStatus(),
        ])
            .pipe(tap(([documentTypes, documentStatus]) => {
            this.documentTypes = documentTypes;
            this.documentStatus = documentStatus.map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentStatusKey, label: doc.description })));
        }), finalize(() => {
            this.setFetching('edi', false);
            this.spinner.off();
        }))
            .subscribe();
    }
    doesContainDocumentType(documentTypes = [{ documentTypeKey: 0 }], documentType = { documentTypeKey: 0 }) {
        return (documentTypes.filter((doc) => documentType.documentTypeKey === doc.documentTypeKey).length > 0);
    }
    getAvailableDocumentTypes() {
        return this.documentTypes
            .filter((documentType) => !this.doesContainDocumentType(this.edi, documentType))
            .map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentTypeKey, label: doc.description })));
    }
    setFetching(form, value) {
        this.groupBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
EdiFormContainerComponent.ctorParameters = () => [
    { type: ConfigService },
    { type: GroupBus },
    { type: SpinnerService }
];
__decorate([
    Input('edi')
], EdiFormContainerComponent.prototype, "ediSetter", null);
__decorate([
    Output()
], EdiFormContainerComponent.prototype, "closeEdiDialog", void 0);
EdiFormContainerComponent = __decorate([
    Component({
        selector: 'lib-edi-form-container',
        template: `
    <lib-edi-form
      [documentTypes]="this.getAvailableDocumentTypes()"
      [documentStatus]="documentStatus"
      (closeEdiDialog)="closeDialog()"
    ></lib-edi-form>
  `
    })
], EdiFormContainerComponent);

let EdiFormComponent = class EdiFormComponent {
    constructor(formBuilder, groupBus) {
        this.formBuilder = formBuilder;
        this.groupBus = groupBus;
        this.closeEdiDialog = new EventEmitter();
        this.documentTypes = [];
        this.documentStatus = [];
        this.documentTemplates = [
            { label: '810 Invoice', value: 1 },
            { label: '812 Credit/Debit Adjustment', value: 2 },
            { label: '820 Remittance Advice', value: 3 },
            { label: '824 Application Advice', value: 4 },
            { label: '830 Planning Schedule with Release Capability', value: 5 },
            { label: '850 Purchase Order', value: 6 },
            { label: '855 Purchase Order Acknowledgement', value: 7 },
            { label: '860 Purchase Order Change Request', value: 8 },
            { label: '864 Text Message', value: 9 },
        ];
        this.availableDocumentTypes = [];
    }
    set documentTypeSetter(documentTypes) {
        this.documentTypes = documentTypes;
    }
    set documentStatusSetter(documentStatus) {
        this.documentStatus = documentStatus;
    }
    ngOnInit() {
        this.ediForm = this.formBuilder.group({
            documentTypeKey: ['', Validators.required],
            documentStatusKey: ['', Validators.required],
            documentTemplateTypeKey: [''],
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
        this.ediForm.reset();
    }
    save() {
        this.groupBus.publish({
            eventType: 'create',
            type: 'edi',
            payload: {
                documentTypeKey: this.ediForm.get('documentTypeKey').value,
                documentStatusKey: this.ediForm.get('documentStatusKey').value,
            },
        });
        this.closeDialog();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
EdiFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: GroupBus }
];
__decorate([
    Input('documentTypes')
], EdiFormComponent.prototype, "documentTypeSetter", null);
__decorate([
    Input('documentStatus')
], EdiFormComponent.prototype, "documentStatusSetter", null);
__decorate([
    Output()
], EdiFormComponent.prototype, "closeEdiDialog", void 0);
EdiFormComponent = __decorate([
    Component({
        selector: 'lib-edi-form',
        template: "<form class=\"vertical-flow\" [formGroup]=\"ediForm\" (ngSubmit)=\"save()\">\r\n  <div class=\"vertical-flow stacked-labels\">\r\n    <div>\r\n      <label for=\"documentType\">Type</label>\r\n      <p-dropdown\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentType\"\r\n        [options]=\"documentTypes\"\r\n        formControlName=\"documentTypeKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n    </div>\r\n    <div>\r\n      <label for=\"documentStatus\">Status</label>\r\n      <p-dropdown\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentStatus\"\r\n        [options]=\"documentStatus\"\r\n        formControlName=\"documentStatusKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n    </div>\r\n    <div>\r\n      <label for=\"documentTemplate\">Template Type</label>\r\n      <p-dropdown\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentTemplate\"\r\n        [options]=\"documentTemplates\"\r\n        formControlName=\"documentTemplateTypeKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      [disabled]=\"ediForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], EdiFormComponent);

const searchFilters$1 = (simpleSearch = '', pagination) => {
    return {
        offset: pagination.first,
        limit: pagination.rows,
        filters: [
            {
                field: 'DocumentTypeKey',
                operator: 'contains',
                value: simpleSearch,
                logic: 'or',
            },
            {
                field: 'DocumentStatusKey',
                operator: 'contains',
                value: simpleSearch,
                logic: 'or',
            },
        ],
        sort: [
            {
                orderBy: pagination.sortField || 'DocumentTypeKey',
                sortOrder: pagination.sortOrder === 1 ? 'asc' : 'desc' || 'asc',
            },
        ],
    };
};

let EdiComponent = class EdiComponent {
    constructor(confirmationService, groupBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.groupBus = groupBus;
        this.translocoService = translocoService;
        this.store = store;
        this.fetching = false;
        this.toolbarButtons = [];
        this.showEdiDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set ediSetter(edi) {
        this.data$ = of(edi);
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['documentType', 'documentStatus'];
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.showEdiDialog = true;
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    delete(selection = [], clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate(''),
            header: this.translocoService.translate(''),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                selection.forEach((edi) => {
                    this.groupBus.publish({
                        eventType: 'delete',
                        type: 'edi',
                        typeKey: edi.accountRelationshipDocumentKey,
                    });
                });
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    clear() {
        this.groupBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters$1('', {
                first: 0,
                rows: 25,
                sortField: 'DocumentTypeKey',
                sortOrder: 1,
            }),
        });
    }
    search(_a) {
        var { filters: { simpleSearch } } = _a, pagination = __rest(_a, ["filters"]);
        this.groupBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters$1(simpleSearch, pagination),
        });
    }
    closeEdiDialog() {
        this.showEdiDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'number',
                    header: translate.NUMBER,
                },
                {
                    field: 'documentType',
                    header: 'Type',
                },
                {
                    field: 'documentStatus',
                    header: 'Status',
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            add: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            delete: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
EdiComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: GroupBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('edi')
], EdiComponent.prototype, "ediSetter", null);
__decorate([
    Input()
], EdiComponent.prototype, "fetching", void 0);
EdiComponent = __decorate([
    Component({
        selector: 'lib-edi',
        template: "<lib-search-container\r\n  *ngIf=\"columnsAvailable\"\r\n  name=\"supplierEDI\"\r\n  i18nSearchField=\"{{ 'PARTNERS.EDI_SEARCH' | transloco }}\"\r\n  [buttons]=\"toolbarButtons\"\r\n  [loading]=\"fetching\"\r\n  [columns]=\"columns\"\r\n  [columnsToDisplay]=\"columnsToDisplay\"\r\n  [paging]=\"paging\"\r\n  [results]=\"data$\"\r\n  [searchProperty]=\"'simpleSearch'\"\r\n  [disableAdvancedSearch]=\"true\"\r\n  (clear)=\"clear()\"\r\n  (query)=\"search($event)\"\r\n  (toolbar)=\"onToolbarClick($event)\"\r\n></lib-search-container>\r\n\r\n<p-dialog\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [(visible)]=\"showEdiDialog\"\r\n  [showHeader]=\"false\"\r\n>\r\n  <lib-working-spinner-component></lib-working-spinner-component>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.ADD_EDI' | transloco }}\r\n  </h2>\r\n  <lib-edi-form-container\r\n    [edi]=\"data$ | async\"\r\n    (closeEdiDialog)=\"closeEdiDialog()\"\r\n  ></lib-edi-form-container>\r\n</p-dialog>\r\n",
        styles: [""]
    })
], EdiComponent);

let FormsComponent = class FormsComponent {
    constructor(accountService) {
        this.accountService = accountService;
        this.imageSrc = '';
        this.imageAlt = '';
        this.isCompanyLogoPresent = false;
        this.subscriptions = [];
    }
    set groupSetter(group) {
        this.group = group;
        this.getLogoAssetKey();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getLogoAssetKey() {
        if (this.group &&
            this.group.details &&
            this.group.details.logo_AccountAssetKey !== null) {
            this.setCompanyLogo(Number(this.group.details.logo_AccountAssetKey), Number(this.group.details.accountKey));
        }
    }
    setCompanyLogo(logoId, accountKey) {
        if (logoId <= 0) {
            return;
        }
        // this.subscriptions.push(
        //   this.accountService.getLogoBlob(logoId, accountKey).subscribe((resp) => {
        //     this.imageSrc = this.accountService.createUrlFromBlob(resp);
        //     this.isCompanyLogoPresent = true;
        //   })
        // );
    }
};
FormsComponent.ctorParameters = () => [
    { type: AccountService }
];
__decorate([
    Input('group')
], FormsComponent.prototype, "groupSetter", null);
__decorate([
    Input()
], FormsComponent.prototype, "fetching", void 0);
__decorate([
    Input()
], FormsComponent.prototype, "updating", void 0);
FormsComponent = __decorate([
    Component({
        selector: 'lib-forms',
        template: "<section>\r\n  <lib-header\r\n    [imageTemplate]=\"header_image\"\r\n    [titleTemplate]=\"header_title\"\r\n    [contentTemplate]=\"header_content\"\r\n  >\r\n    <ng-template #header_title>\r\n      <h2 class=\"header-card-title\">{{ 'GROUP.EDIT' | transloco }}</h2>\r\n    </ng-template>\r\n    <ng-template #header_image>\r\n      <div class=\"row no-margin-left\">\r\n        <div class=\"defaultImageStyle logo-container\">\r\n          <span *ngIf=\"!isCompanyLogoPresent\"\r\n            >{{ 'PIM.ASSET' | transloco }} <br />{{\r\n              'PIM.NOT_FOUND' | transloco\r\n            }}</span\r\n          >\r\n          <img\r\n            [src]=\"imageSrc\"\r\n            [alt]=\"imageAlt\"\r\n            *ngIf=\"isCompanyLogoPresent\"\r\n            class=\"logo-container\"\r\n          />\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template #header_content>\r\n      <div class=\"vertical-flow\">\r\n        <div class=\"horizontal-flow\">\r\n          <div class=\"vertical-flow\">\r\n            <h4 class=\"content-title\">\r\n              <div *ngIf=\"group?.details?.legalName?.length > 0; else dbaName\">\r\n                {{ group?.details?.legalName }}\r\n                <span *ngIf=\"group?.details?.dbaName?.length > 0\"\r\n                  >({{ group?.details?.dbaName }})</span\r\n                >\r\n              </div>\r\n              <ng-template #dbaName>\r\n                <span *ngIf=\"group?.details?.dbaName?.length > 0\">{{\r\n                  group?.details?.dbaName\r\n                }}</span>\r\n              </ng-template>\r\n            </h4>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.LBMXID' | transloco }} : {{ group?.details?.lbmxId }}\r\n            </p>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.ISA_NUMBER' | transloco }} :\r\n              {{ group?.details?.isaNumber }}\r\n            </p>\r\n          </div>\r\n          <div class=\"vertical-flow\">\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.COUNTRY' | transloco }} :\r\n              {{ group?.details?.country }}\r\n            </p>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.ZIP_POSTAL_CODE' | transloco }} :\r\n              {{ group?.details?.postalCode }}\r\n            </p>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.WEBSITE' | transloco }} :\r\n              {{ group?.details?.website }}\r\n            </p>\r\n          </div>\r\n        </div>\r\n        <div class=\"horizontal-flow\">\r\n          <div class=\"vertical-flow\">\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.ADDRESS_ONE' | transloco }} :\r\n              {{ group?.details?.address1 }}\r\n            </p>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.ADDRESS_TWO' | transloco }} :\r\n              {{ group?.details?.address2 }}\r\n            </p>\r\n            <p class=\"content-title\">City : {{ group?.details?.city }}</p>\r\n            <p class=\"content-title\">\r\n              {{ 'SUPPLIER.STATE_PROVINCE' | transloco }} :\r\n              {{ group?.details?.province }}\r\n            </p>\r\n          </div>\r\n          <div>\r\n            <!-- <p class=\"content-title\">{{'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco}} : {{ group?.details?.currencyType }}</p> -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n  </lib-header>\r\n</section>\r\n<section>\r\n  <p-tabView>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n      <lib-details [details]=\"group?.details\"></lib-details>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n      <lib-contacts [contacts]=\"group?.contacts\"></lib-contacts>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_BANKING' | transloco }}\">\r\n      <lib-banking [bankingInfo]=\"group?.bankingInfo\"></lib-banking>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_LOCATIONS' | transloco }}\">\r\n      <lib-locations [locations]=\"group?.locations\"></lib-locations\r\n    ></p-tabPanel>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_EDI' | transloco }}\">\r\n      <lib-edi [edi]=\"group?.documents\"></lib-edi>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"{{ 'SUPPLIER.TAB_NOTES' | transloco }}\">\r\n      <lib-notes [notes]=\"group?.notes\"></lib-notes\r\n    ></p-tabPanel>\r\n  </p-tabView>\r\n  <p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n</section>\r\n",
        styles: [".content-title{font-size:22px;display:block;margin:0 2em 0 0}"]
    })
], FormsComponent);

let HeaderComponent = class HeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], HeaderComponent.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], HeaderComponent.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], HeaderComponent.prototype, "contentTemplate", void 0);
HeaderComponent = __decorate([
    Component({
        selector: 'lib-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em;\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], HeaderComponent);

let LocationsComponent$1 = class LocationsComponent {
    constructor(translocoService, store) {
        this.translocoService = translocoService;
        this.store = store;
        this.fetching = false;
        this.viewLocationsData = {};
        this.toolbarButtons = [];
        this.displayEditLocation = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set locationsSetter(locations) {
        this.locations = locations;
        this.data$ = of(locations);
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['legalName', 'dbaName'];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayEditLocation = true;
                this.viewLocationsData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.search();
    }
    search({ filters: { country } } = { filters: { country: '.*' } }) {
        const regex = new RegExp(country, 'i');
        this.data$ = of(this.locations.filter((bankingInfo) => bankingInfo.country.match(regex)));
    }
    closeEditLocationDialog() {
        this.displayEditLocation = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                },
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                },
                {
                    field: 'number',
                    header: translate.NUMBER,
                },
                {
                    field: 'country',
                    header: translate.COUNTRY,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                {
                    field: 'province',
                    header: translate.STATE_PROVINCE,
                },
                {
                    field: 'postalCode',
                    header: translate.ZIP_POSTAL_CODE,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
LocationsComponent$1.ctorParameters = () => [
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('locations')
], LocationsComponent$1.prototype, "locationsSetter", null);
__decorate([
    Input()
], LocationsComponent$1.prototype, "fetching", void 0);
LocationsComponent$1 = __decorate([
    Component({
        selector: 'lib-locations',
        template: "<div>\r\n  <lib-search-container\r\n    *ngIf=\"columnsAvailable\"\r\n    name=\"groupLocations\"\r\n    i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n    [buttons]=\"toolbarButtons\"\r\n    [loading]=\"fetching\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"columnsToDisplay\"\r\n    [paging]=\"paging\"\r\n    [results]=\"data$\"\r\n    [searchProperty]=\"'country'\"\r\n    [disableAdvancedSearch]=\"true\"\r\n    (clear)=\"clear()\"\r\n    (query)=\"search($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n  ></lib-search-container>\r\n  <p-dialog\r\n    [modal]=\"true\"\r\n    position=\"center\"\r\n    [(visible)]=\"displayEditLocation\"\r\n    [showHeader]=\"false\"\r\n  >\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'SUPPLIER.VIEW_LOCATION' | transloco }}\r\n    </h2>\r\n    <lib-view-location\r\n      [location]=\"viewLocationsData\"\r\n      (closeEditLocationDialog)=\"closeEditLocationDialog()\"\r\n    ></lib-view-location>\r\n  </p-dialog>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], LocationsComponent$1);

let ViewLocationComponent = class ViewLocationComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeEditLocationDialog = new EventEmitter();
    }
    set locationSetter(location) {
        this.initializeForm(location);
    }
    initializeForm(locationInput) {
        const location = locationInput || {};
        this.viewLocationForm = this.formBuilder.group({
            legalName: [{ value: location.legalName, disabled: true }],
            dbaName: [{ value: location.dbaName, disabled: true }],
            number: [{ value: location.number, disabled: true }],
            country: [{ value: location.country, disabled: true }],
            city: [{ value: location.city, disabled: true }],
            province: [{ value: location.province, disabled: true }],
            postalCode: [{ value: location.postalCode, disabled: true }],
            address1: [{ value: location.address1, disabled: true }],
            address2: [{ value: location.address2, disabled: true }],
        });
    }
    closeDialog() {
        this.closeEditLocationDialog.emit();
    }
};
ViewLocationComponent.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('location')
], ViewLocationComponent.prototype, "locationSetter", null);
__decorate([
    Output()
], ViewLocationComponent.prototype, "closeEditLocationDialog", void 0);
ViewLocationComponent = __decorate([
    Component({
        selector: 'lib-view-location',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"viewLocationForm\"\r\n>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"legalName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"dbaName\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"number\">{{ 'SUPPLIER.NUMBER' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"number\"\r\n    />\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"address1\"\r\n      />\r\n    </div>\r\n\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"address2\"\r\n      />\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"city\"\r\n      />\r\n    </div>\r\n\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"province\">{{ 'SUPPLIER.STATE_PROVINCE' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"province\"\r\n      />\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"postalCode\">{{\r\n        'SUPPLIER.ZIP_POSTAL_CODE' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"postalCode\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"country\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"primaryLightGreyLargeBtn\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ViewLocationComponent);

let MarketplaceSetupComponent = class MarketplaceSetupComponent {
    constructor(mppService, translocoService, toast, router, route, mpSetupService, store) {
        this.mppService = mppService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.router = router;
        this.route = route;
        this.mpSetupService = mpSetupService;
        this.store = store;
        this.submitMarketplaceEdit = new EventEmitter();
        this.enableEdit = false;
        this.templateTypes = TemplateTypes;
        this.baseUrl = `${this.mppService.getConfig().account}`;
        // edit marketplace setup states
        this.showEditDialog = false;
    }
    set detailsSetter(details) {
        this.details = details;
    }
    ngOnInit() {
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(16)) {
                    this.enableEdit = true;
                }
            }
        }))
            .subscribe();
    }
    openEditDialog() {
        this.editMarketplaceSetupConfig = {
            endpoint: `wizard/marketplace/central-setup/edit`,
            httpMethod: HttpMethod$1.GET,
            body: {},
        };
        this.mpSetupService.wizardConfig = this.editMarketplaceSetupConfig;
        this.mpSetupService.baseUrl = this.baseUrl;
        this.router.navigate(['./marketplace-edit'], { relativeTo: this.route });
    }
    formatBoolean(value) {
        return value === true ? 'Yes' : 'No';
    }
};
MarketplaceSetupComponent.ctorParameters = () => [
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Router },
    { type: ActivatedRoute },
    { type: MarketplaceSetupService },
    { type: Store }
];
__decorate([
    Input('details')
], MarketplaceSetupComponent.prototype, "detailsSetter", null);
__decorate([
    Output()
], MarketplaceSetupComponent.prototype, "submitMarketplaceEdit", void 0);
MarketplaceSetupComponent = __decorate([
    Component({
        selector: 'lib-marketplace-setup',
        template: "<div class=\"toolbar\">\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    class=\"ds tertiary small\"\r\n    label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    (click)=\"openEditDialog()\"\r\n    [disabled]=\"!enableEdit\"\r\n  ></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <div>\r\n    <ng-container\r\n      *ngTemplateOutlet=\"\r\n        receivablePaymentOptions;\r\n        context: {\r\n          details: {\r\n            label: 'MEMBER.ACCOUNTS_RECEIVABLE_PAYMENT_OPTIONS' | transloco,\r\n            partialPayments: formatBoolean(details?.memberPartialPayment),\r\n            allowTerms: formatBoolean(details?.memberTakeTermsAfter)\r\n          }\r\n        }\r\n      \"\r\n    ></ng-container>\r\n    <ng-container\r\n      *ngTemplateOutlet=\"\r\n        payablePaymentOptions;\r\n        context: {\r\n          details: {\r\n            label: 'MEMBER.ACCOUNTS_PAYABLE_PAYMENT_OPTIONS' | transloco,\r\n            eftDeliveryType: details?.eftDeliveryType,\r\n            paymentMethods: details?.paymentMethods,\r\n            marketplaceTakeTerms: formatBoolean(\r\n              details?.marketplaceTakeTermsAfter\r\n            ),\r\n            marketplacePartialPayment: formatBoolean(\r\n              details?.marketplacePartialPayment\r\n            ),\r\n            paymentPreference: details?.paymentPreferenceType\r\n          }\r\n        }\r\n      \"\r\n    ></ng-container>\r\n  </div>\r\n  <ng-template #receivablePaymentOptions let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">\r\n          {{ value.label }}\r\n        </div>\r\n        <div>\r\n          <span\r\n            >{{ 'MEMBER.ALLOW_MEMBERS_PARTIAL_PAYMENTS' | transloco }}:\r\n            {{ value.partialPayments }}</span\r\n          >\r\n        </div>\r\n        <div></div>\r\n        <div>\r\n          <span>\r\n            {{ 'MEMBER.ALLOW_TERMS_TAKEN' | transloco }}:\r\n            {{ value.allowTerms }}</span\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template #payablePaymentOptions let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">\r\n          {{ value.label }}\r\n        </div>\r\n        <div>\r\n          <span>\r\n            {{ 'MEMBER.ACH_DELIVERY' | transloco }}:\r\n            {{ value.eftDeliveryType }}</span\r\n          >\r\n        </div>\r\n        <div></div>\r\n        <div>\r\n          <span>\r\n            {{ 'MEMBER.BUYING_GROUPS_PAYMENT_METHOD' | transloco }}:\r\n            {{ value.paymentMethods }}</span\r\n          >\r\n        </div>\r\n        <div></div>\r\n        <div>\r\n          <span>\r\n            {{ 'MEMBER.BUYING_GROUP_ABILITY_PARTIAL' | transloco }}:\r\n            {{ value.marketplacePartialPayment }}</span\r\n          >\r\n        </div>\r\n        <div></div>\r\n        <div>\r\n          <span>\r\n            {{ 'MEMBER.BUYING_GROUP_ABILITY_TERMS' | transloco }}:\r\n            {{ value.marketplaceTakeTerms }}</span\r\n          >\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n"
    })
], MarketplaceSetupComponent);

let MyMarketplaceHeaderComponent = class MyMarketplaceHeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], MyMarketplaceHeaderComponent.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], MyMarketplaceHeaderComponent.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], MyMarketplaceHeaderComponent.prototype, "contentTemplate", void 0);
MyMarketplaceHeaderComponent = __decorate([
    Component({
        selector: 'lib-my-marketplace-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], MyMarketplaceHeaderComponent);

const flagForFollowUp = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
];
const searchFilters$2 = (simpleSearch = '', pagination) => {
    return {
        offset: pagination.first,
        limit: pagination.rows,
        filters: [
            {
                field: 'Message',
                operator: 'contains',
                value: simpleSearch,
                logic: '',
            },
        ],
        sort: [
            {
                orderBy: pagination.sortField || 'Message',
                sortOrder: pagination.sortOrder === 1 ? 'asc' : 'desc' || 'asc',
            },
        ],
    };
};

let NoteFormComponent = class NoteFormComponent {
    constructor(formBuilder, groupBus) {
        this.formBuilder = formBuilder;
        this.groupBus = groupBus;
        this.closeNoteDialog = new EventEmitter();
        this.flagForFollowUpOptions = flagForFollowUp;
    }
    set noteSetter(note) {
        this.action = note ? 'update' : 'create';
        this.note = note;
        this.initializeForm(note);
    }
    initializeForm(noteInput) {
        const note = noteInput || {};
        this.noteForm = this.formBuilder.group({
            message: [note.message, Validators.required],
            flagForFollowUp: [note.flagForFollowUp, Validators.required],
        });
    }
    closeDialog() {
        this.closeNoteDialog.emit();
        this.noteForm.reset();
    }
    save() {
        const accountRelationshipNoteKey = this.action === 'create' ? '' : `${this.note.accountRelationshipNoteKey}`;
        this.groupBus.publish({
            eventType: this.action,
            type: 'note',
            typeKey: accountRelationshipNoteKey,
            payload: Object.assign(Object.assign({}, this.note), this.noteForm.value),
        });
        this.closeDialog();
    }
};
NoteFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: GroupBus }
];
__decorate([
    Input('note')
], NoteFormComponent.prototype, "noteSetter", null);
__decorate([
    Output()
], NoteFormComponent.prototype, "closeNoteDialog", void 0);
NoteFormComponent = __decorate([
    Component({
        selector: 'lib-note-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"noteForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"message\">{{ 'SUPPLIER.MESSAGE' | transloco }}</label>\r\n    <textarea\r\n      rows=\"5\"\r\n      autoresize=\"true\"\r\n      name=\"message\"\r\n      pInputTextarea\r\n      formControlName=\"message\"\r\n      class=\"ui-inputtext\"\r\n    ></textarea>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"flagForFollowUp\">{{\r\n      'SUPPLIER.FLAG_FOR_FOLLOW_UP' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"province\"\r\n      [options]=\"flagForFollowUpOptions\"\r\n      formControlName=\"flagForFollowUp\"\r\n      filter=\"true\"\r\n      placeholder=\"Please Select a flag\"\r\n    ></p-dropdown>\r\n  </div>\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"primaryLightGreyLargeBtn\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      [disabled]=\"noteForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"primaryDefaultLargeBtn\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], NoteFormComponent);

let NotesComponent = class NotesComponent {
    constructor(confirmationService, groupBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.groupBus = groupBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showNoteDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set notesSetter(notes) {
        this.notes = notes;
        this.data$ = of(notes);
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.groupBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'note' && payload.result) {
                this.data$ = of(payload.data);
            }
        }));
        this.fetching$ = this.groupBus.fetching$.pipe(map(({ note }) => note));
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['message', 'flagForFollowUp'];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    deleteNote(notes, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                notes.forEach((note) => this.groupBus.publish({
                    eventType: 'delete',
                    type: 'note',
                    typeKey: `${note.accountRelationshipNoteKey}`,
                }));
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.showNoteDialog = true;
                this.editNote = undefined;
                break;
            case 'edit':
                this.showNoteDialog = true;
                this.editNote = selection[0];
                break;
            case 'delete':
                this.deleteNote(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        this.groupBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters$2('', {
                first: 0,
                rows: 25,
                sortField: 'Message',
                sortOrder: 1,
            }),
        });
    }
    search(_a) {
        var { filters: { simpleSearch } } = _a, pagination = __rest(_a, ["filters"]);
        this.groupBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters$2(simpleSearch, pagination),
        });
    }
    closeNoteDialog() {
        this.showNoteDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'message',
                    header: translate.MESSAGE,
                },
                {
                    field: 'flagForFollowUp',
                    header: translate.FLAG_FOR_FOLLOW_UP,
                    formatter: (flag) => `${flag.flagForFollowUp ? 'Yes' : 'No'}`,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            add: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            delete: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
NotesComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: GroupBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('notes')
], NotesComponent.prototype, "notesSetter", null);
NotesComponent = __decorate([
    Component({
        selector: 'lib-notes',
        template: "<lib-search-container\r\n  *ngIf=\"columnsAvailable\"\r\n  name=\"groupNotes\"\r\n  i18nSearchField=\"{{ 'PARTNERS.NOTE_SEARCH' | transloco }}\"\r\n  [buttons]=\"toolbarButtons\"\r\n  [columns]=\"columns\"\r\n  [columnsToDisplay]=\"columnsToDisplay\"\r\n  [loading]=\"fetching$ | async\"\r\n  [paging]=\"paging\"\r\n  [results]=\"data$\"\r\n  [disableAdvancedSearch]=\"true\"\r\n  [searchProperty]=\"'simpleSearch'\"\r\n  (clear)=\"clear()\"\r\n  (query)=\"search($event)\"\r\n  (toolbar)=\"onToolbarClick($event)\"\r\n></lib-search-container>\r\n\r\n<p-dialog\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [(visible)]=\"showNoteDialog\"\r\n  [showHeader]=\"false\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    <ng-container *ngIf=\"editNote; else Add\">\r\n      {{ 'SUPPLIER.EDIT_NOTES' | transloco }}\r\n    </ng-container>\r\n    <ng-template #Add>\r\n      {{ 'SUPPLIER.ADD_NOTES' | transloco }}\r\n    </ng-template>\r\n  </h2>\r\n  <lib-note-form\r\n    [note]=\"editNote\"\r\n    (closeNoteDialog)=\"closeNoteDialog()\"\r\n  ></lib-note-form>\r\n</p-dialog>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], NotesComponent);

let ViewGroupsComponent = class ViewGroupsComponent {
    constructor(accountService, store, mpSetupService) {
        this.accountService = accountService;
        this.store = store;
        this.mpSetupService = mpSetupService;
        this.refreshMarketplace = new EventEmitter();
        this.imageSrc = '';
        this.marketplaceKey = '';
        this.accountKey = '';
        this.marketplaceLogoPresent = false;
        this.subscriptions = [];
        this.authorized = false;
    }
    set myMarketplaceSetter(myMarketplace) {
        this.myMarketplace = myMarketplace;
        this.displayLogo();
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getPermissions()), tap((authorizedActions) => {
            this.authorized = authorizedActions.edit || authorizedActions.view;
        }))
            .subscribe());
        this.store
            .pipe(select(selectors.marketplaces), tap((marketplaces) => {
            this.marketplaceKey = marketplaces.marketplace;
        }))
            .subscribe();
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            var _a;
            if (user) {
                this.accountKey = (_a = user.userInfo.AccountKey) === null || _a === void 0 ? void 0 : _a.toString();
            }
        }))
            .subscribe();
    }
    displayLogo() {
        try {
            this.accountAssetKey = Number(this.myMarketplace.details.logo_AccountAssetKey);
            this.imageSrc =
                this.accountAssetKey > 0
                    ? this.accountService.getImageUrl(this.accountAssetKey, this.myMarketplace.details.accountKey)
                    : '';
            this.marketplaceLogoPresent = this.accountAssetKey > 0 ? true : false;
        }
        catch (error) {
            /*empty */
        }
    }
    billingInfoSubmit() {
        this.refreshMarketplace.emit();
    }
    getPermissions() {
        return {
            view: toolKeys.MPP_GROUP,
            edit: toolKeys.MPP_GROUP_MAINTENANCE,
        };
    }
    tabChange(event) {
        this.mpSetupService.activeIndex = event;
    }
};
ViewGroupsComponent.ctorParameters = () => [
    { type: AccountService },
    { type: Store },
    { type: MarketplaceSetupService }
];
__decorate([
    Input('myMarketplace')
], ViewGroupsComponent.prototype, "myMarketplaceSetter", null);
__decorate([
    Input()
], ViewGroupsComponent.prototype, "fetching", void 0);
__decorate([
    Output()
], ViewGroupsComponent.prototype, "refreshMarketplace", void 0);
ViewGroupsComponent = __decorate([
    Component({
        selector: 'lib-view-groups',
        template: "<div *ngIf=\"authorized\" class=\"details-container\">\r\n  <div>\r\n    <lib-my-marketplace-header\r\n      [imageTemplate]=\"header_image\"\r\n      [titleTemplate]=\"header_title\"\r\n      [contentTemplate]=\"header_content\"\r\n    >\r\n      <ng-template #header_title>\r\n        <h2 class=\"header-card-title\">\r\n          {{ 'GROUP.MY_MARKETPLACE' | transloco }}\r\n        </h2>\r\n      </ng-template>\r\n      <ng-template #header_image>\r\n        <ng-container *ngIf=\"marketplaceLogoPresent; else logoMissing\">\r\n          <div class=\"img-container header\">\r\n            <img class=\"target\" [src]=\"imageSrc\" />\r\n          </div>\r\n        </ng-container>\r\n        <ng-template #logoMissing>\r\n          <div class=\"img-container header no-img\">\r\n            <span>\r\n              {{ 'COMPANY.LOGO_DEFAULT_MSG_1' | transloco }}<br />{{\r\n                'COMPANY.LOGO_DEFAULT_MSG_2' | transloco\r\n              }}\r\n            </span>\r\n          </div>\r\n        </ng-template>\r\n      </ng-template>\r\n      <ng-template #header_content>\r\n        <div class=\"vertical-flow\">\r\n          <h4 class=\"content-title\">\r\n            <ng-container\r\n              *ngIf=\"\r\n                myMarketplace?.details?.dbaName?.length > 0;\r\n                else legalName\r\n              \"\r\n            >\r\n              {{ myMarketplace?.details?.legalName }} ({{\r\n                myMarketplace?.details?.dbaName\r\n              }})\r\n            </ng-container>\r\n            <ng-template #legalName>\r\n              {{ myMarketplace?.details?.legalName }}\r\n            </ng-template>\r\n          </h4>\r\n          <!-- <p>\r\n            {{ 'SUPPLIER.LBMXID' | transloco }} :\r\n            {{ myMarketplace?.details?.lbmxId }}\r\n          </p> -->\r\n        </div>\r\n      </ng-template>\r\n    </lib-my-marketplace-header>\r\n  </div>\r\n  <div>\r\n    <p-tabView\r\n      (activeIndexChange)=\"tabChange($event)\"\r\n      [activeIndex]=\"mpSetupService.activeIndex\"\r\n      *ngIf=\"myMarketplace?.details\"\r\n    >\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n        <lib-details [details]=\"myMarketplace?.details\"></lib-details>\r\n      </p-tabPanel>\r\n      <p-tabPanel\r\n        header=\"{{ 'MEMBER.BILLING_TYPE' | transloco }}\"\r\n        *ngIf=\"accountKey === marketplaceKey\"\r\n      >\r\n        <lib-billing-type\r\n          [billingInfo]=\"myMarketplace?.details\"\r\n          (editBillingInfoSubmit)=\"billingInfoSubmit()\"\r\n        ></lib-billing-type>\r\n      </p-tabPanel>\r\n      <p-tabPanel\r\n        header=\"{{ 'MEMBER.MARKETPLACE_SETUP' | transloco }}\"\r\n        *ngIf=\"\r\n          accountKey === marketplaceKey &&\r\n          myMarketplace?.details?.billingTypeKey !== 2\r\n        \"\r\n      >\r\n        <lib-marketplace-setup\r\n          [details]=\"myMarketplace?.details\"\r\n          (submitMarketplaceEdit)=\"billingInfoSubmit()\"\r\n        ></lib-marketplace-setup>\r\n      </p-tabPanel>\r\n      <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n        <lib-contacts [contacts]=\"myMarketplace?.contacts\"></lib-contacts>\r\n      </p-tabPanel>\r\n    </p-tabView>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], ViewGroupsComponent);

let GroupModule = class GroupModule {
};
GroupModule = __decorate([
    NgModule({
        declarations: [
            AdvancedSearchComponent,
            DetailsComponent$2,
            GroupComponent,
            FormsComponent,
            MyMarketplaceHeaderComponent,
            ViewMarketplaceContainerComponent,
            ViewGroupsComponent,
            HeaderComponent,
            ContactsComponent$2,
            LocationsComponent$1,
            ViewLocationComponent,
            BankingComponent,
            ViewBankingComponent$1,
            NotesComponent,
            FormsContainerComponent,
            NoteFormComponent,
            ContactFormComponent$2,
            ContactFormContainerComponent$2,
            EdiFormContainerComponent,
            EdiFormComponent,
            EdiComponent,
            BillingTypeComponent,
            MarketplaceSetupComponent,
            MarketplaceSetupEditComponent,
        ],
        imports: [
            CommonModule,
            AccordionModule,
            ButtonModule,
            CheckboxModule,
            ConfirmDialogModule,
            DropdownModule,
            MultiSelectModule,
            ReactiveFormsModule,
            RouterModule,
            SearchContainerModule$1,
            TabViewModule,
            ToolbarModule,
            TranslocoModule,
            TreeTableModule,
            UtilsModule,
            DialogModule,
            ListboxModule,
            InputMaskModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            FormsModule,
            ProgressSpinnerModule$2,
            PhoneFormModule,
        ],
        providers: [ConfirmationService$1],
    })
], GroupModule);

const groups = [
    {
        lbmxId: 5508,
        groupKey: 710,
        groupName: 'Skipstorm',
        country: 'CAN',
        address: '1636 Sunbrook Place',
        city: 'Canmore',
        province: 'AB',
        postalCode: 'T1W',
        phoneNumber: '631-173-1697',
        faxNumber: '816-547-0639',
        groupWebsite: 'http://oxzlx.com',
        contactFirstName: 'Goldina',
        contactLastName: 'Tosh',
        contactTitle: 'Ms',
        contactPhoneNumber: '546-331-7449',
        contactEmailAddress: 'gtosh0@sfgate.com',
    },
];
const category = [
    { label: 'Test', value: 'Test' },
    { label: 'Non-Test', value: 'Non-Test' },
];
const region = [
    { label: 'North', value: 'North' },
    { label: 'South', value: 'South' },
];

const members = [
    {
        lbmxId: 5508,
        memberKey: 710,
        memberName: 'Some Member Name',
        country: 'CAN',
        address: '1636 Sunbrook Place',
        city: 'Canmore',
        province: 'AB',
        postalCode: 'T1W',
        phoneNumber: '631-173-1697',
        faxNumber: '816-547-0639',
        memberWebsite: 'http://oxzlx.com',
        contactFirstName: 'Goldina',
        contactLastName: 'Tosh',
        contactTitle: 'Ms',
        contactPhoneNumber: '546-331-7449',
        contactEmailAddress: 'gtosh0@sfgate.com',
    },
];
const category$1 = [
    { label: 'Test', value: 'Test' },
    { label: 'Non-Test', value: 'Non-Test' },
];
const region$1 = [
    { label: 'North', value: 'North' },
    { label: 'South', value: 'South' },
];
const memberCategory = [
    { category: 'fake category 1', value: 'fake category 1' },
    { category: 'fake category 2', value: 'fake category 2' },
    { category: 'fake category 3', value: 'fake category 3' },
    { category: 'fake category 4', value: 'fake category 4' },
];
const countryProvinceList = [
    {
        label: 'Canada',
        data: 'Canada',
        children: [
            {
                label: 'Ontario',
                data: 'Ontario',
            },
            {
                label: 'Alberta',
                data: 'Alberta',
            },
            {
                label: 'Manitoba',
                data: 'Manitoba',
            },
            {
                label: 'Quebec',
                data: 'Quebec',
            },
        ],
    },
    {
        label: 'Australia',
        data: 'Australia',
        children: [
            { label: 'New South Wales', data: 'New South Wales' },
            { label: 'Victoria', data: 'Victoria' },
            { label: 'Perth', data: 'Perth' },
        ],
    },
];
const memberRegions = [
    {
        data: 'East',
        value: 'East',
    },
    {
        data: 'North',
        value: 'North',
    },
    {
        data: 'Upper Coast',
        value: 'Upper Coast',
    },
    {
        data: 'North East',
        value: 'North East',
    },
];

const suppliers = [
    {
        accountKey: 375,
        accountKey_Owner: 1,
        accountRelationshipKey: 1004,
        relationshipTypeKey: 1,
        relationshipType: 'Supplier',
        lbmxId: 5508,
        legalName: 'Skipstorm',
        dbaName: 'Skipstorm',
        supplierName: 'Skipstorm',
        logo: 'assets/images/default_image.jpg',
        isaNumber: 1,
        country: 'CAN',
        address1: '1636 Sunbrook Place',
        address2: '2747 Sunbrook2 Place',
        city: 'Canmore',
        province: 'AB',
        postalCode: 'T1W',
        supplierWebsite: 'http://oxzlx.com',
        currency: 'CAD',
        number: 710,
        category: 'Test',
        region: 'North',
    },
];
const supplierCategory = [
    { category: 'fake category 1', value: 'fake category 1' },
    { category: 'fake category 2', value: 'fake category 2' },
    { category: 'fake category 3', value: 'fake category 3' },
    { category: 'fake category 4', value: 'fake category 4' },
];
const category$2 = [
    { label: 'Test', value: 'Test' },
    { label: 'Non-Test', value: 'Non-Test' },
];
const region$2 = [
    { label: 'North', value: 'North' },
    { label: 'South', value: 'South' },
];

let SearchContainerService = class SearchContainerService {
    constructor() {
        this.defaultState = {
            first: 0,
            rows: 25,
            selection: [],
        };
        this.databases = {
            groups,
            members,
            suppliers,
        };
    }
    search(endpoint, name) {
        const term = new RegExp(name, 'i');
        return this.databases[endpoint].filter((supplier) => term.test(supplier.supplierName));
    }
    getSelection(stateKey) {
        const storage = this.getStateFromLocalStorage(stateKey);
        return storage.selection || [];
    }
    getStateFromLocalStorage(stateKey) {
        return JSON.parse(localStorage.getItem(stateKey));
    }
    initLocalGridState(stateKey, overrides = {}) {
        const state = Object.assign(Object.assign(Object.assign({}, this.defaultState), overrides), this.getStateFromLocalStorage(stateKey));
        localStorage.setItem(stateKey, JSON.stringify(state));
    }
    setLocalGridState(stateKey, overrides = {}) {
        const state = Object.assign(Object.assign({}, this.defaultState), overrides);
        localStorage.setItem(stateKey, JSON.stringify(state));
    }
    mergeWithLocalGridState(stateKey, overrides = {}) {
        const state = Object.assign(Object.assign({}, this.getStateFromLocalStorage(stateKey)), overrides);
        localStorage.setItem(stateKey, JSON.stringify(state));
    }
};
SearchContainerService.ɵprov = ɵɵdefineInjectable({ factory: function SearchContainerService_Factory() { return new SearchContainerService(); }, token: SearchContainerService, providedIn: "root" });
SearchContainerService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], SearchContainerService);

let SearchDirective = class SearchDirective {
    constructor() {
        this.searchEvent = new EventEmitter();
    }
    search($event) {
        this.searchEvent.emit($event);
    }
};
__decorate([
    Output()
], SearchDirective.prototype, "searchEvent", void 0);
__decorate([
    HostListener('setFilterEvent', ['$event'])
], SearchDirective.prototype, "search", null);
SearchDirective = __decorate([
    Directive({
        selector: '[libSearch]',
    })
], SearchDirective);

let SearchContainerComponent = class SearchContainerComponent {
    constructor(confirmationService, formBuilder, router, searchContainer) {
        this.confirmationService = confirmationService;
        this.formBuilder = formBuilder;
        this.router = router;
        this.searchContainer = searchContainer;
        this.clear = new EventEmitter();
        this.query = new EventEmitter();
        this.toolbar = new EventEmitter();
        this.copyDisabled = true;
        this.deleteDisabled = true;
        this.editDisabled = true;
        this.showAdvancedSearch = false;
        this.editURL = '';
        this.subscriptions = [];
    }
    ngOnInit() {
        // Initialize the grid state
        this.gridStateKey = this.routerGridStateKey();
        this.searchContainer.initLocalGridState(this.gridStateKey, {
            columnOrder: this.columns.map((c) => c.field),
        });
        // Column Configuration
        this.columnsToDisplay = this.searchContainer.getStateFromLocalStorage(this.gridStateKey).columnOrder;
        this.selectedColumns = this.columns.filter((c) => this.columnsToDisplay.includes(c.field));
        // Forms
        this.selectedColumnsForm = this.formBuilder.group({
            selected: [this.selectedColumns],
        });
        this.subscriptions.push(this.selectedColumnsForm.valueChanges.subscribe(({ selected }) => {
            this.selectedColumns = selected;
        }));
        this.searchForm = this.formBuilder.group({
            [this.searchProperty]: '',
        });
        this.searchFilter = {};
        this.items = this.getMenuItems();
        this.showGrid = true;
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    ngAfterContentInit() {
        this.subscriptions.push(this.advSearch.searchEvent.subscribe(($event) => {
            this.handleSetSearchFilters($event);
        }));
    }
    confirmDelete() {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => this.onToolbarClick('delete'),
            reject: () => { },
        });
    }
    onClearClick() {
        const _a = this.searchFilter, _b = this.searchProperty, _ = _a[_b], filters = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        this.searchForm.reset({ [this.searchProperty]: '' });
        this.handleSetSearchFilters({ filters, options: { clearResults: true } });
    }
    onDeleteClick() {
        this.confirmDelete();
    }
    onResetClick() {
        this.searchContainer.setLocalGridState(this.gridStateKey, {
            columnOrder: this.columns.map((c) => c.field),
            columnWidths: [48, ...Array(this.columns.length).fill(250)].toString(),
        });
        this.selectedColumns = [...this.columns];
        this.selectedColumnsForm.reset({ selected: this.selectedColumns });
        this.clearResults();
    }
    onSearchClick() {
        const { [this.searchProperty]: searchText } = this.searchForm.value;
        const searchTerm = searchText === '' ? {} : { [this.searchProperty]: searchText };
        const filters = Object.assign(Object.assign({}, this.searchFilter), searchTerm);
        this.handleSetSearchFilters({ filters, options: { search: true } });
    }
    onToolbarClick(command) {
        let selection = [];
        switch (command) {
            case 'new':
                break;
            default:
                selection = this.searchContainer.getSelection(this.gridStateKey);
                break;
        }
        this.toolbar.emit({
            command,
            selection,
        });
    }
    handleSearch() {
        this.query.emit(this.searchFilter);
    }
    handleSelection({ data: rows }) {
        if (rows.length === 1) {
            this.editURL = `${rows[0][this.idColumn]}/edit`;
        }
        this.copyDisabled = this.editDisabled = rows.length !== 1;
        this.deleteDisabled = rows.length === 0;
        this.items = this.getMenuItems();
    }
    handleSetSearchFilters({ filters = {}, options = { clearResults: false, search: false }, }) {
        this.searchFilter = Object.assign({}, filters);
        if (options.clearResults) {
            this.clearResults();
        }
        if (options.search) {
            this.handleSearch();
        }
    }
    toggleAdvancedSearch() {
        this.showAdvancedSearch = !this.showAdvancedSearch;
    }
    // Private functions
    clearResults() {
        this.searchContainer.mergeWithLocalGridState(this.gridStateKey, {
            selection: [],
        });
        this.copyDisabled = true;
        this.deleteDisabled = true;
        this.editDisabled = true;
        this.items = this.getMenuItems();
        this.clear.emit();
        this.reRenderGrid();
    }
    getMenuItems() {
        return [
            { label: 'New', command: () => this.onToolbarClick('new') },
            {
                label: 'Copy',
                command: () => this.onToolbarClick('copy'),
                disabled: this.copyDisabled,
            },
            {
                label: 'Edit',
                command: () => this.onToolbarClick('edit'),
                disabled: this.editDisabled,
            },
            {
                label: 'Delete',
                disabled: this.deleteDisabled,
                command: () => this.onToolbarClick('delete'),
            },
            { label: 'Import' },
            { label: 'Export', command: () => this.onToolbarClick('export') },
            { label: 'LBMX ID' },
        ];
    }
    reRenderGrid() {
        this.showGrid = false;
        setTimeout(() => {
            this.showGrid = true;
        });
    }
    routerGridStateKey() {
        return `${this.router.url.replace(/[/]/g, '_')}_${this.name}`;
    }
};
SearchContainerComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: FormBuilder },
    { type: Router },
    { type: SearchContainerService }
];
__decorate([
    Input()
], SearchContainerComponent.prototype, "columns", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "endPoint", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "i18nSearchField", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "idColumn", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "name", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "results", void 0);
__decorate([
    Input()
], SearchContainerComponent.prototype, "searchProperty", void 0);
__decorate([
    Output()
], SearchContainerComponent.prototype, "clear", void 0);
__decorate([
    Output()
], SearchContainerComponent.prototype, "query", void 0);
__decorate([
    Output()
], SearchContainerComponent.prototype, "toolbar", void 0);
__decorate([
    ContentChild(SearchDirective)
], SearchContainerComponent.prototype, "advSearch", void 0);
SearchContainerComponent = __decorate([
    Component({
        selector: 'lib-search-container',
        template: "<!-- Search Label placeholder -->\r\n<div class=\"row searchLabelContainer\">\r\n  <div class=\"col-sm-12 hidden-xs searchHeader\">\r\n    {{ i18nSearchField }}\r\n  </div>\r\n  <div class=\"col-xs-12 visible-xs\">\r\n    {{ i18nSearchField }}\r\n  </div>\r\n</div>\r\n<!-- End of  Search Label placeholder -->\r\n<!-- Simple Search Form placeholder -->\r\n<div class=\"row\">\r\n  <form [formGroup]=\"searchForm\">\r\n    <div class=\"col-sm-6 col-xs-12 simpleSearchContainer\">\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        formControlName=\"{{ searchProperty }}\"\r\n        placeholder=\"{{ 'SEARCH_CONTAINER.SEARCH' | transloco }}\"\r\n        class=\"width-100 ui-inputtext simpleSearchInput\"\r\n      />\r\n    </div>\r\n\r\n    <div class=\"col-sm-6 col-xs-12 clearBtnContainerMobile\">\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        (click)=\"onClearClick()\"\r\n        label=\"{{ 'SEARCH_CONTAINER.CLEAR' | transloco }}\"\r\n        class=\"primaryDefaultLargeBtn ui-button simpleSearchClearButton\"\r\n      ></button>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'SEARCH_CONTAINER.SEARCH' | transloco }}\"\r\n        (click)=\"onSearchClick()\"\r\n        class=\"primaryBlackLargeBtn ui-button simpleSearchButton\"\r\n      ></button>\r\n    </div>\r\n  </form>\r\n</div>\r\n<!-- End of Simple Search Form placeholder -->\r\n\r\n<!-- Filter/Reset/Column Selector Dropdown placeholder -->\r\n<div class=\"row gridControlsContainer\">\r\n  <!-- Filter/Reset/Column Selector Dropdown Mobile view placeholder -->\r\n  <div class=\"row visible-xs gridControlsContainerMob\">\r\n    <div class=\"col-xs-3 gridResetBtnMobile\">\r\n      <button\r\n        pButton\r\n        class=\"smallIconBtn ui-button gridResetButton\"\r\n        type=\"button\"\r\n        label=\"{{ 'SEARCH_CONTAINER.RESET' | transloco }}\"\r\n        (click)=\"onResetClick()\"\r\n      ></button>\r\n    </div>\r\n    <div\r\n      [formGroup]=\"selectedColumnsForm\"\r\n      class=\"col-xs-9 gridMultiselectMobile\"\r\n    >\r\n      <p-multiSelect\r\n        [options]=\"columns\"\r\n        formControlName=\"selected\"\r\n        optionLabel=\"header\"\r\n        selectedItemsLabel=\"{0} {{\r\n          'SEARCH_CONTAINER.SELECTED_COLUMNS' | transloco\r\n        }}\"\r\n        styleClass=\"gridControlMultiSelect \"\r\n        defaultLabel=\"{{ 'SEARCH_CONTAINER.CHOOSE_COLUMNS' | transloco }}\"\r\n      >\r\n      </p-multiSelect>\r\n    </div>\r\n  </div>\r\n  <!-- End of Filter/Reset/Column Selector Dropdown Mobile view placeholder -->\r\n  <!-- Filter/Reset/Column Selector Dropdown Tablet & Desktop placeholder -->\r\n  <div class=\"col-sm-3 filterContainer no-padding-left\">\r\n    <div\r\n      class=\"width-100 advancedSearchContainer\"\r\n      [ngClass]=\"{\r\n        'lightGreyBackgroundColor ': showAdvancedSearch,\r\n        whiteBackgroundColor: !showAdvancedSearch\r\n      }\"\r\n      (click)=\"toggleAdvancedSearch()\"\r\n    >\r\n      <div class=\"filterTitleContainer\">\r\n        <i class=\"pi pi-sliders-h\"></i>\r\n        {{ 'SEARCH_CONTAINER.FILTER' | transloco }}\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div\r\n    class=\"col-sm-6 col-sm-offset-3 gridControls no-padding-right right hidden-xs\"\r\n  >\r\n    <!-- <div class=\"row hidden-xs\"> -->\r\n    <div>\r\n      <button\r\n        pButton\r\n        class=\"smallIconBtn ui-button gridResetButton\"\r\n        type=\"button\"\r\n        label=\"{{ 'SEARCH_CONTAINER.RESET' | transloco }}\"\r\n        (click)=\"onResetClick()\"\r\n      ></button>\r\n    </div>\r\n    <div\r\n      [formGroup]=\"selectedColumnsForm\"\r\n      class=\"gridControlsMultiselectContainer\"\r\n    >\r\n      <p-multiSelect\r\n        [options]=\"columns\"\r\n        formControlName=\"selected\"\r\n        optionLabel=\"header\"\r\n        selectedItemsLabel=\"{0} {{\r\n          'SEARCH_CONTAINER.SELECTED_COLUMNS' | transloco\r\n        }}\"\r\n        styleClass=\"gridControlMultiSelect\"\r\n        defaultLabel=\"{{ 'SEARCH_CONTAINER.CHOOSE_COLUMNS' | transloco }}\"\r\n      >\r\n      </p-multiSelect>\r\n    </div>\r\n    <!-- </div> -->\r\n  </div>\r\n  <!-- End of Filter/Reset/Column Selector Dropdown Tablet & Desktop placeholder -->\r\n</div>\r\n<!-- End of Filter/Reset/Column Selector Dropdown placeholder -->\r\n<!-- Advanced Search/Search Toolbar/GRID container-->\r\n<div class=\"row\">\r\n  <div\r\n    [ngClass]=\"{ 'col-sm-3': showAdvancedSearch }\"\r\n    class=\"advancedFilterContainer\"\r\n    style=\"padding-left: 0px;\"\r\n    *ngIf=\"showAdvancedSearch\"\r\n  >\r\n    <ng-content select=\"lib-advanced-search\"></ng-content>\r\n  </div>\r\n  <div\r\n    [ngClass]=\"{\r\n      'col-sm-9 ': showAdvancedSearch,\r\n      'col-sm-12 col-xs-12': !showAdvancedSearch\r\n    }\"\r\n  >\r\n    <!-- Search Toobar placeholder -->\r\n    <div class=\"row lightGreyBackgroundColor searchToolBarContainer\">\r\n      <div class=\"row searchToolBar\">\r\n        <div class=\"col-sm-3 col-xs-3\">\r\n          <span class=\"toolbarHeader\">\r\n            {{ 'SEARCH_CONTAINER.RESULTS' | transloco }}\r\n          </span>\r\n        </div>\r\n        <div class=\"col-sm-9 col-xs-9 visible-xs toolbarMoreMenuContainer\">\r\n          <p-menu\r\n            #menuToolbar\r\n            [popup]=\"true\"\r\n            [model]=\"items\"\r\n            appendTo=\"body\"\r\n          ></p-menu>\r\n          <i\r\n            (click)=\"menuToolbar.toggle($event)\"\r\n            class=\"pi pi-ellipsis-v toolbarMoreMenu\"\r\n          >\r\n          </i>\r\n        </div>\r\n      </div>\r\n      <!--Tablet/Desktop : Toolbar placeholder-->\r\n      <div class=\"col-sm-12 searchToolbarButtonContainer hidden-xs\">\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.NEW' | transloco }}\"\r\n          (click)=\"onToolbarClick('new')\"\r\n        ></button>\r\n\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.COPY' | transloco }}\"\r\n          [disabled]=\"copyDisabled\"\r\n          (click)=\"onToolbarClick('copy')\"\r\n        ></button>\r\n\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.EDIT' | transloco }}\"\r\n          [disabled]=\"editDisabled\"\r\n          (click)=\"onToolbarClick('edit')\"\r\n        ></button>\r\n\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.DELETE' | transloco }}\"\r\n          [disabled]=\"deleteDisabled\"\r\n          (click)=\"onToolbarClick('delete')\"\r\n        ></button>\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.IMPORT' | transloco }}\"\r\n        ></button>\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"{{ 'SEARCH_CONTAINER.EXPORT' | transloco }}\"\r\n          (click)=\"onToolbarClick('export')\"\r\n        ></button>\r\n        <button\r\n          pButton\r\n          class=\"smallIconBtn ui-button searchToolbarButton\"\r\n          type=\"button\"\r\n          label=\"LBMX ID\"\r\n        ></button>\r\n      </div>\r\n      <!--End of Tablet/Desktop : Toolbar placeholder-->\r\n    </div>\r\n    <!-- End of Search Toolbar placeholder -->\r\n    <div class=\"row\">\r\n      <lib-phoenix-grid\r\n        *ngIf=\"showGrid\"\r\n        [data$]=\"results\"\r\n        [columns]=\"selectedColumns\"\r\n        [stateKey]=\"gridStateKey\"\r\n        [rowsPerPageArray]=\"[25, 50, 100]\"\r\n        [allowResizingOfColumns]=\"true\"\r\n        [allowSingleColumnSorting]=\"true\"\r\n        [allowPaginator]=\"true\"\r\n        [allowScroll]=\"true\"\r\n        [allowSelection]=\"true\"\r\n        (selectAllCheckBoxEvent)=\"handleSelection($event)\"\r\n        (singleCheckBoxSelectEvent)=\"handleSelection($event)\"\r\n      ></lib-phoenix-grid>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- End of Advanced Search/Search Toolbar/GRID container-->\r\n",
        styles: [""]
    })
], SearchContainerComponent);

let SearchContainerModule = class SearchContainerModule {
};
SearchContainerModule = __decorate([
    NgModule({
        declarations: [SearchContainerComponent, SearchDirective],
        imports: [
            CommonModule,
            ConfirmDialogModule,
            MenuModule,
            MultiSelectModule,
            ReactiveFormsModule,
            RouterModule,
            TranslocoModule,
            UtilsModule,
        ],
        exports: [SearchContainerComponent, SearchDirective],
        providers: [ConfirmationService$1],
    })
], SearchContainerModule);

let AdvancedSearchComponent$1 = class AdvancedSearchComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.setFilterEvent = new EventEmitter();
        this.defaultValues = {
            locationGroup: '',
            headOffice: '',
            activeStatus: true,
            inactiveStatus: false,
            prodMode: true,
            testMode: false,
        };
    }
    ngOnInit() {
        this.locationAdvancedSearchForm = this.formBuilder.group(Object.entries(this.defaultValues).reduce((prev, [key, value]) => (Object.assign(Object.assign({}, prev), { [key]: [value] })), {}));
        this.setFilterEvent.emit({ filters: this.filterEmptyFields() });
    }
    handleAdvancedSearch() {
        this.setFilterEvent.emit({
            filters: this.filterEmptyFields(),
            options: { search: true },
        });
    }
    handleClear() {
        this.locationAdvancedSearchForm.reset(this.defaultValues);
        this.setFilterEvent.emit({
            filters: {},
            options: { clearResults: true },
        });
    }
    filterEmptyFields() {
        return Object.entries(this.locationAdvancedSearchForm.value).reduce((prev, [field, value]) => {
            if (value !== '') {
                return Object.assign(Object.assign({}, prev), { [field]: value });
            }
            else {
                return prev;
            }
        }, {});
    }
};
AdvancedSearchComponent$1.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Output()
], AdvancedSearchComponent$1.prototype, "setFilterEvent", void 0);
AdvancedSearchComponent$1 = __decorate([
    Component({
        selector: 'lib-advanced-search',
        template: "<div class=\"width-100 advancedSearchOuterContainer\">\r\n  <p-accordion styleClass=\"advancedSearchTabHeader\">\r\n    <form [formGroup]=\"locationAdvancedSearchForm\">\r\n      <p-accordionTab header=\"{{ 'LOCATION.ACTIVE_INACTIVE' | transloco }}\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <p-checkbox\r\n              label=\"{{ 'LOCATION.ACTIVE' | transloco }}\"\r\n              binary=\"true\"\r\n              formControlName=\"activeStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'LOCATION.INACTIVE' | transloco }}\"\r\n              formControlName=\"inactiveStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </div>\r\n      </p-accordionTab>\r\n      <p-accordionTab header=\"{{ 'LOCATION.LOCATION_GROUP' | transloco }}\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"width-100 ui-inputtext\"\r\n              placeholder=\"{{ 'LOCATION.LOCATION_GROUP' | transloco }}\"\r\n              formControlName=\"locationGroup\"\r\n            />\r\n          </div>\r\n        </div>\r\n      </p-accordionTab>\r\n      <p-accordionTab header=\"{{ 'LOCATION.HEAD_OFFICE' | transloco }}\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <input\r\n              pInputText\r\n              type=\"text\"\r\n              class=\"width-100 ui-inputtext\"\r\n              placeholder=\"{{ 'LOCATION.HEAD_OFFICE' | transloco }}\"\r\n              formControlName=\"headOffice\"\r\n            />\r\n          </div>\r\n        </div>\r\n      </p-accordionTab>\r\n      <p-accordionTab header=\"{{ 'LOCATION.MODE' | transloco }}\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'LOCATION.PRODUCTION' | transloco }}\"\r\n              formControlName=\"prodMode\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'LOCATION.TEST' | transloco }}\"\r\n              formControlName=\"testMode\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </div>\r\n      </p-accordionTab>\r\n      &nbsp;\r\n      <div class=\"width-100\">\r\n        <button\r\n          pButton\r\n          class=\"primaryDefaultLargeBtn width-100\"\r\n          type=\"button\"\r\n          label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n          (click)=\"handleAdvancedSearch()\"\r\n        ></button>\r\n      </div>\r\n      &nbsp;\r\n      <div class=\"width-100\">\r\n        <button\r\n          pButton\r\n          class=\"primaryDefaultLargeBtn width-100\"\r\n          type=\"button\"\r\n          label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n          (click)=\"handleClear()\"\r\n        ></button>\r\n      </div>\r\n    </form>\r\n  </p-accordion>\r\n</div>\r\n",
        styles: [""]
    })
], AdvancedSearchComponent$1);

let InformationFormComponent = class InformationFormComponent {
    constructor(formBuilder, store) {
        this.formBuilder = formBuilder;
        this.store = store;
        this.informationSaved = new EventEmitter();
        this.subscriptions = [];
    }
    ngOnInit() {
        this.countries$ = this.store.pipe(select(selectors.countriesDropdown));
        this.provinces$ = this.store.pipe(select(selectors.provincesDropdown, {
            countryCode: this.location.country,
        }));
        this.locationForm = this.formBuilder.group({
            lbmxId: [this.location.lbmxId, Validators.required],
            locationKey: [this.location.locationKey, Validators.required],
            locationName: [this.location.locationName, Validators.required],
            country: [this.location.country, Validators.required],
            address: [this.location.address, Validators.required],
            city: [this.location.city, Validators.required],
            province: [this.location.province, Validators.required],
            postalCode: [this.location.postalCode, Validators.required],
            phoneNumber: [this.location.phoneNumber, Validators.required],
            faxNumber: [this.location.faxNumber, Validators.required],
            locationWebsite: [this.location.locationWebsite, Validators.required],
            contactFirstName: [this.location.contactFirstName, Validators.required],
            contactLastName: [this.location.contactLastName, Validators.required],
            contactTitle: [this.location.contactTitle, Validators.required],
            contactPhoneNumber: [
                this.location.contactPhoneNumber,
                Validators.required,
            ],
            contactEmailAddress: [
                this.location.contactEmailAddress,
                Validators.required,
            ],
            notes: [this.location.notes],
        });
        this.subscriptions.push(this.locationForm.valueChanges.subscribe(this.handleChanges(selectors.provincesDropdown)));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    handleSubmit() {
        this.informationSaved.emit(this.locationForm.value);
    }
    handleChanges(selector) {
        return ({ country }) => {
            this.provinces$ = this.store.pipe(select(selector, { countryCode: country }));
        };
    }
};
InformationFormComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: Store }
];
__decorate([
    Input()
], InformationFormComponent.prototype, "location", void 0);
__decorate([
    Output()
], InformationFormComponent.prototype, "informationSaved", void 0);
InformationFormComponent = __decorate([
    Component({
        selector: 'lib-information-form',
        template: "<form class=\"width-100\" [formGroup]=\"locationForm\" (ngSubmit)=\"handleSubmit()\">\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <label for=\"lbmxId\">LBMX Id</label>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"lbmxId\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('lbmxId')\"\r\n      ></lib-control-message>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"locationKey\">Location Key</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"locationKey\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('locationKey')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-12\">\r\n      <div>\r\n        <label for=\"locationName\">Location Name</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"locationName\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('locationName')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-12\">\r\n      <div>\r\n        <label for=\"country\">Country</label>\r\n      </div>\r\n      <div>\r\n        <p-dropdown\r\n          [style]=\"{ width: '100%' }\"\r\n          autoWidth=\"false\"\r\n          name=\"country\"\r\n          [options]=\"countries$ | async\"\r\n          formControlName=\"country\"\r\n          filter=\"true\"\r\n        ></p-dropdown>\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('country')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"address\">Address</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"address\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('address')\"\r\n      ></lib-control-message>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"city\">City</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"city\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('city')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"province\">State | Province</label>\r\n      </div>\r\n      <div>\r\n        <p-dropdown\r\n          [style]=\"{ width: '100%' }\"\r\n          autoWidth=\"false\"\r\n          name=\"province\"\r\n          [options]=\"provinces$ | async\"\r\n          formControlName=\"province\"\r\n        ></p-dropdown>\r\n        <lib-control-message\r\n          [control]=\"locationForm.get('province')\"\r\n        ></lib-control-message>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"postalCode\">Zip | Postal Code</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"postalCode\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('postalCode')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"phoneNumber\">Phone Number</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"phoneNumber\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('phoneNumber')\"\r\n      ></lib-control-message>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"faxNumber\">Fax Number</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"faxNumber\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('faxNumber')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-12\">\r\n      <div>\r\n        <label for=\"locationWebsite\">Location Website</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"locationWebsite\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('locationWebsite')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"contactFirstName\">Contact First Name</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"contactFirstName\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('contactFirstName')\"\r\n      ></lib-control-message>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"contactLastName\">Contact Last Name</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"contactLastName\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('contactLastName')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-12\">\r\n      <div>\r\n        <label for=\"contactTitle\">Contact Title</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"contactTitle\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('contactTitle')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"contactPhoneNumber\">Contact Phone Number</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"contactPhoneNumber\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('contactPhoneNumber')\"\r\n      ></lib-control-message>\r\n    </div>\r\n    <div class=\"col-sm-6\">\r\n      <div>\r\n        <label for=\"contactEmailAddress\">Contact Email Address</label>\r\n      </div>\r\n      <div>\r\n        <input pInputText type=\"text\" formControlName=\"contactEmailAddress\" />\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('contactEmailAddress')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-12\">\r\n      <div>\r\n        <label for=\"notes\">Notes</label>\r\n      </div>\r\n      <div>\r\n        <textarea\r\n          rows=\"5\"\r\n          autoresize=\"false\"\r\n          name=\"notes\"\r\n          pInputTextarea\r\n          formControlName=\"notes\"\r\n          class=\"width-100 ui-inputtext\"\r\n        ></textarea>\r\n      </div>\r\n      <lib-control-message\r\n        [control]=\"locationForm.get('notes')\"\r\n      ></lib-control-message>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row margin-bottom-15px\">\r\n    <div class=\"col-sm-4 col-xs-6\">\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"Cancel\"\r\n        class=\"width-100 primaryLightGreyLargeBtn\"\r\n        autowidth=\"false\"\r\n      ></button>\r\n    </div>\r\n    <div class=\"col-sm-8 col-xs-6 no-padding-left\">\r\n      <button\r\n        [disabled]=\"false\"\r\n        pButton\r\n        type=\"button\"\r\n        label=\"Save\"\r\n        type=\"submit\"\r\n        class=\"width-100 primaryDefaultLargeBtn\"\r\n        autowidth=\"false\"\r\n      ></button>\r\n    </div>\r\n  </div>\r\n</form>\r\n",
        styles: ["label{letter-spacing:0;color:#2d2d2d;opacity:1;display:block;margin:0 0 .25em}.p-dropdown,input,textarea{width:100%}.feedback{min-height:1.4em}.feedback>span{color:red;font-size:.8em}"]
    })
], InformationFormComponent);

let LocationFormComponent$2 = class LocationFormComponent {
    constructor() {
        this.location = {};
        this.activateLocationForm = true;
        this.activateAttributesForm = false;
    }
    ngOnInit() { }
    handleSave($event) {
        this.activateAttributesForm = true;
        this.activateLocationForm = false;
    }
};
__decorate([
    Input()
], LocationFormComponent$2.prototype, "location", void 0);
LocationFormComponent$2 = __decorate([
    Component({
        selector: 'lib-location-form',
        template: "<p-tabView styleClass=\"tabViewHeader\">\r\n  <p-tabPanel header=\"Location Information\" [selected]=\"activateLocationForm\">\r\n    <lib-information-form\r\n      [location]=\"location\"\r\n      (informationSaved)=\"handleSave($event)\"\r\n    ></lib-information-form>\r\n  </p-tabPanel>\r\n</p-tabView>\r\n",
        styles: [""]
    })
], LocationFormComponent$2);

let LocationModule = class LocationModule {
};
LocationModule = __decorate([
    NgModule({
        declarations: [
            AdvancedSearchComponent$1,
            InformationFormComponent,
            NewLocationComponent,
            LocationComponent,
            LocationFormComponent$2,
            UpdateLocationComponent,
            ViewLocationsComponent,
        ],
        imports: [
            CommonModule,
            AccordionModule,
            ButtonModule,
            CheckboxModule,
            ConfirmDialogModule,
            DropdownModule,
            MultiSelectModule,
            ReactiveFormsModule,
            RouterModule,
            SearchContainerModule,
            TabViewModule,
            ToolbarModule,
            TranslocoModule,
            TreeTableModule,
            UtilsModule,
        ],
        providers: [ConfirmationService$1],
    })
], LocationModule);

let ApplyPaymentFormComponent = class ApplyPaymentFormComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input()
], ApplyPaymentFormComponent.prototype, "form", void 0);
__decorate([
    Output()
], ApplyPaymentFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], ApplyPaymentFormComponent.prototype, "saveDialog", void 0);
ApplyPaymentFormComponent = __decorate([
    Component({
        selector: 'lib-apply-payment-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.APPLY_PAYMENT_INFORMATION' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ApplyPaymentFormComponent);

const schemaDefinition$2 = (fields) => ({
    fields,
});

let ApplyPaymentComponent = class ApplyPaymentComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$2;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/apply-payment/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            var _a;
            if (!this.itemSelected) {
                fields = Object.assign(Object.assign({}, fields), { options: Object.assign(Object.assign({}, fields === null || fields === void 0 ? void 0 : fields.options), { options: [...(_a = fields === null || fields === void 0 ? void 0 : fields.options) === null || _a === void 0 ? void 0 : _a.options].filter((option) => {
                            return `${option === null || option === void 0 ? void 0 : option.value}` !== '3';
                        }) }) });
            }
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ApplyPaymentComponent.ctorParameters = () => [
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ApplyPaymentComponent.prototype, "itemSelected", void 0);
__decorate([
    Input()
], ApplyPaymentComponent.prototype, "baseUrl", void 0);
__decorate([
    Output()
], ApplyPaymentComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], ApplyPaymentComponent.prototype, "saveDialog", void 0);
ApplyPaymentComponent = __decorate([
    Component({
        selector: 'lib-apply-payment',
        template: ` <lib-apply-payment-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-apply-payment-form>`
    })
], ApplyPaymentComponent);

const schemaDefinition$3 = (translate) => ({
    fields: {
        accountLegalName: {
            type: 'text',
            label: translate['MEMBER_LEGAL_NAME'],
            readonly: true,
        },
        accountDbaName: {
            type: 'text',
            label: translate['MEMBER_DBA_NAME'],
            readonly: true,
        },
        legalName: {
            type: 'text',
            label: translate['LOCATION_LEGAL_NAME'],
            readonly: true,
        },
        dbaName: {
            type: 'text',
            label: translate['LOCATION_DBA_NAME'],
            readonly: true,
        },
        crossReferenceNumber: {
            type: 'text',
            label: translate['MY_LOCATION_NUMBER'],
            validations: [
                {
                    test: ({ crossReferenceNumber }) => {
                        return `${crossReferenceNumber}`.trim().length < 51;
                    },
                    message: translate['MY_LOCATION_NUMBER_VALIDATION'],
                },
            ],
        },
        accountKey_Partner: {
            display: false,
        },
        accountLocationKey: {
            display: false,
        },
    },
});
function toFormValues(data) {
    const { legalName, dbaName, crossReferenceNumber, accountDbaName, accountLegalName, accountLocationKey, accountKey_Partner, } = data;
    return {
        legalName,
        dbaName,
        crossReferenceNumber,
        accountDbaName,
        accountLegalName,
        accountLocationKey,
        accountKey_Partner,
    };
}
function fromFormValues(data) {
    const { legalName, dbaName, accountDbaName, accountLegalName } = data, rest = __rest(data, ["legalName", "dbaName", "accountDbaName", "accountLegalName"]);
    return Object.assign({}, rest);
}

let EditComponent = class EditComponent {
    constructor(formGenerator) {
        this.formGenerator = formGenerator;
        this.closeEditDialog = new EventEmitter();
        this.saveEditDialog = new EventEmitter();
        this.state = {};
    }
    set dataSetter(data) {
        if (data) {
            this.data = toFormValues(data);
        }
    }
    ngOnInit() {
        this.form = this.formGenerator.init(schemaDefinition$3(this.translate), this.data);
    }
    save() {
        this.saveEditDialog.emit(fromFormValues(this.form.values));
    }
    close() {
        this.closeEditDialog.emit();
    }
};
EditComponent.ctorParameters = () => [
    { type: GenerateFormService }
];
__decorate([
    Input('data')
], EditComponent.prototype, "dataSetter", null);
__decorate([
    Output()
], EditComponent.prototype, "closeEditDialog", void 0);
__decorate([
    Output()
], EditComponent.prototype, "saveEditDialog", void 0);
__decorate([
    Input()
], EditComponent.prototype, "translate", void 0);
EditComponent = __decorate([
    Component({
        selector: 'lib-edit',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.MEMBER_CROSS_REFERENCE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n",
        changeDetection: ChangeDetectionStrategy.OnPush
    })
], EditComponent);

const schemaDefinition$4 = (translate, options, formats) => {
    return {
        fields: {
            exportDataOption: {
                type: 'pDropdown',
                label: translate['WHICH_DATA_TO_EXPORT'],
                options: [{ label: translate['SELECT'], value: '' }, ...options],
                required: true,
            },
            fileFormatType: {
                type: 'pDropdown',
                label: translate['FORMAT'],
                options: [{ label: translate['SELECT'], value: '' }, ...formats],
                required: true,
            },
            fileName: {
                type: 'text',
                label: translate['NAME_YOUR_DATA_FILE'],
                required: true,
            },
        },
    };
};
function toFormValues$1(data) { }
function fromFormValues$1(data, originalData) { }

let ExportContainerComponent = class ExportContainerComponent {
    constructor(configService, spinner, formGenerator) {
        this.configService = configService;
        this.spinner = spinner;
        this.formGenerator = formGenerator;
        this.closeExportDialog = new EventEmitter();
        this.saveExportDialog = new EventEmitter();
        this.options = [];
        this.formats = [];
        this.state = {};
        this.subscriptions = [];
        this.schemaDefinition = schemaDefinition$4;
    }
    ngOnInit() {
        this.subscriptions.push(forkJoin([
            this.configService.getExportFormatTypes(),
            this.configService.getExportDataTypes(),
        ])
            .pipe(tap(([formats, options]) => {
            this.options = options.map((exportOption) => {
                return {
                    label: exportOption.description.trim(),
                    value: exportOption.exportDataTypeKey,
                };
            });
            if (!this.itemSelected) {
                this.options = this.options.filter(option => {
                    return option.value !== 3;
                });
            }
            this.formats = formats.map((exportFormat) => {
                return {
                    label: exportFormat.description.trim(),
                    value: exportFormat.exportFormatTypeKey,
                };
            });
            this.form = this.formGenerator.init(this.schemaDefinition(this.translate, this.options, this.formats));
        }), finalize(() => {
            this.spinner.off();
        }))
            .subscribe());
    }
};
ExportContainerComponent.ctorParameters = () => [
    { type: ConfigService },
    { type: SpinnerService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ExportContainerComponent.prototype, "translate", void 0);
__decorate([
    Input()
], ExportContainerComponent.prototype, "itemSelected", void 0);
__decorate([
    Output()
], ExportContainerComponent.prototype, "closeExportDialog", void 0);
__decorate([
    Output()
], ExportContainerComponent.prototype, "saveExportDialog", void 0);
ExportContainerComponent = __decorate([
    Component({
        selector: 'lib-export-container',
        template: ` <lib-export
    [form]="form"
    (closeExportDialog)="closeExportDialog.emit()"
    (saveExportDialog)="saveExportDialog.emit($event)"
  ></lib-export>`
    })
], ExportContainerComponent);

let ExportComponent = class ExportComponent {
    constructor() {
        this.closeExportDialog = new EventEmitter();
        this.saveExportDialog = new EventEmitter();
        this.state = {};
    }
    ngOnInit() { }
    save() {
        this.saveExportDialog.emit(this.form.values);
    }
    close() {
        this.closeExportDialog.emit();
    }
};
__decorate([
    Output()
], ExportComponent.prototype, "closeExportDialog", void 0);
__decorate([
    Output()
], ExportComponent.prototype, "saveExportDialog", void 0);
__decorate([
    Input()
], ExportComponent.prototype, "form", void 0);
ExportComponent = __decorate([
    Component({
        selector: 'lib-export',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.EXPORT' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ExportComponent);

const schemaDefinition$5 = (translate) => ({
    layout: {},
    fields: {
        file: {
            type: 'pFileUpload',
            label: 'Browse',
        },
    },
});
function toFormValues$2(data) { }
function fromFormValues$2(data, originalData) { }

let ImportComponent = class ImportComponent {
    constructor(formGenerator, crossReferenceService, toast, transloco, store) {
        this.formGenerator = formGenerator;
        this.crossReferenceService = crossReferenceService;
        this.toast = toast;
        this.transloco = transloco;
        this.store = store;
        this.closeImportDialog = new EventEmitter();
        this.saveImportDialog = new EventEmitter();
        this.state = {};
        this.importFile = null;
        this.subscriptions = [];
        this.isFileUploading = false;
        this.formatError = false;
    }
    ngOnInit() {
        this.form = this.formGenerator.init(schemaDefinition$5(this.translate));
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.userKey = user.userInfo.UserKey;
            this.email = user.sub;
        }))
            .subscribe());
    }
    save() {
        this.saveImportDialog.emit();
    }
    close() {
        this.closeImportDialog.emit();
    }
    onSelectFile(event) {
        const file = event.target.files[0];
        if (file) {
            const extension = file.name.split('.').pop().toLocaleLowerCase();
            const extensions = ['csv', 'xlsx'];
            if (extensions.includes(extension)) {
                this.importFile = file;
            }
            else {
                this.importFile = null;
                this.toast.errorNotify(this.transloco.translate('PIM.INVALID_FORMAT_MSG') + extensions, null, 8000);
            }
        }
    }
    uploadFile() {
        this.isFileUploading = true;
        this.crossReferenceService
            .import('member', this.importFile, this.email)
            .pipe(tap(() => {
            this.isFileUploading = false;
            this.toast.successNotify(this.transloco.translate('SUPPLIER.SUCCESS_TOAST_MESSAGE'));
        }), catchError(() => of(this.toast.errorNotify(this.transloco.translate('SUPPLIER.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.close();
        }))
            .subscribe();
    }
};
ImportComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: CrossReferenceService },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Output()
], ImportComponent.prototype, "closeImportDialog", void 0);
__decorate([
    Output()
], ImportComponent.prototype, "saveImportDialog", void 0);
__decorate([
    Input()
], ImportComponent.prototype, "translate", void 0);
ImportComponent = __decorate([
    Component({
        selector: 'lib-import',
        template: "<h2 class=\"dialog-title\">\r\n  {{ 'SUPPLIER.IMPORT' | transloco }}\r\n</h2>\r\n<div style=\"display: flex; flex-direction: column; row-gap: 1em\">\r\n  <ng-container *ngIf=\"!isFileUploading; else fileUploading\">\r\n    <p class=\"white-space-pre-line\">\r\n      {{ 'PIM.IMPORT_DOCUMENT_TYPE_ACCEPTED' | transloco }}\r\n    </p>\r\n    <div style=\"display: flex; column-gap: 0.5em\">\r\n      <div style=\"display: flex; flex-grow: 1\">\r\n        <input\r\n          style=\"flex-grow: 1\"\r\n          pInputText\r\n          type=\"text\"\r\n          class=\"ui-inputtext\"\r\n          disabled\r\n          value=\"{{ importFile ? importFile.name : null }}\"\r\n          placeholder=\"import file\"\r\n        />\r\n      </div>\r\n      <div>\r\n        <button\r\n          pButton\r\n          class=\"ds\"\r\n          label=\"{{ 'ACTIONS.BROWSE' | transloco }}\"\r\n          (click)=\"selectFile.click()\"\r\n        ></button>\r\n        <input\r\n          #selectFile\r\n          type=\"file\"\r\n          (change)=\"onSelectFile($event)\"\r\n          accept=\"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv\"\r\n          style=\"display: none\"\r\n        />\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <ng-template #fileUploading>\r\n    <p>\r\n      {{ 'PIM.IMPORT_PROCESS_MSG' | transloco }}\r\n    </p>\r\n  </ng-template>\r\n  <div class=\"import-file-btn\">\r\n    <button\r\n      pButton\r\n      class=\"ds\"\r\n      [disabled]=\"importFile === null || isFileUploading === true\"\r\n      label=\"{{ 'PIM.IMPORT' | transloco }}\"\r\n      (click)=\"uploadFile()\"\r\n    ></button>\r\n  </div>\r\n  <div>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ImportComponent);

const schemaDefinition$6 = (translate) => ({
    fields: {
        accountLegalName: {
            type: 'text',
            label: translate['MEMBER_LEGAL_NAME'],
            readonly: true,
        },
        accountDbaName: {
            type: 'text',
            label: translate['MEMBER_DBA_NAME'],
            readonly: true,
        },
        legalName: {
            type: 'text',
            label: translate['LOCATION_LEGAL_NAME'],
            readonly: true,
        },
        dbaName: {
            type: 'text',
            label: translate['LOCATION_DBA_NAME'],
            readonly: true,
        },
        crossReferenceNumber: {
            type: 'text',
            label: translate['MY_LOCATION_NUMBER'],
            readonly: true,
        },
        accountKey_Partner: {
            display: false,
        },
        accountLocationKey: {
            display: false,
        },
    },
});
function toFormValues$3(data) {
    const { legalName, dbaName, crossReferenceNumber, accountDbaName, accountLegalName, accountLocationKey, accountKey_Partner, } = data;
    return {
        legalName,
        dbaName,
        crossReferenceNumber,
        accountDbaName,
        accountLegalName,
        accountLocationKey,
        accountKey_Partner,
    };
}
function fromFormValues$3(data) {
    const { legalName, dbaName, accountDbaName, accountLegalName } = data, rest = __rest(data, ["legalName", "dbaName", "accountDbaName", "accountLegalName"]);
    return Object.assign({}, rest);
}

let ViewComponent = class ViewComponent {
    constructor(formGenerator) {
        this.formGenerator = formGenerator;
        this.closeViewDialog = new EventEmitter();
        this.state = {};
    }
    set dataSetter(data) {
        if (data) {
            this.data = toFormValues$3(data);
        }
    }
    ngOnInit() {
        this.form = this.formGenerator.init(schemaDefinition$6(this.translate), this.data);
    }
    close() {
        this.closeViewDialog.emit();
    }
};
ViewComponent.ctorParameters = () => [
    { type: GenerateFormService }
];
__decorate([
    Input('data')
], ViewComponent.prototype, "dataSetter", null);
__decorate([
    Output()
], ViewComponent.prototype, "closeViewDialog", void 0);
__decorate([
    Input()
], ViewComponent.prototype, "translate", void 0);
ViewComponent = __decorate([
    Component({
        selector: 'lib-view',
        template: "<h2 class=\"dialog-title\">\r\n  {{ 'SUPPLIER.MEMBER_CROSS_REFERENCE' | transloco }}\r\n</h2>\r\n\r\n<lui-form [form]=\"form\"></lui-form>\r\n\r\n<div style=\"display: flex; column-gap: 0.5em\">\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n    class=\"ds secondary\"\r\n    style=\"flex-grow: 1\"\r\n    (click)=\"close()\"\r\n  ></button>\r\n</div>\r\n",
        changeDetection: ChangeDetectionStrategy.OnPush
    })
], ViewComponent);

let MemberCrossReferencesModule = class MemberCrossReferencesModule {
};
MemberCrossReferencesModule = __decorate([
    NgModule({
        declarations: [
            MemberCrossReferencesComponent,
            ViewMembersCrossReferencesComponent,
            EditComponent,
            ExportComponent,
            ImportComponent,
            ExportContainerComponent,
            ApplyPaymentComponent,
            ApplyPaymentFormComponent,
            ViewComponent,
        ],
        imports: [
            CommonModule,
            DialogModule$1,
            RouterModule,
            SearchContainerModule$1,
            SearchContainerLoaderModule,
            TranslocoModule,
            PerFormPrimengModule,
            ButtonModule$2,
            ProgressSpinnerModule$2,
            UtilsModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
    })
], MemberCrossReferencesModule);

let AdvancedSearchComponent$2 = class AdvancedSearchComponent {
    constructor(accountRelationshipService) {
        this.accountRelationshipService = accountRelationshipService;
        this.setFilterEvent = new EventEmitter();
        this.appliedIcon = 'assets/images/filter-on.png';
        this.countryProvinceList = [];
        this.activeStatus = true;
        this.inactiveStatus = false;
        this.creditOnHoldYes = false;
        this.creditOnHoldNo = true;
        this.selectedProvince = [];
        this.dateJoinedFrom = null;
        this.dateJoinedTo = null;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.accountRelationshipService
            .getSearchFilters('member')
            .pipe(tap((filters) => {
            this.memberCategories = filters.categories;
            this.countryProvinceTreeData(filters.countries);
            this.memberRegion = filters.regions;
        }))
            .subscribe());
        this.dateType = this.accountRelationshipService.getUserDateFormat();
        this.subscriptions.push(timer(0).subscribe(() => {
            this.handleAdvancedSearch();
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    countryProvinceTreeData(countries) {
        const temp = [];
        if (countries.length > 0) {
            for (const cont of countries) {
                temp.push(this.transform(cont));
            }
        }
        this.countryProvinceList = temp;
    }
    transform(country) {
        const treeNode = {
            label: country.countryName,
            data: country.countryCode,
            children: [],
        };
        if (country.provinces === undefined || country.provinces === null) {
            return treeNode;
        }
        country.provinces.forEach((province) => {
            treeNode.children.push({
                label: province.provinceName,
                data: province.provinceCode.trim(),
            });
        });
        return treeNode;
    }
    handleAdvancedSearch() {
        const filters = this.getAppliedFilters();
        this.filtersEvent(filters);
    }
    getAppliedFilters() {
        let filters = [];
        filters = [
            ...filters,
            // status filters
            ...(!this.activeStatus && !this.inactiveStatus
                ? []
                : this.activeStatus && this.inactiveStatus
                    ? [
                        {
                            field: 'Status',
                            operator: 'eq',
                            values: ['Active', 'Inactive'],
                        },
                    ]
                    : this.activeStatus
                        ? [
                            {
                                field: 'Status',
                                operator: 'eq',
                                values: ['Active'],
                            },
                        ]
                        : [
                            {
                                field: 'Status',
                                operator: 'eq',
                                values: ['Inactive'],
                            },
                        ]),
            // category filters
            ...(this.selectedCategories && this.selectedCategories.length > 0
                ? [
                    {
                        field: 'CategoryKey',
                        operator: 'eq',
                        values: [...`${this.selectedCategories}`.split(',')],
                    },
                ]
                : []),
            // regions filters
            ...(this.selectedRegions && this.selectedRegions.length > 0
                ? [
                    {
                        field: 'RegionKey',
                        operator: 'eq',
                        values: [...`${this.selectedRegions}`.split(',')],
                    },
                ]
                : []),
            // date joined filters
            ...(!this.dateJoinedFrom && !this.dateJoinedTo
                ? []
                : this.dateJoinedFrom && this.dateJoinedTo
                    ? [
                        {
                            field: 'AcceptedOn',
                            operator: 'gte',
                            values: [this.dateJoinedFrom],
                        },
                        {
                            field: 'AcceptedOn',
                            operator: 'lte',
                            values: [this.dateJoinedTo],
                        },
                    ]
                    : this.dateJoinedFrom
                        ? [
                            {
                                field: 'AcceptedOn',
                                operator: 'gte',
                                values: [this.dateJoinedFrom],
                            },
                        ]
                        : [
                            {
                                field: 'AcceptedOn',
                                operator: 'lte',
                                values: [this.dateJoinedTo],
                            },
                        ]),
            // Credit on Hold
            ...(!this.creditOnHoldYes && !this.creditOnHoldNo
                ? []
                : this.creditOnHoldYes && this.creditOnHoldNo
                    ? [
                        {
                            field: 'OnHold',
                            operator: 'eq',
                            values: ['true', 'false'],
                        },
                    ]
                    : this.creditOnHoldYes
                        ? [
                            {
                                field: 'OnHold',
                                operator: 'eq',
                                values: ['true'],
                            },
                        ]
                        : [
                            {
                                field: 'OnHold',
                                operator: 'eq',
                                values: ['false'],
                            },
                        ]),
        ];
        // province filters
        if (this.selectedProvince && this.selectedProvince.length > 0) {
            const defaultValue = [];
            const selectedNodes = this.selectedProvince;
            const provinces = selectedNodes
                .filter((x) => (x.parent || x.children === undefined) && !x.partialSelected)
                .map((y) => y.data);
            const countries = selectedNodes
                .filter((x) => x.children || x.parent)
                .map((y) => y.children ? y.data : y.parent ? y.parent.data : defaultValue)
                .filter((itm, idx, arr) => arr.indexOf(itm) === idx);
            filters = [
                ...filters,
                ...[
                    {
                        field: 'Province',
                        operator: 'eq',
                        values: provinces,
                    },
                ],
            ];
        }
        return filters;
    }
    handleClear() {
        this.selectedCategories = [];
        this.selectedRegions = [];
        this.selectedProvince = [];
        this.dateJoinedFrom = this.dateJoinedTo = null;
        this.activeStatus =
            this.inactiveStatus =
                this.creditOnHoldYes =
                    this.creditOnHoldNo =
                        false;
        this.filtersEvent([]);
    }
    filtersEvent(filters) {
        this.setFilterEvent.emit({
            filters,
            options: { search: true },
        });
    }
    getValidDate($event, type) {
        if (type === 'From') {
            this.dateJoinedFrom = $event;
        }
        else {
            this.dateJoinedTo = $event;
        }
    }
};
AdvancedSearchComponent$2.ctorParameters = () => [
    { type: AccountRelationshipService }
];
__decorate([
    Output()
], AdvancedSearchComponent$2.prototype, "setFilterEvent", void 0);
AdvancedSearchComponent$2 = __decorate([
    Component({
        selector: 'lib-advanced-search',
        template: "<div class=\"vertical-flow advanced-search\">\r\n  <div class=\"horizontal-fixed space-between-075\">\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n      (click)=\"handleClear()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n      (click)=\"handleAdvancedSearch()\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"space-before-100\">\r\n    <p-accordion\r\n      styleClass=\"advancedSearchTabHeader\"\r\n      expandIcon=\"pi pi-caret-right\"\r\n      collapseIcon=\"pi pi-caret-down\"\r\n      [multiple]=\"true\"\r\n    >\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <p-accordionTab *ngIf=\"countryProvinceList?.length\">\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.STATE_PROVINCE' | transloco }}\r\n              </div>\r\n\r\n              <div class=\"facet-icon\" *ngIf=\"selectedProvince?.length\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div>\r\n            <p-tree\r\n              [value]=\"countryProvinceList\"\r\n              selectionMode=\"checkbox\"\r\n              [(selection)]=\"selectedProvince\"\r\n              [styleClass]=\"\r\n                selectedProvince?.length === 0\r\n                  ? 'clearPartialSelectionIcon'\r\n                  : ''\r\n              \"\r\n            ></p-tree>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.ACTIVE_INACTIVE' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"activeStatus || inactiveStatus\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.ACTIVE' | transloco }}\"\r\n              [(ngModel)]=\"activeStatus\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.INACTIVE' | transloco }}\"\r\n              [(ngModel)]=\"inactiveStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab *ngIf=\"memberCategories?.length\">\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.CATEGORY' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"selectedCategories?.length\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div\r\n            *ngFor=\"let memCategory of memberCategories; let i = index\"\r\n            class=\"vertical-flow\"\r\n          >\r\n            <p-checkbox\r\n              [ngClass]=\"i > 0 ? 'space-before-075' : ''\"\r\n              [label]=\"memCategory.name\"\r\n              [name]=\"category\"\r\n              [value]=\"memCategory.tagKey\"\r\n              [(ngModel)]=\"selectedCategories\"\r\n            ></p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab *ngIf=\"memberRegion?.length\">\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.REGION' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"selectedRegions?.length\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div\r\n            *ngFor=\"let x of memberRegion; let j = index\"\r\n            class=\"vertical-flow\"\r\n          >\r\n            <p-checkbox\r\n              [ngClass]=\"j > 0 ? 'space-before-075' : ''\"\r\n              [label]=\"x.name\"\r\n              [name]=\"region\"\r\n              [value]=\"x.tagKey\"\r\n              [(ngModel)]=\"selectedRegions\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.DATE_JOINED' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"dateJoinedFrom || dateJoinedTo\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow space-between-075 input-filter\">\r\n            <div>{{ 'ADVANCED_SEARCH.RANGE' | transloco }}</div>\r\n            <div>\r\n              <p-calendar\r\n                [showIcon]=\"true\"\r\n                [dateFormat]=\"dateType.primeNgFormat\"\r\n                [placeholder]=\"dateType.description\"\r\n                [(ngModel)]=\"dateJoinedFrom\"\r\n                [maxDate]=\"dateJoinedTo\"\r\n                appendTo=\"body\"\r\n                (onSelect)=\"getValidDate($event, 'From')\"\r\n              ></p-calendar>\r\n            </div>\r\n\r\n            <div>\r\n              <p-calendar\r\n                [dateFormat]=\"dateType.primeNgFormat\"\r\n                [placeholder]=\"dateType.description\"\r\n                [(ngModel)]=\"dateJoinedTo\"\r\n                [showIcon]=\"true\"\r\n                [minDate]=\"dateJoinedFrom\"\r\n                appendTo=\"body\"\r\n                (onSelect)=\"getValidDate($event, 'To')\"\r\n              ></p-calendar>\r\n            </div>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.CREDIT_ON_HOLD' | transloco }}\r\n              </div>\r\n\r\n              <div class=\"facet-icon\" *ngIf=\"creditOnHoldYes || creditOnHoldNo\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              [(ngModel)]=\"creditOnHoldYes\"\r\n              [binary]=\"true\"\r\n              label=\"{{ 'MARKETPLACE_ADVANCED_SEARCH.YES' | transloco }}\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              label=\"{{ 'MARKETPLACE_ADVANCED_SEARCH.NO' | transloco }}\"\r\n              binary=\"true\"\r\n              [(ngModel)]=\"creditOnHoldNo\"\r\n            ></p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n      </div>\r\n    </p-accordion>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], AdvancedSearchComponent$2);

let BankingComponent$1 = class BankingComponent {
    constructor(translocoService, store) {
        this.translocoService = translocoService;
        this.store = store;
        this.viewBankingInfo = {};
        this.toolbarButtons = [];
        this.displayViewBanking = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set bankingInfoSetter(bankingInfos) {
        this.data$ = of(bankingInfos);
        this.bankingInfo = bankingInfos;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['contactName', 'contactEmail'];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayViewBanking = true;
                this.viewBankingInfo = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.search();
    }
    search({ filters: { contactName } } = { filters: { contactName: '.*' } }) {
        const regex = new RegExp(contactName, 'i');
        this.data$ = of(this.bankingInfo.filter((bankingInfo) => bankingInfo.contactName.match(regex)));
    }
    closeViewBankingDialog() {
        this.displayViewBanking = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactName',
                    header: translate.VIEW_BANKING_CONTACT_NAME,
                },
                {
                    field: 'contactEmail',
                    header: translate.VIEW_BANKING_CONTACT_EMAIL,
                },
                {
                    field: 'externalAccountName',
                    header: translate.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'internalAccountName',
                    header: translate.VIEW_BANKING_INTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'accountNumber',
                    header: translate.VIEW_BANKING_ACCOUNT_NUMBER,
                },
                {
                    field: 'routingNumber',
                    header: translate.VIEW_BANKING_ROUTING_NUMBER,
                },
                {
                    field: 'federalTaxID',
                    header: translate.VIEW_BANKING_FEDERAL_TAX_ID,
                },
                {
                    field: 'identificationNumber',
                    header: translate.VIEW_BANKING_IDENTIFICATION_NUMBER,
                },
                {
                    field: 'traceNumber',
                    header: translate.VIEW_BANKING_TRACE_NUMBER,
                },
                {
                    field: 'sequenceNumber',
                    header: translate.VIEW_BANKING_SEQUENCE_NUMBER,
                },
                {
                    field: 'originName',
                    header: translate.VIEW_BANKING_ORIGIN_NAME,
                },
                {
                    field: 'bankName',
                    header: translate.VIEW_BANKING_BANK_NAME,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
BankingComponent$1.ctorParameters = () => [
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('bankingInfo')
], BankingComponent$1.prototype, "bankingInfoSetter", null);
BankingComponent$1 = __decorate([
    Component({
        selector: 'lib-banking',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"memberBanking\"\r\n      i18nSearchField=\"{{ 'PARTNERS.BANKING_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [searchProperty]=\"'contactName'\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n    ></lib-search-container>\r\n    <p-dialog\r\n      [modal]=\"true\"\r\n      position=\"center\"\r\n      [(visible)]=\"displayViewBanking\"\r\n      [showHeader]=\"false\"\r\n    >\r\n      <h2 class=\"dialog-title\">\r\n        {{ 'SUPPLIER.VIEW_BANKING' | transloco }}\r\n      </h2>\r\n      <lib-view-banking\r\n        [bankingInfo]=\"viewBankingInfo\"\r\n        (closeViewBankingDialog)=\"closeViewBankingDialog()\"\r\n      ></lib-view-banking>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], BankingComponent$1);

let ViewBankingComponent$2 = class ViewBankingComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeViewBankingDialog = new EventEmitter();
    }
    set bankingInfoSetter(bankingInfo) {
        this.initializeForm(bankingInfo);
    }
    initializeForm(bankingInfoInput) {
        const bankingInfo = bankingInfoInput || {};
        this.editBankingForm = this.formBuilder.group({
            contactName: [{ value: bankingInfo.contactName, disabled: true }],
            contactEmail: [{ value: bankingInfo.contactEmail, disabled: true }],
            accountNumber: [{ value: bankingInfo.accountNumber, disabled: true }],
            externalAccountName: [
                { value: bankingInfo.externalAccountName, disabled: true },
            ],
            internalAccountName: [
                { value: bankingInfo.internalAccountName, disabled: true },
            ],
            routingNumber: [{ value: bankingInfo.routingNumber, disabled: true }],
            federalTaxID: [{ value: bankingInfo.federalTaxID, disabled: true }],
            identificationNumber: [
                { value: bankingInfo.identificationNumber, disabled: true },
            ],
            traceNumber: [{ value: bankingInfo.traceNumber, disabled: true }],
            sequenceNumber: [{ value: bankingInfo.sequenceNumber, disabled: true }],
            originName: [{ value: bankingInfo.originName, disabled: true }],
            bankName: [{ value: bankingInfo.bankName, disabled: true }],
        });
    }
    closeDialog() {
        this.closeViewBankingDialog.emit();
        this.editBankingForm.reset();
    }
};
ViewBankingComponent$2.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('bankingInfo')
], ViewBankingComponent$2.prototype, "bankingInfoSetter", null);
__decorate([
    Output()
], ViewBankingComponent$2.prototype, "closeViewBankingDialog", void 0);
ViewBankingComponent$2 = __decorate([
    Component({
        selector: 'lib-view-banking',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"editBankingForm\"\r\n>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactName\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactEmail\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_EMAIL' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactEmail\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"accountNumber\">{{\r\n      'SUPPLIER.VIEW_BANKING_ACCOUNT_NUMBER' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"accountNumber\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"externalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"externalAccountName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"internalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_INTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"internalAccountName\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"routingNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_ROUTING_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"routingNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"federalTaxID\">{{\r\n        'SUPPLIER.VIEW_BANKING_FEDERAL_TAX_ID' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"federalTaxID\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"identificationNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_IDENTIFICATION_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"identificationNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"traceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_TRACE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"traceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"originName\">{{\r\n        'SUPPLIER.VIEW_BANKING_ORIGIN_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"originName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"sequenceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_SEQUENCE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"sequenceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"bankName\">{{\r\n      'SUPPLIER.VIEW_BANKING_BANK_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"bankName\"\r\n    />\r\n  </div>\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n    class=\"ds secondary\"\r\n    autowidth=\"false\"\r\n    (click)=\"closeDialog()\"\r\n  ></button>\r\n</form>\r\n",
        styles: [""]
    })
], ViewBankingComponent$2);

let ContactFormContainerComponent$3 = class ContactFormContainerComponent {
    constructor(config, accountService, memberBus, spinner) {
        this.config = config;
        this.accountService = accountService;
        this.memberBus = memberBus;
        this.spinner = spinner;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set contactSetter(contact) {
        this.contact = contact;
    }
    ngOnInit() {
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ contact }) => contact));
        this.setFetching('contact', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.config.getContactRoles(),
            this.config.getPhoneTypes(),
            this.config.getCountries(),
            this.accountService.getAccount(),
        ])
            .pipe(tap(([roles, phoneTypes, countries, account]) => {
            this.contactRoles = roles.map((role) => {
                return {
                    label: role.description,
                    value: role.contactRoleKey,
                };
            });
            this.phoneTypes = phoneTypes.map((phoneType) => {
                return {
                    label: phoneType.description,
                    value: phoneType.phoneTypeKey,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: `${country.countryName} (${country.countryCode})`,
                    value: alpha3ToAlpha2(country.countryCode),
                };
            });
            this.account = account;
        }), finalize(() => {
            this.setFetching('contact', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.memberBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeContactDialog.emit();
    }
};
ContactFormContainerComponent$3.ctorParameters = () => [
    { type: ConfigService },
    { type: AccountService },
    { type: MemberBus },
    { type: SpinnerService }
];
__decorate([
    Input()
], ContactFormContainerComponent$3.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormContainerComponent$3.prototype, "contactSetter", null);
__decorate([
    Output()
], ContactFormContainerComponent$3.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$3.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$3.prototype, "contactsCRUD", void 0);
ContactFormContainerComponent$3 = __decorate([
    Component({
        selector: 'lib-contact-form-container',
        template: `<lib-contact-form
    [action]="action"
    [account]="account"
    [countries]="countries"
    [contact]="contact"
    [contactRoles]="contactRoles"
    [phoneTypes]="phoneTypes"
    (closeContactDialog)="closeContactDialog.emit()"
    (deletePhones)="deletePhones.emit($event)"
    (contactsCRUD)="contactsCRUD.emit($event)"
  ></lib-contact-form>`
    })
], ContactFormContainerComponent$3);

let ContactFormComponent$3 = class ContactFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.controls = [
            'firstName',
            'lastName',
            'title',
            'email',
            'contactRoleKey',
            'notes',
        ];
        this.resetPhone = false;
        this.deletedPhones = [];
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.emailError = {
            email: () => this.transloco.translate('VALIDATION_MESSAGE.EMAIL'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set contactSetter(contact) {
        this.contact = contact;
        this.initializeForm(contact);
    }
    initializeForm(contactInput) {
        const contact = contactInput
            ? contactInput
            : {};
        this.contactForm = this.formBuilder.group({
            firstName: [contact.firstName, Validators.required],
            lastName: [contact.lastName, Validators.required],
            title: [contact.title, Validators.required],
            email: [
                contact.email,
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            contactRoleKey: [contact.contactRoleKey || 1, Validators.required],
            notes: [contact.notes],
            phone: [contact === null || contact === void 0 ? void 0 : contact.phone, Validators.required],
        });
    }
    closeDialog() {
        this.resetContactForm();
        this.closeContactDialog.emit();
        this.deletedPhones = [];
    }
    deletePhone(deletedPhones) {
        this.deletedPhones = [...this.deletedPhones, deletedPhones];
    }
    getContactRole() {
        var _a;
        try {
            return (_a = this.contactRoles) === null || _a === void 0 ? void 0 : _a.find((contactRole) => contactRole.value === this.contact.contactRoleKey).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        if (this.deletedPhones && this.deletedPhones.length > 0) {
            this.deletedPhones.forEach((payload) => this.deletePhones.emit(payload));
        }
        const contactKey = this.action === 'add' ? '' : `${this.contact.contactKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.contactsCRUD.emit({
            eventType,
            type: 'contact',
            typeKey: contactKey,
            payload: {
                [`${eventType}`]: this.formatContactPayload(),
            },
        });
        this.closeDialog();
    }
    formatContactPayload() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const phones = ((_c = (_b = (_a = this.contactForm) === null || _a === void 0 ? void 0 : _a.get('phone')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.phone) ? (_f = (_e = (_d = this.contactForm) === null || _d === void 0 ? void 0 : _d.get('phone')) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.phone : (_h = (_g = this.contactForm) === null || _g === void 0 ? void 0 : _g.get('phone')) === null || _h === void 0 ? void 0 : _h.value;
        return Object.assign(Object.assign(Object.assign({}, this.contact), this.contactForm.value), { phone: phones.map((phone) => {
                return Object.assign(Object.assign({}, phone), { contactPhoneKey: (phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) !== null
                        ? Number(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey)
                        : 0, phoneTypeKey: (phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) : 1, phoneNumber: this.formatPhoneForSave(phone), phoneCountryCode: phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode });
            }) });
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    resetContactForm() {
        this.resetPhone = true;
        this.controls.forEach((control) => this.contactForm.get(control).setValue(''));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
ContactFormComponent$3.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], ContactFormComponent$3.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormComponent$3.prototype, "contactSetter", null);
__decorate([
    Input()
], ContactFormComponent$3.prototype, "account", void 0);
__decorate([
    Input()
], ContactFormComponent$3.prototype, "contactRoles", void 0);
__decorate([
    Input()
], ContactFormComponent$3.prototype, "phoneTypes", void 0);
__decorate([
    Input()
], ContactFormComponent$3.prototype, "countries", void 0);
__decorate([
    Output()
], ContactFormComponent$3.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormComponent$3.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormComponent$3.prototype, "contactsCRUD", void 0);
ContactFormComponent$3 = __decorate([
    Component({
        selector: 'lib-contact-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"contactForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"firstName\">{{\r\n      'SUPPLIER.CONTACT_FIRST_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else firstName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"firstName\"\r\n    />\r\n    <ng-template #firstName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.firstName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.firstName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"lastName\">{{ 'SUPPLIER.CONTACT_LAST_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else lastName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"lastName\"\r\n    />\r\n    <ng-template #lastName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.lastName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.lastName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"title\">{{ 'SUPPLIER.CONTACT_TITLE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else title\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"title\"\r\n    />\r\n    <ng-template #title>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.title\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.title\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <lib-phone-form\r\n    [countries]=\"countries\"\r\n    [defaultCountry]=\"account?.details?.country\"\r\n    [phoneTypes]=\"phoneTypes\"\r\n    [resetPhone]=\"resetPhone\"\r\n    [viewOnly]=\"action === 'view'\"\r\n    (deletedPhone)=\"deletePhone($event)\"\r\n    formControlName=\"phone\"\r\n  ></lib-phone-form>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"email\">{{ 'SUPPLIER.CONTACT_EMAIL' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else email\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"email\"\r\n    />\r\n    <ng-template #email>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.email\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.email\"\r\n      [errorMsg]=\"emailError.email\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"contactRoleKey\">{{\r\n      'SUPPLIER.CONTACT_ROLE' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else role\"\r\n      placeholder=\"{{ 'SUPPLIER.CONTACT_SELECT_ROLE' | transloco }}\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"contactRoleKey\"\r\n      [options]=\"contactRoles\"\r\n      formControlName=\"contactRoleKey\"\r\n      filter=\"true\"\r\n    ></p-dropdown>\r\n    <ng-template #role>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getContactRole()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.role\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"notes\">{{ 'SUPPLIER.CONTACT_NOTES' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else notes\"\r\n      rows=\"5\"\r\n      autoresize=\"false\"\r\n      name=\"notes\"\r\n      pInputTextarea\r\n      formControlName=\"notes\"\r\n      class=\"width-100 ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #notes>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"false\"\r\n        name=\"notes\"\r\n        pInputTextarea\r\n        formControlName=\"notes\"\r\n        class=\"width-100 ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"contactForm?.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ContactFormComponent$3);

let ContactsComponent$3 = class ContactsComponent {
    constructor(confirmationService, memberBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.memberBus = memberBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showContactDialog = false;
        this.columnsAvailable = false;
        this.fetching = false;
        this.subscriptions = [];
        this.authorizedActions = {};
        this.action = null;
    }
    set notesSetter(contacts) {
        this.contacts = contacts;
    }
    set contactRolesSetter(contactsRoles) {
        this.contactRoles = contactsRoles;
    }
    set phoneTypesSetter(phoneTypes) {
        this.phoneTypes = phoneTypes;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.memberBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'contact' && payload.result) {
                this.data$ = of(this.transformContactPhoneForSC(payload.data.accountRelationshipContactResponse));
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ contact }) => (this.fetching = contact)));
        this.columnsToDisplay = [
            'firstName',
            'workPhone',
            'mobilePhone',
            'otherPhone',
            'email',
            'contactRole',
            'title',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(contacts, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const contactKeys = [];
                contacts.forEach((contactInfo) => contactKeys.push(contactInfo.contactKey));
                const contactKeysString = JSON.stringify(contactKeys);
                this.memberBus.publish({
                    eventType: 'delete',
                    type: 'contact',
                    typeKey: contactKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'firstName'),
                    },
                });
                // TODO: Remove in Future Version if Single Delete is Obsolete
                // contacts.forEach((contact) =>
                //   this.memberBus.publish({
                //     eventType: 'delete',
                //     type: 'contact',
                //     typeKey: `${contact.contactKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showContactDialog = true;
                this.editContactData = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'firstName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters(term, pagination, [], 'firstName'),
        });
    }
    deletePhones(payload) {
        this.memberBus.publish({
            eventType: 'delete',
            type: 'contactPhone',
            payload: {
                delete: payload,
                search: searchFilters('', this.prevPagination, [], 'firstName'),
            },
        });
    }
    contactsCRUD(data) {
        this.memberBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'firstName') }) }));
    }
    closeContactDialog() {
        this.showContactDialog = false;
        this.action = null;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactRole',
                    header: translate.CONTACT_ROLE,
                    formatter: ({ contactRoleKey }) => `${roles[contactRoleKey]}`,
                },
                {
                    field: 'firstName',
                    header: translate.FULL_NAME,
                    formatter: ({ firstName, lastName }) => `${firstName} ${lastName}`,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (contact) => contact,
                    required: true,
                },
                {
                    field: 'workPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.WORK_PHONE}`,
                    formatter: ({ workPhone }) => {
                        var _a;
                        return `${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber) || ''} ${((_a = workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'mobilePhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.MOBILE_PHONE}`,
                    formatter: ({ mobilePhone }) => {
                        var _a;
                        return `${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber) || ''} ${((_a = mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'otherPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.OTHER_PHONE}`,
                    formatter: ({ otherPhone }) => {
                        var _a;
                        return `${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber) || ''} ${((_a = otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'title',
                    header: translate.TITLE,
                },
                {
                    field: 'email',
                    header: translate.EMAIL,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    formatPhoneNumber(phoneNumber, countryCode) {
        try {
            return parsePhoneNumber(phoneNumber, alpha3ToAlpha2(countryCode)).formatInternational();
        }
        catch (_a) {
            return phoneNumber;
        }
    }
    transformContactPhoneForSC(contacts) {
        return contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => {
            const mobilePhone = this.findPhone(contact, 1);
            const otherPhone = this.findPhone(contact, 2);
            const workPhone = this.findPhone(contact, 3);
            return Object.assign(Object.assign({}, contact), { mobilePhone: Object.assign(Object.assign({}, mobilePhone), { phoneNumber: this.formatPhoneNumber(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber, mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneCountryCode) }), otherPhone: Object.assign(Object.assign({}, otherPhone), { phoneNumber: this.formatPhoneNumber(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber, otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneCountryCode) }), workPhone: Object.assign(Object.assign({}, workPhone), { phoneNumber: this.formatPhoneNumber(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber, workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneCountryCode) }) });
        });
    }
    findPhone(contact, phoneTypeKey) {
        try {
            return contact.phone.find((phn) => phn.phoneTypeKey === phoneTypeKey);
        }
        catch (_a) {
            return undefined;
        }
    }
    openViewContact(contact) {
        this.action = 'view';
        this.showContactDialog = true;
        this.editContactData = contact;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
            add: toolKeys.MPP_MEMBER_MAINTENANCE,
            edit: toolKeys.MPP_MEMBER_MAINTENANCE,
            delete: toolKeys.MPP_MEMBER_MAINTENANCE,
        };
    }
};
ContactsComponent$3.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MemberBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('contacts')
], ContactsComponent$3.prototype, "notesSetter", null);
__decorate([
    Input('contactRoles')
], ContactsComponent$3.prototype, "contactRolesSetter", null);
__decorate([
    Input('phoneTypes')
], ContactsComponent$3.prototype, "phoneTypesSetter", null);
ContactsComponent$3 = __decorate([
    Component({
        selector: 'lib-contacts',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"memberContacts\"\r\n      i18nSearchField=\"{{ 'PARTNERS.CONTACT_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewContact($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showContactDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (deletePhones)=\"deletePhones($event)\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], ContactsComponent$3);

let DetailsComponent$3 = class DetailsComponent {
    constructor(formBuilder, memberBus, spinner, transloco) {
        this.formBuilder = formBuilder;
        this.memberBus = memberBus;
        this.spinner = spinner;
        this.transloco = transloco;
        this.defaultSelectItem = {
            value: null,
            label: this.transloco.translate('ACTIONS.SELECT'),
        };
        this.pattern = {
            pattern: () => this.transloco.translate('VALIDATION_MESSAGE.MEMBER_NUMBER'),
        };
        this.enableEdit = false;
        this.permissions = {};
    }
    set detailsSetter(details) {
        this.details = details;
        this.initializeMemberForm();
    }
    set configurationSetter(configuration) {
        if (configuration) {
            configuration.categories.unshift({
                value: null,
                label: this.transloco.translate('ACTIONS.SELECT'),
            });
            configuration.regions.unshift({
                value: null,
                label: this.transloco.translate('ACTIONS.SELECT'),
            });
        }
        this.categories =
            configuration && configuration.categories ? configuration.categories : [];
        this.regions =
            configuration && configuration.regions ? configuration.regions : [];
    }
    set tagsSetter(tags) {
        this.memberForm.controls.category.setValue(tags && tags.category ? tags.category.value : this.defaultSelectItem.value);
        this.memberForm.controls.region.setValue(tags && tags.region ? tags.region.value : this.defaultSelectItem.value);
    }
    set permissionsSetter(permissions) {
        this.permissions = permissions;
    }
    ngOnInit() {
        this.memberBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'details') {
                payload.error === 3
                    ? (this.enableEdit = true)
                    : (this.enableEdit = false);
            }
        });
    }
    initializeMemberForm() {
        this.memberForm = this.formBuilder.group({
            number: [
                this.details ? this.details.number : 0,
                [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')],
            ],
            category: [this.details ? this.details.categoryKey : null],
            region: [this.details ? this.details.regionKey : null],
            legalName: [
                { value: this.details ? this.details.legalName : null, disabled: true },
            ],
            dbaName: [
                { value: this.details ? this.details.dbaName : null, disabled: true },
            ],
            address1: [
                { value: this.details ? this.details.address1 : null, disabled: true },
            ],
            address2: [
                { value: this.details ? this.details.address2 : null, disabled: true },
            ],
            country: [
                {
                    value: this.details ? this.details.country.trim() : null,
                    disabled: true,
                },
            ],
            city: [
                { value: this.details ? this.details.city : null, disabled: true },
            ],
            postalCode: [
                {
                    value: this.details ? this.details.postalCode : null,
                    disabled: true,
                },
            ],
            province: [
                {
                    value: this.details ? this.details.province.trim() : null,
                    disabled: true,
                },
            ],
            // isaNumber: [
            //   { value: this.details ? this.details.isaNumber : null, disabled: true },
            // ],
            phone: [
                {
                    value: this.details
                        ? this.formatPhoneToInternational(this.details.phone, this.details.country)
                        : null,
                    disabled: true,
                },
            ],
            email: [
                { value: this.details ? this.details.email : null, disabled: true },
            ],
            website: [
                { value: this.details ? this.details.website : null, disabled: true },
            ],
            currency: [
                {
                    value: this.details ? this.details.currencyType : null,
                    disabled: true,
                },
            ],
        });
    }
    formatPhoneToInternational(fax, country) {
        try {
            return parsePhoneNumber(fax, alpha3ToAlpha2(country || 'CA')).formatInternational();
        }
        catch (_a) {
            return fax;
        }
    }
    save() {
        this.memberBus.publish({
            eventType: 'update',
            type: 'details',
            payload: {
                update: Object.assign(Object.assign({}, this.details), { number: this.memberForm.value.number, regionKey: this.memberForm.value.region
                        ? this.memberForm.value.region
                        : null, categoryKey: this.memberForm.value.category
                        ? this.memberForm.value.category
                        : null }),
            },
        });
    }
    configEditModal() {
        this.enableEdit = !this.enableEdit;
    }
    cancelEditModal() {
        this.initializeMemberForm();
        this.enableEdit = !this.enableEdit;
    }
};
DetailsComponent$3.ctorParameters = () => [
    { type: FormBuilder },
    { type: MemberBus },
    { type: SpinnerService },
    { type: TranslocoService }
];
__decorate([
    Input('details')
], DetailsComponent$3.prototype, "detailsSetter", null);
__decorate([
    Input('configuration')
], DetailsComponent$3.prototype, "configurationSetter", null);
__decorate([
    Input('tags')
], DetailsComponent$3.prototype, "tagsSetter", null);
__decorate([
    Input('permissions')
], DetailsComponent$3.prototype, "permissionsSetter", null);
DetailsComponent$3 = __decorate([
    Component({
        selector: 'lib-details',
        template: "<!--Member Details - View Mode-->\r\n<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button\r\n    pButton\r\n    class=\"ds tertiary small\"\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    [disabled]=\"!permissions?.edit\"\r\n    (click)=\"configEditModal()\"\r\n  ></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <!-- <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ISA_NUMBER' | transloco,\r\n          value: details.isaNumber\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container> -->\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.LEGAL_NAME' | transloco,\r\n          value: details.legalName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.DBA_NAME' | transloco,\r\n          value: details.dbaName\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MEMBER.MEMBER_NUMBER' | transloco,\r\n          value: details.number\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_ONE' | transloco,\r\n          value: details.address1\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_TWO' | transloco,\r\n          value: details.address2\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: { label: 'SUPPLIER.CITY' | transloco, value: details.city }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.STATE_PROVINCE' | transloco,\r\n          value: details.provinceName || details.province.trim()\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ZIP_POSTAL_CODE' | transloco,\r\n          value: details.postalCode\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.COUNTRY' | transloco,\r\n          value: details.countryName || details.country\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco,\r\n          value: details.phone\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.EMAIL' | transloco,\r\n          value: details.email\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.ACCOUNT_WEBSITE' | transloco,\r\n          value: details.website\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco,\r\n          value: details.currencyType\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CATEGORY' | transloco,\r\n          value: details.category\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-container\r\n    *ngTemplateOutlet=\"\r\n      memberDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.REGION' | transloco,\r\n          value: details.region\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container>\r\n  <ng-template #memberDetails let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">\r\n          {{ value.label }}\r\n        </div>\r\n        <div>\r\n          <span> {{ value.value }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n<!--Member Details - Edit Modal-->\r\n<p-dialog\r\n  [(visible)]=\"enableEdit\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  styleClass=\"lbmx-modal\"\r\n>\r\n  <div class=\"vertical-flow modal-details-container\">\r\n    <h2 class=\"center\">{{ 'COMMON.EDIT_DETAILS' | transloco }}</h2>\r\n    <form\r\n      class=\"vertical-flow space-before-100\"\r\n      [formGroup]=\"memberForm\"\r\n      (ngSubmit)=\"save()\"\r\n    >\r\n      <!-- <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"isaNumber\">{{ 'SUPPLIER.ISA_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"isaNumber\"\r\n          />\r\n        </div>\r\n      </div> -->\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"legalName\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"dbaName\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"number\">{{ 'MEMBER.MEMBER_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"number\"\r\n          />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"memberForm?.controls?.number\"\r\n            [errorMsg]=\"pattern.pattern\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div\r\n        class=\"vertical-flow space-before-000 space-between-025\"\r\n        *ngIf=\"categories?.length\"\r\n      >\r\n        <label for=\"category\">{{ 'SUPPLIER.CATEGORY' | transloco }}</label>\r\n        <p-dropdown\r\n          autoWidth=\"false\"\r\n          name=\"category\"\r\n          [options]=\"categories\"\r\n          formControlName=\"category\"\r\n          filter=\"true\"\r\n        ></p-dropdown>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"memberForm?.controls?.category\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div\r\n        class=\"vertical-flow space-before-000 space-between-025\"\r\n        *ngIf=\"regions?.length\"\r\n      >\r\n        <label for=\"region\">{{ 'SUPPLIER.REGION' | transloco }}</label>\r\n        <p-dropdown\r\n          autoWidth=\"false\"\r\n          name=\"region\"\r\n          [options]=\"regions\"\r\n          formControlName=\"region\"\r\n          filter=\"true\"\r\n        ></p-dropdown>\r\n        <span class=\"feedback\">\r\n          <lib-control-message\r\n            [control]=\"memberForm?.controls?.region\"\r\n          ></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address1\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"address2\"\r\n          />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"city\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"province\">{{\r\n          'SUPPLIER.STATE_PROVINCE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"province\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"postalCode\">{{\r\n          'SUPPLIER.ZIP_POSTAL_CODE' | transloco\r\n        }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"postalCode\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"country\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <div>\r\n          <label for=\"phone\">{{\r\n            'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco\r\n          }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"phone\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <div>\r\n          <label for=\"email\">{{ 'SUPPLIER.EMAIL' | transloco }}</label>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"email\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"website\">{{ 'COMPANY.ACCOUNT_WEBSITE' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"website\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"currency\">{{\r\n          'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco\r\n        }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"currency\"\r\n          />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"horizontal-flow form-controls space-before-150\">\r\n        <button\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n          class=\"ds secondary\"\r\n          autowidth=\"false\"\r\n          (click)=\"cancelEditModal()\"\r\n        ></button>\r\n        <button\r\n          [disabled]=\"memberForm.invalid\"\r\n          pButton\r\n          type=\"button\"\r\n          label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n          type=\"submit\"\r\n          class=\"ds primary\"\r\n          autowidth=\"false\"\r\n        ></button>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</p-dialog>\r\n",
        styles: [""]
    })
], DetailsComponent$3);

let EdiFormContainerComponent$1 = class EdiFormContainerComponent {
    constructor(config, memberBus, spinner) {
        this.config = config;
        this.memberBus = memberBus;
        this.spinner = spinner;
        this.closeEdiDialog = new EventEmitter();
        this.ediCRUD = new EventEmitter();
        this.edi = [];
        this.documentTypes = [];
        this.documentStatus = [];
    }
    set ediSetter(edi) {
        this.edi = edi;
    }
    ngOnInit() {
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ edi }) => edi));
        this.setFetching('edi', true);
        this.spinner.on();
        this.subscription = forkJoin([
            this.config.getDocumentTypes(),
            this.config.getDocumentStatus(),
        ])
            .pipe(tap(([documentTypes, documentStatus]) => {
            this.documentTypes = documentTypes;
            this.documentStatus = documentStatus.map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentStatusKey, label: doc.description })));
        }), finalize(() => {
            this.setFetching('edi', false);
            this.spinner.off();
        }))
            .subscribe();
    }
    doesContainDocumentType(documentTypes = [{ documentTypeKey: 0 }], documentType = { documentTypeKey: 0 }) {
        return ((documentTypes === null || documentTypes === void 0 ? void 0 : documentTypes.filter((doc) => (documentType === null || documentType === void 0 ? void 0 : documentType.documentTypeKey) === (doc === null || doc === void 0 ? void 0 : doc.documentTypeKey)).length) > 0);
    }
    getAvailableDocumentTypes() {
        return this.action === 'edit'
            ? [
                ...this.documentTypes
                    .filter((documentType) => !this.doesContainDocumentType(this.edi, documentType))
                    .map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentTypeKey, label: `${doc.template + ' ' + doc.description}` }))),
                {
                    value: this.editEdi.documentTypeKey,
                    label: this.editEdi.documentType,
                },
            ]
            : this.documentTypes
                .filter((documentType) => !this.doesContainDocumentType(this.edi, documentType))
                .map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentTypeKey, label: `${doc.template + ' ' + doc.description}` })));
    }
    setFetching(form, value) {
        this.memberBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
EdiFormContainerComponent$1.ctorParameters = () => [
    { type: ConfigService },
    { type: MemberBus },
    { type: SpinnerService }
];
__decorate([
    Input('edi')
], EdiFormContainerComponent$1.prototype, "ediSetter", null);
__decorate([
    Input()
], EdiFormContainerComponent$1.prototype, "action", void 0);
__decorate([
    Input()
], EdiFormContainerComponent$1.prototype, "editEdi", void 0);
__decorate([
    Output()
], EdiFormContainerComponent$1.prototype, "closeEdiDialog", void 0);
__decorate([
    Output()
], EdiFormContainerComponent$1.prototype, "ediCRUD", void 0);
EdiFormContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-edi-form-container',
        template: `
    <lib-edi-form
      [action]="action"
      [edi]="editEdi"
      [documentTypes]="getAvailableDocumentTypes()"
      [documentStatus]="documentStatus"
      (ediCRUD)="ediCRUD.emit($event)"
      (closeEdiDialog)="closeDialog()"
    ></lib-edi-form>
  `
    })
], EdiFormContainerComponent$1);

let EdiFormComponent$1 = class EdiFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeEdiDialog = new EventEmitter();
        this.ediCRUD = new EventEmitter();
        this.documentTypes = [];
        this.documentStatus = [];
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set ediSetter(edi) {
        this.edi = edi;
        this.initializeForm(edi);
    }
    set documentTypeSetter(documentTypes) {
        this.documentTypes = documentTypes;
    }
    set documentStatusSetter(documentStatus) {
        this.documentStatus = documentStatus;
    }
    initializeForm(ediInput) {
        const edi = ediInput ? ediInput : {};
        this.ediForm = this.formBuilder.group({
            documentTypeKey: [(edi === null || edi === void 0 ? void 0 : edi.documentTypeKey) || 0, Validators.required],
            documentStatusKey: [(edi === null || edi === void 0 ? void 0 : edi.documentStatusKey) || 0, Validators.required],
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
        this.ediForm.reset();
    }
    save() {
        var _a, _b, _c, _d, _e;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.ediCRUD.emit({
            eventType,
            type: 'edi',
            typeKey: `${(_a = this.edi) === null || _a === void 0 ? void 0 : _a.accountRelationshipDocumentKey}`,
            payload: {
                [`${eventType}`]: {
                    documentTypeKey: (_c = (_b = this.ediForm) === null || _b === void 0 ? void 0 : _b.get('documentTypeKey')) === null || _c === void 0 ? void 0 : _c.value,
                    documentStatusKey: (_e = (_d = this.ediForm) === null || _d === void 0 ? void 0 : _d.get('documentStatusKey')) === null || _e === void 0 ? void 0 : _e.value,
                },
            },
        });
        this.closeDialog();
    }
};
EdiFormComponent$1.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], EdiFormComponent$1.prototype, "action", void 0);
__decorate([
    Input('edi')
], EdiFormComponent$1.prototype, "ediSetter", null);
__decorate([
    Input('documentTypes')
], EdiFormComponent$1.prototype, "documentTypeSetter", null);
__decorate([
    Input('documentStatus')
], EdiFormComponent$1.prototype, "documentStatusSetter", null);
__decorate([
    Output()
], EdiFormComponent$1.prototype, "closeEdiDialog", void 0);
__decorate([
    Output()
], EdiFormComponent$1.prototype, "ediCRUD", void 0);
EdiFormComponent$1 = __decorate([
    Component({
        selector: 'lib-edi-form',
        template: "<form class=\"vertical-flow\" [formGroup]=\"ediForm\" (ngSubmit)=\"save()\">\r\n  <div class=\"vertical-flow stacked-labels\">\r\n    <div>\r\n      <label for=\"documentType\">Type</label>\r\n      <p-dropdown\r\n        *ngIf=\"action !== 'view'; else docType\"\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentType\"\r\n        [options]=\"documentTypes\"\r\n        formControlName=\"documentTypeKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n      <ng-template #docType>\r\n        <input\r\n          pInputText\r\n          type=\"text\"\r\n          class=\"ui-inputtext\"\r\n          [value]=\"edi.documentType\"\r\n          [attr.disabled]=\"true\"\r\n        />\r\n      </ng-template>\r\n      <span class=\"feedback\">\r\n        <lib-control-message\r\n          [control]=\"ediForm.controls.documentTypeKey\"\r\n          [errorMsg]=\"requiredMsg.requiredMsg\"\r\n        ></lib-control-message>\r\n      </span>\r\n    </div>\r\n    <div>\r\n      <label for=\"documentStatus\">Status</label>\r\n      <p-dropdown\r\n        *ngIf=\"action !== 'view'; else docStatus\"\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentStatus\"\r\n        [options]=\"documentStatus\"\r\n        formControlName=\"documentStatusKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n      <ng-template #docStatus>\r\n        <input\r\n          pInputText\r\n          type=\"text\"\r\n          class=\"ui-inputtext\"\r\n          [value]=\"edi.documentStatus\"\r\n          [attr.disabled]=\"true\"\r\n        />\r\n      </ng-template>\r\n      <span class=\"feedback\">\r\n        <lib-control-message\r\n          [control]=\"ediForm.controls.documentStatusKey\"\r\n          [errorMsg]=\"requiredMsg.requiredMsg\"\r\n        ></lib-control-message>\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      [disabled]=\"ediForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], EdiFormComponent$1);

let EdiComponent$1 = class EdiComponent {
    constructor(confirmationService, memberBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.memberBus = memberBus;
        this.translocoService = translocoService;
        this.store = store;
        this.fetching = false;
        this.toolbarButtons = [];
        this.showEdiDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set ediSetter(edi) {
        this.data$ = of(edi);
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.subscriptions.push(this.memberBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'edi' && payload.result) {
                this.data$ = of(payload.data.accountRelationshipDocumentResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.translateLabels();
        this.columnsToDisplay = ['documentType', 'documentStatus'];
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showEdiDialog = true;
                this.editEdi = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showEdiDialog = true;
                this.editEdi = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showEdiDialog = true;
                this.editEdi = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    delete(selection = [], clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const accountRelationshipDocumentKeys = [];
                selection.forEach((accountRelationshipDocument) => accountRelationshipDocumentKeys.push(accountRelationshipDocument.accountRelationshipDocumentKey));
                const accountRelationshipDocumentKeysString = JSON.stringify(accountRelationshipDocumentKeys);
                this.memberBus.publish({
                    eventType: 'delete',
                    type: 'edi',
                    typeKey: accountRelationshipDocumentKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'documentType'),
                    },
                });
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'documentType',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters(term, pagination, [], 'documentType'),
        });
    }
    ediCRUD(data) {
        this.memberBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'documentType') }) }));
    }
    closeEdiDialog() {
        this.showEdiDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'documentType',
                    header: translate.TYPE,
                },
                {
                    field: 'documentStatus',
                    header: translate.STATUS,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
            add: toolKeys.MPP_MEMBER_MAINTENANCE,
            edit: toolKeys.MPP_MEMBER_MAINTENANCE,
            delete: toolKeys.MPP_MEMBER_MAINTENANCE,
        };
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
EdiComponent$1.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MemberBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('edi')
], EdiComponent$1.prototype, "ediSetter", null);
__decorate([
    Input()
], EdiComponent$1.prototype, "fetching", void 0);
EdiComponent$1 = __decorate([
    Component({
        selector: 'lib-edi',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"memberEDI\"\r\n      i18nSearchField=\"{{ 'PARTNERS.EDI_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [loading]=\"fetching\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [searchProperty]=\"'term'\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showEdiDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <lib-working-spinner-component></lib-working-spinner-component>\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.EDIT_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [editEdi]=\"editEdi\"\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (ediCRUD)=\"ediCRUD($event)\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.ADD_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (ediCRUD)=\"ediCRUD($event)\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.VIEW_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [editEdi]=\"editEdi\"\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], EdiComponent$1);

let FormsComponent$1 = class FormsComponent {
    constructor(accountService, store) {
        this.accountService = accountService;
        this.store = store;
        this.resultsSubmission = new EventEmitter();
        this.imageSrc = '';
        this.imageAlt = '';
        this.authorizedActions = {};
        this.isCompanyLogoPresent = false;
        this.enablePay = false;
        this.subscriptions = [];
    }
    set memberSetter(member) {
        this.member = member;
        this.displayLogo();
    }
    set configurationSetter(configuration) {
        this.configuration = configuration;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.store
            .pipe(select(selectors.marketplaces), tap((marketplaces) => {
            this.marketplaceKey = marketplaces.marketplace;
        }))
            .subscribe();
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            var _a;
            if (user) {
                this.accountKey = (_a = user.userInfo.AccountKey) === null || _a === void 0 ? void 0 : _a.toString();
            }
        }))
            .subscribe();
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(29)) {
                    this.enablePay = true;
                }
            }
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    displayLogo() {
        if (this.member &&
            this.member.details &&
            this.member.details.logo_AccountAssetKey !== null) {
            const accountAssetKey = Number(this.member.details.logo_AccountAssetKey);
            this.imageSrc =
                accountAssetKey > 0
                    ? this.accountService.getImageUrl(accountAssetKey, this.member.details.accountKey)
                    : '';
            this.isCompanyLogoPresent = accountAssetKey > 0 ? true : false;
        }
    }
    getPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
            edit: toolKeys.MPP_MEMBER_MAINTENANCE,
        };
    }
    paySubmit() {
        this.resultsSubmission.emit();
    }
};
FormsComponent$1.ctorParameters = () => [
    { type: AccountService },
    { type: Store }
];
__decorate([
    Input('member')
], FormsComponent$1.prototype, "memberSetter", null);
__decorate([
    Input('configuration')
], FormsComponent$1.prototype, "configurationSetter", null);
__decorate([
    Input()
], FormsComponent$1.prototype, "fetching", void 0);
__decorate([
    Input()
], FormsComponent$1.prototype, "updating", void 0);
__decorate([
    Output()
], FormsComponent$1.prototype, "resultsSubmission", void 0);
FormsComponent$1 = __decorate([
    Component({
        selector: 'lib-forms',
        template: "<div\r\n  *ngIf=\"authorizedActions?.view || authorizedActions?.edit\"\r\n  class=\"details-container\"\r\n>\r\n  <div>\r\n    <section>\r\n      <lib-header\r\n        [imageTemplate]=\"header_image\"\r\n        [titleTemplate]=\"header_title\"\r\n        [contentTemplate]=\"header_content\"\r\n      >\r\n        <ng-template #header_title>\r\n          <h2 class=\"header-card-title\">{{ 'MEMBER.MEMBER' | transloco }}</h2>\r\n        </ng-template>\r\n        <ng-template #header_image>\r\n          <ng-container *ngIf=\"isCompanyLogoPresent; else logoMissing\">\r\n            <div class=\"img-container header\">\r\n              <img class=\"target\" [src]=\"imageSrc\" />\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #logoMissing>\r\n            <div class=\"img-container header no-img\">\r\n              <span>\r\n                {{ 'COMPANY.LOGO_DEFAULT_MSG_1' | transloco }}<br />{{\r\n                  'COMPANY.LOGO_DEFAULT_MSG_2' | transloco\r\n                }}\r\n              </span>\r\n            </div>\r\n          </ng-template>\r\n        </ng-template>\r\n        <ng-template #header_content>\r\n          <div class=\"vertical-flow\">\r\n            <h4 class=\"content-title\">\r\n              <ng-container\r\n                *ngIf=\"member?.details?.dbaName?.length > 0; else legalName\"\r\n              >\r\n                {{ member?.details?.legalName }} (\r\n                {{ member?.details?.dbaName }} )\r\n              </ng-container>\r\n              <ng-template #legalName>\r\n                {{ member?.details?.legalName }}\r\n              </ng-template>\r\n            </h4>\r\n            <!-- <p>\r\n              {{ 'SUPPLIER.LBMXID' | transloco }}\r\n              {{ member?.details?.lbmxId }}\r\n            </p> -->\r\n          </div>\r\n        </ng-template>\r\n      </lib-header>\r\n    </section>\r\n  </div>\r\n  <div>\r\n    <section>\r\n      <p-tabView>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n          <lib-details\r\n            [details]=\"member?.details\"\r\n            [tags]=\"member?.tags\"\r\n            [configuration]=\"configuration\"\r\n            [permissions]=\"authorizedActions\"\r\n          ></lib-details>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n          <lib-contacts [contacts]=\"member?.contacts\"></lib-contacts>\r\n        </p-tabPanel>\r\n        <p-tabPanel\r\n          header=\"{{ 'SUPPLIER.TAB_BANKING' | transloco }}\"\r\n          disabled=\"true\"\r\n        >\r\n          <lib-banking [bankingInfo]=\"member?.bankingInfo\"></lib-banking>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_LOCATIONS' | transloco }}\">\r\n          <lib-locations [locations]=\"member?.locations\"></lib-locations\r\n        ></p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_EDI' | transloco }}\">\r\n          <lib-edi [edi]=\"member?.documents\"></lib-edi>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_NOTES' | transloco }}\">\r\n          <lib-notes [notes]=\"member?.notes\"></lib-notes\r\n        ></p-tabPanel>\r\n        <p-tabPanel\r\n          *ngIf=\"accountKey === marketplaceKey && enablePay\"\r\n          header=\"{{ 'SUPPLIER.TAB_PAY' | transloco }}\"\r\n        >\r\n          <lib-pay\r\n            (editPaySubmit)=\"paySubmit()\"\r\n            [pay]=\"member?.details\"\r\n          ></lib-pay\r\n        ></p-tabPanel>\r\n      </p-tabView>\r\n      <p-confirmDialog\r\n        [closeOnEscape]=\"false\"\r\n        [closable]=\"false\"\r\n      ></p-confirmDialog>\r\n    </section>\r\n  </div>\r\n</div>\r\n",
        styles: [".content-title{font-size:22px;display:block;margin:0 2em 0 0}"]
    })
], FormsComponent$1);

let HeaderComponent$1 = class HeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], HeaderComponent$1.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], HeaderComponent$1.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], HeaderComponent$1.prototype, "contentTemplate", void 0);
HeaderComponent$1 = __decorate([
    Component({
        selector: 'lib-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em;\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], HeaderComponent$1);

let LocationsComponent$2 = class LocationsComponent {
    constructor(translocoService, memberBus, store) {
        this.translocoService = translocoService;
        this.memberBus = memberBus;
        this.store = store;
        this.viewLocationsData = {};
        this.toolbarButtons = [];
        this.displayEditLocation = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set locationsSetter(locations) {
        this.locations = locations;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.memberBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'locations' && payload.result) {
                this.data$ = of(payload.data.locations);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ locations }) => locations));
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
            records: 250,
        };
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayEditLocation = true;
                this.viewLocationsData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.memberBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters('', {
                first: 0,
                rows: 25,
                sortField: 'LegalName',
                sortOrder: 1,
            }, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.memberBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters(term, pagination, [], 'legalName'),
        });
    }
    closeEditLocationDialog() {
        this.displayEditLocation = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxid',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                    required: true,
                },
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                },
                {
                    field: 'number',
                    header: translate.LOCATION_NUMBER,
                },
                {
                    field: 'country',
                    header: translate.COUNTRY,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                {
                    field: 'province',
                    header: translate.STATE_PROVINCE,
                },
                {
                    field: 'postalCode',
                    header: translate.ZIP_POSTAL_CODE,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    openViewLocation(location) {
        this.displayEditLocation = true;
        this.viewLocationsData = location;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
        };
    }
};
LocationsComponent$2.ctorParameters = () => [
    { type: TranslocoService },
    { type: MemberBus },
    { type: Store }
];
__decorate([
    Input('locations')
], LocationsComponent$2.prototype, "locationsSetter", null);
LocationsComponent$2 = __decorate([
    Component({
        selector: 'lib-locations',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"memberLocations\"\r\n      i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [loading]=\"fetching$ | async\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [searchProperty]=\"'term'\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewLocation($event)\"\r\n    ></lib-search-container>\r\n    <p-dialog\r\n      [(visible)]=\"displayEditLocation\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <h2 class=\"dialog-title\">\r\n        {{ 'SUPPLIER.VIEW_LOCATION' | transloco }}\r\n      </h2>\r\n      <lib-view-location\r\n        [location]=\"viewLocationsData\"\r\n        (closeEditLocationDialog)=\"closeEditLocationDialog()\"\r\n      ></lib-view-location>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], LocationsComponent$2);

let ViewLocationComponent$1 = class ViewLocationComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeEditLocationDialog = new EventEmitter();
    }
    set locationSetter(location) {
        this.initializeForm(location);
    }
    initializeForm(locationInput) {
        const location = locationInput || {};
        this.viewLocationForm = this.formBuilder.group({
            isaNumber: [{ value: location.isaNumber, disabled: true }],
            lbmxId: [{ value: location.lbmxid, disabled: true }],
            legalName: [{ value: location.legalName, disabled: true }],
            dbaName: [{ value: location.dbaName, disabled: true }],
            number: [{ value: location.number, disabled: true }],
            country: [{ value: location.country, disabled: true }],
            city: [{ value: location.city, disabled: true }],
            province: [{ value: location.province, disabled: true }],
            postalCode: [{ value: location.postalCode, disabled: true }],
            address1: [{ value: location.address1, disabled: true }],
            address2: [{ value: location.address2, disabled: true }],
        });
    }
    closeDialog() {
        this.closeEditLocationDialog.emit();
    }
};
ViewLocationComponent$1.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('location')
], ViewLocationComponent$1.prototype, "locationSetter", null);
__decorate([
    Output()
], ViewLocationComponent$1.prototype, "closeEditLocationDialog", void 0);
ViewLocationComponent$1 = __decorate([
    Component({
        selector: 'lib-view-location',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"viewLocationForm\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"legalName\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"dbaName\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"country\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address1\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address2\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"city\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"number\">{{ 'SUPPLIER.LOCATION_NUMBER' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"number\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"province\">{{ 'SUPPLIER.STATE_PROVINCE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"province\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"postalCode\">{{ 'SUPPLIER.ZIP_POSTAL_CODE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"postalCode\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ViewLocationComponent$1);

let NoteFormComponent$1 = class NoteFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeNoteDialog = new EventEmitter();
        this.notesCRUD = new EventEmitter();
        this.flagForFollowUpOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ];
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set noteSetter(note) {
        this.note = note;
        this.initializeForm(note);
    }
    initializeForm(noteInput) {
        const note = noteInput || {};
        this.noteForm = this.formBuilder.group({
            flagForFollowUp: [note.flagForFollowUp, Validators.required],
            message: [note.message, Validators.required],
        });
    }
    closeDialog() {
        this.closeNoteDialog.emit();
        this.noteForm.reset();
    }
    getFagForFollowUpOptions() {
        var _a;
        try {
            return (_a = this.flagForFollowUpOptions) === null || _a === void 0 ? void 0 : _a.find((option) => { var _a; return option.value === ((_a = this.note) === null || _a === void 0 ? void 0 : _a.flagForFollowUp); }).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        const accountRelationshipNoteKey = this.action === 'add' ? '' : `${this.note.accountRelationshipNoteKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.notesCRUD.emit({
            eventType,
            type: 'note',
            typeKey: accountRelationshipNoteKey,
            payload: { [`${eventType}`]: Object.assign(Object.assign({}, this.note), this.noteForm.value) },
        });
        this.closeDialog();
    }
};
NoteFormComponent$1.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], NoteFormComponent$1.prototype, "action", void 0);
__decorate([
    Input('note')
], NoteFormComponent$1.prototype, "noteSetter", null);
__decorate([
    Output()
], NoteFormComponent$1.prototype, "closeNoteDialog", void 0);
__decorate([
    Output()
], NoteFormComponent$1.prototype, "notesCRUD", void 0);
NoteFormComponent$1 = __decorate([
    Component({
        selector: 'lib-note-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"noteForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"flagForFollowUp\">{{\r\n      'SUPPLIER.FLAG_FOR_FOLLOW_UP' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else flagForFollowUp\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"province\"\r\n      [options]=\"flagForFollowUpOptions\"\r\n      formControlName=\"flagForFollowUp\"\r\n      filter=\"true\"\r\n      placeholder=\"Please Select a flag\"\r\n    ></p-dropdown>\r\n    <ng-template #flagForFollowUp>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getFagForFollowUpOptions()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <span class=\"feedback\">\r\n      <lib-control-message\r\n        [control]=\"noteForm.controls.flagForFollowUp\"\r\n        [errorMsg]=\"requiredMsg.requiredMsg\"\r\n      ></lib-control-message>\r\n    </span>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"message\">{{ 'SUPPLIER.MESSAGE' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else message\"\r\n      rows=\"5\"\r\n      autoresize=\"true\"\r\n      name=\"message\"\r\n      pInputTextarea\r\n      formControlName=\"message\"\r\n      class=\"ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #message>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"true\"\r\n        name=\"message\"\r\n        pInputTextarea\r\n        formControlName=\"message\"\r\n        class=\"ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n    <span class=\"feedback\">\r\n      <lib-control-message\r\n        [control]=\"noteForm.controls.message\"\r\n        [errorMsg]=\"requiredMsg.requiredMsg\"\r\n      ></lib-control-message>\r\n    </span>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"noteForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], NoteFormComponent$1);

let NotesComponent$1 = class NotesComponent {
    constructor(confirmationService, memberBus, translocoService, store, datePipe) {
        this.confirmationService = confirmationService;
        this.memberBus = memberBus;
        this.translocoService = translocoService;
        this.store = store;
        this.datePipe = datePipe;
        this.toolbarButtons = [];
        this.showNoteDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set notesSetter(notes) {
        this.notes = notes;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.memberBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'note' && payload.result) {
                this.data$ = of(payload.data.accountRelationshipNoteResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.memberBus.fetching$.pipe(map(({ note }) => note));
        this.columnsToDisplay = [
            'addedOn',
            'addedByName',
            'message',
            'flagForFollowUp',
            'modifiedOn',
            'modifiedByName',
        ];
        this.subscriptions.push(this.store.pipe(select(selectors.userProfile)).subscribe((res) => {
            var _a;
            this.dateFormat = (_a = res === null || res === void 0 ? void 0 : res.userInfo) === null || _a === void 0 ? void 0 : _a.DateTypeFormat;
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    deleteNote(notes, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                const accountRelationshipNoteKeys = [];
                notes.forEach((note) => accountRelationshipNoteKeys.push(note.accountRelationshipNoteKey));
                const accountRelationshipNoteKeysString = JSON.stringify(accountRelationshipNoteKeys);
                this.memberBus.publish({
                    eventType: 'delete',
                    type: 'note',
                    typeKey: accountRelationshipNoteKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'AddedOn'),
                    },
                });
                // TODO: Remove from Future Versions if Single Delete is Obsolete
                // notes.forEach((note) =>
                //   this.memberBus.publish({
                //     eventType: 'delete',
                //     type: 'note',
                //     typeKey: `${note.accountRelationshipNoteKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showNoteDialog = true;
                this.editNote = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showNoteDialog = true;
                this.editNote = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showNoteDialog = true;
                this.editNote = selection[0];
                break;
            case 'delete':
                const foo = this.deleteNote(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'AddedOn',
            sortOrder: -1,
        };
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.memberBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters(term, pagination, [], 'AddedOn', -1),
        });
    }
    notesCRUD(data) {
        this.memberBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'AddedOn', -1) }) }));
    }
    closeNoteDialog() {
        this.action = null;
        this.showNoteDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'message',
                    header: translate.MESSAGE,
                    formatter: ({ message }) => {
                        try {
                            return message.slice().length < 30
                                ? message
                                : `${message.slice(0, 30)}...`;
                        }
                        catch (error) {
                            return `${error}`;
                        }
                    },
                    link: (_) => ({
                        path: './',
                    }),
                    event: (note) => note,
                },
                {
                    field: 'addedOn',
                    header: translate.ADDED_ON,
                    required: true,
                    formatter: ({ addedOn }) => `${this.datePipe.transform(addedOn, this.dateFormat)}`,
                },
                {
                    field: 'addedByName',
                    header: translate.ADDED_BY,
                    formatter: ({ addedByName }) => `${addedByName ? addedByName : ''}`,
                },
                {
                    field: 'flagForFollowUp',
                    header: translate.FLAG_FOR_FOLLOW_UP,
                    formatter: (flag) => `${flag.flagForFollowUp ? 'Yes' : 'No'}`,
                },
                {
                    field: 'modifiedOn',
                    header: translate.MODIFIED_ON,
                    formatter: ({ modifiedOn }) => `${modifiedOn
                        ? this.datePipe.transform(modifiedOn, this.dateFormat)
                        : ''}`,
                },
                {
                    field: 'modifiedByName',
                    header: translate.MODIFIED_BY,
                    formatter: ({ modifiedByName }) => `${modifiedByName ? modifiedByName : ''}`,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    openViewNote(note) {
        this.action = 'view';
        this.showNoteDialog = true;
        this.editNote = note;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_MEMBER,
            add: toolKeys.MPP_MEMBER_MAINTENANCE,
            edit: toolKeys.MPP_MEMBER_MAINTENANCE,
            delete: toolKeys.MPP_MEMBER_MAINTENANCE,
        };
    }
};
NotesComponent$1.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: MemberBus },
    { type: TranslocoService },
    { type: Store },
    { type: DatePipe }
];
__decorate([
    Input('notes')
], NotesComponent$1.prototype, "notesSetter", null);
NotesComponent$1 = __decorate([
    Component({
        selector: 'lib-notes',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"memberNotes\"\r\n      i18nSearchField=\"{{ 'PARTNERS.NOTE_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching$ | async\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewNote($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showNoteDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.EDIT_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.ADD_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.VIEW_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], NotesComponent$1);

let PayComponent = class PayComponent {
    constructor(mppService, translocoService, toast, confirmationService, store) {
        this.mppService = mppService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.confirmationService = confirmationService;
        this.store = store;
        this.editPaySubmit = new EventEmitter();
        this.showEditDialog = false;
        this.templateTypes = TemplateTypes;
        this.baseUrl = `${this.mppService.getConfig().account}`;
        this.enableEdit = true;
    }
    set paySetter(pay) {
        this.details = pay;
        this.editPayWizardConfig = {
            endpoint: `wizard/member/${pay === null || pay === void 0 ? void 0 : pay.accountRelationshipKey}/pay-setup`,
            httpMethod: HttpMethod$1.GET,
            body: {},
        };
    }
    ngOnInit() {
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(18)) {
                    this.enableEdit = false;
                }
            }
        }))
            .subscribe();
    }
    openEditDialog() {
        this.showEditDialog = true;
    }
    closeEditDialog() {
        this.confirmationService.confirm({
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.showEditDialog = false;
            },
        });
    }
    submitEditPay(event) {
        this.showEditDialog = false;
        this.editPaySubmit.emit();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
PayComponent.ctorParameters = () => [
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: ConfirmationService },
    { type: Store }
];
__decorate([
    Input('pay')
], PayComponent.prototype, "paySetter", null);
__decorate([
    Output()
], PayComponent.prototype, "editPaySubmit", void 0);
PayComponent = __decorate([
    Component({
        selector: 'lib-pay',
        template: "<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button pButton type=\"button\" label=\"{{ 'ACTIONS.EDIT' | transloco }}\" class=\"ds tertiary small\"\r\n    (click)=\"openEditDialog()\" [disabled]=\"enableEdit\"></button>\r\n</div>\r\n\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <div>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.SUPPORTED_PAYMENT_METHODS' | transloco,\r\n            value: details?.paymentMethods\r\n          }\r\n        }\r\n      \"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.ACH_EFT_DELIVERY' | transloco,\r\n            value: details?.partnerEFTDeliveryType\r\n          }\r\n        }\r\n      \"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.START_DATE' | transloco,\r\n            value: details?.partnerStartDateFormatted\r\n          }\r\n        }\r\n      \"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.END_DATE' | transloco,\r\n            value: details?.partnerEndDateFormatted\r\n          }\r\n        }\r\n      \"></ng-container>\r\n  </div>\r\n\r\n  <ng-template #billingDetails let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">{{ value.label }}:</div>\r\n        <div>\r\n          <span> {{ value.value }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n\r\n<p-dialog *ngIf=\"showEditDialog\" [visible]=\"true\" [showHeader]=\"false\" [modal]=\"true\" position=\"center\"\r\n  [draggable]=\"false\" [resizable]=\"false\" [responsive]=\"true\" [focusOnShow]=\"false\" styleClass=\"lbmx-modal\">\r\n  <lui-wizard-v3 [baseUrl]=\"baseUrl\" [wizardConfig]=\"editPayWizardConfig\" (submit)=\"submitEditPay($event)\"\r\n    (cancel)=\"closeEditDialog()\">\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div class=\"error\" style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \">\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeEditDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>"
    })
], PayComponent);

let MemberModule = class MemberModule {
};
MemberModule = __decorate([
    NgModule({
        declarations: [
            AdvancedSearchComponent$2,
            DetailsComponent$3,
            MemberComponent,
            FormsComponent$1,
            ViewMembersComponent,
            HeaderComponent$1,
            ContactsComponent$3,
            LocationsComponent$2,
            ViewLocationComponent$1,
            BankingComponent$1,
            ViewBankingComponent$2,
            NotesComponent$1,
            FormsContainerComponent$1,
            NoteFormComponent$1,
            ContactFormComponent$3,
            ContactFormContainerComponent$3,
            EdiComponent$1,
            EdiFormContainerComponent$1,
            EdiFormComponent$1,
            PayComponent,
        ],
        imports: [
            CommonModule,
            AccordionModule,
            ButtonModule,
            CheckboxModule,
            ConfirmDialogModule,
            CalendarModule,
            DropdownModule,
            MultiSelectModule,
            ReactiveFormsModule,
            RouterModule,
            SearchContainerModule$1,
            TabViewModule,
            ToolbarModule,
            TranslocoModule,
            TreeTableModule,
            UtilsModule,
            DialogModule,
            ListboxModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            ProgressSpinnerModule$2,
            FormsModule,
            InputMaskModule,
            TreeModule,
            PhoneFormModule,
        ],
        providers: [ConfirmationService$1],
    })
], MemberModule);

const schemaDefinition$7 = (translate, isEditMode) => ({
    fields: {
        legalName: {
            type: 'text',
            label: translate['SUPPLIER_LEGAL_NAME'],
            disabled: true,
        },
        dbaName: {
            type: 'text',
            label: translate['SUPPLIER_DBA_NAME'],
            disabled: true,
        },
        accountLegalName: {
            type: 'text',
            label: translate['LOCATION_LEGAL_NAME'],
            disabled: true,
        },
        accountDbaName: {
            type: 'text',
            label: translate['LOCATION_DBA_NAME'],
            disabled: true,
        },
        crossReferenceNumber: {
            type: 'text',
            label: translate['MY_LOCATION_NUMBER'],
            disabled: !isEditMode,
            validations: [
                {
                    test: ({ crossReferenceNumber }) => {
                        return `${crossReferenceNumber}`.trim().length < 51;
                    },
                    message: translate['MY_LOCATION_NUMBER_VALIDATION'],
                },
            ],
        },
        documentTypes: {
            type: 'pCheckbox',
            label: translate['DOCUMENT_TYPES'],
            disabled: !isEditMode,
            options: [
                { label: translate['INVOICE'], value: 'invoice' },
                { label: translate['POA'], value: 'poa' },
                { label: translate['ASN'], value: 'asn' },
            ],
        },
        accountKey_Partner: {
            display: false,
        },
        accountLocationKey: {
            display: false,
        },
    },
});
function toFormValues$4(data) {
    const { legalName, dbaName, crossReferenceNumber, accountDbaName, accountLegalName, invoice, asn, poa, accountLocationKey, accountKey_Partner, } = data;
    const docTypes = [
        { type: 'invoice', value: invoice },
        { type: 'asn', value: asn },
        { type: 'poa', value: poa },
    ]
        .map(({ type, value }) => (value ? type : ''))
        .filter((item) => item !== '');
    return {
        legalName,
        dbaName,
        crossReferenceNumber,
        accountDbaName,
        accountLegalName,
        documentTypes: docTypes,
        accountLocationKey,
        accountKey_Partner,
    };
}
function fromFormValues$4(data) {
    const { documentTypes, legalName, dbaName, accountDbaName, accountLegalName } = data, rest = __rest(data, ["documentTypes", "legalName", "dbaName", "accountDbaName", "accountLegalName"]);
    return Object.assign(Object.assign({}, rest), { asn: documentTypes.includes('asn'), poa: documentTypes.includes('poa'), invoice: documentTypes.includes('invoice') });
}

let EditComponent$1 = class EditComponent {
    constructor(formGenerator) {
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.submitDialog = new EventEmitter();
        this.state = {};
    }
    set dataSetter(data) {
        if (data) {
            this.data = toFormValues$4(data);
        }
    }
    ngOnInit() {
        this.form = this.formGenerator.init(schemaDefinition$7(this.translate, this.isEditMode), this.data);
    }
    save() {
        this.submitDialog.emit(fromFormValues$4(this.form.values));
    }
    close() {
        this.closeDialog.emit();
    }
};
EditComponent$1.ctorParameters = () => [
    { type: GenerateFormService }
];
__decorate([
    Input('data')
], EditComponent$1.prototype, "dataSetter", null);
__decorate([
    Input()
], EditComponent$1.prototype, "translate", void 0);
__decorate([
    Input()
], EditComponent$1.prototype, "isEditMode", void 0);
__decorate([
    Output()
], EditComponent$1.prototype, "closeDialog", void 0);
__decorate([
    Output()
], EditComponent$1.prototype, "submitDialog", void 0);
EditComponent$1 = __decorate([
    Component({
        selector: 'lib-edit',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'SUPPLIER.SUPPLIER_CROSS_REFERENCE' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 1em\">\r\n    <ng-container *ngIf=\"isEditMode; else viewMode\">\r\n      <button pButton type=\"button\" label=\"{{ 'ACTIONS.CANCEL' | transloco }}\" class=\"ds secondary\"\r\n        (click)=\"close()\"></button>\r\n      <button pButton type=\"button\" label=\"{{ 'ACTIONS.SAVE' | transloco }}\" class=\"ds\" (click)=\"save()\"\r\n        [disabled]=\"!form?.valid\" style=\"flex-grow: 1\"></button>\r\n\r\n    </ng-container>\r\n    <ng-template #viewMode>\r\n      <button pButton type=\"button\" label=\"{{ 'ACTIONS.CLOSE' | transloco }}\" class=\"ds secondary\" style=\"flex-grow: 1\"\r\n        (click)=\"close()\"></button>\r\n    </ng-template>\r\n  </div>\r\n</div>\r\n",
        changeDetection: ChangeDetectionStrategy.OnPush
    })
], EditComponent$1);

let SupplierCrossReferencesModule = class SupplierCrossReferencesModule {
};
SupplierCrossReferencesModule = __decorate([
    NgModule({
        declarations: [
            ViewSuppliersCrossReferencesComponent,
            SupplierCrossReferencesComponent,
            EditComponent$1,
        ],
        imports: [
            CommonModule,
            DialogModule$1,
            RouterModule,
            SearchContainerModule$1,
            SearchContainerLoaderModule,
            TranslocoModule,
            PerFormPrimengModule,
            ButtonModule$2,
            ProgressSpinnerModule$2,
            UtilsModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
    })
], SupplierCrossReferencesModule);

let AdvancedSearchComponent$3 = class AdvancedSearchComponent {
    constructor(accountRelationship) {
        this.accountRelationship = accountRelationship;
        this.setFilterEvent = new EventEmitter();
        this.appliedIcon = 'assets/images/filter-on.png';
        this.dateJoinedFrom = null;
        this.dateJoinedTo = null;
        this.activeStatus = true;
        this.inactiveStatus = false;
        this.centralBill = false;
        this.directBill = false;
        this.testInvoiceStatus = false;
        this.prodInvoiceStatus = false;
        this.testPurchaseOrderStatus = false;
        this.prodPurchaseOrderStatus = false;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.accountRelationship
            .getSearchFilters('supplier')
            .pipe(tap((filters) => {
            this.supplierCategories = filters.categories;
        }))
            .subscribe());
        this.dateType = this.accountRelationship.getUserDateFormat();
        this.subscriptions.push(timer(0).subscribe(() => {
            this.handleAdvancedSearch();
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    handleAdvancedSearch() {
        const filters = this.getAppliedFilters();
        this.filtersEvent(filters);
    }
    getAppliedFilters() {
        let filters = [];
        // status filters
        filters = [
            ...filters,
            // status filters
            ...(!this.activeStatus && !this.inactiveStatus
                ? []
                : this.activeStatus && this.inactiveStatus
                    ? [
                        {
                            field: 'Status',
                            operator: 'eq',
                            values: ['Active', 'Inactive'],
                        },
                    ]
                    : this.activeStatus
                        ? [
                            {
                                field: 'Status',
                                operator: 'eq',
                                values: ['Active'],
                            },
                        ]
                        : [
                            {
                                field: 'Status',
                                operator: 'eq',
                                values: ['Inactive'],
                            },
                        ]),
            // category filters
            ...(this.selectedCategories && this.selectedCategories.length > 0
                ? [
                    {
                        field: 'CategoryKey',
                        operator: 'eq',
                        values: [...`${this.selectedCategories}`.split(',')],
                    },
                ]
                : []),
            // billing type filters
            ...(!this.centralBill && !this.directBill
                ? []
                : this.centralBill && this.directBill
                    ? [
                        {
                            field: 'BillingTypeKey',
                            operator: 'eq',
                            values: ['1', '2'],
                        },
                    ]
                    : this.centralBill
                        ? [
                            {
                                field: 'BillingTypeKey',
                                operator: 'eq',
                                values: ['1'],
                            },
                        ]
                        : [
                            {
                                field: 'BillingTypeKey',
                                operator: 'eq',
                                values: ['2'],
                            },
                        ]),
            // date joined filters
            ...(!this.dateJoinedFrom && !this.dateJoinedTo
                ? []
                : this.dateJoinedFrom && this.dateJoinedTo
                    ? [
                        {
                            field: 'AcceptedOn',
                            operator: 'gte',
                            values: [this.dateJoinedFrom],
                        },
                        {
                            field: 'AcceptedOn',
                            operator: 'lte',
                            values: [this.dateJoinedTo],
                        },
                    ]
                    : this.dateJoinedFrom
                        ? [
                            {
                                field: 'AcceptedOn',
                                operator: 'gte',
                                values: [this.dateJoinedFrom],
                            },
                        ]
                        : [
                            {
                                field: 'AcceptedOn',
                                operator: 'lte',
                                values: [this.dateJoinedTo],
                            },
                        ]),
            // Invoice Types and Status Filters
            ...(this.testInvoiceStatus || this.prodInvoiceStatus
                ? [
                    {
                        field: 'InvoiceStatusKey',
                        operator: 'eq',
                        values: [
                            ...(this.testInvoiceStatus ? ['1'] : []),
                            ...(this.prodInvoiceStatus ? ['2'] : []),
                        ],
                    },
                ]
                : []),
            // PO Types and Status Filters
            ...(this.testPurchaseOrderStatus || this.prodPurchaseOrderStatus
                ? [
                    {
                        field: 'POStatusKey',
                        operator: 'eq',
                        values: [
                            ...(this.testPurchaseOrderStatus ? ['1'] : []),
                            ...(this.prodPurchaseOrderStatus ? ['2'] : []),
                        ],
                    },
                ]
                : []),
        ];
        return filters;
    }
    handleClear() {
        this.selectedCategories = [];
        this.dateJoinedFrom = this.dateJoinedTo = null;
        this.inactiveStatus = this.activeStatus = false;
        this.centralBill = this.directBill = false;
        this.testInvoiceStatus = this.prodInvoiceStatus = false;
        this.prodPurchaseOrderStatus = this.testPurchaseOrderStatus = false;
        this.filtersEvent([]);
    }
    getValidDate($event, type) {
        if (type === 'From') {
            this.dateJoinedFrom = $event;
        }
        else {
            this.dateJoinedTo = $event;
        }
    }
    filtersEvent(filters) {
        this.setFilterEvent.emit({
            filters,
            options: { search: true },
        });
    }
};
AdvancedSearchComponent$3.ctorParameters = () => [
    { type: AccountRelationshipService }
];
__decorate([
    Output()
], AdvancedSearchComponent$3.prototype, "setFilterEvent", void 0);
AdvancedSearchComponent$3 = __decorate([
    Component({
        selector: 'lib-advanced-search',
        template: "<div class=\"vertical-flow advanced-search\">\r\n  <div class=\"horizontal-fixed space-between-075\">\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n      (click)=\"handleClear()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n      (click)=\"handleAdvancedSearch()\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"space-before-100\">\r\n    <p-accordion\r\n      styleClass=\"advancedSearchTabHeader\"\r\n      expandIcon=\"pi pi-caret-right\"\r\n      collapseIcon=\"pi pi-caret-down\"\r\n      [multiple]=\"true\"\r\n    >\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.ACTIVE_INACTIVE' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"activeStatus || inactiveStatus\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.ACTIVE' | transloco }}\"\r\n              [(ngModel)]=\"activeStatus\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.INACTIVE' | transloco }}\"\r\n              [(ngModel)]=\"inactiveStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab *ngIf=\"supplierCategories?.length\">\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.CATEGORY' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"selectedCategories?.length\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div\r\n            *ngFor=\"let supCategory of supplierCategories; let i = index\"\r\n            class=\"vertical-flow\"\r\n          >\r\n            <p-checkbox\r\n              [ngClass]=\"i > 0 ? 'space-before-075' : ''\"\r\n              [label]=\"supCategory.name\"\r\n              [name]=\"supplierCategory\"\r\n              [value]=\"supCategory.tagKey\"\r\n              [(ngModel)]=\"selectedCategories\"\r\n            ></p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.BILLING_TYPE' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"centralBill || directBill\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              label=\"{{ 'SUPPLIER.CENTRAL_BILL' | transloco }}\"\r\n              binary=\"true\"\r\n              [(ngModel)]=\"centralBill\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.DIRECT_BILL' | transloco }}\"\r\n              [(ngModel)]=\"directBill\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.DATE_JOINED' | transloco }}\r\n              </div>\r\n              <div class=\"facet-icon\" *ngIf=\"dateJoinedFrom || dateJoinedTo\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow space-between-075 input-filter\">\r\n            <div>{{ 'ADVANCED_SEARCH.RANGE' | transloco }}</div>\r\n            <div>\r\n              <p-calendar\r\n                [showIcon]=\"true\"\r\n                [dateFormat]=\"dateType.primeNgFormat\"\r\n                [placeholder]=\"dateType.description\"\r\n                [(ngModel)]=\"dateJoinedFrom\"\r\n                [maxDate]=\"dateJoinedTo\"\r\n                appendTo=\"body\"\r\n                (onSelect)=\"getValidDate($event, 'From')\"\r\n              ></p-calendar>\r\n            </div>\r\n\r\n            <div>\r\n              <p-calendar\r\n                [dateFormat]=\"dateType.primeNgFormat\"\r\n                [placeholder]=\"dateType.description\"\r\n                [(ngModel)]=\"dateJoinedTo\"\r\n                [showIcon]=\"true\"\r\n                [minDate]=\"dateJoinedFrom\"\r\n                appendTo=\"body\"\r\n                (onSelect)=\"getValidDate($event, 'To')\"\r\n              ></p-calendar>\r\n            </div>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.INVOICE_STATUS' | transloco }}\r\n              </div>\r\n              <div\r\n                class=\"facet-icon\"\r\n                *ngIf=\"testInvoiceStatus || prodInvoiceStatus\"\r\n              >\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.TEST' | transloco }}\"\r\n              [(ngModel)]=\"testInvoiceStatus\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.PRODUCTION' | transloco }}\"\r\n              [(ngModel)]=\"prodInvoiceStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'SUPPLIER.PURCHASE_ORDER_STATUS' | transloco }}\r\n              </div>\r\n              <div\r\n                class=\"facet-icon\"\r\n                *ngIf=\"testPurchaseOrderStatus || prodPurchaseOrderStatus\"\r\n              >\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.TEST' | transloco }}\"\r\n              [(ngModel)]=\"testPurchaseOrderStatus\"\r\n            >\r\n            </p-checkbox>\r\n            <p-checkbox\r\n              class=\"space-before-075\"\r\n              binary=\"true\"\r\n              label=\"{{ 'SUPPLIER.PRODUCTION' | transloco }}\"\r\n              [(ngModel)]=\"prodPurchaseOrderStatus\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n      </div>\r\n    </p-accordion>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], AdvancedSearchComponent$3);

let BankingComponent$2 = class BankingComponent {
    constructor(translocoService, store) {
        this.translocoService = translocoService;
        this.store = store;
        this.viewBankingInfo = {};
        this.displayViewBanking = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set bankingInfoSetter(bankingInfos) {
        this.data$ = of(bankingInfos);
        this.bankingInfo = bankingInfos;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.paging = {
            page: { first: 20, rows: 20 },
            records: 300,
        };
        this.columnsToDisplay = ['contactName', 'contactEmail'];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayViewBanking = true;
                this.viewBankingInfo = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.search();
    }
    search({ filters: { contactName } } = { filters: { contactName: '.*' } }) {
        const regex = new RegExp(contactName, 'i');
        this.data$ = of(this.bankingInfo.filter((bankingInfo) => bankingInfo.contactName.match(regex)));
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactName',
                    header: translate.VIEW_BANKING_CONTACT_NAME,
                },
                {
                    field: 'contactEmail',
                    header: translate.VIEW_BANKING_CONTACT_EMAIL,
                },
                {
                    field: 'externalAccountName',
                    header: translate.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'internalAccountName',
                    header: translate.VIEW_BANKING_INTERNAL_ACCOUNT_NAME,
                },
                {
                    field: 'accountNumber',
                    header: translate.VIEW_BANKING_ACCOUNT_NUMBER,
                },
                {
                    field: 'routingNumber',
                    header: translate.VIEW_BANKING_ROUTING_NUMBER,
                },
                {
                    field: 'federalTaxID',
                    header: translate.VIEW_BANKING_FEDERAL_TAX_ID,
                },
                {
                    field: 'identificationNumber',
                    header: translate.VIEW_BANKING_IDENTIFICATION_NUMBER,
                },
                {
                    field: 'traceNumber',
                    header: translate.VIEW_BANKING_TRACE_NUMBER,
                },
                {
                    field: 'sequenceNumber',
                    header: translate.VIEW_BANKING_SEQUENCE_NUMBER,
                },
                {
                    field: 'originName',
                    header: translate.VIEW_BANKING_ORIGIN_NAME,
                },
                {
                    field: 'bankName',
                    header: translate.VIEW_BANKING_BANK_NAME,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
    closeViewBankingDialog() {
        this.displayViewBanking = false;
    }
};
BankingComponent$2.ctorParameters = () => [
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('bankingInfo')
], BankingComponent$2.prototype, "bankingInfoSetter", null);
BankingComponent$2 = __decorate([
    Component({
        selector: 'lib-banking',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"supplierBanking\"\r\n      i18nSearchField=\"{{ 'PARTNERS.BANKING_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [searchProperty]=\"'contactName'\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n    ></lib-search-container>\r\n    <p-dialog\r\n      [modal]=\"true\"\r\n      position=\"center\"\r\n      [(visible)]=\"displayViewBanking\"\r\n      [showHeader]=\"false\"\r\n    >\r\n      <h2 class=\"dialog-title\">\r\n        {{ 'SUPPLIER.VIEW_BANKING' | transloco }}\r\n      </h2>\r\n      <lib-view-banking\r\n        [bankingInfo]=\"viewBankingInfo\"\r\n        (closeViewBankingDialog)=\"closeViewBankingDialog()\"\r\n      ></lib-view-banking>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], BankingComponent$2);

let ViewBankingComponent$3 = class ViewBankingComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeViewBankingDialog = new EventEmitter();
    }
    set bankingInfoSetter(bankingInfo) {
        this.initializeForm(bankingInfo);
    }
    initializeForm(bankingInfoInput) {
        const bankingInfo = bankingInfoInput || {};
        this.editBankingForm = this.formBuilder.group({
            contactName: [{ value: bankingInfo.contactName, disabled: true }],
            contactEmail: [{ value: bankingInfo.contactEmail, disabled: true }],
            accountNumber: [{ value: bankingInfo.accountNumber, disabled: true }],
            externalAccountName: [
                { value: bankingInfo.externalAccountName, disabled: true },
            ],
            internalAccountName: [
                { value: bankingInfo.internalAccountName, disabled: true },
            ],
            routingNumber: [{ value: bankingInfo.routingNumber, disabled: true }],
            federalTaxID: [{ value: bankingInfo.federalTaxID, disabled: true }],
            identificationNumber: [
                { value: bankingInfo.identificationNumber, disabled: true },
            ],
            traceNumber: [{ value: bankingInfo.traceNumber, disabled: true }],
            sequenceNumber: [{ value: bankingInfo.sequenceNumber, disabled: true }],
            originName: [{ value: bankingInfo.originName, disabled: true }],
            bankName: [{ value: bankingInfo.bankName, disabled: true }],
        });
    }
    closeDialog() {
        this.closeViewBankingDialog.emit();
        this.editBankingForm.reset();
    }
};
ViewBankingComponent$3.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('bankingInfo')
], ViewBankingComponent$3.prototype, "bankingInfoSetter", null);
__decorate([
    Output()
], ViewBankingComponent$3.prototype, "closeViewBankingDialog", void 0);
ViewBankingComponent$3 = __decorate([
    Component({
        selector: 'lib-view-banking',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"editBankingForm\"\r\n>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactName\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"contactEmail\">{{\r\n        'SUPPLIER.VIEW_BANKING_CONTACT_EMAIL' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"contactEmail\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"accountNumber\">{{\r\n      'SUPPLIER.VIEW_BANKING_ACCOUNT_NUMBER' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"accountNumber\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"externalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_EXTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"externalAccountName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"internalAccountName\">{{\r\n        'SUPPLIER.VIEW_BANKING_INTERNAL_ACCOUNT_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"internalAccountName\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"routingNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_ROUTING_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"routingNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"federalTaxID\">{{\r\n        'SUPPLIER.VIEW_BANKING_FEDERAL_TAX_ID' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"federalTaxID\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"identificationNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_IDENTIFICATION_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"identificationNumber\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"traceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_TRACE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"traceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-100\">\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"originName\">{{\r\n        'SUPPLIER.VIEW_BANKING_ORIGIN_NAME' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"originName\"\r\n      />\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <label for=\"sequenceNumber\">{{\r\n        'SUPPLIER.VIEW_BANKING_SEQUENCE_NUMBER' | transloco\r\n      }}</label>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        formControlName=\"sequenceNumber\"\r\n      />\r\n    </div>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"bankName\">{{\r\n      'SUPPLIER.VIEW_BANKING_BANK_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"bankName\"\r\n    />\r\n  </div>\r\n  <button\r\n    pButton\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n    class=\"ds secondary\"\r\n    autowidth=\"false\"\r\n    (click)=\"closeDialog()\"\r\n  ></button>\r\n</form>\r\n",
        styles: [""]
    })
], ViewBankingComponent$3);

let ContactFormContainerComponent$4 = class ContactFormContainerComponent {
    constructor(config, accountService, supplierBus, spinner) {
        this.config = config;
        this.accountService = accountService;
        this.supplierBus = supplierBus;
        this.spinner = spinner;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.subscriptions = [];
    }
    set contactSetter(contact) {
        this.contact = contact;
    }
    ngOnInit() {
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ contact }) => contact));
        this.setFetching('contact', true);
        this.spinner.on();
        this.subscriptions.push(forkJoin([
            this.config.getContactRoles(),
            this.config.getPhoneTypes(),
            this.config.getCountries(),
            this.accountService.getAccount(),
        ])
            .pipe(tap(([roles, phoneTypes, countries, account]) => {
            this.contactRoles = roles.map((role) => {
                return {
                    label: role.description,
                    value: role.contactRoleKey,
                };
            });
            this.phoneTypes = phoneTypes.map((phoneType) => {
                return {
                    label: phoneType.description,
                    value: phoneType.phoneTypeKey,
                };
            });
            this.countries = countries
                .filter((country) => alpha3ToAlpha2(country === null || country === void 0 ? void 0 : country.countryCode) !==
                undefined)
                .map((country) => {
                return {
                    label: `${country.countryName} (${country.countryCode})`,
                    value: alpha3ToAlpha2(country.countryCode),
                };
            });
            this.account = account;
        }), finalize(() => {
            this.setFetching('contact', false);
            this.spinner.off();
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    setFetching(form, value) {
        this.supplierBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
};
ContactFormContainerComponent$4.ctorParameters = () => [
    { type: ConfigService },
    { type: AccountService },
    { type: SupplierBus },
    { type: SpinnerService }
];
__decorate([
    Input()
], ContactFormContainerComponent$4.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormContainerComponent$4.prototype, "contactSetter", null);
__decorate([
    Output()
], ContactFormContainerComponent$4.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$4.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormContainerComponent$4.prototype, "contactsCRUD", void 0);
ContactFormContainerComponent$4 = __decorate([
    Component({
        selector: 'lib-contact-form-container',
        template: `<lib-contact-form
    [action]="action"
    [account]="account"
    [countries]="countries"
    [contact]="contact"
    [contactRoles]="contactRoles"
    [phoneTypes]="phoneTypes"
    (closeContactDialog)="closeContactDialog.emit()"
    (deletePhones)="deletePhones.emit($event)"
    (contactsCRUD)="contactsCRUD.emit($event)"
  ></lib-contact-form>`
    })
], ContactFormContainerComponent$4);

let ContactFormComponent$4 = class ContactFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeContactDialog = new EventEmitter();
        this.deletePhones = new EventEmitter();
        this.contactsCRUD = new EventEmitter();
        this.controls = [
            'firstName',
            'lastName',
            'title',
            'email',
            'contactRoleKey',
            'notes',
        ];
        this.resetPhone = false;
        this.deletedPhones = [];
        this.phoneExtension = {
            phoneExtension: () => this.transloco.translate('VALIDATION_MESSAGE.PHONE_EXTENSION'),
        };
        this.emailError = {
            email: () => this.transloco.translate('VALIDATION_MESSAGE.EMAIL'),
        };
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set contactSetter(contact) {
        this.contact = contact;
        this.initializeForm(contact);
    }
    initializeForm(contactInput) {
        const contact = contactInput
            ? contactInput
            : {};
        this.contactForm = this.formBuilder.group({
            firstName: [contact.firstName, Validators.required],
            lastName: [contact.lastName, Validators.required],
            title: [contact.title, Validators.required],
            email: [
                contact.email,
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
                ],
            ],
            contactRoleKey: [contact.contactRoleKey || 1, Validators.required],
            notes: [contact.notes],
            phone: [contact === null || contact === void 0 ? void 0 : contact.phone, Validators.required],
        });
    }
    closeDialog() {
        this.resetContactForm();
        this.closeContactDialog.emit();
        this.deletedPhones = [];
    }
    deletePhone(deletedPhones) {
        this.deletedPhones = [...this.deletedPhones, deletedPhones];
    }
    getContactRole() {
        var _a;
        try {
            return (_a = this.contactRoles) === null || _a === void 0 ? void 0 : _a.find((contactRole) => contactRole.value === this.contact.contactRoleKey).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        if (this.deletedPhones && this.deletedPhones.length > 0) {
            this.deletedPhones.forEach((payload) => this.deletePhones.emit(payload));
        }
        const contactKey = this.action === 'add' ? '' : `${this.contact.contactKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.contactsCRUD.emit({
            eventType,
            type: 'contact',
            typeKey: contactKey,
            payload: {
                [`${eventType}`]: this.formatContactPayload(),
            },
        });
        this.closeDialog();
    }
    formatContactPayload() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const phones = ((_c = (_b = (_a = this.contactForm) === null || _a === void 0 ? void 0 : _a.get('phone')) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.phone) ? (_f = (_e = (_d = this.contactForm) === null || _d === void 0 ? void 0 : _d.get('phone')) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.phone : (_h = (_g = this.contactForm) === null || _g === void 0 ? void 0 : _g.get('phone')) === null || _h === void 0 ? void 0 : _h.value;
        return Object.assign(Object.assign(Object.assign({}, this.contact), this.contactForm.value), { phone: phones.map((phone) => {
                return Object.assign(Object.assign({}, phone), { contactPhoneKey: (phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey) !== null
                        ? Number(phone === null || phone === void 0 ? void 0 : phone.contactPhoneKey)
                        : 0, phoneTypeKey: (phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) !== null ? Number(phone === null || phone === void 0 ? void 0 : phone.phoneTypeKey) : 1, phoneNumber: this.formatPhoneForSave(phone), phoneCountryCode: phone === null || phone === void 0 ? void 0 : phone.phoneCountryCode });
            }) });
    }
    formatPhoneForSave(phone) {
        try {
            return parsePhoneNumber(phone.phoneNumber, phone.phoneCountryCode).format('E.164');
        }
        catch (_a) {
            return phone.phoneNumber;
        }
    }
    resetContactForm() {
        this.resetPhone = true;
        this.controls.forEach((control) => this.contactForm.get(control).setValue(''));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
ContactFormComponent$4.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], ContactFormComponent$4.prototype, "action", void 0);
__decorate([
    Input('contact')
], ContactFormComponent$4.prototype, "contactSetter", null);
__decorate([
    Input()
], ContactFormComponent$4.prototype, "account", void 0);
__decorate([
    Input()
], ContactFormComponent$4.prototype, "contactRoles", void 0);
__decorate([
    Input()
], ContactFormComponent$4.prototype, "phoneTypes", void 0);
__decorate([
    Input()
], ContactFormComponent$4.prototype, "countries", void 0);
__decorate([
    Output()
], ContactFormComponent$4.prototype, "closeContactDialog", void 0);
__decorate([
    Output()
], ContactFormComponent$4.prototype, "deletePhones", void 0);
__decorate([
    Output()
], ContactFormComponent$4.prototype, "contactsCRUD", void 0);
ContactFormComponent$4 = __decorate([
    Component({
        selector: 'lib-contact-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"contactForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"firstName\">{{\r\n      'SUPPLIER.CONTACT_FIRST_NAME' | transloco\r\n    }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else firstName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"firstName\"\r\n    />\r\n    <ng-template #firstName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.firstName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.firstName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"lastName\">{{ 'SUPPLIER.CONTACT_LAST_NAME' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else lastName\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"lastName\"\r\n    />\r\n    <ng-template #lastName>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.lastName\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.lastName\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"title\">{{ 'SUPPLIER.CONTACT_TITLE' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else title\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"title\"\r\n    />\r\n    <ng-template #title>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.title\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.title\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <lib-phone-form\r\n    [countries]=\"countries\"\r\n    [defaultCountry]=\"account?.details?.country\"\r\n    [phoneTypes]=\"phoneTypes\"\r\n    [resetPhone]=\"resetPhone\"\r\n    [viewOnly]=\"action === 'view'\"\r\n    (deletedPhone)=\"deletePhone($event)\"\r\n    formControlName=\"phone\"\r\n  ></lib-phone-form>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"email\">{{ 'SUPPLIER.CONTACT_EMAIL' | transloco }}</label>\r\n    <input\r\n      *ngIf=\"action !== 'view'; else email\"\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"email\"\r\n    />\r\n    <ng-template #email>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"contact?.email\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.email\"\r\n      [errorMsg]=\"emailError.email\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"contactRoleKey\">{{\r\n      'SUPPLIER.CONTACT_ROLE' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else role\"\r\n      placeholder=\"{{ 'SUPPLIER.CONTACT_SELECT_ROLE' | transloco }}\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"contactRoleKey\"\r\n      [options]=\"contactRoles\"\r\n      formControlName=\"contactRoleKey\"\r\n      filter=\"true\"\r\n    ></p-dropdown>\r\n    <ng-template #role>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getContactRole()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <lib-control-message\r\n      [control]=\"contactForm?.controls?.role\"\r\n      [errorMsg]=\"requiredMsg.requiredMsg\"\r\n    ></lib-control-message>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"notes\">{{ 'SUPPLIER.CONTACT_NOTES' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else notes\"\r\n      rows=\"5\"\r\n      autoresize=\"false\"\r\n      name=\"notes\"\r\n      pInputTextarea\r\n      formControlName=\"notes\"\r\n      class=\"width-100 ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #notes>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"false\"\r\n        name=\"notes\"\r\n        pInputTextarea\r\n        formControlName=\"notes\"\r\n        class=\"width-100 ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"contactForm?.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ContactFormComponent$4);

let ContactsComponent$4 = class ContactsComponent {
    constructor(confirmationService, supplierBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.supplierBus = supplierBus;
        this.translocoService = translocoService;
        this.store = store;
        this.toolbarButtons = [];
        this.showContactDialog = false;
        this.columnsAvailable = false;
        this.fetching = false;
        this.subscriptions = [];
        this.authorizedActions = {};
        this.action = null;
    }
    set contactsSetter(contacts) {
        this.contacts = contacts;
    }
    set contactRolesSetter(contactsRoles) {
        this.contactRoles = contactsRoles;
    }
    set phoneTypesSetter(phoneTypes) {
        this.phoneTypes = phoneTypes;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.supplierBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'contact' && payload.result) {
                this.data$ = of(this.transformContactPhoneForSC(payload.data.accountRelationshipContactResponse));
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ contact }) => (this.fetching = contact)));
        this.columnsToDisplay = [
            'firstName',
            'workPhone',
            'mobilePhone',
            'otherPhone',
            'email',
            'contactRole',
            'title',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    delete(contacts, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const contactKeys = [];
                contacts.forEach((contactInfo) => contactKeys.push(contactInfo.contactKey));
                const contactKeysString = JSON.stringify(contactKeys);
                this.supplierBus.publish({
                    eventType: 'delete',
                    type: 'contact',
                    typeKey: contactKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'firstName'),
                    },
                });
                // TODO: Remove from Future Versions if Single Delete is Obsolete
                // contacts.forEach((contact) =>
                //   this.supplierBus.publish({
                //     eventType: 'delete',
                //     type: 'contact',
                //     typeKey: `${contact.contactKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showContactDialog = true;
                this.editContactData = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showContactDialog = true;
                this.editContactData = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'firstName',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'contact',
            payload: searchFilters(term, pagination, [], 'firstName'),
        });
    }
    deletePhones(payload) {
        this.supplierBus.publish({
            eventType: 'delete',
            type: 'contactPhone',
            payload: {
                delete: payload,
                search: searchFilters('', this.prevPagination, [], 'firstName'),
            },
        });
    }
    contactsCRUD(data) {
        this.supplierBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'firstName') }) }));
    }
    closeContactDialog() {
        this.showContactDialog = false;
        this.action = null;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'contactRole',
                    header: translate.CONTACT_ROLE,
                    formatter: ({ contactRoleKey }) => `${roles[contactRoleKey]}`,
                },
                {
                    field: 'firstName',
                    header: translate.FULL_NAME,
                    formatter: ({ firstName, lastName }) => `${firstName} ${lastName}`,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (contact) => contact,
                    required: true,
                },
                {
                    field: 'workPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.WORK_PHONE}`,
                    formatter: ({ workPhone }) => {
                        var _a;
                        return `${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber) || ''} ${((_a = workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'mobilePhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.MOBILE_PHONE}`,
                    formatter: ({ mobilePhone }) => {
                        var _a;
                        return `${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber) || ''} ${((_a = mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'otherPhone',
                    header: `${translate.PHONE_NUMBER}\n${translate.OTHER_PHONE}`,
                    formatter: ({ otherPhone }) => {
                        var _a;
                        return `${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber) || ''} ${((_a = otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'x' : ''} ${(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneExtension) || ''}`;
                    },
                },
                {
                    field: 'title',
                    header: translate.TITLE,
                },
                {
                    field: 'email',
                    header: translate.EMAIL,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    formatPhoneNumber(phoneNumber, countryCode) {
        try {
            return parsePhoneNumber(phoneNumber, alpha3ToAlpha2(countryCode)).formatInternational();
        }
        catch (_a) {
            return phoneNumber;
        }
    }
    transformContactPhoneForSC(contacts) {
        return contacts === null || contacts === void 0 ? void 0 : contacts.map((contact) => {
            const mobilePhone = this.findPhone(contact, 1);
            const otherPhone = this.findPhone(contact, 2);
            const workPhone = this.findPhone(contact, 3);
            return Object.assign(Object.assign({}, contact), { mobilePhone: Object.assign(Object.assign({}, mobilePhone), { phoneNumber: this.formatPhoneNumber(mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneNumber, mobilePhone === null || mobilePhone === void 0 ? void 0 : mobilePhone.phoneCountryCode) }), otherPhone: Object.assign(Object.assign({}, otherPhone), { phoneNumber: this.formatPhoneNumber(otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneNumber, otherPhone === null || otherPhone === void 0 ? void 0 : otherPhone.phoneCountryCode) }), workPhone: Object.assign(Object.assign({}, workPhone), { phoneNumber: this.formatPhoneNumber(workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneNumber, workPhone === null || workPhone === void 0 ? void 0 : workPhone.phoneCountryCode) }) });
        });
    }
    findPhone(contact, phoneTypeKey) {
        try {
            return contact.phone.find((phn) => phn.phoneTypeKey === phoneTypeKey);
        }
        catch (_a) {
            return undefined;
        }
    }
    openViewContact(contact) {
        this.action = 'view';
        this.showContactDialog = true;
        this.editContactData = contact;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
            add: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            delete: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
ContactsComponent$4.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: SupplierBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('contacts')
], ContactsComponent$4.prototype, "contactsSetter", null);
__decorate([
    Input('contactRoles')
], ContactsComponent$4.prototype, "contactRolesSetter", null);
__decorate([
    Input('phoneTypes')
], ContactsComponent$4.prototype, "phoneTypesSetter", null);
ContactsComponent$4 = __decorate([
    Component({
        selector: 'lib-contacts',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"supplierContacts\"\r\n      i18nSearchField=\"{{ 'PARTNERS.CONTACT_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewContact($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showContactDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.EDIT_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (deletePhones)=\"deletePhones($event)\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.ADD_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (contactsCRUD)=\"contactsCRUD($event)\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'COMPANY.VIEW_CONTACT' | transloco }}\r\n        </h2>\r\n        <lib-contact-form-container\r\n          [action]=\"action\"\r\n          [contact]=\"editContactData\"\r\n          (closeContactDialog)=\"closeContactDialog()\"\r\n        >\r\n        </lib-contact-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], ContactsComponent$4);

let DetailsComponent$4 = class DetailsComponent {
    constructor(formBuilder, supplierBus, spinner, transloco, store) {
        this.formBuilder = formBuilder;
        this.supplierBus = supplierBus;
        this.spinner = spinner;
        this.transloco = transloco;
        this.store = store;
        this.defaultSelectItem = {
            value: null,
            label: this.transloco.translate('ACTIONS.SELECT'),
        };
        this.pattern = {
            pattern: () => this.transloco.translate('VALIDATION_MESSAGE.SUPPLIER_NUMBER'),
        };
        this.enableEditBtn = false;
        this.enableEdit = false;
        this.permissions = {};
    }
    set detailsSetter(details) {
        this.details = details;
        this.initializeForm();
    }
    set configurationSetter(configuration) {
        if (configuration) {
            configuration.categories.unshift({
                value: null,
                label: this.transloco.translate('ACTIONS.SELECT'),
            });
            configuration.regions.unshift({
                value: null,
                label: this.transloco.translate('ACTIONS.SELECT'),
            });
        }
        this.categories =
            configuration && configuration.categories ? configuration.categories : [];
        this.regions =
            configuration && configuration.regions ? configuration.regions : [];
    }
    set tagsSetter(tags) {
        this.supplierForm.controls.category.setValue(tags && tags.category ? tags.category.value : this.defaultSelectItem.value);
        this.supplierForm.controls.region.setValue(tags && tags.region ? tags.region.value : this.defaultSelectItem.value);
    }
    set permissionsSetter(permissions) {
        this.permissions = permissions;
    }
    ngOnInit() {
        this.supplierBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'details') {
                payload.error === 3
                    ? (this.enableEdit = true)
                    : (this.enableEdit = false);
            }
        });
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                this.permissions.edit = user.toolKeys.includes(14);
            }
        }))
            .subscribe();
    }
    initializeForm() {
        this.supplierForm = this.formBuilder.group({
            number: [
                this.details ? this.details.number : 0,
                [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')],
            ],
            category: [this.details ? this.details.categoryKey : null],
            region: [this.details ? this.details.regionKey : null],
            legalName: [
                { value: this.details ? this.details.legalName : null, disabled: true },
            ],
            dbaName: [
                { value: this.details ? this.details.dbaName : null, disabled: true },
            ],
            address1: [
                { value: this.details ? this.details.address1 : null, disabled: true },
            ],
            address2: [
                { value: this.details ? this.details.address2 : null, disabled: true },
            ],
            country: [
                {
                    value: this.details ? this.details.country.trim() : null,
                    disabled: true,
                },
            ],
            city: [
                { value: this.details ? this.details.city : null, disabled: true },
            ],
            postalCode: [
                {
                    value: this.details ? this.details.postalCode : null,
                    disabled: true,
                },
            ],
            province: [
                {
                    value: this.details ? this.details.province.trim() : null,
                    disabled: true,
                },
            ],
            // isaNumber: [
            //   { value: this.details ? this.details.isaNumber : null, disabled: true },
            // ],
            phone: [
                {
                    value: this.details
                        ? this.formatPhoneToInternational(this.details.phone, this.details.country)
                        : null,
                    disabled: true,
                },
            ],
            email: [
                { value: this.details ? this.details.email : null, disabled: true },
            ],
            website: [
                { value: this.details ? this.details.website : null, disabled: true },
            ],
            currency: [
                {
                    value: this.details ? this.details.currencyType : null,
                    disabled: true,
                },
            ],
        });
    }
    formatPhoneToInternational(fax, country) {
        try {
            return parsePhoneNumber(fax, alpha3ToAlpha2(country || 'CA')).formatInternational();
        }
        catch (_a) {
            return fax;
        }
    }
    save() {
        this.supplierBus.publish({
            eventType: 'update',
            type: 'details',
            payload: {
                update: Object.assign(Object.assign({}, this.details), { number: this.supplierForm.value.number, regionKey: this.supplierForm.value.region
                        ? this.supplierForm.value.region
                        : this.defaultSelectItem.value, categoryKey: this.supplierForm.value.category
                        ? this.supplierForm.value.category
                        : this.defaultSelectItem.value }),
            },
        });
    }
    configEditModal() {
        if (this.permissions.edit) {
            this.enableEdit = true;
        }
    }
    cancelEditModal() {
        this.initializeForm();
        this.enableEdit = false;
    }
};
DetailsComponent$4.ctorParameters = () => [
    { type: FormBuilder },
    { type: SupplierBus },
    { type: SpinnerService },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('details')
], DetailsComponent$4.prototype, "detailsSetter", null);
__decorate([
    Input('configuration')
], DetailsComponent$4.prototype, "configurationSetter", null);
__decorate([
    Input('tags')
], DetailsComponent$4.prototype, "tagsSetter", null);
__decorate([
    Input('permissions')
], DetailsComponent$4.prototype, "permissionsSetter", null);
DetailsComponent$4 = __decorate([
    Component({
        selector: 'lib-details',
        template: "<!--Supplier Details - View Mode-->\r\n<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button pButton class=\"ds tertiary small\" type=\"button\" label=\"{{ 'ACTIONS.EDIT' | transloco }}\"\r\n    [disabled]=\"!permissions?.edit\" (click)=\"configEditModal()\"></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <!-- <ng-container\r\n    *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ISA_NUMBER' | transloco,\r\n          value: details.isaNumber\r\n        }\r\n      }\r\n    \"\r\n  ></ng-container> -->\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.LEGAL_NAME' | transloco,\r\n          value: details.legalName\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.DBA_NAME' | transloco,\r\n          value: details.dbaName\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.SUPPLIER_NUMBER' | transloco,\r\n          value: details.number\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_ONE' | transloco,\r\n          value: details.address1\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ADDRESS_TWO' | transloco,\r\n          value: details.address2\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: { label: 'SUPPLIER.CITY' | transloco, value: details.city }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.STATE_PROVINCE' | transloco,\r\n          value: details.provinceName || details.province.trim()\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.ZIP_POSTAL_CODE' | transloco,\r\n          value: details.postalCode\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.COUNTRY' | transloco,\r\n          value: details.countryName || details.country\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco,\r\n          value: details.phone\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.EMAIL' | transloco,\r\n          value: details.email\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'COMPANY.ACCOUNT_WEBSITE' | transloco,\r\n          value: details.website\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco,\r\n          value: details.currencyType\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.CATEGORY' | transloco,\r\n          value: details.category\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-container *ngTemplateOutlet=\"\r\n      supplierDetails;\r\n      context: {\r\n        details: {\r\n          label: 'SUPPLIER.REGION' | transloco,\r\n          value: details.region\r\n        }\r\n      }\r\n    \"></ng-container>\r\n  <ng-template #supplierDetails let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">\r\n          {{ value.label }}\r\n        </div>\r\n        <div>\r\n          <span> {{ value.value }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>\r\n<!--Supplier Details - Edit Modal-->\r\n<p-dialog [(visible)]=\"enableEdit\" [showHeader]=\"false\" [modal]=\"true\" position=\"center\" [draggable]=\"false\"\r\n  [resizable]=\"false\" [responsive]=\"true\" [focusOnShow]=\"false\" styleClass=\"lbmx-modal\">\r\n  <div class=\"vertical-flow modal-details-container\">\r\n    <h2 class=\"center\">{{ 'COMMON.EDIT_DETAILS' | transloco }}</h2>\r\n    <form class=\"vertical-flow space-before-100\" [formGroup]=\"supplierForm\" (ngSubmit)=\"save()\">\r\n      <!-- <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"isaNumber\">{{ 'SUPPLIER.ISA_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            class=\"ui-inputtext\"\r\n            formControlName=\"isaNumber\"\r\n          />\r\n        </div>\r\n      </div> -->\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"legalName\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"dbaName\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"number\">{{ 'SUPPLIER.SUPPLIER_NUMBER' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"number\" />\r\n        </div>\r\n        <span class=\"feedback\">\r\n          <lib-control-message [control]=\"supplierForm?.controls?.number\"\r\n            [errorMsg]=\"pattern.pattern\"></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-before-000 space-between-025\" *ngIf=\"categories?.length\">\r\n        <label for=\"category\">{{ 'SUPPLIER.CATEGORY' | transloco }}</label>\r\n        <p-dropdown autoWidth=\"false\" name=\"category\" [options]=\"categories\" formControlName=\"category\"\r\n          filter=\"true\"></p-dropdown>\r\n        <span class=\"feedback\">\r\n          <lib-control-message [control]=\"supplierForm?.controls?.category\"></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-between-025 space-before-000\" *ngIf=\"regions?.length\">\r\n        <label for=\"region\">{{ 'SUPPLIER.REGION' | transloco }}</label>\r\n        <p-dropdown autoWidth=\"false\" name=\"region\" [options]=\"regions\" formControlName=\"region\"\r\n          filter=\"true\"></p-dropdown>\r\n        <span class=\"feedback\">\r\n          <lib-control-message [control]=\"supplierForm?.controls?.region\"></lib-control-message>\r\n        </span>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-before-000 space-between-025\">\r\n        <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"address1\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"address2\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"city\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"province\">{{\r\n          'SUPPLIER.STATE_PROVINCE' | transloco\r\n          }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"province\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"postalCode\">{{\r\n          'SUPPLIER.ZIP_POSTAL_CODE' | transloco\r\n          }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"postalCode\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"country\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <div>\r\n          <label for=\"phone\">{{\r\n            'SUPPLIER.CONTACT_PHONE_NUMBER' | transloco\r\n            }}</label>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"phone\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <div>\r\n          <label for=\"email\">{{ 'SUPPLIER.EMAIL' | transloco }}</label>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"email\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"website\">{{ 'COMPANY.ACCOUNT_WEBSITE' | transloco }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"website\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-025 space-before-150\">\r\n        <label for=\"currency\">{{\r\n          'MARKETPLACE_ADVANCED_SEARCH.CURRENCY' | transloco\r\n          }}</label>\r\n        <div>\r\n          <input pInputText type=\"text\" class=\"ui-inputtext\" formControlName=\"currency\" />\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"horizontal-flow form-controls space-before-150\">\r\n        <button pButton type=\"button\" label=\"{{ 'ACTIONS.CANCEL' | transloco }}\" class=\"ds secondary\" autowidth=\"false\"\r\n          (click)=\"cancelEditModal()\"></button>\r\n        <button [disabled]=\"supplierForm.invalid\" pButton type=\"button\" label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n          type=\"submit\" class=\"ds primary\" autowidth=\"false\"></button>\r\n      </div>\r\n    </form>\r\n  </div>\r\n</p-dialog>",
        styles: [""]
    })
], DetailsComponent$4);

let EdiFormContainerComponent$2 = class EdiFormContainerComponent {
    constructor(config, supplierBus, spinner) {
        this.config = config;
        this.supplierBus = supplierBus;
        this.spinner = spinner;
        this.closeEdiDialog = new EventEmitter();
        this.ediCRUD = new EventEmitter();
        this.edi = [];
        this.documentTypes = [];
        this.documentStatus = [];
    }
    set ediSetter(edi) {
        this.edi = edi;
    }
    ngOnInit() {
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ edi }) => edi));
        this.setFetching('edi', true);
        this.spinner.on();
        this.subscription = forkJoin([
            this.config.getDocumentTypes(),
            this.config.getDocumentStatus(),
        ])
            .pipe(tap(([documentTypes, documentStatus]) => {
            this.documentTypes = documentTypes;
            this.documentStatus = documentStatus.map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentStatusKey, label: doc.description })));
        }), finalize(() => {
            this.setFetching('edi', false);
            this.spinner.off();
        }))
            .subscribe();
    }
    doesContainDocumentType(documentTypes = [{ documentTypeKey: 0 }], documentType = { documentTypeKey: 0 }) {
        return ((documentTypes === null || documentTypes === void 0 ? void 0 : documentTypes.filter((doc) => (documentType === null || documentType === void 0 ? void 0 : documentType.documentTypeKey) === (doc === null || doc === void 0 ? void 0 : doc.documentTypeKey)).length) > 0);
    }
    getAvailableDocumentTypes() {
        return this.action === 'edit'
            ? [
                ...this.documentTypes
                    .filter((documentType) => !this.doesContainDocumentType(this.edi, documentType))
                    .map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentTypeKey, label: `${doc.template + ' ' + doc.description}` }))),
                {
                    value: this.editEdi.documentTypeKey,
                    label: this.editEdi.documentType,
                },
            ]
            : this.documentTypes
                .filter((documentType) => !this.doesContainDocumentType(this.edi, documentType))
                .map((doc) => (Object.assign(Object.assign({}, doc), { value: doc.documentTypeKey, label: `${doc.template + ' ' + doc.description}` })));
    }
    setFetching(form, value) {
        this.supplierBus.publish({
            eventType: 'setFetching',
            payload: { form, value },
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
};
EdiFormContainerComponent$2.ctorParameters = () => [
    { type: ConfigService },
    { type: SupplierBus },
    { type: SpinnerService }
];
__decorate([
    Input('edi')
], EdiFormContainerComponent$2.prototype, "ediSetter", null);
__decorate([
    Input()
], EdiFormContainerComponent$2.prototype, "action", void 0);
__decorate([
    Input()
], EdiFormContainerComponent$2.prototype, "editEdi", void 0);
__decorate([
    Output()
], EdiFormContainerComponent$2.prototype, "closeEdiDialog", void 0);
__decorate([
    Output()
], EdiFormContainerComponent$2.prototype, "ediCRUD", void 0);
EdiFormContainerComponent$2 = __decorate([
    Component({
        selector: 'lib-edi-form-container',
        template: `
    <lib-edi-form
      [action]="action"
      [edi]="editEdi"
      [documentTypes]="getAvailableDocumentTypes()"
      [documentStatus]="documentStatus"
      (ediCRUD)="ediCRUD.emit($event)"
      (closeEdiDialog)="closeDialog()"
    ></lib-edi-form>
  `
    })
], EdiFormContainerComponent$2);

let EdiFormComponent$2 = class EdiFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeEdiDialog = new EventEmitter();
        this.ediCRUD = new EventEmitter();
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set ediSetter(edi) {
        this.edi = edi;
        this.initializeForm(edi);
    }
    set documentTypeSetter(documentTypes) {
        this.documentTypes = documentTypes;
    }
    set documentStatusSetter(documentStatus) {
        this.documentStatus = documentStatus;
    }
    initializeForm(ediInput) {
        const edi = ediInput ? ediInput : {};
        this.ediForm = this.formBuilder.group({
            documentTypeKey: [(edi === null || edi === void 0 ? void 0 : edi.documentTypeKey) || 0, Validators.required],
            documentStatusKey: [(edi === null || edi === void 0 ? void 0 : edi.documentStatusKey) || 0, Validators.required],
        });
    }
    closeDialog() {
        this.closeEdiDialog.emit();
        this.ediForm.reset();
    }
    save() {
        var _a, _b, _c, _d, _e;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.ediCRUD.emit({
            eventType,
            type: 'edi',
            typeKey: `${(_a = this.edi) === null || _a === void 0 ? void 0 : _a.accountRelationshipDocumentKey}`,
            payload: {
                [`${eventType}`]: {
                    documentTypeKey: (_c = (_b = this.ediForm) === null || _b === void 0 ? void 0 : _b.get('documentTypeKey')) === null || _c === void 0 ? void 0 : _c.value,
                    documentStatusKey: (_e = (_d = this.ediForm) === null || _d === void 0 ? void 0 : _d.get('documentStatusKey')) === null || _e === void 0 ? void 0 : _e.value,
                },
            },
        });
        this.closeDialog();
    }
};
EdiFormComponent$2.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], EdiFormComponent$2.prototype, "action", void 0);
__decorate([
    Input('edi')
], EdiFormComponent$2.prototype, "ediSetter", null);
__decorate([
    Input('documentTypes')
], EdiFormComponent$2.prototype, "documentTypeSetter", null);
__decorate([
    Input('documentStatus')
], EdiFormComponent$2.prototype, "documentStatusSetter", null);
__decorate([
    Output()
], EdiFormComponent$2.prototype, "closeEdiDialog", void 0);
__decorate([
    Output()
], EdiFormComponent$2.prototype, "ediCRUD", void 0);
EdiFormComponent$2 = __decorate([
    Component({
        selector: 'lib-edi-form',
        template: "<form class=\"vertical-flow\" [formGroup]=\"ediForm\" (ngSubmit)=\"save()\">\r\n  <div class=\"vertical-flow stacked-labels\">\r\n    <div>\r\n      <label for=\"documentType\">Type</label>\r\n      <p-dropdown\r\n        *ngIf=\"action !== 'view'; else docType\"\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentType\"\r\n        [options]=\"documentTypes\"\r\n        formControlName=\"documentTypeKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n      <ng-template #docType>\r\n        <input\r\n          pInputText\r\n          type=\"text\"\r\n          class=\"ui-inputtext\"\r\n          [value]=\"edi.documentType\"\r\n          [attr.disabled]=\"true\"\r\n        />\r\n      </ng-template>\r\n      <span class=\"feedback\">\r\n        <lib-control-message\r\n          [control]=\"ediForm.controls.documentTypeKey\"\r\n          [errorMsg]=\"requiredMsg.requiredMsg\"\r\n        ></lib-control-message>\r\n      </span>\r\n    </div>\r\n    <div>\r\n      <label for=\"documentStatus\">Status</label>\r\n      <p-dropdown\r\n        *ngIf=\"action !== 'view'; else docStatus\"\r\n        [style]=\"{ width: '100%' }\"\r\n        name=\"documentStatus\"\r\n        [options]=\"documentStatus\"\r\n        formControlName=\"documentStatusKey\"\r\n        filter=\"true\"\r\n        placeholder=\"Select\"\r\n      ></p-dropdown>\r\n      <ng-template #docStatus>\r\n        <input\r\n          pInputText\r\n          type=\"text\"\r\n          class=\"ui-inputtext\"\r\n          [value]=\"edi.documentStatus\"\r\n          [attr.disabled]=\"true\"\r\n        />\r\n      </ng-template>\r\n      <span class=\"feedback\">\r\n        <lib-control-message\r\n          [control]=\"ediForm.controls.documentStatusKey\"\r\n          [errorMsg]=\"requiredMsg.requiredMsg\"\r\n        ></lib-control-message>\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      [disabled]=\"ediForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], EdiFormComponent$2);

let EdiComponent$2 = class EdiComponent {
    constructor(confirmationService, supplierBus, translocoService, store) {
        this.confirmationService = confirmationService;
        this.supplierBus = supplierBus;
        this.translocoService = translocoService;
        this.store = store;
        this.fetching = false;
        this.toolbarButtons = [];
        this.showEdiDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set ediSetter(edi) {
        this.data$ = of(edi);
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.subscriptions.push(this.supplierBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'edi' && payload.result) {
                this.data$ = of(payload.data.accountRelationshipDocumentResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.translateLabels();
        this.columnsToDisplay = ['documentType', 'documentStatus'];
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showEdiDialog = true;
                this.editEdi = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showEdiDialog = true;
                this.editEdi = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showEdiDialog = true;
                this.editEdi = selection[0];
                break;
            case 'delete':
                this.delete(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    delete(selection = [], clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                const accountRelationshipDocumentKeys = [];
                selection.forEach((accountRelationshipDocument) => accountRelationshipDocumentKeys.push(accountRelationshipDocument.accountRelationshipDocumentKey));
                const accountRelationshipDocumentKeysString = JSON.stringify(accountRelationshipDocumentKeys);
                this.supplierBus.publish({
                    eventType: 'delete',
                    type: 'edi',
                    typeKey: accountRelationshipDocumentKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'documentType'),
                    },
                });
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'documentType',
            sortOrder: 1,
        };
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'edi',
            payload: searchFilters(term, pagination, [], 'documentType'),
        });
    }
    ediCRUD(data) {
        this.supplierBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'documentType') }) }));
    }
    closeEdiDialog() {
        this.showEdiDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'documentType',
                    header: translate.TYPE,
                },
                {
                    field: 'documentStatus',
                    header: translate.STATUS,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
            add: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            delete: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
EdiComponent$2.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: SupplierBus },
    { type: TranslocoService },
    { type: Store }
];
__decorate([
    Input('edi')
], EdiComponent$2.prototype, "ediSetter", null);
__decorate([
    Input()
], EdiComponent$2.prototype, "fetching", void 0);
EdiComponent$2 = __decorate([
    Component({
        selector: 'lib-edi',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"supplierEDI\"\r\n      i18nSearchField=\"{{ 'PARTNERS.EDI_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [loading]=\"fetching\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [searchProperty]=\"'term'\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showEdiDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <lib-working-spinner-component></lib-working-spinner-component>\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.EDIT_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [editEdi]=\"editEdi\"\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (ediCRUD)=\"ediCRUD($event)\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.ADD_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (ediCRUD)=\"ediCRUD($event)\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.VIEW_EDI' | transloco }}\r\n        </h2>\r\n        <lib-edi-form-container\r\n          [editEdi]=\"editEdi\"\r\n          [action]=\"action\"\r\n          [edi]=\"data$ | async\"\r\n          (closeEdiDialog)=\"closeEdiDialog()\"\r\n        ></lib-edi-form-container>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], EdiComponent$2);

let FormsComponent$2 = class FormsComponent {
    constructor(accountService, store, mppService) {
        this.accountService = accountService;
        this.store = store;
        this.mppService = mppService;
        this.editPaySubmit = new EventEmitter();
        this.imageSrc = '';
        this.imageAlt = '';
        this.authorizedActions = {};
        this.isCompanyLogoPresent = false;
        this.enablePay = false;
        this.subscriptions = [];
    }
    set supplierSetter(supplier) {
        this.supplier = supplier;
        this.getLogoAssetKey();
    }
    set configurationSetter(configuration) {
        this.configuration = configuration;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.store
            .pipe(select(selectors.marketplaces), tap((marketplaces) => {
            this.marketplaceKey = marketplaces.marketplace;
        }))
            .subscribe();
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            var _a;
            if (user) {
                this.accountKey = (_a = user.userInfo.AccountKey) === null || _a === void 0 ? void 0 : _a.toString();
            }
        }))
            .subscribe();
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(29)) {
                    this.enablePay = true;
                }
            }
        }))
            .subscribe();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getLogoAssetKey() {
        if (this.supplier &&
            this.supplier.details &&
            this.supplier.details.logo_AccountAssetKey !== null) {
            const accountAssetKey = Number(this.supplier.details.logo_AccountAssetKey);
            this.imageSrc =
                accountAssetKey > 0
                    ? this.accountService.getImageUrl(accountAssetKey, this.supplier.details.accountKey)
                    : '';
            this.isCompanyLogoPresent = accountAssetKey > 0 ? true : false;
        }
    }
    getPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
    paySubmit() {
        this.editPaySubmit.emit();
    }
};
FormsComponent$2.ctorParameters = () => [
    { type: AccountService },
    { type: Store },
    { type: MarketplacePartnersService }
];
__decorate([
    Input('supplier')
], FormsComponent$2.prototype, "supplierSetter", null);
__decorate([
    Input('configuration')
], FormsComponent$2.prototype, "configurationSetter", null);
__decorate([
    Input()
], FormsComponent$2.prototype, "fetching", void 0);
__decorate([
    Input()
], FormsComponent$2.prototype, "updating", void 0);
__decorate([
    Output()
], FormsComponent$2.prototype, "editPaySubmit", void 0);
FormsComponent$2 = __decorate([
    Component({
        selector: 'lib-forms',
        template: "<div\r\n  *ngIf=\"authorizedActions?.view || authorizedActions?.edit\"\r\n  class=\"details-container\"\r\n>\r\n  <div>\r\n    <section>\r\n      <lib-header\r\n        [imageTemplate]=\"header_image\"\r\n        [titleTemplate]=\"header_title\"\r\n        [contentTemplate]=\"header_content\"\r\n      >\r\n        <ng-template #header_title>\r\n          <h2 class=\"header-card-title\">\r\n            {{ 'PIM.SUPPLIER' | transloco }}\r\n          </h2>\r\n        </ng-template>\r\n        <ng-template #header_image>\r\n          <ng-container *ngIf=\"isCompanyLogoPresent; else logoMissing\">\r\n            <div class=\"img-container header\">\r\n              <img class=\"target\" [src]=\"imageSrc\" />\r\n            </div>\r\n          </ng-container>\r\n          <ng-template #logoMissing>\r\n            <div class=\"img-container header no-img\">\r\n              <span>\r\n                {{ 'COMPANY.LOGO_DEFAULT_MSG_1' | transloco }}<br />{{\r\n                  'COMPANY.LOGO_DEFAULT_MSG_2' | transloco\r\n                }}\r\n              </span>\r\n            </div>\r\n          </ng-template>\r\n        </ng-template>\r\n        <ng-template #header_content>\r\n          <div class=\"vertical-flow\">\r\n            <h4 class=\"content-title\">\r\n              <ng-container\r\n                *ngIf=\"supplier?.details?.dbaName?.length > 0; else legalName\"\r\n              >\r\n                {{ supplier?.details?.legalName }} (\r\n                {{ supplier?.details?.dbaName }} )\r\n              </ng-container>\r\n              <ng-template #legalName>\r\n                {{ supplier?.details?.legalName }}\r\n              </ng-template>\r\n            </h4>\r\n            <!-- <p>\r\n              {{ 'SUPPLIER.LBMXID' | transloco }}\r\n              {{ supplier?.details?.lbmxId }}\r\n            </p> -->\r\n          </div>\r\n        </ng-template>\r\n      </lib-header>\r\n    </section>\r\n  </div>\r\n  <div>\r\n    <section>\r\n      <p-tabView [activeIndex]=\"mppService.activeIndex\">\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_DETAILS' | transloco }}\">\r\n          <lib-details\r\n            [details]=\"supplier?.details\"\r\n            [tags]=\"supplier?.tags\"\r\n            [configuration]=\"configuration\"\r\n            [permissions]=\"authorizedActions\"\r\n          ></lib-details>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_CONTACTS' | transloco }}\">\r\n          <lib-contacts [contacts]=\"supplier?.contacts\"></lib-contacts>\r\n        </p-tabPanel>\r\n        <p-tabPanel\r\n          header=\"{{ 'SUPPLIER.TAB_BANKING' | transloco }}\"\r\n          disabled=\"true\"\r\n        >\r\n          <lib-banking [bankingInfo]=\"supplier?.bankingInfo\"></lib-banking>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_LOCATIONS' | transloco }}\">\r\n          <lib-locations [locations]=\"supplier?.locations\"></lib-locations\r\n        ></p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_EDI' | transloco }}\">\r\n          <lib-edi [edi]=\"supplier?.documents\"></lib-edi>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"{{ 'SUPPLIER.TAB_NOTES' | transloco }}\">\r\n          <lib-notes [notes]=\"supplier?.notes\"></lib-notes\r\n        ></p-tabPanel>\r\n        <p-tabPanel\r\n          header=\"{{ 'SUPPLIER.TAB_PAY' | transloco }}\"\r\n          *ngIf=\"accountKey === marketplaceKey && enablePay\"\r\n        >\r\n          <lib-pay\r\n            (editPaySubmit)=\"paySubmit()\"\r\n            [pay]=\"supplier?.details\"\r\n          ></lib-pay>\r\n        </p-tabPanel>\r\n      </p-tabView>\r\n      <p-confirmDialog\r\n        [closeOnEscape]=\"false\"\r\n        [closable]=\"false\"\r\n      ></p-confirmDialog>\r\n    </section>\r\n  </div>\r\n</div>\r\n",
        styles: [".content-title{font-size:22px;display:block;margin:0 2em 0 0}"]
    })
], FormsComponent$2);

let HeaderComponent$2 = class HeaderComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], HeaderComponent$2.prototype, "imageTemplate", void 0);
__decorate([
    Input()
], HeaderComponent$2.prototype, "titleTemplate", void 0);
__decorate([
    Input()
], HeaderComponent$2.prototype, "contentTemplate", void 0);
HeaderComponent$2 = __decorate([
    Component({
        selector: 'lib-header',
        template: "<section class=\"vertical-flow\">\r\n  <ng-container *ngTemplateOutlet=\"titleTemplate\"></ng-container>\r\n  <section class=\"horizontal-flow\">\r\n    <div style=\"margin-right: 1.5em;\">\r\n      <ng-container *ngTemplateOutlet=\"imageTemplate\"></ng-container>\r\n    </div>\r\n    <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\r\n  </section>\r\n</section>\r\n",
        styles: [""]
    })
], HeaderComponent$2);

let LocationsComponent$3 = class LocationsComponent {
    constructor(translocoService, supplierBus, store) {
        this.translocoService = translocoService;
        this.supplierBus = supplierBus;
        this.store = store;
        this.viewLocationsData = {};
        this.toolbarButtons = [];
        this.displayEditLocation = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set locationsSetter(locations) {
        this.locations = locations;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.supplierBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'locations' && payload.result) {
                this.data$ = of(payload.data.locations);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ locations }) => locations));
        this.columnsToDisplay = [
            'legalName',
            'dbaName',
            'number',
            'address1',
            'city',
            'province',
            'postalCode',
            'country',
        ];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'view':
                this.displayEditLocation = true;
                this.viewLocationsData = selection[0];
                break;
            default:
                break;
        }
    }
    clear() {
        this.supplierBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters('', {
                first: 0,
                rows: 25,
                sortField: 'LegalName',
                sortOrder: 1,
            }, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.supplierBus.publish({
            eventType: 'search',
            type: 'locations',
            payload: searchFilters(term, pagination, [], 'legalName'),
        });
    }
    closeEditLocationDialog() {
        this.displayEditLocation = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
            ];
            this.columns = [
                // {
                //   field: 'isaNumber',
                //   header: translate.ISA_NUMBER,
                // },
                // {
                //   field: 'lbmxid',
                //   header: translate.LBMXID,
                // },
                {
                    field: 'legalName',
                    header: translate.LEGAL_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                    required: true,
                },
                {
                    field: 'dbaName',
                    header: translate.DBA_NAME,
                    link: (_) => ({
                        path: './',
                    }),
                    event: (location) => location,
                },
                {
                    field: 'number',
                    header: translate.LOCATION_NUMBER,
                },
                {
                    field: 'country',
                    header: translate.COUNTRY,
                },
                {
                    field: 'address1',
                    header: translate.ADDRESS_ONE,
                },
                {
                    field: 'address2',
                    header: translate.ADDRESS_TWO,
                },
                {
                    field: 'city',
                    header: translate.CITY,
                },
                {
                    field: 'province',
                    header: translate.STATE_PROVINCE,
                },
                {
                    field: 'postalCode',
                    header: translate.ZIP_POSTAL_CODE,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
        };
    }
    openViewLocation(location) {
        this.displayEditLocation = true;
        this.viewLocationsData = location;
    }
};
LocationsComponent$3.ctorParameters = () => [
    { type: TranslocoService },
    { type: SupplierBus },
    { type: Store }
];
__decorate([
    Input('locations')
], LocationsComponent$3.prototype, "locationsSetter", null);
LocationsComponent$3 = __decorate([
    Component({
        selector: 'lib-locations',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"supplierLocations\"\r\n      i18nSearchField=\"{{ 'PARTNERS.LOCATION_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [loading]=\"fetching$ | async\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [searchProperty]=\"'term'\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewLocation($event)\"\r\n    ></lib-search-container>\r\n    <p-dialog\r\n      [(visible)]=\"displayEditLocation\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <h2 class=\"dialog-title\">\r\n        {{ 'SUPPLIER.VIEW_LOCATION' | transloco }}\r\n      </h2>\r\n      <lib-view-location\r\n        [location]=\"viewLocationsData\"\r\n        (closeEditLocationDialog)=\"closeEditLocationDialog()\"\r\n      ></lib-view-location>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], LocationsComponent$3);

let ViewLocationComponent$2 = class ViewLocationComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.closeEditLocationDialog = new EventEmitter();
    }
    set locationSetter(location) {
        this.initializeForm(location);
    }
    initializeForm(locationInput) {
        const location = locationInput || {};
        this.viewLocationForm = this.formBuilder.group({
            isaNumber: [{ value: location.isaNumber, disabled: true }],
            lbmxId: [{ value: location.lbmxid, disabled: true }],
            legalName: [{ value: location.legalName, disabled: true }],
            dbaName: [{ value: location.dbaName, disabled: true }],
            number: [{ value: location.number, disabled: true }],
            country: [{ value: location.country, disabled: true }],
            city: [{ value: location.city, disabled: true }],
            province: [{ value: location.province, disabled: true }],
            postalCode: [{ value: location.postalCode, disabled: true }],
            address1: [{ value: location.address1, disabled: true }],
            address2: [{ value: location.address2, disabled: true }],
        });
    }
    closeDialog() {
        this.closeEditLocationDialog.emit();
    }
};
ViewLocationComponent$2.ctorParameters = () => [
    { type: FormBuilder }
];
__decorate([
    Input('location')
], ViewLocationComponent$2.prototype, "locationSetter", null);
__decorate([
    Output()
], ViewLocationComponent$2.prototype, "closeEditLocationDialog", void 0);
ViewLocationComponent$2 = __decorate([
    Component({
        selector: 'lib-view-location',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"viewLocationForm\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"legalName\">{{ 'SUPPLIER.LEGAL_NAME' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"legalName\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"dbaName\">{{ 'SUPPLIER.DBA_NAME' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"dbaName\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"country\">{{ 'SUPPLIER.COUNTRY' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"country\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address1\">{{ 'SUPPLIER.ADDRESS_ONE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address1\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"address2\">{{ 'SUPPLIER.ADDRESS_TWO' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"address2\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"city\">{{ 'SUPPLIER.CITY' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"city\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"number\">{{ 'SUPPLIER.LOCATION_NUMBER' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"number\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"province\">{{ 'SUPPLIER.STATE_PROVINCE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"province\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"postalCode\">{{ 'SUPPLIER.ZIP_POSTAL_CODE' | transloco }}</label>\r\n    <input\r\n      pInputText\r\n      type=\"text\"\r\n      class=\"ui-inputtext\"\r\n      formControlName=\"postalCode\"\r\n      [attr.disabled]=\"true\"\r\n    />\r\n  </div>\r\n\r\n  <div class=\"horizontal-flow form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], ViewLocationComponent$2);

let NoteFormComponent$2 = class NoteFormComponent {
    constructor(formBuilder, transloco) {
        this.formBuilder = formBuilder;
        this.transloco = transloco;
        this.closeNoteDialog = new EventEmitter();
        this.notesCRUD = new EventEmitter();
        this.flagForFollowUpOptions = [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ];
        this.requiredMsg = {
            requiredMsg: () => this.transloco.translate('COMMON.REQUIRED'),
        };
    }
    set noteSetter(note) {
        this.note = note;
        this.initializeForm(note);
    }
    initializeForm(noteInput) {
        const note = noteInput || {};
        this.noteForm = this.formBuilder.group({
            flagForFollowUp: [note.flagForFollowUp, Validators.required],
            message: [note.message, Validators.required],
        });
    }
    closeDialog() {
        this.closeNoteDialog.emit();
        this.noteForm.reset();
    }
    getFagForFollowUpOptions() {
        var _a;
        try {
            return (_a = this.flagForFollowUpOptions) === null || _a === void 0 ? void 0 : _a.find((option) => { var _a; return option.value === ((_a = this.note) === null || _a === void 0 ? void 0 : _a.flagForFollowUp); }).label;
        }
        catch (error) {
            return '';
        }
    }
    save() {
        const accountRelationshipNoteKey = this.action === 'add' ? '' : `${this.note.accountRelationshipNoteKey}`;
        const eventType = this.action === 'add' ? 'create' : 'update';
        this.notesCRUD.emit({
            eventType,
            type: 'note',
            typeKey: accountRelationshipNoteKey,
            payload: { [`${eventType}`]: Object.assign(Object.assign({}, this.note), this.noteForm.value) },
        });
        this.closeDialog();
    }
};
NoteFormComponent$2.ctorParameters = () => [
    { type: FormBuilder },
    { type: TranslocoService }
];
__decorate([
    Input()
], NoteFormComponent$2.prototype, "action", void 0);
__decorate([
    Input('note')
], NoteFormComponent$2.prototype, "noteSetter", null);
__decorate([
    Output()
], NoteFormComponent$2.prototype, "closeNoteDialog", void 0);
__decorate([
    Output()
], NoteFormComponent$2.prototype, "notesCRUD", void 0);
NoteFormComponent$2 = __decorate([
    Component({
        selector: 'lib-note-form',
        template: "<form\r\n  class=\"vertical-flow space-before-100 space-between-100 form\"\r\n  [formGroup]=\"noteForm\"\r\n  (ngSubmit)=\"save()\"\r\n>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"flagForFollowUp\">{{\r\n      'SUPPLIER.FLAG_FOR_FOLLOW_UP' | transloco\r\n    }}</label>\r\n    <p-dropdown\r\n      *ngIf=\"action !== 'view'; else flagForFollowUp\"\r\n      [style]=\"{ width: '100%' }\"\r\n      name=\"province\"\r\n      [options]=\"flagForFollowUpOptions\"\r\n      formControlName=\"flagForFollowUp\"\r\n      filter=\"true\"\r\n      placeholder=\"Please Select a flag\"\r\n    ></p-dropdown>\r\n    <ng-template #flagForFollowUp>\r\n      <input\r\n        pInputText\r\n        type=\"text\"\r\n        class=\"ui-inputtext\"\r\n        [value]=\"getFagForFollowUpOptions()\"\r\n        [attr.disabled]=\"true\"\r\n      />\r\n    </ng-template>\r\n    <span class=\"feedback\">\r\n      <lib-control-message\r\n        [control]=\"noteForm.controls.flagForFollowUp\"\r\n        [errorMsg]=\"requiredMsg.requiredMsg\"\r\n      ></lib-control-message>\r\n    </span>\r\n  </div>\r\n  <div class=\"vertical-flow space-between-025 input\">\r\n    <label for=\"message\">{{ 'SUPPLIER.MESSAGE' | transloco }}</label>\r\n    <textarea\r\n      *ngIf=\"action !== 'view'; else message\"\r\n      rows=\"5\"\r\n      autoresize=\"true\"\r\n      name=\"message\"\r\n      pInputTextarea\r\n      formControlName=\"message\"\r\n      class=\"ui-inputtext\"\r\n    ></textarea>\r\n    <ng-template #message>\r\n      <textarea\r\n        rows=\"5\"\r\n        autoresize=\"true\"\r\n        name=\"message\"\r\n        pInputTextarea\r\n        formControlName=\"message\"\r\n        class=\"ui-inputtext\"\r\n        [attr.disabled]=\"true\"\r\n      ></textarea>\r\n    </ng-template>\r\n    <span class=\"feedback\">\r\n      <lib-control-message\r\n        [control]=\"noteForm.controls.message\"\r\n        [errorMsg]=\"requiredMsg.requiredMsg\"\r\n      ></lib-control-message>\r\n    </span>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      *ngIf=\"action !== 'view'\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"action !== 'view'; else close\"\r\n      [disabled]=\"noteForm.invalid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      type=\"submit\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n    ></button>\r\n    <ng-template #close>\r\n      <button\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        class=\"ds secondary\"\r\n        autowidth=\"false\"\r\n        (click)=\"closeDialog()\"\r\n      ></button>\r\n    </ng-template>\r\n  </div>\r\n</form>\r\n",
        styles: [""]
    })
], NoteFormComponent$2);

let NotesComponent$2 = class NotesComponent {
    constructor(confirmationService, supplierBus, translocoService, store, datePipe) {
        this.confirmationService = confirmationService;
        this.supplierBus = supplierBus;
        this.translocoService = translocoService;
        this.store = store;
        this.datePipe = datePipe;
        this.toolbarButtons = [];
        this.showNoteDialog = false;
        this.columnsAvailable = false;
        this.subscriptions = [];
        this.authorizedActions = {};
    }
    set notesSetter(notes) {
        this.notes = notes;
    }
    ngOnInit() {
        this.paging = {
            sizes: [25, 50, 75, 100],
            page: { first: 0, rows: 25 },
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, this.getButtonPermissions()), tap((authorizedActions) => {
            this.authorizedActions = authorizedActions;
        }))
            .subscribe());
        this.translateLabels();
        this.subscriptions.push(this.supplierBus.actionResult$.subscribe(({ payload }) => {
            if (payload.type === 'note' && payload.result) {
                this.data$ = of(payload.data.accountRelationshipNoteResponse);
                this.paging = Object.assign(Object.assign({}, this.paging), { records: payload.data.totalResults });
            }
        }));
        this.fetching$ = this.supplierBus.fetching$.pipe(map(({ note }) => note));
        this.columnsToDisplay = [
            'addedOn',
            'addedByName',
            'message',
            'flagForFollowUp',
            'modifiedOn',
            'modifiedByName',
        ];
        this.subscriptions.push(this.store.pipe(select(selectors.userProfile)).subscribe((res) => {
            var _a;
            this.dateFormat = (_a = res === null || res === void 0 ? void 0 : res.userInfo) === null || _a === void 0 ? void 0 : _a.DateTypeFormat;
        }));
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    deleteNote(notes, clearSelection) {
        this.confirmationService.confirm({
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            header: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_HEADER'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                const accountRelationshipNoteKeys = [];
                notes.forEach((note) => accountRelationshipNoteKeys.push(note.accountRelationshipNoteKey));
                const accountRelationshipNoteKeysString = JSON.stringify(accountRelationshipNoteKeys);
                this.supplierBus.publish({
                    eventType: 'delete',
                    type: 'note',
                    typeKey: accountRelationshipNoteKeysString,
                    payload: {
                        search: searchFilters('', this.prevPagination, [], 'AddedOn'),
                    },
                });
                // TODO: Remove from Future Versions if Single Delete is Obsolete
                // notes.forEach((note) =>
                //   this.supplierBus.publish({
                //     eventType: 'delete',
                //     type: 'note',
                //     typeKey: `${note.accountRelationshipNoteKey}`,
                //   })
                // );
                clearSelection();
            },
            reject: () => {
                clearSelection();
            },
        });
    }
    onToolbarClick({ command, selection, clearSelection }) {
        switch (command) {
            case 'add':
                this.action = 'add';
                this.showNoteDialog = true;
                this.editNote = undefined;
                break;
            case 'view':
                this.action = 'view';
                this.showNoteDialog = true;
                this.editNote = selection[0];
                break;
            case 'edit':
                this.action = 'edit';
                this.showNoteDialog = true;
                this.editNote = selection[0];
                break;
            case 'delete':
                this.deleteNote(selection, clearSelection);
                break;
            default:
                break;
        }
    }
    clear() {
        const pagination = {
            first: 0,
            rows: 25,
            sortField: 'AddedOn',
            sortOrder: -1,
        };
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters('', pagination, []),
        });
    }
    search(_a) {
        var { filters: { term } } = _a, pagination = __rest(_a, ["filters"]);
        this.prevPagination = pagination;
        this.supplierBus.publish({
            eventType: 'search',
            type: 'note',
            payload: searchFilters(term, pagination, [], 'AddedOn', -1),
        });
    }
    notesCRUD(data) {
        this.supplierBus.publish(Object.assign(Object.assign({}, data), { payload: Object.assign(Object.assign({}, data.payload), { search: searchFilters('', this.prevPagination, [], 'AddedOn', -1) }) }));
    }
    closeNoteDialog() {
        this.action = null;
        this.showNoteDialog = false;
    }
    translateLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('SUPPLIER')
            .pipe(map((translate) => translate), tap((translate) => {
            this.toolbarButtons = [
                {
                    name: 'add',
                    label: translate.TOOLBAR_BUTTONS_ADD,
                    disabled: !this.authorizedActions.add,
                    mode: 0 /* ALWAYS */,
                },
                {
                    name: 'view',
                    label: translate.VIEW,
                    disabled: !this.authorizedActions.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'edit',
                    label: translate.TOOLBAR_BUTTONS_EDIT,
                    disabled: !this.authorizedActions.edit,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'delete',
                    label: translate.TOOLBAR_BUTTONS_DELETE,
                    disabled: !this.authorizedActions.delete,
                    mode: 2 /* MULTIPLE */,
                },
            ];
            this.columns = [
                {
                    field: 'message',
                    header: translate.MESSAGE,
                    formatter: ({ message }) => {
                        try {
                            return message.slice().length < 30
                                ? message
                                : `${message.slice(0, 30)}...`;
                        }
                        catch (error) {
                            return `${error}`;
                        }
                    },
                    link: (_) => ({
                        path: './',
                    }),
                    event: (note) => note,
                },
                {
                    field: 'addedOn',
                    header: translate.ADDED_ON,
                    required: true,
                    formatter: ({ addedOn }) => `${this.datePipe.transform(addedOn, this.dateFormat)}`,
                },
                {
                    field: 'addedByName',
                    header: translate.ADDED_BY,
                    formatter: ({ addedByName }) => `${addedByName ? addedByName : ''}`,
                },
                {
                    field: 'flagForFollowUp',
                    header: translate.FLAG_FOR_FOLLOW_UP,
                    formatter: (flag) => `${flag.flagForFollowUp ? 'Yes' : 'No'}`,
                },
                {
                    field: 'modifiedOn',
                    header: translate.MODIFIED_ON,
                    formatter: ({ modifiedOn }) => `${modifiedOn
                        ? this.datePipe.transform(modifiedOn, this.dateFormat)
                        : ''}`,
                },
                {
                    field: 'modifiedByName',
                    header: translate.MODIFIED_BY,
                    formatter: ({ modifiedByName }) => `${modifiedByName ? modifiedByName : ''}`,
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    openViewNote(note) {
        this.action = 'view';
        this.showNoteDialog = true;
        this.editNote = note;
    }
    getButtonPermissions() {
        return {
            view: toolKeys.MPP_SUPPLIER,
            add: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            edit: toolKeys.MPP_SUPPLIER_MAINTENANCE,
            delete: toolKeys.MPP_SUPPLIER_MAINTENANCE,
        };
    }
};
NotesComponent$2.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: SupplierBus },
    { type: TranslocoService },
    { type: Store },
    { type: DatePipe }
];
__decorate([
    Input('notes')
], NotesComponent$2.prototype, "notesSetter", null);
NotesComponent$2 = __decorate([
    Component({
        selector: 'lib-notes',
        template: "<div class=\"vertical-flow\">\r\n  <div class=\"space-before-100\">\r\n    <lib-search-container\r\n      *ngIf=\"columnsAvailable\"\r\n      name=\"supplierNotes\"\r\n      i18nSearchField=\"{{ 'PARTNERS.NOTE_SEARCH' | transloco }}\"\r\n      [buttons]=\"toolbarButtons\"\r\n      [columns]=\"columns\"\r\n      [columnsToDisplay]=\"columnsToDisplay\"\r\n      [loading]=\"fetching$ | async\"\r\n      [paging]=\"paging\"\r\n      [results]=\"data$\"\r\n      [disableAdvancedSearch]=\"true\"\r\n      [searchProperty]=\"'term'\"\r\n      (clear)=\"clear()\"\r\n      (query)=\"search($event)\"\r\n      (toolbar)=\"onToolbarClick($event)\"\r\n      [lazy]=\"true\"\r\n      (lazyLoad)=\"search($event)\"\r\n      [lazyLoadOnInit]=\"true\"\r\n      [initialQuery]=\"{}\"\r\n      (field)=\"openViewNote($event)\"\r\n    ></lib-search-container>\r\n\r\n    <p-dialog\r\n      [(visible)]=\"showNoteDialog\"\r\n      [modal]=\"true\"\r\n      [style]=\"{ width: '520px' }\"\r\n      [baseZIndex]=\"10000\"\r\n      [draggable]=\"false\"\r\n      [resizable]=\"false\"\r\n      [showHeader]=\"false\"\r\n      [focusOnShow]=\"false\"\r\n      position=\"center\"\r\n    >\r\n      <ng-container *ngIf=\"action === 'edit'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.EDIT_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'add'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.ADD_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n      <ng-container *ngIf=\"action === 'view'\">\r\n        <h2 class=\"dialog-title\">\r\n          {{ 'SUPPLIER.VIEW_NOTES' | transloco }}\r\n        </h2>\r\n        <lib-note-form\r\n          [action]=\"action\"\r\n          [note]=\"editNote\"\r\n          (notesCRUD)=\"notesCRUD($event)\"\r\n          (closeNoteDialog)=\"closeNoteDialog()\"\r\n        ></lib-note-form>\r\n      </ng-container>\r\n    </p-dialog>\r\n  </div>\r\n</div>\r\n",
        styles: [".dialog-title{font-size:24px;text-align:center}"]
    })
], NotesComponent$2);

let PayComponent$1 = class PayComponent {
    constructor(mppService, translocoService, confirmationService, toast, store, router, route) {
        this.mppService = mppService;
        this.translocoService = translocoService;
        this.confirmationService = confirmationService;
        this.toast = toast;
        this.store = store;
        this.router = router;
        this.route = route;
        this.editPaySubmit = new EventEmitter();
        this.showEditDialog = false;
        this.templateTypes = TemplateTypes;
        this.baseUrl = `${this.mppService.getConfig().account}`;
        this.enableEdit = true;
    }
    set paySetter(pay) {
        this.details = pay;
        this.mppService.payEditDetailsConfig = {
            endpoint: `wizard/supplier/${pay === null || pay === void 0 ? void 0 : pay.accountRelationshipKey}/pay-setup`,
            httpMethod: HttpMethod$1.GET,
        };
    }
    ngOnInit() {
        this.mppService.supplierKey = this.router.url.split('/')[3];
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            if (user) {
                if (user.toolKeys.includes(14)) {
                    this.enableEdit = false;
                }
            }
        }))
            .subscribe();
    }
    openEditDialog() {
        this.router.navigate(['../../pay-edit'], { relativeTo: this.route });
    }
};
PayComponent$1.ctorParameters = () => [
    { type: MarketplacePartnersService },
    { type: TranslocoService },
    { type: ConfirmationService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: Router },
    { type: ActivatedRoute }
];
__decorate([
    Input('pay')
], PayComponent$1.prototype, "paySetter", null);
__decorate([
    Output()
], PayComponent$1.prototype, "editPaySubmit", void 0);
PayComponent$1 = __decorate([
    Component({
        selector: 'lib-pay',
        template: "<div class=\"horizontal-flow space-between-025 space-before-275 toolbar\">\r\n  <button pButton type=\"button\" label=\"{{ 'ACTIONS.EDIT' | transloco }}\" class=\"ds tertiary small\"\r\n    (click)=\"openEditDialog()\" [disabled]=\"enableEdit\"></button>\r\n</div>\r\n<div *ngIf=\"details\" class=\"details\">\r\n  <div>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'MEMBER.ACCEPTED_PAYMENT_METHODS' | transloco,\r\n            value: details?.paymentMethods\r\n          }\r\n        }\r\n      \"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.START_DATE' | transloco,\r\n            value: details?.partnerStartDateFormatted\r\n          }\r\n        }\r\n      \"></ng-container>\r\n    <ng-container *ngTemplateOutlet=\"\r\n        billingDetails;\r\n        context: {\r\n          details: {\r\n            label: 'ADMINISTRATION.END_DATE' | transloco,\r\n            value: details?.partnerEndDateFormatted\r\n          }\r\n        }\r\n      \"></ng-container>\r\n  </div>\r\n\r\n  <ng-template #billingDetails let-value=\"details\">\r\n    <div class=\"view-details view-details-row\">\r\n      <div class=\"view-details view-details-tile\">\r\n        <div class=\"view-details view-details-label\">{{ value.label }}:</div>\r\n        <div>\r\n          <span> {{ value.value }}</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </ng-template>\r\n</div>"
    })
], PayComponent$1);

let SupplierModule = class SupplierModule {
};
SupplierModule = __decorate([
    NgModule({
        declarations: [
            AdvancedSearchComponent$3,
            DetailsComponent$4,
            SupplierComponent,
            FormsComponent$2,
            ViewSuppliersComponent,
            HeaderComponent$2,
            ContactsComponent$4,
            LocationsComponent$3,
            ViewLocationComponent$2,
            BankingComponent$2,
            ViewBankingComponent$3,
            NotesComponent$2,
            FormsContainerComponent$2,
            NoteFormComponent$2,
            ContactFormComponent$4,
            ContactFormContainerComponent$4,
            EdiComponent$2,
            EdiFormContainerComponent$2,
            EdiFormComponent$2,
            PayComponent$1,
            PayEditWizardComponent,
        ],
        imports: [
            CommonModule,
            AccordionModule,
            ButtonModule,
            CheckboxModule,
            ConfirmDialogModule,
            DropdownModule,
            MultiSelectModule,
            ReactiveFormsModule,
            RouterModule,
            SearchContainerModule$1,
            TabViewModule,
            ToolbarModule,
            TranslocoModule,
            TreeTableModule,
            UtilsModule,
            DialogModule,
            ListboxModule,
            InputMaskModule,
            FormsModule,
            PhoneFormModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            ProgressSpinnerModule$2,
            CalendarModule,
            TreeModule,
        ],
        providers: [ConfirmationService$1],
    })
], SupplierModule);

let MarketplacePartnersModule = class MarketplacePartnersModule {
};
MarketplacePartnersModule = __decorate([
    NgModule({
        declarations: [MarketplacePartnersComponent, RequestsComponent],
        imports: [
            GroupModule,
            LocationModule,
            MemberModule,
            MemberCrossReferencesModule,
            RouterModule.forChild(routes$7),
            SupplierModule,
            SupplierCrossReferencesModule,
            PerFormPrimengModule,
            CompanyModule$1,
            CompanyModule,
            DialogModule,
            DataViewModule,
            DropdownModule,
            FormsModule,
            ConfirmDialogModule,
            MultiSelectModule,
            UtilsModule,
        ],
        exports: [MarketplacePartnersComponent],
        providers: [ConfirmationService$1, SearchContainerLoaderService],
    })
], MarketplacePartnersModule);

class MarketplacePartnersConfig {
    constructor() {
        this.getAccountRelationshipEndpoint = null;
        this.getAccountEndpoint = null;
        this.getConfigEndpoint = null;
        this.getLocationEndpoint = null;
        this.getUserStateEndpoint = null;
        this.getFieldCategoriesEndpoint = null;
        this.getAllProductFieldsEndpoint = null;
        this.accountAssetsEndPoint = null;
        this.deleteAccountAssetsEndPoint = null;
        this.deleteLogoAssetKeyEndpoint = null;
        this.updateAccountEndpoint = null;
        this.getDocumentServerEndpoint = null;
        this.account = null;
        this.apiBaseUrl = null;
    }
}

/*
 * Public API Surface of marketplace-partners
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplacePartnersComponent, MarketplacePartnersConfig, MarketplacePartnersModule, MarketplacePartnersService, RequestsComponent as ɵa, GroupModule as ɵb, EdiFormComponent as ɵba, EdiComponent as ɵbb, BillingTypeComponent as ɵbc, MarketplaceSetupComponent as ɵbd, MarketplaceSetupEditComponent as ɵbe, PhoneFormModule as ɵbf, PhoneFormComponent as ɵbg, LocationModule as ɵbh, AdvancedSearchComponent$1 as ɵbi, InformationFormComponent as ɵbj, NewLocationComponent as ɵbk, LocationComponent as ɵbl, LocationFormComponent$2 as ɵbm, UpdateLocationComponent as ɵbn, LocationService as ɵbo, ViewLocationsComponent as ɵbp, SearchContainerModule as ɵbq, SearchContainerComponent as ɵbr, SearchDirective as ɵbs, SearchContainerService as ɵbt, MemberModule as ɵbu, AdvancedSearchComponent$2 as ɵbv, DetailsComponent$3 as ɵbw, MemberBus as ɵbx, MemberComponent as ɵby, FormsComponent$1 as ɵbz, AdvancedSearchComponent as ɵc, ViewMembersComponent as ɵca, HeaderComponent$1 as ɵcb, ContactsComponent$3 as ɵcc, LocationsComponent$2 as ɵcd, ViewLocationComponent$1 as ɵce, BankingComponent$1 as ɵcf, ViewBankingComponent$2 as ɵcg, NotesComponent$1 as ɵch, FormsContainerComponent$1 as ɵci, NoteFormComponent$1 as ɵcj, ContactFormComponent$3 as ɵck, ContactFormContainerComponent$3 as ɵcl, EdiComponent$1 as ɵcm, EdiFormContainerComponent$1 as ɵcn, EdiFormComponent$1 as ɵco, PayComponent as ɵcp, MemberCrossReferencesModule as ɵcq, MemberCrossReferencesComponent as ɵcr, ViewMembersCrossReferencesComponent as ɵcs, CrossReferenceService as ɵct, BaseHttpService as ɵcu, EditComponent as ɵcv, ExportComponent as ɵcw, ImportComponent as ɵcx, ExportContainerComponent as ɵcy, ApplyPaymentComponent as ɵcz, DetailsComponent$2 as ɵd, ApplyPaymentFormComponent as ɵda, ViewComponent as ɵdb, routes$7 as ɵdc, AuthGuardService as ɵdd, routes$1 as ɵde, routes$2 as ɵdf, routes$4 as ɵdg, routes$6 as ɵdh, SupplierComponent as ɵdi, SupplierBus as ɵdj, ViewSuppliersComponent as ɵdk, FormsContainerComponent$2 as ɵdl, PayEditWizardComponent as ɵdm, routes as ɵdn, CompanyComponent as ɵdo, MyCompanyBus as ɵdp, ViewCompanyContainerComponent as ɵdq, routes$5 as ɵdr, SupplierCrossReferencesComponent as ɵds, ViewSuppliersCrossReferencesComponent as ɵdt, routes$3 as ɵdu, SupplierModule as ɵdv, AdvancedSearchComponent$3 as ɵdw, DetailsComponent$4 as ɵdx, FormsComponent$2 as ɵdy, HeaderComponent$2 as ɵdz, GroupComponent as ɵe, ContactsComponent$4 as ɵea, LocationsComponent$3 as ɵeb, ViewLocationComponent$2 as ɵec, BankingComponent$2 as ɵed, ViewBankingComponent$3 as ɵee, NotesComponent$2 as ɵef, NoteFormComponent$2 as ɵeg, ContactFormComponent$4 as ɵeh, ContactFormContainerComponent$4 as ɵei, EdiComponent$2 as ɵej, EdiFormContainerComponent$2 as ɵek, EdiFormComponent$2 as ɵel, PayComponent$1 as ɵem, SupplierCrossReferencesModule as ɵen, EditComponent$1 as ɵeo, CompanyModule$1 as ɵep, ViewCompanyComponent$1 as ɵeq, CompanyHeaderComponent$1 as ɵer, ContactsComponent$1 as ɵes, CompanyLocationsComponent$1 as ɵet, CompanyBankingComponent$1 as ɵeu, DetailsComponent$1 as ɵew, ContactFormComponent$1 as ɵex, ContactFormContainerComponent$1 as ɵey, LocationFormComponent$1 as ɵez, FormsComponent as ɵf, LocationFormContainerComponent$1 as ɵfa, LocationsComponent as ɵfb, ApplyBankingComponent as ɵfc, ApplyBankingFormComponent as ɵfd, ViewBankingComponent as ɵfe, ViewBankingFormComponent as ɵff, WizardModule as ɵfg, WizardComponent as ɵfh, ScreenComponent as ɵfj, CompanyModule as ɵfk, ViewCompanyComponent as ɵfl, CompanyComponent$1 as ɵfm, MyCompanyBus$1 as ɵfn, CompanyHeaderComponent as ɵfo, ContactsComponent as ɵfp, CompanyLocationsComponent as ɵfq, DetailsComponent as ɵfr, ContactFormComponent as ɵfs, ContactFormContainerComponent as ɵft, ViewCompanyContainerComponent$1 as ɵfu, LocationFormComponent as ɵfv, LocationFormContainerComponent as ɵfw, CompanyBankingComponent as ɵfx, CompanyPaymentPreferencesComponent as ɵfy, AccountService as ɵg, MyMarketplaceHeaderComponent as ɵh, ViewMarketplaceContainerComponent as ɵi, AccountRelationshipService as ɵj, GroupBus as ɵk, ViewGroupsComponent as ɵl, MarketplaceSetupService as ɵm, HeaderComponent as ɵn, ContactsComponent$2 as ɵo, LocationsComponent$1 as ɵp, ViewLocationComponent as ɵq, BankingComponent as ɵr, ViewBankingComponent$1 as ɵs, NotesComponent as ɵt, FormsContainerComponent as ɵu, NoteFormComponent as ɵv, ContactFormComponent$2 as ɵw, ContactFormContainerComponent$2 as ɵx, ConfigService as ɵy, EdiFormContainerComponent as ɵz };
//# sourceMappingURL=lbmx-marketplace-partners.js.map
